
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0d86"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0d86"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("e1QUF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5vRUK"));

});
parcelRegister("5vRUK", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $4039ab3b8cfc0794$export$ffb0004e005737fa, (v) => $4039ab3b8cfc0794$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $4039ab3b8cfc0794$export$34b9dba7ce09269b, (v) => $4039ab3b8cfc0794$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $4039ab3b8cfc0794$export$25062201e9e25d76, (v) => $4039ab3b8cfc0794$export$25062201e9e25d76 = v);
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4039ab3b8cfc0794$export$ffb0004e005737fa;
var $4039ab3b8cfc0794$export$34b9dba7ce09269b;
var $4039ab3b8cfc0794$export$25062201e9e25d76;
'use strict';

var $jAJLu = parcelRequire("jAJLu");
var $4039ab3b8cfc0794$var$g = 60103;
$4039ab3b8cfc0794$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $4039ab3b8cfc0794$var$h = Symbol.for;
    $4039ab3b8cfc0794$var$g = $4039ab3b8cfc0794$var$h("react.element");
    $4039ab3b8cfc0794$export$ffb0004e005737fa = $4039ab3b8cfc0794$var$h("react.fragment");
}
var $4039ab3b8cfc0794$var$m = $jAJLu.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $4039ab3b8cfc0794$var$n = Object.prototype.hasOwnProperty, $4039ab3b8cfc0794$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4039ab3b8cfc0794$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$4039ab3b8cfc0794$var$n.call(a, b) && !$4039ab3b8cfc0794$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $4039ab3b8cfc0794$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $4039ab3b8cfc0794$var$m.current
    };
}
$4039ab3b8cfc0794$export$34b9dba7ce09269b = $4039ab3b8cfc0794$var$q;
$4039ab3b8cfc0794$export$25062201e9e25d76 = $4039ab3b8cfc0794$var$q;

});
parcelRegister("jAJLu", function(module, exports) {
'use strict';

module.exports = (parcelRequire("foSMt"));

});
parcelRegister("foSMt", function(module, exports) {

$parcel$export(module.exports, "Children", () => $b3639741ed285037$export$dca3b0875bd9a954, (v) => $b3639741ed285037$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $b3639741ed285037$export$16fa2f45be04daa8, (v) => $b3639741ed285037$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $b3639741ed285037$export$ffb0004e005737fa, (v) => $b3639741ed285037$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $b3639741ed285037$export$e2c29f18771995cb, (v) => $b3639741ed285037$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $b3639741ed285037$export$221d75b3f55bb0bd, (v) => $b3639741ed285037$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $b3639741ed285037$export$5f8d39834fd61797, (v) => $b3639741ed285037$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $b3639741ed285037$export$74bf444e3cd11ea5, (v) => $b3639741ed285037$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $b3639741ed285037$export$ae55be85d98224ed, (v) => $b3639741ed285037$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $b3639741ed285037$export$e530037191fcd5d7, (v) => $b3639741ed285037$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $b3639741ed285037$export$fd42f52fd3ae1109, (v) => $b3639741ed285037$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $b3639741ed285037$export$c8a8987d4410bf2d, (v) => $b3639741ed285037$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $b3639741ed285037$export$d38cd72104c1f0e9, (v) => $b3639741ed285037$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $b3639741ed285037$export$7d1e3a5e95ceca43, (v) => $b3639741ed285037$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $b3639741ed285037$export$257a8862b851cb5b, (v) => $b3639741ed285037$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $b3639741ed285037$export$a8257692ac88316c, (v) => $b3639741ed285037$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $b3639741ed285037$export$488013bae63b21da, (v) => $b3639741ed285037$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $b3639741ed285037$export$7c73462e0d25e514, (v) => $b3639741ed285037$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $b3639741ed285037$export$35808ee640e87ca7, (v) => $b3639741ed285037$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $b3639741ed285037$export$fae74005e78b1a27, (v) => $b3639741ed285037$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $b3639741ed285037$export$dc8fbce3eb94dc1e, (v) => $b3639741ed285037$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $b3639741ed285037$export$6d9c69b0de29b591, (v) => $b3639741ed285037$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $b3639741ed285037$export$d5a552a76deda3c2, (v) => $b3639741ed285037$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $b3639741ed285037$export$e5c5a5f917a5871c, (v) => $b3639741ed285037$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $b3639741ed285037$export$1538c33de8887b59, (v) => $b3639741ed285037$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $b3639741ed285037$export$13e3392192263954, (v) => $b3639741ed285037$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $b3639741ed285037$export$b8f5890fc79d6aca, (v) => $b3639741ed285037$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $b3639741ed285037$export$60241385465d0a34, (v) => $b3639741ed285037$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $b3639741ed285037$export$83d89fbfd8236492, (v) => $b3639741ed285037$export$83d89fbfd8236492 = v);
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b3639741ed285037$export$dca3b0875bd9a954;
var $b3639741ed285037$export$16fa2f45be04daa8;
var $b3639741ed285037$export$ffb0004e005737fa;
var $b3639741ed285037$export$e2c29f18771995cb;
var $b3639741ed285037$export$221d75b3f55bb0bd;
var $b3639741ed285037$export$5f8d39834fd61797;
var $b3639741ed285037$export$74bf444e3cd11ea5;
var $b3639741ed285037$export$ae55be85d98224ed;
var $b3639741ed285037$export$e530037191fcd5d7;
var $b3639741ed285037$export$fd42f52fd3ae1109;
var $b3639741ed285037$export$c8a8987d4410bf2d;
var $b3639741ed285037$export$d38cd72104c1f0e9;
var $b3639741ed285037$export$7d1e3a5e95ceca43;
var $b3639741ed285037$export$257a8862b851cb5b;
var $b3639741ed285037$export$a8257692ac88316c;
var $b3639741ed285037$export$488013bae63b21da;
var $b3639741ed285037$export$7c73462e0d25e514;
var $b3639741ed285037$export$35808ee640e87ca7;
var $b3639741ed285037$export$fae74005e78b1a27;
var $b3639741ed285037$export$dc8fbce3eb94dc1e;
var $b3639741ed285037$export$6d9c69b0de29b591;
var $b3639741ed285037$export$d5a552a76deda3c2;
var $b3639741ed285037$export$e5c5a5f917a5871c;
var $b3639741ed285037$export$1538c33de8887b59;
var $b3639741ed285037$export$13e3392192263954;
var $b3639741ed285037$export$b8f5890fc79d6aca;
var $b3639741ed285037$export$60241385465d0a34;
var $b3639741ed285037$export$83d89fbfd8236492;
'use strict';

var $2ocMU = parcelRequire("2ocMU");
var $b3639741ed285037$var$n = "function" === typeof Symbol && Symbol.for, $b3639741ed285037$var$p = $b3639741ed285037$var$n ? Symbol.for("react.element") : 60103, $b3639741ed285037$var$q = $b3639741ed285037$var$n ? Symbol.for("react.portal") : 60106, $b3639741ed285037$var$r = $b3639741ed285037$var$n ? Symbol.for("react.fragment") : 60107, $b3639741ed285037$var$t = $b3639741ed285037$var$n ? Symbol.for("react.strict_mode") : 60108, $b3639741ed285037$var$u = $b3639741ed285037$var$n ? Symbol.for("react.profiler") : 60114, $b3639741ed285037$var$v = $b3639741ed285037$var$n ? Symbol.for("react.provider") : 60109, $b3639741ed285037$var$w = $b3639741ed285037$var$n ? Symbol.for("react.context") : 60110, $b3639741ed285037$var$x = $b3639741ed285037$var$n ? Symbol.for("react.forward_ref") : 60112, $b3639741ed285037$var$y = $b3639741ed285037$var$n ? Symbol.for("react.suspense") : 60113, $b3639741ed285037$var$z = $b3639741ed285037$var$n ? Symbol.for("react.memo") : 60115, $b3639741ed285037$var$A = $b3639741ed285037$var$n ? Symbol.for("react.lazy") : 60116, $b3639741ed285037$var$B = "function" === typeof Symbol && Symbol.iterator;
function $b3639741ed285037$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b3639741ed285037$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b3639741ed285037$var$E = {};
function $b3639741ed285037$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $b3639741ed285037$var$E;
    this.updater = c || $b3639741ed285037$var$D;
}
$b3639741ed285037$var$F.prototype.isReactComponent = {};
$b3639741ed285037$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($b3639741ed285037$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b3639741ed285037$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b3639741ed285037$var$G() {}
$b3639741ed285037$var$G.prototype = $b3639741ed285037$var$F.prototype;
function $b3639741ed285037$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $b3639741ed285037$var$E;
    this.updater = c || $b3639741ed285037$var$D;
}
var $b3639741ed285037$var$I = $b3639741ed285037$var$H.prototype = new $b3639741ed285037$var$G;
$b3639741ed285037$var$I.constructor = $b3639741ed285037$var$H;
$2ocMU($b3639741ed285037$var$I, $b3639741ed285037$var$F.prototype);
$b3639741ed285037$var$I.isPureReactComponent = !0;
var $b3639741ed285037$var$J = {
    current: null
}, $b3639741ed285037$var$K = Object.prototype.hasOwnProperty, $b3639741ed285037$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b3639741ed285037$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$b3639741ed285037$var$K.call(b, e) && !$b3639741ed285037$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $b3639741ed285037$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $b3639741ed285037$var$J.current
    };
}
function $b3639741ed285037$var$N(a, b) {
    return {
        $$typeof: $b3639741ed285037$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b3639741ed285037$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b3639741ed285037$var$p;
}
function $b3639741ed285037$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b3639741ed285037$var$P = /\/+/g, $b3639741ed285037$var$Q = [];
function $b3639741ed285037$var$R(a, b, c, e) {
    if ($b3639741ed285037$var$Q.length) {
        var d = $b3639741ed285037$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $b3639741ed285037$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $b3639741ed285037$var$Q.length && $b3639741ed285037$var$Q.push(a);
}
function $b3639741ed285037$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b3639741ed285037$var$p:
                case $b3639741ed285037$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $b3639741ed285037$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $b3639741ed285037$var$U(d, k);
        g += $b3639741ed285037$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $b3639741ed285037$var$B && a[$b3639741ed285037$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $b3639741ed285037$var$U(d, k++), g += $b3639741ed285037$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($b3639741ed285037$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $b3639741ed285037$var$V(a, b, c) {
    return null == a ? 0 : $b3639741ed285037$var$T(a, "", b, c);
}
function $b3639741ed285037$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b3639741ed285037$var$escape(a.key) : b.toString(36);
}
function $b3639741ed285037$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $b3639741ed285037$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $b3639741ed285037$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($b3639741ed285037$var$O(a) && (a = $b3639741ed285037$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($b3639741ed285037$var$P, "$&/") + "/") + c)), e.push(a));
}
function $b3639741ed285037$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($b3639741ed285037$var$P, "$&/") + "/");
    b = $b3639741ed285037$var$R(b, g, e, d);
    $b3639741ed285037$var$V(a, $b3639741ed285037$var$aa, b);
    $b3639741ed285037$var$S(b);
}
var $b3639741ed285037$var$Y = {
    current: null
};
function $b3639741ed285037$var$Z() {
    var a = $b3639741ed285037$var$Y.current;
    if (null === a) throw Error($b3639741ed285037$var$C(321));
    return a;
}
var $b3639741ed285037$var$ba = {
    ReactCurrentDispatcher: $b3639741ed285037$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $b3639741ed285037$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $2ocMU
};
$b3639741ed285037$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $b3639741ed285037$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $b3639741ed285037$var$R(null, null, b, c);
        $b3639741ed285037$var$V(a, $b3639741ed285037$var$W, b);
        $b3639741ed285037$var$S(b);
    },
    count: function(a) {
        return $b3639741ed285037$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $b3639741ed285037$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$b3639741ed285037$var$O(a)) throw Error($b3639741ed285037$var$C(143));
        return a;
    }
};
$b3639741ed285037$export$16fa2f45be04daa8 = $b3639741ed285037$var$F;
$b3639741ed285037$export$ffb0004e005737fa = $b3639741ed285037$var$r;
$b3639741ed285037$export$e2c29f18771995cb = $b3639741ed285037$var$u;
$b3639741ed285037$export$221d75b3f55bb0bd = $b3639741ed285037$var$H;
$b3639741ed285037$export$5f8d39834fd61797 = $b3639741ed285037$var$t;
$b3639741ed285037$export$74bf444e3cd11ea5 = $b3639741ed285037$var$y;
$b3639741ed285037$export$ae55be85d98224ed = $b3639741ed285037$var$ba;
$b3639741ed285037$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($b3639741ed285037$var$C(267, a));
    var e = $2ocMU({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $b3639741ed285037$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$b3639741ed285037$var$K.call(b, h) && !$b3639741ed285037$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $b3639741ed285037$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$b3639741ed285037$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $b3639741ed285037$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $b3639741ed285037$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$b3639741ed285037$export$c8a8987d4410bf2d = $b3639741ed285037$var$M;
$b3639741ed285037$export$d38cd72104c1f0e9 = function(a) {
    var b = $b3639741ed285037$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b3639741ed285037$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b3639741ed285037$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b3639741ed285037$var$x,
        render: a
    };
};
$b3639741ed285037$export$a8257692ac88316c = $b3639741ed285037$var$O;
$b3639741ed285037$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b3639741ed285037$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$b3639741ed285037$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b3639741ed285037$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b3639741ed285037$export$35808ee640e87ca7 = function(a, b) {
    return $b3639741ed285037$var$Z().useCallback(a, b);
};
$b3639741ed285037$export$fae74005e78b1a27 = function(a, b) {
    return $b3639741ed285037$var$Z().useContext(a, b);
};
$b3639741ed285037$export$dc8fbce3eb94dc1e = function() {};
$b3639741ed285037$export$6d9c69b0de29b591 = function(a, b) {
    return $b3639741ed285037$var$Z().useEffect(a, b);
};
$b3639741ed285037$export$d5a552a76deda3c2 = function(a, b, c) {
    return $b3639741ed285037$var$Z().useImperativeHandle(a, b, c);
};
$b3639741ed285037$export$e5c5a5f917a5871c = function(a, b) {
    return $b3639741ed285037$var$Z().useLayoutEffect(a, b);
};
$b3639741ed285037$export$1538c33de8887b59 = function(a, b) {
    return $b3639741ed285037$var$Z().useMemo(a, b);
};
$b3639741ed285037$export$13e3392192263954 = function(a, b, c) {
    return $b3639741ed285037$var$Z().useReducer(a, b, c);
};
$b3639741ed285037$export$b8f5890fc79d6aca = function(a) {
    return $b3639741ed285037$var$Z().useRef(a);
};
$b3639741ed285037$export$60241385465d0a34 = function(a) {
    return $b3639741ed285037$var$Z().useState(a);
};
$b3639741ed285037$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("2ocMU", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $1bd7be12f41d51a4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $1bd7be12f41d51a4$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $1bd7be12f41d51a4$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $1bd7be12f41d51a4$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $1bd7be12f41d51a4$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $1bd7be12f41d51a4$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $1bd7be12f41d51a4$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($1bd7be12f41d51a4$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($1bd7be12f41d51a4$var$getOwnPropertySymbols) {
            symbols = $1bd7be12f41d51a4$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($1bd7be12f41d51a4$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});





parcelRegister("idvMB", function(module, exports) {
'use strict';
function $d43218560b950c9f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d43218560b950c9f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d43218560b950c9f$var$checkDCE();

module.exports = (parcelRequire("4e07D"));

});
parcelRegister("4e07D", function(module, exports) {
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $jAJLu = parcelRequire("jAJLu");

var $2ocMU = parcelRequire("2ocMU");

var $x7ZH6 = parcelRequire("x7ZH6");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$jAJLu) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $jAJLu.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $2ocMU({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $jAJLu.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $2ocMU({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $2ocMU({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $x7ZH6.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $x7ZH6.unstable_scheduleCallback($x7ZH6.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $x7ZH6.unstable_UserBlockingPriority, ed = $x7ZH6.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $2ocMU({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$2ocMU(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $2ocMU(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $2ocMU({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $2ocMU({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $x7ZH6.unstable_runWithPriority, Jf = $x7ZH6.unstable_scheduleCallback, Kf = $x7ZH6.unstable_cancelCallback, Lf = $x7ZH6.unstable_requestPaint, Mf = $x7ZH6.unstable_now, Nf = $x7ZH6.unstable_getCurrentPriorityLevel, Of = $x7ZH6.unstable_ImmediatePriority, Pf = $x7ZH6.unstable_UserBlockingPriority, Qf = $x7ZH6.unstable_NormalPriority, Rf = $x7ZH6.unstable_LowPriority, Sf = $x7ZH6.unstable_IdlePriority, Tf = {}, Uf = $x7ZH6.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $2ocMU({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $2ocMU({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $jAJLu.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $2ocMU({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $2ocMU({}, f, {
                    value: void 0
                });
                d = $2ocMU({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $2ocMU({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($2ocMU({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.14.0";

});
parcelRegister("x7ZH6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a2e1L"));

});
parcelRegister("a2e1L", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $74e4f8d5a3a41b65$export$c4744153514ff05d, (v) => $74e4f8d5a3a41b65$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $74e4f8d5a3a41b65$export$d66a1c1c77bd778b, (v) => $74e4f8d5a3a41b65$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $74e4f8d5a3a41b65$export$3e506c1ccc9cc1a7, (v) => $74e4f8d5a3a41b65$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $74e4f8d5a3a41b65$export$e26fe2ed2fa76875, (v) => $74e4f8d5a3a41b65$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $74e4f8d5a3a41b65$export$502329bbf4b505b1, (v) => $74e4f8d5a3a41b65$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $74e4f8d5a3a41b65$export$6e3807111c4874c4, (v) => $74e4f8d5a3a41b65$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $74e4f8d5a3a41b65$export$c27134553091fb3a, (v) => $74e4f8d5a3a41b65$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $74e4f8d5a3a41b65$export$33ee1acdc04fd2a2, (v) => $74e4f8d5a3a41b65$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $74e4f8d5a3a41b65$export$b00a404bbd5edef2, (v) => $74e4f8d5a3a41b65$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $74e4f8d5a3a41b65$export$8352ce38b91d0c62, (v) => $74e4f8d5a3a41b65$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $74e4f8d5a3a41b65$export$d3dfb8e4810cb555, (v) => $74e4f8d5a3a41b65$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $74e4f8d5a3a41b65$export$839f9183b0465a69, (v) => $74e4f8d5a3a41b65$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $74e4f8d5a3a41b65$export$72fdf0e06517287b, (v) => $74e4f8d5a3a41b65$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $74e4f8d5a3a41b65$export$4b844e58a3e414b4, (v) => $74e4f8d5a3a41b65$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $74e4f8d5a3a41b65$export$816d2913ae6b83b1, (v) => $74e4f8d5a3a41b65$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $74e4f8d5a3a41b65$export$61bcfe829111a1d0, (v) => $74e4f8d5a3a41b65$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $74e4f8d5a3a41b65$export$7ee8c9beb337bc3f, (v) => $74e4f8d5a3a41b65$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $74e4f8d5a3a41b65$export$b5836b71941fa3ed, (v) => $74e4f8d5a3a41b65$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $74e4f8d5a3a41b65$export$cf845f2c119da08a, (v) => $74e4f8d5a3a41b65$export$cf845f2c119da08a = v);
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $74e4f8d5a3a41b65$export$c4744153514ff05d;
var $74e4f8d5a3a41b65$export$d66a1c1c77bd778b;
var $74e4f8d5a3a41b65$export$3e506c1ccc9cc1a7;
var $74e4f8d5a3a41b65$export$e26fe2ed2fa76875;
var $74e4f8d5a3a41b65$export$502329bbf4b505b1;
var $74e4f8d5a3a41b65$export$6e3807111c4874c4;
var $74e4f8d5a3a41b65$export$c27134553091fb3a;
var $74e4f8d5a3a41b65$export$33ee1acdc04fd2a2;
var $74e4f8d5a3a41b65$export$b00a404bbd5edef2;
var $74e4f8d5a3a41b65$export$8352ce38b91d0c62;
var $74e4f8d5a3a41b65$export$d3dfb8e4810cb555;
var $74e4f8d5a3a41b65$export$839f9183b0465a69;
var $74e4f8d5a3a41b65$export$72fdf0e06517287b;
var $74e4f8d5a3a41b65$export$4b844e58a3e414b4;
var $74e4f8d5a3a41b65$export$816d2913ae6b83b1;
var $74e4f8d5a3a41b65$export$61bcfe829111a1d0;
var $74e4f8d5a3a41b65$export$7ee8c9beb337bc3f;
var $74e4f8d5a3a41b65$export$b5836b71941fa3ed;
var $74e4f8d5a3a41b65$export$cf845f2c119da08a;
'use strict';
var $74e4f8d5a3a41b65$var$f, $74e4f8d5a3a41b65$var$g, $74e4f8d5a3a41b65$var$h, $74e4f8d5a3a41b65$var$k, $74e4f8d5a3a41b65$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $74e4f8d5a3a41b65$var$p = null, $74e4f8d5a3a41b65$var$q = null, $74e4f8d5a3a41b65$var$t = function() {
        if (null !== $74e4f8d5a3a41b65$var$p) try {
            var a = $74e4f8d5a3a41b65$export$c4744153514ff05d();
            $74e4f8d5a3a41b65$var$p(!0, a);
            $74e4f8d5a3a41b65$var$p = null;
        } catch (b) {
            throw setTimeout($74e4f8d5a3a41b65$var$t, 0), b;
        }
    }, $74e4f8d5a3a41b65$var$u = Date.now();
    $74e4f8d5a3a41b65$export$c4744153514ff05d = function() {
        return Date.now() - $74e4f8d5a3a41b65$var$u;
    };
    $74e4f8d5a3a41b65$var$f = function(a) {
        null !== $74e4f8d5a3a41b65$var$p ? setTimeout($74e4f8d5a3a41b65$var$f, 0, a) : ($74e4f8d5a3a41b65$var$p = a, setTimeout($74e4f8d5a3a41b65$var$t, 0));
    };
    $74e4f8d5a3a41b65$var$g = function(a, b) {
        $74e4f8d5a3a41b65$var$q = setTimeout(a, b);
    };
    $74e4f8d5a3a41b65$var$h = function() {
        clearTimeout($74e4f8d5a3a41b65$var$q);
    };
    $74e4f8d5a3a41b65$var$k = function() {
        return !1;
    };
    $74e4f8d5a3a41b65$var$l = $74e4f8d5a3a41b65$export$d66a1c1c77bd778b = function() {};
} else {
    var $74e4f8d5a3a41b65$var$w = window.performance, $74e4f8d5a3a41b65$var$x = window.Date, $74e4f8d5a3a41b65$var$y = window.setTimeout, $74e4f8d5a3a41b65$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $74e4f8d5a3a41b65$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $74e4f8d5a3a41b65$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $74e4f8d5a3a41b65$var$w && "function" === typeof $74e4f8d5a3a41b65$var$w.now) $74e4f8d5a3a41b65$export$c4744153514ff05d = function() {
        return $74e4f8d5a3a41b65$var$w.now();
    };
    else {
        var $74e4f8d5a3a41b65$var$B = $74e4f8d5a3a41b65$var$x.now();
        $74e4f8d5a3a41b65$export$c4744153514ff05d = function() {
            return $74e4f8d5a3a41b65$var$x.now() - $74e4f8d5a3a41b65$var$B;
        };
    }
    var $74e4f8d5a3a41b65$var$C = !1, $74e4f8d5a3a41b65$var$D = null, $74e4f8d5a3a41b65$var$E = -1, $74e4f8d5a3a41b65$var$F = 5, $74e4f8d5a3a41b65$var$G = 0;
    $74e4f8d5a3a41b65$var$k = function() {
        return $74e4f8d5a3a41b65$export$c4744153514ff05d() >= $74e4f8d5a3a41b65$var$G;
    };
    $74e4f8d5a3a41b65$var$l = function() {};
    $74e4f8d5a3a41b65$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $74e4f8d5a3a41b65$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $74e4f8d5a3a41b65$var$H = new MessageChannel, $74e4f8d5a3a41b65$var$I = $74e4f8d5a3a41b65$var$H.port2;
    $74e4f8d5a3a41b65$var$H.port1.onmessage = function() {
        if (null !== $74e4f8d5a3a41b65$var$D) {
            var a = $74e4f8d5a3a41b65$export$c4744153514ff05d();
            $74e4f8d5a3a41b65$var$G = a + $74e4f8d5a3a41b65$var$F;
            try {
                $74e4f8d5a3a41b65$var$D(!0, a) ? $74e4f8d5a3a41b65$var$I.postMessage(null) : ($74e4f8d5a3a41b65$var$C = !1, $74e4f8d5a3a41b65$var$D = null);
            } catch (b) {
                throw $74e4f8d5a3a41b65$var$I.postMessage(null), b;
            }
        } else $74e4f8d5a3a41b65$var$C = !1;
    };
    $74e4f8d5a3a41b65$var$f = function(a) {
        $74e4f8d5a3a41b65$var$D = a;
        $74e4f8d5a3a41b65$var$C || ($74e4f8d5a3a41b65$var$C = !0, $74e4f8d5a3a41b65$var$I.postMessage(null));
    };
    $74e4f8d5a3a41b65$var$g = function(a, b) {
        $74e4f8d5a3a41b65$var$E = $74e4f8d5a3a41b65$var$y(function() {
            a($74e4f8d5a3a41b65$export$c4744153514ff05d());
        }, b);
    };
    $74e4f8d5a3a41b65$var$h = function() {
        $74e4f8d5a3a41b65$var$z($74e4f8d5a3a41b65$var$E);
        $74e4f8d5a3a41b65$var$E = -1;
    };
}
function $74e4f8d5a3a41b65$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $74e4f8d5a3a41b65$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $74e4f8d5a3a41b65$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $74e4f8d5a3a41b65$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $74e4f8d5a3a41b65$var$K(n, c)) void 0 !== r && 0 > $74e4f8d5a3a41b65$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $74e4f8d5a3a41b65$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $74e4f8d5a3a41b65$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $74e4f8d5a3a41b65$var$N = [], $74e4f8d5a3a41b65$var$O = [], $74e4f8d5a3a41b65$var$P = 1, $74e4f8d5a3a41b65$var$Q = null, $74e4f8d5a3a41b65$var$R = 3, $74e4f8d5a3a41b65$var$S = !1, $74e4f8d5a3a41b65$var$T = !1, $74e4f8d5a3a41b65$var$U = !1;
function $74e4f8d5a3a41b65$var$V(a) {
    for(var b = $74e4f8d5a3a41b65$var$L($74e4f8d5a3a41b65$var$O); null !== b;){
        if (null === b.callback) $74e4f8d5a3a41b65$var$M($74e4f8d5a3a41b65$var$O);
        else if (b.startTime <= a) $74e4f8d5a3a41b65$var$M($74e4f8d5a3a41b65$var$O), b.sortIndex = b.expirationTime, $74e4f8d5a3a41b65$var$J($74e4f8d5a3a41b65$var$N, b);
        else break;
        b = $74e4f8d5a3a41b65$var$L($74e4f8d5a3a41b65$var$O);
    }
}
function $74e4f8d5a3a41b65$var$W(a) {
    $74e4f8d5a3a41b65$var$U = !1;
    $74e4f8d5a3a41b65$var$V(a);
    if (!$74e4f8d5a3a41b65$var$T) {
        if (null !== $74e4f8d5a3a41b65$var$L($74e4f8d5a3a41b65$var$N)) $74e4f8d5a3a41b65$var$T = !0, $74e4f8d5a3a41b65$var$f($74e4f8d5a3a41b65$var$X);
        else {
            var b = $74e4f8d5a3a41b65$var$L($74e4f8d5a3a41b65$var$O);
            null !== b && $74e4f8d5a3a41b65$var$g($74e4f8d5a3a41b65$var$W, b.startTime - a);
        }
    }
}
function $74e4f8d5a3a41b65$var$X(a, b) {
    $74e4f8d5a3a41b65$var$T = !1;
    $74e4f8d5a3a41b65$var$U && ($74e4f8d5a3a41b65$var$U = !1, $74e4f8d5a3a41b65$var$h());
    $74e4f8d5a3a41b65$var$S = !0;
    var c = $74e4f8d5a3a41b65$var$R;
    try {
        $74e4f8d5a3a41b65$var$V(b);
        for($74e4f8d5a3a41b65$var$Q = $74e4f8d5a3a41b65$var$L($74e4f8d5a3a41b65$var$N); null !== $74e4f8d5a3a41b65$var$Q && (!($74e4f8d5a3a41b65$var$Q.expirationTime > b) || a && !$74e4f8d5a3a41b65$var$k());){
            var d = $74e4f8d5a3a41b65$var$Q.callback;
            if (null !== d) {
                $74e4f8d5a3a41b65$var$Q.callback = null;
                $74e4f8d5a3a41b65$var$R = $74e4f8d5a3a41b65$var$Q.priorityLevel;
                var e = d($74e4f8d5a3a41b65$var$Q.expirationTime <= b);
                b = $74e4f8d5a3a41b65$export$c4744153514ff05d();
                "function" === typeof e ? $74e4f8d5a3a41b65$var$Q.callback = e : $74e4f8d5a3a41b65$var$Q === $74e4f8d5a3a41b65$var$L($74e4f8d5a3a41b65$var$N) && $74e4f8d5a3a41b65$var$M($74e4f8d5a3a41b65$var$N);
                $74e4f8d5a3a41b65$var$V(b);
            } else $74e4f8d5a3a41b65$var$M($74e4f8d5a3a41b65$var$N);
            $74e4f8d5a3a41b65$var$Q = $74e4f8d5a3a41b65$var$L($74e4f8d5a3a41b65$var$N);
        }
        if (null !== $74e4f8d5a3a41b65$var$Q) var m = !0;
        else {
            var n = $74e4f8d5a3a41b65$var$L($74e4f8d5a3a41b65$var$O);
            null !== n && $74e4f8d5a3a41b65$var$g($74e4f8d5a3a41b65$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $74e4f8d5a3a41b65$var$Q = null, $74e4f8d5a3a41b65$var$R = c, $74e4f8d5a3a41b65$var$S = !1;
    }
}
function $74e4f8d5a3a41b65$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $74e4f8d5a3a41b65$var$Z = $74e4f8d5a3a41b65$var$l;
$74e4f8d5a3a41b65$export$3e506c1ccc9cc1a7 = 5;
$74e4f8d5a3a41b65$export$e26fe2ed2fa76875 = 1;
$74e4f8d5a3a41b65$export$502329bbf4b505b1 = 4;
$74e4f8d5a3a41b65$export$6e3807111c4874c4 = 3;
$74e4f8d5a3a41b65$export$c27134553091fb3a = null;
$74e4f8d5a3a41b65$export$33ee1acdc04fd2a2 = 2;
$74e4f8d5a3a41b65$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$74e4f8d5a3a41b65$export$8352ce38b91d0c62 = function() {
    $74e4f8d5a3a41b65$var$T || $74e4f8d5a3a41b65$var$S || ($74e4f8d5a3a41b65$var$T = !0, $74e4f8d5a3a41b65$var$f($74e4f8d5a3a41b65$var$X));
};
$74e4f8d5a3a41b65$export$d3dfb8e4810cb555 = function() {
    return $74e4f8d5a3a41b65$var$R;
};
$74e4f8d5a3a41b65$export$839f9183b0465a69 = function() {
    return $74e4f8d5a3a41b65$var$L($74e4f8d5a3a41b65$var$N);
};
$74e4f8d5a3a41b65$export$72fdf0e06517287b = function(a) {
    switch($74e4f8d5a3a41b65$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $74e4f8d5a3a41b65$var$R;
    }
    var c = $74e4f8d5a3a41b65$var$R;
    $74e4f8d5a3a41b65$var$R = b;
    try {
        return a();
    } finally{
        $74e4f8d5a3a41b65$var$R = c;
    }
};
$74e4f8d5a3a41b65$export$4b844e58a3e414b4 = function() {};
$74e4f8d5a3a41b65$export$816d2913ae6b83b1 = $74e4f8d5a3a41b65$var$Z;
$74e4f8d5a3a41b65$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $74e4f8d5a3a41b65$var$R;
    $74e4f8d5a3a41b65$var$R = a;
    try {
        return b();
    } finally{
        $74e4f8d5a3a41b65$var$R = c;
    }
};
$74e4f8d5a3a41b65$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $74e4f8d5a3a41b65$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $74e4f8d5a3a41b65$var$Y(a);
    } else c = $74e4f8d5a3a41b65$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $74e4f8d5a3a41b65$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $74e4f8d5a3a41b65$var$J($74e4f8d5a3a41b65$var$O, a), null === $74e4f8d5a3a41b65$var$L($74e4f8d5a3a41b65$var$N) && a === $74e4f8d5a3a41b65$var$L($74e4f8d5a3a41b65$var$O) && ($74e4f8d5a3a41b65$var$U ? $74e4f8d5a3a41b65$var$h() : $74e4f8d5a3a41b65$var$U = !0, $74e4f8d5a3a41b65$var$g($74e4f8d5a3a41b65$var$W, e - d))) : (a.sortIndex = c, $74e4f8d5a3a41b65$var$J($74e4f8d5a3a41b65$var$N, a), $74e4f8d5a3a41b65$var$T || $74e4f8d5a3a41b65$var$S || ($74e4f8d5a3a41b65$var$T = !0, $74e4f8d5a3a41b65$var$f($74e4f8d5a3a41b65$var$X)));
    return a;
};
$74e4f8d5a3a41b65$export$b5836b71941fa3ed = function() {
    var a = $74e4f8d5a3a41b65$export$c4744153514ff05d();
    $74e4f8d5a3a41b65$var$V(a);
    var b = $74e4f8d5a3a41b65$var$L($74e4f8d5a3a41b65$var$N);
    return b !== $74e4f8d5a3a41b65$var$Q && null !== $74e4f8d5a3a41b65$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $74e4f8d5a3a41b65$var$Q.expirationTime || $74e4f8d5a3a41b65$var$k();
};
$74e4f8d5a3a41b65$export$cf845f2c119da08a = function(a) {
    var b = $74e4f8d5a3a41b65$var$R;
    return function() {
        var c = $74e4f8d5a3a41b65$var$R;
        $74e4f8d5a3a41b65$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $74e4f8d5a3a41b65$var$R = c;
        }
    };
};

});




parcelRegister("P3rDU", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("kfv0c"))(import.meta.resolve("j2WBG")),
    import("29tkD")
]).then(()=>parcelRequire('tmXBX'));

});
parcelRegister("kfv0c", function(module, exports) {
"use strict";

var $eNkMr = parcelRequire("eNkMr");
module.exports = $eNkMr(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("eNkMr", function(module, exports) {
"use strict";
var $ac55c2d689d05dee$var$cachedBundles = {};
var $ac55c2d689d05dee$var$cachedPreloads = {};
var $ac55c2d689d05dee$var$cachedPrefetches = {};
function $ac55c2d689d05dee$var$getCache(type) {
    switch(type){
        case 'preload':
            return $ac55c2d689d05dee$var$cachedPreloads;
        case 'prefetch':
            return $ac55c2d689d05dee$var$cachedPrefetches;
        default:
            return $ac55c2d689d05dee$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $ac55c2d689d05dee$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




var $e1QUF = parcelRequire("e1QUF");
parcelRequire("jAJLu");

var $idvMB = parcelRequire("idvMB");
var $053b4050c185c268$var$__create = Object.create;
var $053b4050c185c268$var$__defProp = Object.defineProperty;
var $053b4050c185c268$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $053b4050c185c268$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $053b4050c185c268$var$__getProtoOf = Object.getPrototypeOf;
var $053b4050c185c268$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $053b4050c185c268$var$__defNormalProp = (obj, key, value)=>key in obj ? $053b4050c185c268$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $053b4050c185c268$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$053b4050c185c268$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $053b4050c185c268$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $053b4050c185c268$var$__getOwnPropNames(from))if (!$053b4050c185c268$var$__hasOwnProp.call(to, key) && key !== except) $053b4050c185c268$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $053b4050c185c268$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $053b4050c185c268$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $053b4050c185c268$var$__create($053b4050c185c268$var$__getProtoOf(mod)) : {}, $053b4050c185c268$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $053b4050c185c268$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $053b4050c185c268$var$__publicField = (obj, key, value)=>$053b4050c185c268$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// ../../node_modules/.pnpm/shimmer@1.2.1/node_modules/shimmer/index.js
var $053b4050c185c268$var$require_shimmer = $053b4050c185c268$var$__commonJS({
    "../../node_modules/.pnpm/shimmer@1.2.1/node_modules/shimmer/index.js" (exports, module) {
        "use strict";
        function isFunction3(funktion) {
            return typeof funktion === "function";
        }
        var logger = console.error.bind(console);
        function defineProperty(obj, name, value) {
            var enumerable = !!obj[name] && obj.propertyIsEnumerable(name);
            Object.defineProperty(obj, name, {
                configurable: true,
                enumerable: enumerable,
                writable: true,
                value: value
            });
        }
        function shimmer3(options) {
            if (options && options.logger) {
                if (!isFunction3(options.logger)) logger("new logger isn't a function, not replacing");
                else logger = options.logger;
            }
        }
        function wrap3(nodule, name, wrapper) {
            if (!nodule || !nodule[name]) {
                logger("no original function " + name + " to wrap");
                return;
            }
            if (!wrapper) {
                logger("no wrapper function");
                logger(new Error().stack);
                return;
            }
            if (!isFunction3(nodule[name]) || !isFunction3(wrapper)) {
                logger("original object and wrapper must be functions");
                return;
            }
            var original = nodule[name];
            var wrapped = wrapper(original, name);
            defineProperty(wrapped, "__original", original);
            defineProperty(wrapped, "__unwrap", function() {
                if (nodule[name] === wrapped) defineProperty(nodule, name, original);
            });
            defineProperty(wrapped, "__wrapped", true);
            defineProperty(nodule, name, wrapped);
            return wrapped;
        }
        function massWrap3(nodules, names, wrapper) {
            if (!nodules) {
                logger("must provide one or more modules to patch");
                logger(new Error().stack);
                return;
            } else if (!Array.isArray(nodules)) nodules = [
                nodules
            ];
            if (!(names && Array.isArray(names))) {
                logger("must provide one or more functions to wrap on modules");
                return;
            }
            nodules.forEach(function(nodule) {
                names.forEach(function(name) {
                    wrap3(nodule, name, wrapper);
                });
            });
        }
        function unwrap3(nodule, name) {
            if (!nodule || !nodule[name]) {
                logger("no function to unwrap.");
                logger(new Error().stack);
                return;
            }
            if (!nodule[name].__unwrap) logger("no original to unwrap to -- has " + name + " already been unwrapped?");
            else return nodule[name].__unwrap();
        }
        function massUnwrap3(nodules, names) {
            if (!nodules) {
                logger("must provide one or more modules to patch");
                logger(new Error().stack);
                return;
            } else if (!Array.isArray(nodules)) nodules = [
                nodules
            ];
            if (!(names && Array.isArray(names))) {
                logger("must provide one or more functions to unwrap on modules");
                return;
            }
            nodules.forEach(function(nodule) {
                names.forEach(function(name) {
                    unwrap3(nodule, name);
                });
            });
        }
        shimmer3.wrap = wrap3;
        shimmer3.massWrap = massWrap3;
        shimmer3.unwrap = unwrap3;
        shimmer3.massUnwrap = massUnwrap3;
        module.exports = shimmer3;
    }
});
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/platform/browser/globalThis.js
var $053b4050c185c268$var$_globalThis = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof $parcel$global === "object" ? $parcel$global : {};
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/version.js
var $053b4050c185c268$var$VERSION = "1.9.0";
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/internal/semver.js
var $053b4050c185c268$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $053b4050c185c268$var$_makeCompatibilityCheck(ownVersion) {
    var acceptedVersions = /* @__PURE__ */ new Set([
        ownVersion
    ]);
    var rejectedVersions = /* @__PURE__ */ new Set();
    var myVersionMatch = ownVersion.match($053b4050c185c268$var$re);
    if (!myVersionMatch) return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible2(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match($053b4050c185c268$var$re);
        if (!globalVersionMatch) return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var $053b4050c185c268$var$isCompatible = $053b4050c185c268$var$_makeCompatibilityCheck($053b4050c185c268$var$VERSION);
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/internal/global-utils.js
var $053b4050c185c268$var$major = $053b4050c185c268$var$VERSION.split(".")[0];
var $053b4050c185c268$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + $053b4050c185c268$var$major);
var $053b4050c185c268$var$_global = $053b4050c185c268$var$_globalThis;
function $053b4050c185c268$var$registerGlobal(type, instance, diag3, allowOverride) {
    var _a3;
    if (allowOverride === void 0) allowOverride = false;
    var api = $053b4050c185c268$var$_global[$053b4050c185c268$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a3 = $053b4050c185c268$var$_global[$053b4050c185c268$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a3 !== void 0 ? _a3 : {
        version: $053b4050c185c268$var$VERSION
    };
    if (!allowOverride && api[type]) {
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag3.error(err.stack || err.message);
        return false;
    }
    if (api.version !== $053b4050c185c268$var$VERSION) {
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + $053b4050c185c268$var$VERSION);
        diag3.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag3.debug("@opentelemetry/api: Registered a global for " + type + " v" + $053b4050c185c268$var$VERSION + ".");
    return true;
}
function $053b4050c185c268$var$getGlobal(type) {
    var _a3, _b;
    var globalVersion = (_a3 = $053b4050c185c268$var$_global[$053b4050c185c268$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a3 === void 0 ? void 0 : _a3.version;
    if (!globalVersion || !$053b4050c185c268$var$isCompatible(globalVersion)) return;
    return (_b = $053b4050c185c268$var$_global[$053b4050c185c268$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $053b4050c185c268$var$unregisterGlobal(type, diag3) {
    diag3.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + $053b4050c185c268$var$VERSION + ".");
    var api = $053b4050c185c268$var$_global[$053b4050c185c268$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/diag/ComponentLogger.js
var $053b4050c185c268$var$__read = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $053b4050c185c268$var$__spreadArray = function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $053b4050c185c268$var$DiagComponentLogger = /** @class */ function() {
    function DiagComponentLogger2(props) {
        this._namespace = props.namespace || "DiagComponentLogger";
    }
    DiagComponentLogger2.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $053b4050c185c268$var$logProxy("debug", this._namespace, args);
    };
    DiagComponentLogger2.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $053b4050c185c268$var$logProxy("error", this._namespace, args);
    };
    DiagComponentLogger2.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $053b4050c185c268$var$logProxy("info", this._namespace, args);
    };
    DiagComponentLogger2.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $053b4050c185c268$var$logProxy("warn", this._namespace, args);
    };
    DiagComponentLogger2.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $053b4050c185c268$var$logProxy("verbose", this._namespace, args);
    };
    return DiagComponentLogger2;
}();
function $053b4050c185c268$var$logProxy(funcName, namespace, args) {
    var logger = $053b4050c185c268$var$getGlobal("diag");
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, $053b4050c185c268$var$__spreadArray([], $053b4050c185c268$var$__read(args), false));
}
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/diag/types.js
var $053b4050c185c268$var$DiagLogLevel;
(function(DiagLogLevel2) {
    DiagLogLevel2[DiagLogLevel2["NONE"] = 0] = "NONE";
    DiagLogLevel2[DiagLogLevel2["ERROR"] = 30] = "ERROR";
    DiagLogLevel2[DiagLogLevel2["WARN"] = 50] = "WARN";
    DiagLogLevel2[DiagLogLevel2["INFO"] = 60] = "INFO";
    DiagLogLevel2[DiagLogLevel2["DEBUG"] = 70] = "DEBUG";
    DiagLogLevel2[DiagLogLevel2["VERBOSE"] = 80] = "VERBOSE";
    DiagLogLevel2[DiagLogLevel2["ALL"] = 9999] = "ALL";
})($053b4050c185c268$var$DiagLogLevel || ($053b4050c185c268$var$DiagLogLevel = {}));
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/diag/internal/logLevelLogger.js
function $053b4050c185c268$var$createLogLevelDiagLogger(maxLevel, logger) {
    if (maxLevel < $053b4050c185c268$var$DiagLogLevel.NONE) maxLevel = $053b4050c185c268$var$DiagLogLevel.NONE;
    else if (maxLevel > $053b4050c185c268$var$DiagLogLevel.ALL) maxLevel = $053b4050c185c268$var$DiagLogLevel.ALL;
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === "function" && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc("error", $053b4050c185c268$var$DiagLogLevel.ERROR),
        warn: _filterFunc("warn", $053b4050c185c268$var$DiagLogLevel.WARN),
        info: _filterFunc("info", $053b4050c185c268$var$DiagLogLevel.INFO),
        debug: _filterFunc("debug", $053b4050c185c268$var$DiagLogLevel.DEBUG),
        verbose: _filterFunc("verbose", $053b4050c185c268$var$DiagLogLevel.VERBOSE)
    };
}
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/api/diag.js
var $053b4050c185c268$var$__read2 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $053b4050c185c268$var$__spreadArray2 = function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $053b4050c185c268$var$API_NAME = "diag";
var $053b4050c185c268$var$DiagAPI = /** @class */ function() {
    function DiagAPI2() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = $053b4050c185c268$var$getGlobal("diag");
                if (!logger) return;
                return logger[funcName].apply(logger, $053b4050c185c268$var$__spreadArray2([], $053b4050c185c268$var$__read2(args), false));
            };
        }
        var self2 = this;
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a3, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: $053b4050c185c268$var$DiagLogLevel.INFO
            };
            if (logger === self2) {
                var err = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
                self2.error((_a3 = err.stack) !== null && _a3 !== void 0 ? _a3 : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === "number") optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = $053b4050c185c268$var$getGlobal("diag");
            var newLogger = $053b4050c185c268$var$createLogLevelDiagLogger((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : $053b4050c185c268$var$DiagLogLevel.INFO, logger);
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : "<failed to generate stacktrace>";
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return $053b4050c185c268$var$registerGlobal("diag", newLogger, self2, true);
        };
        self2.setLogger = setLogger;
        self2.disable = function() {
            $053b4050c185c268$var$unregisterGlobal($053b4050c185c268$var$API_NAME, self2);
        };
        self2.createComponentLogger = function(options) {
            return new $053b4050c185c268$var$DiagComponentLogger(options);
        };
        self2.verbose = _logProxy("verbose");
        self2.debug = _logProxy("debug");
        self2.info = _logProxy("info");
        self2.warn = _logProxy("warn");
        self2.error = _logProxy("error");
    }
    DiagAPI2.instance = function() {
        if (!this._instance) this._instance = new DiagAPI2();
        return this._instance;
    };
    return DiagAPI2;
}();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/baggage/internal/baggage-impl.js
var $053b4050c185c268$var$__read3 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $053b4050c185c268$var$__values = function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $053b4050c185c268$var$BaggageImpl = /** @class */ function() {
    function BaggageImpl2(entries) {
        this._entries = entries ? new Map(entries) : /* @__PURE__ */ new Map();
    }
    BaggageImpl2.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return void 0;
        return Object.assign({}, entry);
    };
    BaggageImpl2.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a3) {
            var _b = $053b4050c185c268$var$__read3(_a3, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl2.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl2(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl2.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl2(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl2.prototype.removeEntries = function() {
        var e_1, _a3;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl2(this._entries);
        try {
            for(var keys_1 = $053b4050c185c268$var$__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a3 = keys_1.return)) _a3.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl2.prototype.clear = function() {
        return new BaggageImpl2();
    };
    return BaggageImpl2;
}();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/baggage/internal/symbol.js
var $053b4050c185c268$var$baggageEntryMetadataSymbol = Symbol("BaggageEntryMetadata");
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/baggage/utils.js
var $053b4050c185c268$var$diag = $053b4050c185c268$var$DiagAPI.instance();
function $053b4050c185c268$var$createBaggage(entries) {
    if (entries === void 0) entries = {};
    return new $053b4050c185c268$var$BaggageImpl(new Map(Object.entries(entries)));
}
function $053b4050c185c268$var$baggageEntryMetadataFromString(str) {
    if (typeof str !== "string") {
        $053b4050c185c268$var$diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = "";
    }
    return {
        __TYPE__: $053b4050c185c268$var$baggageEntryMetadataSymbol,
        toString: function() {
            return str;
        }
    };
}
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/context/context.js
function $053b4050c185c268$var$createContextKey(description) {
    return Symbol.for(description);
}
var $053b4050c185c268$var$BaseContext = /** @class */ /* @__PURE__ */ function() {
    function BaseContext2(parentContext) {
        var self2 = this;
        self2._currentContext = parentContext ? new Map(parentContext) : /* @__PURE__ */ new Map();
        self2.getValue = function(key) {
            return self2._currentContext.get(key);
        };
        self2.setValue = function(key, value) {
            var context2 = new BaseContext2(self2._currentContext);
            context2._currentContext.set(key, value);
            return context2;
        };
        self2.deleteValue = function(key) {
            var context2 = new BaseContext2(self2._currentContext);
            context2._currentContext.delete(key);
            return context2;
        };
    }
    return BaseContext2;
}();
var $053b4050c185c268$var$ROOT_CONTEXT = new $053b4050c185c268$var$BaseContext();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/metrics/NoopMeter.js
var $053b4050c185c268$var$__extends = /* @__PURE__ */ function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d2, b2) {
            d2.__proto__ = b2;
        } || function(d2, b2) {
            for(var p in b2)if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $053b4050c185c268$var$NoopMeter = /** @class */ function() {
    function NoopMeter2() {}
    NoopMeter2.prototype.createGauge = function(_name, _options) {
        return $053b4050c185c268$var$NOOP_GAUGE_METRIC;
    };
    NoopMeter2.prototype.createHistogram = function(_name, _options) {
        return $053b4050c185c268$var$NOOP_HISTOGRAM_METRIC;
    };
    NoopMeter2.prototype.createCounter = function(_name, _options) {
        return $053b4050c185c268$var$NOOP_COUNTER_METRIC;
    };
    NoopMeter2.prototype.createUpDownCounter = function(_name, _options) {
        return $053b4050c185c268$var$NOOP_UP_DOWN_COUNTER_METRIC;
    };
    NoopMeter2.prototype.createObservableGauge = function(_name, _options) {
        return $053b4050c185c268$var$NOOP_OBSERVABLE_GAUGE_METRIC;
    };
    NoopMeter2.prototype.createObservableCounter = function(_name, _options) {
        return $053b4050c185c268$var$NOOP_OBSERVABLE_COUNTER_METRIC;
    };
    NoopMeter2.prototype.createObservableUpDownCounter = function(_name, _options) {
        return $053b4050c185c268$var$NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC;
    };
    NoopMeter2.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    NoopMeter2.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter2;
}();
var $053b4050c185c268$var$NoopMetric = /** @class */ /* @__PURE__ */ function() {
    function NoopMetric2() {}
    return NoopMetric2;
}();
var $053b4050c185c268$var$NoopCounterMetric = /** @class */ function(_super) {
    $053b4050c185c268$var$__extends(NoopCounterMetric2, _super);
    function NoopCounterMetric2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric2.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric2;
}($053b4050c185c268$var$NoopMetric);
var $053b4050c185c268$var$NoopUpDownCounterMetric = /** @class */ function(_super) {
    $053b4050c185c268$var$__extends(NoopUpDownCounterMetric2, _super);
    function NoopUpDownCounterMetric2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric2.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric2;
}($053b4050c185c268$var$NoopMetric);
var $053b4050c185c268$var$NoopGaugeMetric = /** @class */ function(_super) {
    $053b4050c185c268$var$__extends(NoopGaugeMetric2, _super);
    function NoopGaugeMetric2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric2.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric2;
}($053b4050c185c268$var$NoopMetric);
var $053b4050c185c268$var$NoopHistogramMetric = /** @class */ function(_super) {
    $053b4050c185c268$var$__extends(NoopHistogramMetric2, _super);
    function NoopHistogramMetric2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric2.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric2;
}($053b4050c185c268$var$NoopMetric);
var $053b4050c185c268$var$NoopObservableMetric = /** @class */ function() {
    function NoopObservableMetric2() {}
    NoopObservableMetric2.prototype.addCallback = function(_callback) {};
    NoopObservableMetric2.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric2;
}();
var $053b4050c185c268$var$NoopObservableCounterMetric = /** @class */ function(_super) {
    $053b4050c185c268$var$__extends(NoopObservableCounterMetric2, _super);
    function NoopObservableCounterMetric2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric2;
}($053b4050c185c268$var$NoopObservableMetric);
var $053b4050c185c268$var$NoopObservableGaugeMetric = /** @class */ function(_super) {
    $053b4050c185c268$var$__extends(NoopObservableGaugeMetric2, _super);
    function NoopObservableGaugeMetric2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric2;
}($053b4050c185c268$var$NoopObservableMetric);
var $053b4050c185c268$var$NoopObservableUpDownCounterMetric = /** @class */ function(_super) {
    $053b4050c185c268$var$__extends(NoopObservableUpDownCounterMetric2, _super);
    function NoopObservableUpDownCounterMetric2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric2;
}($053b4050c185c268$var$NoopObservableMetric);
var $053b4050c185c268$var$NOOP_METER = new $053b4050c185c268$var$NoopMeter();
var $053b4050c185c268$var$NOOP_COUNTER_METRIC = new $053b4050c185c268$var$NoopCounterMetric();
var $053b4050c185c268$var$NOOP_GAUGE_METRIC = new $053b4050c185c268$var$NoopGaugeMetric();
var $053b4050c185c268$var$NOOP_HISTOGRAM_METRIC = new $053b4050c185c268$var$NoopHistogramMetric();
var $053b4050c185c268$var$NOOP_UP_DOWN_COUNTER_METRIC = new $053b4050c185c268$var$NoopUpDownCounterMetric();
var $053b4050c185c268$var$NOOP_OBSERVABLE_COUNTER_METRIC = new $053b4050c185c268$var$NoopObservableCounterMetric();
var $053b4050c185c268$var$NOOP_OBSERVABLE_GAUGE_METRIC = new $053b4050c185c268$var$NoopObservableGaugeMetric();
var $053b4050c185c268$var$NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC = new $053b4050c185c268$var$NoopObservableUpDownCounterMetric();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/propagation/TextMapPropagator.js
var $053b4050c185c268$var$defaultTextMapGetter = {
    get: function(carrier, key) {
        if (carrier == null) return void 0;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var $053b4050c185c268$var$defaultTextMapSetter = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/context/NoopContextManager.js
var $053b4050c185c268$var$__read4 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $053b4050c185c268$var$__spreadArray3 = function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $053b4050c185c268$var$NoopContextManager = /** @class */ function() {
    function NoopContextManager2() {}
    NoopContextManager2.prototype.active = function() {
        return $053b4050c185c268$var$ROOT_CONTEXT;
    };
    NoopContextManager2.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, $053b4050c185c268$var$__spreadArray3([
            thisArg
        ], $053b4050c185c268$var$__read4(args), false));
    };
    NoopContextManager2.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager2.prototype.enable = function() {
        return this;
    };
    NoopContextManager2.prototype.disable = function() {
        return this;
    };
    return NoopContextManager2;
}();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/api/context.js
var $053b4050c185c268$var$__read5 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $053b4050c185c268$var$__spreadArray4 = function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $053b4050c185c268$var$API_NAME2 = "context";
var $053b4050c185c268$var$NOOP_CONTEXT_MANAGER = new $053b4050c185c268$var$NoopContextManager();
var $053b4050c185c268$var$ContextAPI = /** @class */ function() {
    function ContextAPI2() {}
    ContextAPI2.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI2();
        return this._instance;
    };
    ContextAPI2.prototype.setGlobalContextManager = function(contextManager) {
        return $053b4050c185c268$var$registerGlobal($053b4050c185c268$var$API_NAME2, contextManager, $053b4050c185c268$var$DiagAPI.instance());
    };
    ContextAPI2.prototype.active = function() {
        return this._getContextManager().active();
    };
    ContextAPI2.prototype.with = function(context2, fn, thisArg) {
        var _a3;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a3 = this._getContextManager()).with.apply(_a3, $053b4050c185c268$var$__spreadArray4([
            context2,
            fn,
            thisArg
        ], $053b4050c185c268$var$__read5(args), false));
    };
    ContextAPI2.prototype.bind = function(context2, target) {
        return this._getContextManager().bind(context2, target);
    };
    ContextAPI2.prototype._getContextManager = function() {
        return $053b4050c185c268$var$getGlobal($053b4050c185c268$var$API_NAME2) || $053b4050c185c268$var$NOOP_CONTEXT_MANAGER;
    };
    ContextAPI2.prototype.disable = function() {
        this._getContextManager().disable();
        $053b4050c185c268$var$unregisterGlobal($053b4050c185c268$var$API_NAME2, $053b4050c185c268$var$DiagAPI.instance());
    };
    return ContextAPI2;
}();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/trace/trace_flags.js
var $053b4050c185c268$var$TraceFlags;
(function(TraceFlags2) {
    TraceFlags2[TraceFlags2["NONE"] = 0] = "NONE";
    TraceFlags2[TraceFlags2["SAMPLED"] = 1] = "SAMPLED";
})($053b4050c185c268$var$TraceFlags || ($053b4050c185c268$var$TraceFlags = {}));
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/trace/invalid-span-constants.js
var $053b4050c185c268$var$INVALID_SPANID = "0000000000000000";
var $053b4050c185c268$var$INVALID_TRACEID = "00000000000000000000000000000000";
var $053b4050c185c268$var$INVALID_SPAN_CONTEXT = {
    traceId: $053b4050c185c268$var$INVALID_TRACEID,
    spanId: $053b4050c185c268$var$INVALID_SPANID,
    traceFlags: $053b4050c185c268$var$TraceFlags.NONE
};
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/trace/NonRecordingSpan.js
var $053b4050c185c268$var$NonRecordingSpan = /** @class */ function() {
    function NonRecordingSpan2(_spanContext) {
        if (_spanContext === void 0) _spanContext = $053b4050c185c268$var$INVALID_SPAN_CONTEXT;
        this._spanContext = _spanContext;
    }
    NonRecordingSpan2.prototype.spanContext = function() {
        return this._spanContext;
    };
    NonRecordingSpan2.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    NonRecordingSpan2.prototype.setAttributes = function(_attributes) {
        return this;
    };
    NonRecordingSpan2.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan2.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan2.prototype.addLinks = function(_links) {
        return this;
    };
    NonRecordingSpan2.prototype.setStatus = function(_status) {
        return this;
    };
    NonRecordingSpan2.prototype.updateName = function(_name) {
        return this;
    };
    NonRecordingSpan2.prototype.end = function(_endTime) {};
    NonRecordingSpan2.prototype.isRecording = function() {
        return false;
    };
    NonRecordingSpan2.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan2;
}();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/trace/context-utils.js
var $053b4050c185c268$var$SPAN_KEY = $053b4050c185c268$var$createContextKey("OpenTelemetry Context Key SPAN");
function $053b4050c185c268$var$getSpan(context2) {
    return context2.getValue($053b4050c185c268$var$SPAN_KEY) || void 0;
}
function $053b4050c185c268$var$getActiveSpan() {
    return $053b4050c185c268$var$getSpan($053b4050c185c268$var$ContextAPI.getInstance().active());
}
function $053b4050c185c268$var$setSpan(context2, span) {
    return context2.setValue($053b4050c185c268$var$SPAN_KEY, span);
}
function $053b4050c185c268$var$deleteSpan(context2) {
    return context2.deleteValue($053b4050c185c268$var$SPAN_KEY);
}
function $053b4050c185c268$var$setSpanContext(context2, spanContext) {
    return $053b4050c185c268$var$setSpan(context2, new $053b4050c185c268$var$NonRecordingSpan(spanContext));
}
function $053b4050c185c268$var$getSpanContext(context2) {
    var _a3;
    return (_a3 = $053b4050c185c268$var$getSpan(context2)) === null || _a3 === void 0 ? void 0 : _a3.spanContext();
}
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/trace/spancontext-utils.js
var $053b4050c185c268$var$VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var $053b4050c185c268$var$VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function $053b4050c185c268$var$isValidTraceId(traceId) {
    return $053b4050c185c268$var$VALID_TRACEID_REGEX.test(traceId) && traceId !== $053b4050c185c268$var$INVALID_TRACEID;
}
function $053b4050c185c268$var$isValidSpanId(spanId) {
    return $053b4050c185c268$var$VALID_SPANID_REGEX.test(spanId) && spanId !== $053b4050c185c268$var$INVALID_SPANID;
}
function $053b4050c185c268$var$isSpanContextValid(spanContext) {
    return $053b4050c185c268$var$isValidTraceId(spanContext.traceId) && $053b4050c185c268$var$isValidSpanId(spanContext.spanId);
}
function $053b4050c185c268$var$wrapSpanContext(spanContext) {
    return new $053b4050c185c268$var$NonRecordingSpan(spanContext);
}
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/trace/NoopTracer.js
var $053b4050c185c268$var$contextApi = $053b4050c185c268$var$ContextAPI.getInstance();
var $053b4050c185c268$var$NoopTracer = /** @class */ function() {
    function NoopTracer2() {}
    NoopTracer2.prototype.startSpan = function(name, options, context2) {
        if (context2 === void 0) context2 = $053b4050c185c268$var$contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new $053b4050c185c268$var$NonRecordingSpan();
        var parentFromContext = context2 && $053b4050c185c268$var$getSpanContext(context2);
        if ($053b4050c185c268$var$isSpanContext(parentFromContext) && $053b4050c185c268$var$isSpanContextValid(parentFromContext)) return new $053b4050c185c268$var$NonRecordingSpan(parentFromContext);
        else return new $053b4050c185c268$var$NonRecordingSpan();
    };
    NoopTracer2.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $053b4050c185c268$var$contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = $053b4050c185c268$var$setSpan(parentContext, span);
        return $053b4050c185c268$var$contextApi.with(contextWithSpanSet, fn, void 0, span);
    };
    return NoopTracer2;
}();
function $053b4050c185c268$var$isSpanContext(spanContext) {
    return typeof spanContext === "object" && typeof spanContext["spanId"] === "string" && typeof spanContext["traceId"] === "string" && typeof spanContext["traceFlags"] === "number";
}
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/trace/ProxyTracer.js
var $053b4050c185c268$var$NOOP_TRACER = new $053b4050c185c268$var$NoopTracer();
var $053b4050c185c268$var$ProxyTracer = /** @class */ function() {
    function ProxyTracer2(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer2.prototype.startSpan = function(name, options, context2) {
        return this._getTracer().startSpan(name, options, context2);
    };
    ProxyTracer2.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    ProxyTracer2.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $053b4050c185c268$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer2;
}();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/trace/NoopTracerProvider.js
var $053b4050c185c268$var$NoopTracerProvider = /** @class */ function() {
    function NoopTracerProvider2() {}
    NoopTracerProvider2.prototype.getTracer = function(_name, _version, _options) {
        return new $053b4050c185c268$var$NoopTracer();
    };
    return NoopTracerProvider2;
}();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/trace/ProxyTracerProvider.js
var $053b4050c185c268$var$NOOP_TRACER_PROVIDER = new $053b4050c185c268$var$NoopTracerProvider();
var $053b4050c185c268$var$ProxyTracerProvider = /** @class */ function() {
    function ProxyTracerProvider2() {}
    ProxyTracerProvider2.prototype.getTracer = function(name, version, options) {
        var _a3;
        return (_a3 = this.getDelegateTracer(name, version, options)) !== null && _a3 !== void 0 ? _a3 : new $053b4050c185c268$var$ProxyTracer(this, name, version, options);
    };
    ProxyTracerProvider2.prototype.getDelegate = function() {
        var _a3;
        return (_a3 = this._delegate) !== null && _a3 !== void 0 ? _a3 : $053b4050c185c268$var$NOOP_TRACER_PROVIDER;
    };
    ProxyTracerProvider2.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider2.prototype.getDelegateTracer = function(name, version, options) {
        var _a3;
        return (_a3 = this._delegate) === null || _a3 === void 0 ? void 0 : _a3.getTracer(name, version, options);
    };
    return ProxyTracerProvider2;
}();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/trace/SamplingResult.js
var $053b4050c185c268$var$SamplingDecision;
(function(SamplingDecision3) {
    SamplingDecision3[SamplingDecision3["NOT_RECORD"] = 0] = "NOT_RECORD";
    SamplingDecision3[SamplingDecision3["RECORD"] = 1] = "RECORD";
    SamplingDecision3[SamplingDecision3["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})($053b4050c185c268$var$SamplingDecision || ($053b4050c185c268$var$SamplingDecision = {}));
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/trace/span_kind.js
var $053b4050c185c268$var$SpanKind;
(function(SpanKind2) {
    SpanKind2[SpanKind2["INTERNAL"] = 0] = "INTERNAL";
    SpanKind2[SpanKind2["SERVER"] = 1] = "SERVER";
    SpanKind2[SpanKind2["CLIENT"] = 2] = "CLIENT";
    SpanKind2[SpanKind2["PRODUCER"] = 3] = "PRODUCER";
    SpanKind2[SpanKind2["CONSUMER"] = 4] = "CONSUMER";
})($053b4050c185c268$var$SpanKind || ($053b4050c185c268$var$SpanKind = {}));
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/trace/status.js
var $053b4050c185c268$var$SpanStatusCode;
(function(SpanStatusCode2) {
    SpanStatusCode2[SpanStatusCode2["UNSET"] = 0] = "UNSET";
    SpanStatusCode2[SpanStatusCode2["OK"] = 1] = "OK";
    SpanStatusCode2[SpanStatusCode2["ERROR"] = 2] = "ERROR";
})($053b4050c185c268$var$SpanStatusCode || ($053b4050c185c268$var$SpanStatusCode = {}));
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/context-api.js
var $053b4050c185c268$var$context = $053b4050c185c268$var$ContextAPI.getInstance();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/diag-api.js
var $053b4050c185c268$var$diag2 = $053b4050c185c268$var$DiagAPI.instance();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/metrics/NoopMeterProvider.js
var $053b4050c185c268$var$NoopMeterProvider = /** @class */ function() {
    function NoopMeterProvider2() {}
    NoopMeterProvider2.prototype.getMeter = function(_name, _version, _options) {
        return $053b4050c185c268$var$NOOP_METER;
    };
    return NoopMeterProvider2;
}();
var $053b4050c185c268$var$NOOP_METER_PROVIDER = new $053b4050c185c268$var$NoopMeterProvider();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/api/metrics.js
var $053b4050c185c268$var$API_NAME3 = "metrics";
var $053b4050c185c268$var$MetricsAPI = /** @class */ function() {
    function MetricsAPI2() {}
    MetricsAPI2.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI2();
        return this._instance;
    };
    MetricsAPI2.prototype.setGlobalMeterProvider = function(provider) {
        return $053b4050c185c268$var$registerGlobal($053b4050c185c268$var$API_NAME3, provider, $053b4050c185c268$var$DiagAPI.instance());
    };
    MetricsAPI2.prototype.getMeterProvider = function() {
        return $053b4050c185c268$var$getGlobal($053b4050c185c268$var$API_NAME3) || $053b4050c185c268$var$NOOP_METER_PROVIDER;
    };
    MetricsAPI2.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    MetricsAPI2.prototype.disable = function() {
        $053b4050c185c268$var$unregisterGlobal($053b4050c185c268$var$API_NAME3, $053b4050c185c268$var$DiagAPI.instance());
    };
    return MetricsAPI2;
}();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/metrics-api.js
var $053b4050c185c268$var$metrics = $053b4050c185c268$var$MetricsAPI.getInstance();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/propagation/NoopTextMapPropagator.js
var $053b4050c185c268$var$NoopTextMapPropagator = /** @class */ function() {
    function NoopTextMapPropagator2() {}
    NoopTextMapPropagator2.prototype.inject = function(_context, _carrier) {};
    NoopTextMapPropagator2.prototype.extract = function(context2, _carrier) {
        return context2;
    };
    NoopTextMapPropagator2.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator2;
}();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/baggage/context-helpers.js
var $053b4050c185c268$var$BAGGAGE_KEY = $053b4050c185c268$var$createContextKey("OpenTelemetry Baggage Key");
function $053b4050c185c268$var$getBaggage(context2) {
    return context2.getValue($053b4050c185c268$var$BAGGAGE_KEY) || void 0;
}
function $053b4050c185c268$var$getActiveBaggage() {
    return $053b4050c185c268$var$getBaggage($053b4050c185c268$var$ContextAPI.getInstance().active());
}
function $053b4050c185c268$var$setBaggage(context2, baggage) {
    return context2.setValue($053b4050c185c268$var$BAGGAGE_KEY, baggage);
}
function $053b4050c185c268$var$deleteBaggage(context2) {
    return context2.deleteValue($053b4050c185c268$var$BAGGAGE_KEY);
}
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/api/propagation.js
var $053b4050c185c268$var$API_NAME4 = "propagation";
var $053b4050c185c268$var$NOOP_TEXT_MAP_PROPAGATOR = new $053b4050c185c268$var$NoopTextMapPropagator();
var $053b4050c185c268$var$PropagationAPI = /** @class */ function() {
    function PropagationAPI2() {
        this.createBaggage = $053b4050c185c268$var$createBaggage;
        this.getBaggage = $053b4050c185c268$var$getBaggage;
        this.getActiveBaggage = $053b4050c185c268$var$getActiveBaggage;
        this.setBaggage = $053b4050c185c268$var$setBaggage;
        this.deleteBaggage = $053b4050c185c268$var$deleteBaggage;
    }
    PropagationAPI2.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI2();
        return this._instance;
    };
    PropagationAPI2.prototype.setGlobalPropagator = function(propagator) {
        return $053b4050c185c268$var$registerGlobal($053b4050c185c268$var$API_NAME4, propagator, $053b4050c185c268$var$DiagAPI.instance());
    };
    PropagationAPI2.prototype.inject = function(context2, carrier, setter) {
        if (setter === void 0) setter = $053b4050c185c268$var$defaultTextMapSetter;
        return this._getGlobalPropagator().inject(context2, carrier, setter);
    };
    PropagationAPI2.prototype.extract = function(context2, carrier, getter) {
        if (getter === void 0) getter = $053b4050c185c268$var$defaultTextMapGetter;
        return this._getGlobalPropagator().extract(context2, carrier, getter);
    };
    PropagationAPI2.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    PropagationAPI2.prototype.disable = function() {
        $053b4050c185c268$var$unregisterGlobal($053b4050c185c268$var$API_NAME4, $053b4050c185c268$var$DiagAPI.instance());
    };
    PropagationAPI2.prototype._getGlobalPropagator = function() {
        return $053b4050c185c268$var$getGlobal($053b4050c185c268$var$API_NAME4) || $053b4050c185c268$var$NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI2;
}();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/propagation-api.js
var $053b4050c185c268$var$propagation = $053b4050c185c268$var$PropagationAPI.getInstance();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/api/trace.js
var $053b4050c185c268$var$API_NAME5 = "trace";
var $053b4050c185c268$var$TraceAPI = /** @class */ function() {
    function TraceAPI2() {
        this._proxyTracerProvider = new $053b4050c185c268$var$ProxyTracerProvider();
        this.wrapSpanContext = $053b4050c185c268$var$wrapSpanContext;
        this.isSpanContextValid = $053b4050c185c268$var$isSpanContextValid;
        this.deleteSpan = $053b4050c185c268$var$deleteSpan;
        this.getSpan = $053b4050c185c268$var$getSpan;
        this.getActiveSpan = $053b4050c185c268$var$getActiveSpan;
        this.getSpanContext = $053b4050c185c268$var$getSpanContext;
        this.setSpan = $053b4050c185c268$var$setSpan;
        this.setSpanContext = $053b4050c185c268$var$setSpanContext;
    }
    TraceAPI2.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI2();
        return this._instance;
    };
    TraceAPI2.prototype.setGlobalTracerProvider = function(provider) {
        var success = $053b4050c185c268$var$registerGlobal($053b4050c185c268$var$API_NAME5, this._proxyTracerProvider, $053b4050c185c268$var$DiagAPI.instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    TraceAPI2.prototype.getTracerProvider = function() {
        return $053b4050c185c268$var$getGlobal($053b4050c185c268$var$API_NAME5) || this._proxyTracerProvider;
    };
    TraceAPI2.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    TraceAPI2.prototype.disable = function() {
        $053b4050c185c268$var$unregisterGlobal($053b4050c185c268$var$API_NAME5, $053b4050c185c268$var$DiagAPI.instance());
        this._proxyTracerProvider = new $053b4050c185c268$var$ProxyTracerProvider();
    };
    return TraceAPI2;
}();
// ../../node_modules/.pnpm/@opentelemetry+api@1.9.0/node_modules/@opentelemetry/api/build/esm/trace-api.js
var $053b4050c185c268$var$trace = $053b4050c185c268$var$TraceAPI.getInstance();
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/trace/suppress-tracing.js
var $053b4050c185c268$var$SUPPRESS_TRACING_KEY = $053b4050c185c268$var$createContextKey("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function $053b4050c185c268$var$suppressTracing(context2) {
    return context2.setValue($053b4050c185c268$var$SUPPRESS_TRACING_KEY, true);
}
function $053b4050c185c268$var$isTracingSuppressed(context2) {
    return context2.getValue($053b4050c185c268$var$SUPPRESS_TRACING_KEY) === true;
}
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/baggage/constants.js
var $053b4050c185c268$var$BAGGAGE_KEY_PAIR_SEPARATOR = "=";
var $053b4050c185c268$var$BAGGAGE_PROPERTIES_SEPARATOR = ";";
var $053b4050c185c268$var$BAGGAGE_ITEMS_SEPARATOR = ",";
var $053b4050c185c268$var$BAGGAGE_HEADER = "baggage";
var $053b4050c185c268$var$BAGGAGE_MAX_NAME_VALUE_PAIRS = 180;
var $053b4050c185c268$var$BAGGAGE_MAX_PER_NAME_VALUE_PAIRS = 4096;
var $053b4050c185c268$var$BAGGAGE_MAX_TOTAL_LENGTH = 8192;
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/baggage/utils.js
var $053b4050c185c268$var$__read6 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $053b4050c185c268$var$serializeKeyPairs(keyPairs) {
    return keyPairs.reduce(function(hValue, current) {
        var value = "" + hValue + (hValue !== "" ? $053b4050c185c268$var$BAGGAGE_ITEMS_SEPARATOR : "") + current;
        return value.length > $053b4050c185c268$var$BAGGAGE_MAX_TOTAL_LENGTH ? hValue : value;
    }, "");
}
function $053b4050c185c268$var$getKeyPairs(baggage) {
    return baggage.getAllEntries().map(function(_a3) {
        var _b = $053b4050c185c268$var$__read6(_a3, 2), key = _b[0], value = _b[1];
        var entry = encodeURIComponent(key) + "=" + encodeURIComponent(value.value);
        if (value.metadata !== void 0) entry += $053b4050c185c268$var$BAGGAGE_PROPERTIES_SEPARATOR + value.metadata.toString();
        return entry;
    });
}
function $053b4050c185c268$var$parsePairKeyValue(entry) {
    var valueProps = entry.split($053b4050c185c268$var$BAGGAGE_PROPERTIES_SEPARATOR);
    if (valueProps.length <= 0) return;
    var keyPairPart = valueProps.shift();
    if (!keyPairPart) return;
    var separatorIndex = keyPairPart.indexOf($053b4050c185c268$var$BAGGAGE_KEY_PAIR_SEPARATOR);
    if (separatorIndex <= 0) return;
    var key = decodeURIComponent(keyPairPart.substring(0, separatorIndex).trim());
    var value = decodeURIComponent(keyPairPart.substring(separatorIndex + 1).trim());
    var metadata;
    if (valueProps.length > 0) metadata = $053b4050c185c268$var$baggageEntryMetadataFromString(valueProps.join($053b4050c185c268$var$BAGGAGE_PROPERTIES_SEPARATOR));
    return {
        key: key,
        value: value,
        metadata: metadata
    };
}
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/baggage/propagation/W3CBaggagePropagator.js
var $053b4050c185c268$var$W3CBaggagePropagator = /** @class */ function() {
    function W3CBaggagePropagator2() {}
    W3CBaggagePropagator2.prototype.inject = function(context2, carrier, setter) {
        var baggage = $053b4050c185c268$var$propagation.getBaggage(context2);
        if (!baggage || $053b4050c185c268$var$isTracingSuppressed(context2)) return;
        var keyPairs = $053b4050c185c268$var$getKeyPairs(baggage).filter(function(pair) {
            return pair.length <= $053b4050c185c268$var$BAGGAGE_MAX_PER_NAME_VALUE_PAIRS;
        }).slice(0, $053b4050c185c268$var$BAGGAGE_MAX_NAME_VALUE_PAIRS);
        var headerValue = $053b4050c185c268$var$serializeKeyPairs(keyPairs);
        if (headerValue.length > 0) setter.set(carrier, $053b4050c185c268$var$BAGGAGE_HEADER, headerValue);
    };
    W3CBaggagePropagator2.prototype.extract = function(context2, carrier, getter) {
        var headerValue = getter.get(carrier, $053b4050c185c268$var$BAGGAGE_HEADER);
        var baggageString = Array.isArray(headerValue) ? headerValue.join($053b4050c185c268$var$BAGGAGE_ITEMS_SEPARATOR) : headerValue;
        if (!baggageString) return context2;
        var baggage = {};
        if (baggageString.length === 0) return context2;
        var pairs = baggageString.split($053b4050c185c268$var$BAGGAGE_ITEMS_SEPARATOR);
        pairs.forEach(function(entry) {
            var keyPair = $053b4050c185c268$var$parsePairKeyValue(entry);
            if (keyPair) {
                var baggageEntry = {
                    value: keyPair.value
                };
                if (keyPair.metadata) baggageEntry.metadata = keyPair.metadata;
                baggage[keyPair.key] = baggageEntry;
            }
        });
        if (Object.entries(baggage).length === 0) return context2;
        return $053b4050c185c268$var$propagation.setBaggage(context2, $053b4050c185c268$var$propagation.createBaggage(baggage));
    };
    W3CBaggagePropagator2.prototype.fields = function() {
        return [
            $053b4050c185c268$var$BAGGAGE_HEADER
        ];
    };
    return W3CBaggagePropagator2;
}();
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/common/attributes.js
var $053b4050c185c268$var$__values2 = function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $053b4050c185c268$var$__read7 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $053b4050c185c268$var$sanitizeAttributes(attributes) {
    var e_1, _a3;
    var out = {};
    if (typeof attributes !== "object" || attributes == null) return out;
    try {
        for(var _b = $053b4050c185c268$var$__values2(Object.entries(attributes)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = $053b4050c185c268$var$__read7(_c.value, 2), key = _d[0], val = _d[1];
            if (!$053b4050c185c268$var$isAttributeKey(key)) {
                $053b4050c185c268$var$diag2.warn("Invalid attribute key: " + key);
                continue;
            }
            if (!$053b4050c185c268$var$isAttributeValue(val)) {
                $053b4050c185c268$var$diag2.warn("Invalid attribute value set for key: " + key);
                continue;
            }
            if (Array.isArray(val)) out[key] = val.slice();
            else out[key] = val;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a3 = _b.return)) _a3.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return out;
}
function $053b4050c185c268$var$isAttributeKey(key) {
    return typeof key === "string" && key.length > 0;
}
function $053b4050c185c268$var$isAttributeValue(val) {
    if (val == null) return true;
    if (Array.isArray(val)) return $053b4050c185c268$var$isHomogeneousAttributeValueArray(val);
    return $053b4050c185c268$var$isValidPrimitiveAttributeValue(val);
}
function $053b4050c185c268$var$isHomogeneousAttributeValueArray(arr) {
    var e_2, _a3;
    var type;
    try {
        for(var arr_1 = $053b4050c185c268$var$__values2(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()){
            var element = arr_1_1.value;
            if (element == null) continue;
            if (!type) {
                if ($053b4050c185c268$var$isValidPrimitiveAttributeValue(element)) {
                    type = typeof element;
                    continue;
                }
                return false;
            }
            if (typeof element === type) continue;
            return false;
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (arr_1_1 && !arr_1_1.done && (_a3 = arr_1.return)) _a3.call(arr_1);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    return true;
}
function $053b4050c185c268$var$isValidPrimitiveAttributeValue(val) {
    switch(typeof val){
        case "number":
        case "boolean":
        case "string":
            return true;
    }
    return false;
}
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/common/logging-error-handler.js
function $053b4050c185c268$var$loggingErrorHandler() {
    return function(ex) {
        $053b4050c185c268$var$diag2.error($053b4050c185c268$var$stringifyException(ex));
    };
}
function $053b4050c185c268$var$stringifyException(ex) {
    if (typeof ex === "string") return ex;
    else return JSON.stringify($053b4050c185c268$var$flattenException(ex));
}
function $053b4050c185c268$var$flattenException(ex) {
    var result = {};
    var current = ex;
    while(current !== null){
        Object.getOwnPropertyNames(current).forEach(function(propertyName) {
            if (result[propertyName]) return;
            var value = current[propertyName];
            if (value) result[propertyName] = String(value);
        });
        current = Object.getPrototypeOf(current);
    }
    return result;
}
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/common/global-error-handler.js
var $053b4050c185c268$var$delegateHandler = $053b4050c185c268$var$loggingErrorHandler();
function $053b4050c185c268$var$globalErrorHandler(ex) {
    try {
        $053b4050c185c268$var$delegateHandler(ex);
    } catch (_a3) {}
}
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/utils/sampling.js
var $053b4050c185c268$var$TracesSamplerValues;
(function(TracesSamplerValues2) {
    TracesSamplerValues2["AlwaysOff"] = "always_off";
    TracesSamplerValues2["AlwaysOn"] = "always_on";
    TracesSamplerValues2["ParentBasedAlwaysOff"] = "parentbased_always_off";
    TracesSamplerValues2["ParentBasedAlwaysOn"] = "parentbased_always_on";
    TracesSamplerValues2["ParentBasedTraceIdRatio"] = "parentbased_traceidratio";
    TracesSamplerValues2["TraceIdRatio"] = "traceidratio";
})($053b4050c185c268$var$TracesSamplerValues || ($053b4050c185c268$var$TracesSamplerValues = {}));
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/utils/environment.js
var $053b4050c185c268$var$DEFAULT_LIST_SEPARATOR = ",";
var $053b4050c185c268$var$ENVIRONMENT_BOOLEAN_KEYS = [
    "OTEL_SDK_DISABLED"
];
function $053b4050c185c268$var$isEnvVarABoolean(key) {
    return $053b4050c185c268$var$ENVIRONMENT_BOOLEAN_KEYS.indexOf(key) > -1;
}
var $053b4050c185c268$var$ENVIRONMENT_NUMBERS_KEYS = [
    "OTEL_BSP_EXPORT_TIMEOUT",
    "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
    "OTEL_BSP_MAX_QUEUE_SIZE",
    "OTEL_BSP_SCHEDULE_DELAY",
    "OTEL_BLRP_EXPORT_TIMEOUT",
    "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
    "OTEL_BLRP_MAX_QUEUE_SIZE",
    "OTEL_BLRP_SCHEDULE_DELAY",
    "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
    "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
    "OTEL_SPAN_EVENT_COUNT_LIMIT",
    "OTEL_SPAN_LINK_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
    "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
    "OTEL_EXPORTER_OTLP_TIMEOUT",
    "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
    "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
    "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
    "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function $053b4050c185c268$var$isEnvVarANumber(key) {
    return $053b4050c185c268$var$ENVIRONMENT_NUMBERS_KEYS.indexOf(key) > -1;
}
var $053b4050c185c268$var$ENVIRONMENT_LISTS_KEYS = [
    "OTEL_NO_PATCH_MODULES",
    "OTEL_PROPAGATORS",
    "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function $053b4050c185c268$var$isEnvVarAList(key) {
    return $053b4050c185c268$var$ENVIRONMENT_LISTS_KEYS.indexOf(key) > -1;
}
var $053b4050c185c268$var$DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT = Infinity;
var $053b4050c185c268$var$DEFAULT_ATTRIBUTE_COUNT_LIMIT = 128;
var $053b4050c185c268$var$DEFAULT_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT = 128;
var $053b4050c185c268$var$DEFAULT_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT = 128;
var $053b4050c185c268$var$DEFAULT_ENVIRONMENT = {
    OTEL_SDK_DISABLED: false,
    CONTAINER_NAME: "",
    ECS_CONTAINER_METADATA_URI_V4: "",
    ECS_CONTAINER_METADATA_URI: "",
    HOSTNAME: "",
    KUBERNETES_SERVICE_HOST: "",
    NAMESPACE: "",
    OTEL_BSP_EXPORT_TIMEOUT: 3e4,
    OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BSP_MAX_QUEUE_SIZE: 2048,
    OTEL_BSP_SCHEDULE_DELAY: 5e3,
    OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
    OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
    OTEL_BLRP_SCHEDULE_DELAY: 5e3,
    OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
    OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
    OTEL_EXPORTER_JAEGER_ENDPOINT: "",
    OTEL_EXPORTER_JAEGER_PASSWORD: "",
    OTEL_EXPORTER_JAEGER_USER: "",
    OTEL_EXPORTER_OTLP_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
    OTEL_EXPORTER_OTLP_HEADERS: "",
    OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
    OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
    OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
    OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
    OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
    OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
    OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
    OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
    OTEL_LOG_LEVEL: $053b4050c185c268$var$DiagLogLevel.INFO,
    OTEL_NO_PATCH_MODULES: [],
    OTEL_PROPAGATORS: [
        "tracecontext",
        "baggage"
    ],
    OTEL_RESOURCE_ATTRIBUTES: "",
    OTEL_SERVICE_NAME: "",
    OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: $053b4050c185c268$var$DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT,
    OTEL_ATTRIBUTE_COUNT_LIMIT: $053b4050c185c268$var$DEFAULT_ATTRIBUTE_COUNT_LIMIT,
    OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: $053b4050c185c268$var$DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT,
    OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: $053b4050c185c268$var$DEFAULT_ATTRIBUTE_COUNT_LIMIT,
    OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: $053b4050c185c268$var$DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT,
    OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: $053b4050c185c268$var$DEFAULT_ATTRIBUTE_COUNT_LIMIT,
    OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
    OTEL_SPAN_LINK_COUNT_LIMIT: 128,
    OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: $053b4050c185c268$var$DEFAULT_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
    OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: $053b4050c185c268$var$DEFAULT_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT,
    OTEL_TRACES_EXPORTER: "",
    OTEL_TRACES_SAMPLER: $053b4050c185c268$var$TracesSamplerValues.ParentBasedAlwaysOn,
    OTEL_TRACES_SAMPLER_ARG: "",
    OTEL_LOGS_EXPORTER: "",
    OTEL_EXPORTER_OTLP_INSECURE: "",
    OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
    OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
    OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
    OTEL_EXPORTER_OTLP_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
    OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
    OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
    OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
    OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
    OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function $053b4050c185c268$var$parseBoolean(key, environment, values) {
    if (typeof values[key] === "undefined") return;
    var value = String(values[key]);
    environment[key] = value.toLowerCase() === "true";
}
function $053b4050c185c268$var$parseNumber(name, environment, values, min, max) {
    if (min === void 0) min = -Infinity;
    if (max === void 0) max = Infinity;
    if (typeof values[name] !== "undefined") {
        var value = Number(values[name]);
        if (!isNaN(value)) {
            if (value < min) environment[name] = min;
            else if (value > max) environment[name] = max;
            else environment[name] = value;
        }
    }
}
function $053b4050c185c268$var$parseStringList(name, output, input, separator) {
    if (separator === void 0) separator = $053b4050c185c268$var$DEFAULT_LIST_SEPARATOR;
    var givenValue = input[name];
    if (typeof givenValue === "string") output[name] = givenValue.split(separator).map(function(v) {
        return v.trim();
    });
}
var $053b4050c185c268$var$logLevelMap = {
    ALL: $053b4050c185c268$var$DiagLogLevel.ALL,
    VERBOSE: $053b4050c185c268$var$DiagLogLevel.VERBOSE,
    DEBUG: $053b4050c185c268$var$DiagLogLevel.DEBUG,
    INFO: $053b4050c185c268$var$DiagLogLevel.INFO,
    WARN: $053b4050c185c268$var$DiagLogLevel.WARN,
    ERROR: $053b4050c185c268$var$DiagLogLevel.ERROR,
    NONE: $053b4050c185c268$var$DiagLogLevel.NONE
};
function $053b4050c185c268$var$setLogLevelFromEnv(key, environment, values) {
    var value = values[key];
    if (typeof value === "string") {
        var theLevel = $053b4050c185c268$var$logLevelMap[value.toUpperCase()];
        if (theLevel != null) environment[key] = theLevel;
    }
}
function $053b4050c185c268$var$parseEnvironment(values) {
    var environment = {};
    for(var env in $053b4050c185c268$var$DEFAULT_ENVIRONMENT){
        var key = env;
        switch(key){
            case "OTEL_LOG_LEVEL":
                $053b4050c185c268$var$setLogLevelFromEnv(key, environment, values);
                break;
            default:
                if ($053b4050c185c268$var$isEnvVarABoolean(key)) $053b4050c185c268$var$parseBoolean(key, environment, values);
                else if ($053b4050c185c268$var$isEnvVarANumber(key)) $053b4050c185c268$var$parseNumber(key, environment, values);
                else if ($053b4050c185c268$var$isEnvVarAList(key)) $053b4050c185c268$var$parseStringList(key, environment, values);
                else {
                    var value = values[key];
                    if (typeof value !== "undefined" && value !== null) environment[key] = String(value);
                }
        }
    }
    return environment;
}
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/platform/browser/globalThis.js
var $053b4050c185c268$var$_globalThis2 = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof $parcel$global === "object" ? $parcel$global : {};
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/platform/browser/environment.js
function $053b4050c185c268$var$getEnv() {
    var globalEnv = $053b4050c185c268$var$parseEnvironment($053b4050c185c268$var$_globalThis2);
    return Object.assign({}, $053b4050c185c268$var$DEFAULT_ENVIRONMENT, globalEnv);
}
function $053b4050c185c268$var$getEnvWithoutDefaults() {
    return $053b4050c185c268$var$parseEnvironment($053b4050c185c268$var$_globalThis2);
}
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/common/hex-to-binary.js
function $053b4050c185c268$var$intValue(charCode) {
    if (charCode >= 48 && charCode <= 57) return charCode - 48;
    if (charCode >= 97 && charCode <= 102) return charCode - 87;
    return charCode - 55;
}
function $053b4050c185c268$var$hexToBinary(hexStr) {
    var buf = new Uint8Array(hexStr.length / 2);
    var offset = 0;
    for(var i = 0; i < hexStr.length; i += 2){
        var hi = $053b4050c185c268$var$intValue(hexStr.charCodeAt(i));
        var lo = $053b4050c185c268$var$intValue(hexStr.charCodeAt(i + 1));
        buf[offset++] = hi << 4 | lo;
    }
    return buf;
}
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/platform/browser/performance.js
var $053b4050c185c268$var$otperformance = performance;
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/version.js
var $053b4050c185c268$var$VERSION2 = "1.30.1";
// ../../node_modules/.pnpm/@opentelemetry+semantic-conventions@1.28.0/node_modules/@opentelemetry/semantic-conventions/build/esm/trace/SemanticAttributes.js
var $053b4050c185c268$var$TMP_EXCEPTION_TYPE = "exception.type";
var $053b4050c185c268$var$TMP_EXCEPTION_MESSAGE = "exception.message";
var $053b4050c185c268$var$TMP_EXCEPTION_STACKTRACE = "exception.stacktrace";
var $053b4050c185c268$var$TMP_HTTP_METHOD = "http.method";
var $053b4050c185c268$var$TMP_HTTP_URL = "http.url";
var $053b4050c185c268$var$TMP_HTTP_HOST = "http.host";
var $053b4050c185c268$var$TMP_HTTP_SCHEME = "http.scheme";
var $053b4050c185c268$var$TMP_HTTP_STATUS_CODE = "http.status_code";
var $053b4050c185c268$var$TMP_HTTP_USER_AGENT = "http.user_agent";
var $053b4050c185c268$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = "http.request_content_length_uncompressed";
var $053b4050c185c268$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH = "http.response_content_length";
var $053b4050c185c268$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = "http.response_content_length_uncompressed";
var $053b4050c185c268$var$SEMATTRS_EXCEPTION_TYPE = $053b4050c185c268$var$TMP_EXCEPTION_TYPE;
var $053b4050c185c268$var$SEMATTRS_EXCEPTION_MESSAGE = $053b4050c185c268$var$TMP_EXCEPTION_MESSAGE;
var $053b4050c185c268$var$SEMATTRS_EXCEPTION_STACKTRACE = $053b4050c185c268$var$TMP_EXCEPTION_STACKTRACE;
var $053b4050c185c268$var$SEMATTRS_HTTP_METHOD = $053b4050c185c268$var$TMP_HTTP_METHOD;
var $053b4050c185c268$var$SEMATTRS_HTTP_URL = $053b4050c185c268$var$TMP_HTTP_URL;
var $053b4050c185c268$var$SEMATTRS_HTTP_HOST = $053b4050c185c268$var$TMP_HTTP_HOST;
var $053b4050c185c268$var$SEMATTRS_HTTP_SCHEME = $053b4050c185c268$var$TMP_HTTP_SCHEME;
var $053b4050c185c268$var$SEMATTRS_HTTP_STATUS_CODE = $053b4050c185c268$var$TMP_HTTP_STATUS_CODE;
var $053b4050c185c268$var$SEMATTRS_HTTP_USER_AGENT = $053b4050c185c268$var$TMP_HTTP_USER_AGENT;
var $053b4050c185c268$var$SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = $053b4050c185c268$var$TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED;
var $053b4050c185c268$var$SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH = $053b4050c185c268$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH;
var $053b4050c185c268$var$SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = $053b4050c185c268$var$TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED;
// ../../node_modules/.pnpm/@opentelemetry+semantic-conventions@1.28.0/node_modules/@opentelemetry/semantic-conventions/build/esm/resource/SemanticResourceAttributes.js
var $053b4050c185c268$var$TMP_PROCESS_RUNTIME_NAME = "process.runtime.name";
var $053b4050c185c268$var$TMP_SERVICE_NAME = "service.name";
var $053b4050c185c268$var$TMP_TELEMETRY_SDK_NAME = "telemetry.sdk.name";
var $053b4050c185c268$var$TMP_TELEMETRY_SDK_LANGUAGE = "telemetry.sdk.language";
var $053b4050c185c268$var$TMP_TELEMETRY_SDK_VERSION = "telemetry.sdk.version";
var $053b4050c185c268$var$SEMRESATTRS_PROCESS_RUNTIME_NAME = $053b4050c185c268$var$TMP_PROCESS_RUNTIME_NAME;
var $053b4050c185c268$var$SEMRESATTRS_SERVICE_NAME = $053b4050c185c268$var$TMP_SERVICE_NAME;
var $053b4050c185c268$var$SEMRESATTRS_TELEMETRY_SDK_NAME = $053b4050c185c268$var$TMP_TELEMETRY_SDK_NAME;
var $053b4050c185c268$var$SEMRESATTRS_TELEMETRY_SDK_LANGUAGE = $053b4050c185c268$var$TMP_TELEMETRY_SDK_LANGUAGE;
var $053b4050c185c268$var$SEMRESATTRS_TELEMETRY_SDK_VERSION = $053b4050c185c268$var$TMP_TELEMETRY_SDK_VERSION;
var $053b4050c185c268$var$TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS = "webjs";
var $053b4050c185c268$var$TELEMETRYSDKLANGUAGEVALUES_WEBJS = $053b4050c185c268$var$TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS;
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/platform/browser/sdk-info.js
var $053b4050c185c268$var$_a;
var $053b4050c185c268$var$SDK_INFO = ($053b4050c185c268$var$_a = {}, $053b4050c185c268$var$_a[$053b4050c185c268$var$SEMRESATTRS_TELEMETRY_SDK_NAME] = "opentelemetry", $053b4050c185c268$var$_a[$053b4050c185c268$var$SEMRESATTRS_PROCESS_RUNTIME_NAME] = "browser", $053b4050c185c268$var$_a[$053b4050c185c268$var$SEMRESATTRS_TELEMETRY_SDK_LANGUAGE] = $053b4050c185c268$var$TELEMETRYSDKLANGUAGEVALUES_WEBJS, $053b4050c185c268$var$_a[$053b4050c185c268$var$SEMRESATTRS_TELEMETRY_SDK_VERSION] = $053b4050c185c268$var$VERSION2, $053b4050c185c268$var$_a);
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/platform/browser/timer-util.js
function $053b4050c185c268$var$unrefTimer(_timer) {}
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/common/time.js
var $053b4050c185c268$var$NANOSECOND_DIGITS = 9;
var $053b4050c185c268$var$NANOSECOND_DIGITS_IN_MILLIS = 6;
var $053b4050c185c268$var$MILLISECONDS_TO_NANOSECONDS = Math.pow(10, $053b4050c185c268$var$NANOSECOND_DIGITS_IN_MILLIS);
var $053b4050c185c268$var$SECOND_TO_NANOSECONDS = Math.pow(10, $053b4050c185c268$var$NANOSECOND_DIGITS);
function $053b4050c185c268$var$millisToHrTime(epochMillis) {
    var epochSeconds = epochMillis / 1e3;
    var seconds = Math.trunc(epochSeconds);
    var nanos = Math.round(epochMillis % 1e3 * $053b4050c185c268$var$MILLISECONDS_TO_NANOSECONDS);
    return [
        seconds,
        nanos
    ];
}
function $053b4050c185c268$var$getTimeOrigin() {
    var timeOrigin = $053b4050c185c268$var$otperformance.timeOrigin;
    if (typeof timeOrigin !== "number") {
        var perf = $053b4050c185c268$var$otperformance;
        timeOrigin = perf.timing && perf.timing.fetchStart;
    }
    return timeOrigin;
}
function $053b4050c185c268$var$hrTime(performanceNow) {
    var timeOrigin = $053b4050c185c268$var$millisToHrTime($053b4050c185c268$var$getTimeOrigin());
    var now = $053b4050c185c268$var$millisToHrTime(typeof performanceNow === "number" ? performanceNow : $053b4050c185c268$var$otperformance.now());
    return $053b4050c185c268$var$addHrTimes(timeOrigin, now);
}
function $053b4050c185c268$var$timeInputToHrTime(time) {
    if ($053b4050c185c268$var$isTimeInputHrTime(time)) return time;
    else if (typeof time === "number") {
        if (time < $053b4050c185c268$var$getTimeOrigin()) return $053b4050c185c268$var$hrTime(time);
        else return $053b4050c185c268$var$millisToHrTime(time);
    } else if (time instanceof Date) return $053b4050c185c268$var$millisToHrTime(time.getTime());
    else throw TypeError("Invalid input type");
}
function $053b4050c185c268$var$hrTimeDuration(startTime, endTime) {
    var seconds = endTime[0] - startTime[0];
    var nanos = endTime[1] - startTime[1];
    if (nanos < 0) {
        seconds -= 1;
        nanos += $053b4050c185c268$var$SECOND_TO_NANOSECONDS;
    }
    return [
        seconds,
        nanos
    ];
}
function $053b4050c185c268$var$hrTimeToNanoseconds(time) {
    return time[0] * $053b4050c185c268$var$SECOND_TO_NANOSECONDS + time[1];
}
function $053b4050c185c268$var$isTimeInputHrTime(value) {
    return Array.isArray(value) && value.length === 2 && typeof value[0] === "number" && typeof value[1] === "number";
}
function $053b4050c185c268$var$isTimeInput(value) {
    return $053b4050c185c268$var$isTimeInputHrTime(value) || typeof value === "number" || value instanceof Date;
}
function $053b4050c185c268$var$addHrTimes(time1, time2) {
    var out = [
        time1[0] + time2[0],
        time1[1] + time2[1]
    ];
    if (out[1] >= $053b4050c185c268$var$SECOND_TO_NANOSECONDS) {
        out[1] -= $053b4050c185c268$var$SECOND_TO_NANOSECONDS;
        out[0] += 1;
    }
    return out;
}
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/ExportResult.js
var $053b4050c185c268$var$ExportResultCode;
(function(ExportResultCode2) {
    ExportResultCode2[ExportResultCode2["SUCCESS"] = 0] = "SUCCESS";
    ExportResultCode2[ExportResultCode2["FAILED"] = 1] = "FAILED";
})($053b4050c185c268$var$ExportResultCode || ($053b4050c185c268$var$ExportResultCode = {}));
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/propagation/composite.js
var $053b4050c185c268$var$__values3 = function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $053b4050c185c268$var$CompositePropagator = /** @class */ function() {
    function CompositePropagator2(config) {
        if (config === void 0) config = {};
        var _a3;
        this._propagators = (_a3 = config.propagators) !== null && _a3 !== void 0 ? _a3 : [];
        this._fields = Array.from(new Set(this._propagators.map(function(p) {
            return typeof p.fields === "function" ? p.fields() : [];
        }).reduce(function(x, y) {
            return x.concat(y);
        }, [])));
    }
    CompositePropagator2.prototype.inject = function(context2, carrier, setter) {
        var e_1, _a3;
        try {
            for(var _b = $053b4050c185c268$var$__values3(this._propagators), _c = _b.next(); !_c.done; _c = _b.next()){
                var propagator = _c.value;
                try {
                    propagator.inject(context2, carrier, setter);
                } catch (err) {
                    $053b4050c185c268$var$diag2.warn("Failed to inject with " + propagator.constructor.name + ". Err: " + err.message);
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a3 = _b.return)) _a3.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    CompositePropagator2.prototype.extract = function(context2, carrier, getter) {
        return this._propagators.reduce(function(ctx, propagator) {
            try {
                return propagator.extract(ctx, carrier, getter);
            } catch (err) {
                $053b4050c185c268$var$diag2.warn("Failed to extract with " + propagator.constructor.name + ". Err: " + err.message);
            }
            return ctx;
        }, context2);
    };
    CompositePropagator2.prototype.fields = function() {
        return this._fields.slice();
    };
    return CompositePropagator2;
}();
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/internal/validators.js
var $053b4050c185c268$var$VALID_KEY_CHAR_RANGE = "[_0-9a-z-*/]";
var $053b4050c185c268$var$VALID_KEY = "[a-z]" + $053b4050c185c268$var$VALID_KEY_CHAR_RANGE + "{0,255}";
var $053b4050c185c268$var$VALID_VENDOR_KEY = "[a-z0-9]" + $053b4050c185c268$var$VALID_KEY_CHAR_RANGE + "{0,240}@[a-z]" + $053b4050c185c268$var$VALID_KEY_CHAR_RANGE + "{0,13}";
var $053b4050c185c268$var$VALID_KEY_REGEX = new RegExp("^(?:" + $053b4050c185c268$var$VALID_KEY + "|" + $053b4050c185c268$var$VALID_VENDOR_KEY + ")$");
var $053b4050c185c268$var$VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
var $053b4050c185c268$var$INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
function $053b4050c185c268$var$validateKey(key) {
    return $053b4050c185c268$var$VALID_KEY_REGEX.test(key);
}
function $053b4050c185c268$var$validateValue(value) {
    return $053b4050c185c268$var$VALID_VALUE_BASE_REGEX.test(value) && !$053b4050c185c268$var$INVALID_VALUE_COMMA_EQUAL_REGEX.test(value);
}
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/trace/TraceState.js
var $053b4050c185c268$var$MAX_TRACE_STATE_ITEMS = 32;
var $053b4050c185c268$var$MAX_TRACE_STATE_LEN = 512;
var $053b4050c185c268$var$LIST_MEMBERS_SEPARATOR = ",";
var $053b4050c185c268$var$LIST_MEMBER_KEY_VALUE_SPLITTER = "=";
var $053b4050c185c268$var$TraceState = /** @class */ function() {
    function TraceState2(rawTraceState) {
        this._internalState = /* @__PURE__ */ new Map();
        if (rawTraceState) this._parse(rawTraceState);
    }
    TraceState2.prototype.set = function(key, value) {
        var traceState = this._clone();
        if (traceState._internalState.has(key)) traceState._internalState.delete(key);
        traceState._internalState.set(key, value);
        return traceState;
    };
    TraceState2.prototype.unset = function(key) {
        var traceState = this._clone();
        traceState._internalState.delete(key);
        return traceState;
    };
    TraceState2.prototype.get = function(key) {
        return this._internalState.get(key);
    };
    TraceState2.prototype.serialize = function() {
        var _this = this;
        return this._keys().reduce(function(agg, key) {
            agg.push(key + $053b4050c185c268$var$LIST_MEMBER_KEY_VALUE_SPLITTER + _this.get(key));
            return agg;
        }, []).join($053b4050c185c268$var$LIST_MEMBERS_SEPARATOR);
    };
    TraceState2.prototype._parse = function(rawTraceState) {
        if (rawTraceState.length > $053b4050c185c268$var$MAX_TRACE_STATE_LEN) return;
        this._internalState = rawTraceState.split($053b4050c185c268$var$LIST_MEMBERS_SEPARATOR).reverse().reduce(function(agg, part) {
            var listMember = part.trim();
            var i = listMember.indexOf($053b4050c185c268$var$LIST_MEMBER_KEY_VALUE_SPLITTER);
            if (i !== -1) {
                var key = listMember.slice(0, i);
                var value = listMember.slice(i + 1, part.length);
                if ($053b4050c185c268$var$validateKey(key) && $053b4050c185c268$var$validateValue(value)) agg.set(key, value);
            }
            return agg;
        }, /* @__PURE__ */ new Map());
        if (this._internalState.size > $053b4050c185c268$var$MAX_TRACE_STATE_ITEMS) this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, $053b4050c185c268$var$MAX_TRACE_STATE_ITEMS));
    };
    TraceState2.prototype._keys = function() {
        return Array.from(this._internalState.keys()).reverse();
    };
    TraceState2.prototype._clone = function() {
        var traceState = new TraceState2();
        traceState._internalState = new Map(this._internalState);
        return traceState;
    };
    return TraceState2;
}();
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/trace/W3CTraceContextPropagator.js
var $053b4050c185c268$var$TRACE_PARENT_HEADER = "traceparent";
var $053b4050c185c268$var$TRACE_STATE_HEADER = "tracestate";
var $053b4050c185c268$var$VERSION3 = "00";
var $053b4050c185c268$var$VERSION_PART = "(?!ff)[\\da-f]{2}";
var $053b4050c185c268$var$TRACE_ID_PART = "(?![0]{32})[\\da-f]{32}";
var $053b4050c185c268$var$PARENT_ID_PART = "(?![0]{16})[\\da-f]{16}";
var $053b4050c185c268$var$FLAGS_PART = "[\\da-f]{2}";
var $053b4050c185c268$var$TRACE_PARENT_REGEX = new RegExp("^\\s?(" + $053b4050c185c268$var$VERSION_PART + ")-(" + $053b4050c185c268$var$TRACE_ID_PART + ")-(" + $053b4050c185c268$var$PARENT_ID_PART + ")-(" + $053b4050c185c268$var$FLAGS_PART + ")(-.*)?\\s?$");
function $053b4050c185c268$var$parseTraceParent(traceParent) {
    var match = $053b4050c185c268$var$TRACE_PARENT_REGEX.exec(traceParent);
    if (!match) return null;
    if (match[1] === "00" && match[5]) return null;
    return {
        traceId: match[2],
        spanId: match[3],
        traceFlags: parseInt(match[4], 16)
    };
}
var $053b4050c185c268$var$W3CTraceContextPropagator = /** @class */ function() {
    function W3CTraceContextPropagator3() {}
    W3CTraceContextPropagator3.prototype.inject = function(context2, carrier, setter) {
        var spanContext = $053b4050c185c268$var$trace.getSpanContext(context2);
        if (!spanContext || $053b4050c185c268$var$isTracingSuppressed(context2) || !$053b4050c185c268$var$isSpanContextValid(spanContext)) return;
        var traceParent = $053b4050c185c268$var$VERSION3 + "-" + spanContext.traceId + "-" + spanContext.spanId + "-0" + Number(spanContext.traceFlags || $053b4050c185c268$var$TraceFlags.NONE).toString(16);
        setter.set(carrier, $053b4050c185c268$var$TRACE_PARENT_HEADER, traceParent);
        if (spanContext.traceState) setter.set(carrier, $053b4050c185c268$var$TRACE_STATE_HEADER, spanContext.traceState.serialize());
    };
    W3CTraceContextPropagator3.prototype.extract = function(context2, carrier, getter) {
        var traceParentHeader = getter.get(carrier, $053b4050c185c268$var$TRACE_PARENT_HEADER);
        if (!traceParentHeader) return context2;
        var traceParent = Array.isArray(traceParentHeader) ? traceParentHeader[0] : traceParentHeader;
        if (typeof traceParent !== "string") return context2;
        var spanContext = $053b4050c185c268$var$parseTraceParent(traceParent);
        if (!spanContext) return context2;
        spanContext.isRemote = true;
        var traceStateHeader = getter.get(carrier, $053b4050c185c268$var$TRACE_STATE_HEADER);
        if (traceStateHeader) {
            var state = Array.isArray(traceStateHeader) ? traceStateHeader.join(",") : traceStateHeader;
            spanContext.traceState = new $053b4050c185c268$var$TraceState(typeof state === "string" ? state : void 0);
        }
        return $053b4050c185c268$var$trace.setSpanContext(context2, spanContext);
    };
    W3CTraceContextPropagator3.prototype.fields = function() {
        return [
            $053b4050c185c268$var$TRACE_PARENT_HEADER,
            $053b4050c185c268$var$TRACE_STATE_HEADER
        ];
    };
    return W3CTraceContextPropagator3;
}();
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/utils/lodash.merge.js
var $053b4050c185c268$var$objectTag = "[object Object]";
var $053b4050c185c268$var$nullTag = "[object Null]";
var $053b4050c185c268$var$undefinedTag = "[object Undefined]";
var $053b4050c185c268$var$funcProto = Function.prototype;
var $053b4050c185c268$var$funcToString = $053b4050c185c268$var$funcProto.toString;
var $053b4050c185c268$var$objectCtorString = $053b4050c185c268$var$funcToString.call(Object);
var $053b4050c185c268$var$getPrototype = $053b4050c185c268$var$overArg(Object.getPrototypeOf, Object);
var $053b4050c185c268$var$objectProto = Object.prototype;
var $053b4050c185c268$var$hasOwnProperty = $053b4050c185c268$var$objectProto.hasOwnProperty;
var $053b4050c185c268$var$symToStringTag = Symbol ? Symbol.toStringTag : void 0;
var $053b4050c185c268$var$nativeObjectToString = $053b4050c185c268$var$objectProto.toString;
function $053b4050c185c268$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
function $053b4050c185c268$var$isPlainObject(value) {
    if (!$053b4050c185c268$var$isObjectLike(value) || $053b4050c185c268$var$baseGetTag(value) !== $053b4050c185c268$var$objectTag) return false;
    var proto = $053b4050c185c268$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $053b4050c185c268$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $053b4050c185c268$var$funcToString.call(Ctor) === $053b4050c185c268$var$objectCtorString;
}
function $053b4050c185c268$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
function $053b4050c185c268$var$baseGetTag(value) {
    if (value == null) return value === void 0 ? $053b4050c185c268$var$undefinedTag : $053b4050c185c268$var$nullTag;
    return $053b4050c185c268$var$symToStringTag && $053b4050c185c268$var$symToStringTag in Object(value) ? $053b4050c185c268$var$getRawTag(value) : $053b4050c185c268$var$objectToString(value);
}
function $053b4050c185c268$var$getRawTag(value) {
    var isOwn = $053b4050c185c268$var$hasOwnProperty.call(value, $053b4050c185c268$var$symToStringTag), tag = value[$053b4050c185c268$var$symToStringTag];
    var unmasked = false;
    try {
        value[$053b4050c185c268$var$symToStringTag] = void 0;
        unmasked = true;
    } catch (e) {}
    var result = $053b4050c185c268$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$053b4050c185c268$var$symToStringTag] = tag;
        else delete value[$053b4050c185c268$var$symToStringTag];
    }
    return result;
}
function $053b4050c185c268$var$objectToString(value) {
    return $053b4050c185c268$var$nativeObjectToString.call(value);
}
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/utils/merge.js
var $053b4050c185c268$var$MAX_LEVEL = 20;
function $053b4050c185c268$var$merge() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var result = args.shift();
    var objects = /* @__PURE__ */ new WeakMap();
    while(args.length > 0)result = $053b4050c185c268$var$mergeTwoObjects(result, args.shift(), 0, objects);
    return result;
}
function $053b4050c185c268$var$takeValue(value) {
    if ($053b4050c185c268$var$isArray(value)) return value.slice();
    return value;
}
function $053b4050c185c268$var$mergeTwoObjects(one, two, level, objects) {
    if (level === void 0) level = 0;
    var result;
    if (level > $053b4050c185c268$var$MAX_LEVEL) return void 0;
    level++;
    if ($053b4050c185c268$var$isPrimitive(one) || $053b4050c185c268$var$isPrimitive(two) || $053b4050c185c268$var$isFunction(two)) result = $053b4050c185c268$var$takeValue(two);
    else if ($053b4050c185c268$var$isArray(one)) {
        result = one.slice();
        if ($053b4050c185c268$var$isArray(two)) for(var i = 0, j = two.length; i < j; i++)result.push($053b4050c185c268$var$takeValue(two[i]));
        else if ($053b4050c185c268$var$isObject(two)) {
            var keys = Object.keys(two);
            for(var i = 0, j = keys.length; i < j; i++){
                var key = keys[i];
                result[key] = $053b4050c185c268$var$takeValue(two[key]);
            }
        }
    } else if ($053b4050c185c268$var$isObject(one)) {
        if ($053b4050c185c268$var$isObject(two)) {
            if (!$053b4050c185c268$var$shouldMerge(one, two)) return two;
            result = Object.assign({}, one);
            var keys = Object.keys(two);
            for(var i = 0, j = keys.length; i < j; i++){
                var key = keys[i];
                var twoValue = two[key];
                if ($053b4050c185c268$var$isPrimitive(twoValue)) {
                    if (typeof twoValue === "undefined") delete result[key];
                    else result[key] = twoValue;
                } else {
                    var obj1 = result[key];
                    var obj2 = twoValue;
                    if ($053b4050c185c268$var$wasObjectReferenced(one, key, objects) || $053b4050c185c268$var$wasObjectReferenced(two, key, objects)) delete result[key];
                    else {
                        if ($053b4050c185c268$var$isObject(obj1) && $053b4050c185c268$var$isObject(obj2)) {
                            var arr1 = objects.get(obj1) || [];
                            var arr2 = objects.get(obj2) || [];
                            arr1.push({
                                obj: one,
                                key: key
                            });
                            arr2.push({
                                obj: two,
                                key: key
                            });
                            objects.set(obj1, arr1);
                            objects.set(obj2, arr2);
                        }
                        result[key] = $053b4050c185c268$var$mergeTwoObjects(result[key], twoValue, level, objects);
                    }
                }
            }
        } else result = two;
    }
    return result;
}
function $053b4050c185c268$var$wasObjectReferenced(obj, key, objects) {
    var arr = objects.get(obj[key]) || [];
    for(var i = 0, j = arr.length; i < j; i++){
        var info = arr[i];
        if (info.key === key && info.obj === obj) return true;
    }
    return false;
}
function $053b4050c185c268$var$isArray(value) {
    return Array.isArray(value);
}
function $053b4050c185c268$var$isFunction(value) {
    return typeof value === "function";
}
function $053b4050c185c268$var$isObject(value) {
    return !$053b4050c185c268$var$isPrimitive(value) && !$053b4050c185c268$var$isArray(value) && !$053b4050c185c268$var$isFunction(value) && typeof value === "object";
}
function $053b4050c185c268$var$isPrimitive(value) {
    return typeof value === "string" || typeof value === "number" || typeof value === "boolean" || typeof value === "undefined" || value instanceof Date || value instanceof RegExp || value === null;
}
function $053b4050c185c268$var$shouldMerge(one, two) {
    if (!$053b4050c185c268$var$isPlainObject(one) || !$053b4050c185c268$var$isPlainObject(two)) return false;
    return true;
}
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/utils/url.js
var $053b4050c185c268$var$__values4 = function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $053b4050c185c268$var$urlMatches(url, urlToMatch) {
    if (typeof urlToMatch === "string") return url === urlToMatch;
    else return !!url.match(urlToMatch);
}
function $053b4050c185c268$var$isUrlIgnored(url, ignoredUrls) {
    var e_1, _a3;
    if (!ignoredUrls) return false;
    try {
        for(var ignoredUrls_1 = $053b4050c185c268$var$__values4(ignoredUrls), ignoredUrls_1_1 = ignoredUrls_1.next(); !ignoredUrls_1_1.done; ignoredUrls_1_1 = ignoredUrls_1.next()){
            var ignoreUrl = ignoredUrls_1_1.value;
            if ($053b4050c185c268$var$urlMatches(url, ignoreUrl)) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (ignoredUrls_1_1 && !ignoredUrls_1_1.done && (_a3 = ignoredUrls_1.return)) _a3.call(ignoredUrls_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
}
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/utils/promise.js
var $053b4050c185c268$var$Deferred = /** @class */ function() {
    function Deferred2() {
        var _this = this;
        this._promise = new Promise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
    }
    Object.defineProperty(Deferred2.prototype, "promise", {
        get: function() {
            return this._promise;
        },
        enumerable: false,
        configurable: true
    });
    Deferred2.prototype.resolve = function(val) {
        this._resolve(val);
    };
    Deferred2.prototype.reject = function(err) {
        this._reject(err);
    };
    return Deferred2;
}();
// ../../node_modules/.pnpm/@opentelemetry+core@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/utils/callback.js
var $053b4050c185c268$var$__read8 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $053b4050c185c268$var$__spreadArray5 = function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $053b4050c185c268$var$BindOnceFuture = /** @class */ function() {
    function BindOnceFuture2(_callback, _that) {
        this._callback = _callback;
        this._that = _that;
        this._isCalled = false;
        this._deferred = new $053b4050c185c268$var$Deferred();
    }
    Object.defineProperty(BindOnceFuture2.prototype, "isCalled", {
        get: function() {
            return this._isCalled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BindOnceFuture2.prototype, "promise", {
        get: function() {
            return this._deferred.promise;
        },
        enumerable: false,
        configurable: true
    });
    BindOnceFuture2.prototype.call = function() {
        var _a3;
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._isCalled) {
            this._isCalled = true;
            try {
                Promise.resolve((_a3 = this._callback).call.apply(_a3, $053b4050c185c268$var$__spreadArray5([
                    this._that
                ], $053b4050c185c268$var$__read8(args), false))).then(function(val) {
                    return _this._deferred.resolve(val);
                }, function(err) {
                    return _this._deferred.reject(err);
                });
            } catch (err) {
                this._deferred.reject(err);
            }
        }
        return this._deferred.promise;
    };
    return BindOnceFuture2;
}();
// ../../node_modules/.pnpm/@opentelemetry+context-zone-peer-dep@1.30.1_@opentelemetry+api@1.9.0_zone.js@0.15.1/node_modules/@opentelemetry/context-zone-peer-dep/build/esm/util.js
function $053b4050c185c268$var$isListenerObject(obj) {
    if (obj === void 0) obj = {};
    return typeof obj.addEventListener === "function" && typeof obj.removeEventListener === "function";
}
// ../../node_modules/.pnpm/@opentelemetry+context-zone-peer-dep@1.30.1_@opentelemetry+api@1.9.0_zone.js@0.15.1/node_modules/@opentelemetry/context-zone-peer-dep/build/esm/ZoneContextManager.js
var $053b4050c185c268$var$ZONE_CONTEXT_KEY = "OT_ZONE_CONTEXT";
var $053b4050c185c268$var$ZoneContextManager = /** @class */ function() {
    function ZoneContextManager2() {
        this._enabled = false;
        this._zoneCounter = 0;
    }
    ZoneContextManager2.prototype._activeContextFromZone = function(activeZone) {
        return activeZone && activeZone.get($053b4050c185c268$var$ZONE_CONTEXT_KEY) || $053b4050c185c268$var$ROOT_CONTEXT;
    };
    ZoneContextManager2.prototype._bindFunction = function(context2, target) {
        var manager = this;
        var contextWrapper = function() {
            var _this = this;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return manager.with(context2, function() {
                return target.apply(_this, args);
            });
        };
        Object.defineProperty(contextWrapper, "length", {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    };
    ZoneContextManager2.prototype._bindListener = function(context2, obj) {
        var target = obj;
        if (target.__ot_listeners !== void 0) return obj;
        target.__ot_listeners = {};
        if (typeof target.addEventListener === "function") target.addEventListener = this._patchAddEventListener(target, target.addEventListener, context2);
        if (typeof target.removeEventListener === "function") target.removeEventListener = this._patchRemoveEventListener(target, target.removeEventListener);
        return obj;
    };
    ZoneContextManager2.prototype._createZoneName = function() {
        this._zoneCounter++;
        var random = Math.random();
        return this._zoneCounter + "-" + random;
    };
    ZoneContextManager2.prototype._createZone = function(zoneName, context2) {
        var _a3;
        return Zone.current.fork({
            name: zoneName,
            properties: (_a3 = {}, _a3[$053b4050c185c268$var$ZONE_CONTEXT_KEY] = context2, _a3)
        });
    };
    ZoneContextManager2.prototype._getActiveZone = function() {
        return Zone.current;
    };
    ZoneContextManager2.prototype._patchAddEventListener = function(target, original, context2) {
        var contextManager = this;
        return function(event, listener, opts) {
            if (target.__ot_listeners === void 0) target.__ot_listeners = {};
            var listeners = target.__ot_listeners[event];
            if (listeners === void 0) {
                listeners = /* @__PURE__ */ new WeakMap();
                target.__ot_listeners[event] = listeners;
            }
            var patchedListener = contextManager.bind(context2, listener);
            listeners.set(listener, patchedListener);
            return original.call(this, event, patchedListener, opts);
        };
    };
    ZoneContextManager2.prototype._patchRemoveEventListener = function(target, original) {
        return function(event, listener) {
            if (target.__ot_listeners === void 0 || target.__ot_listeners[event] === void 0) return original.call(this, event, listener);
            var events = target.__ot_listeners[event];
            var patchedListener = events.get(listener);
            events.delete(listener);
            return original.call(this, event, patchedListener || listener);
        };
    };
    ZoneContextManager2.prototype.active = function() {
        if (!this._enabled) return $053b4050c185c268$var$ROOT_CONTEXT;
        var activeZone = this._getActiveZone();
        var active = this._activeContextFromZone(activeZone);
        if (active) return active;
        return $053b4050c185c268$var$ROOT_CONTEXT;
    };
    ZoneContextManager2.prototype.bind = function(context2, target) {
        if (context2 === void 0) context2 = this.active();
        if (typeof target === "function") return this._bindFunction(context2, target);
        else if ($053b4050c185c268$var$isListenerObject(target)) this._bindListener(context2, target);
        return target;
    };
    ZoneContextManager2.prototype.disable = function() {
        this._enabled = false;
        return this;
    };
    ZoneContextManager2.prototype.enable = function() {
        this._enabled = true;
        return this;
    };
    ZoneContextManager2.prototype.with = function(context2, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        var zoneName = this._createZoneName();
        var newZone = this._createZone(zoneName, context2);
        return newZone.run(fn, thisArg, args);
    };
    return ZoneContextManager2;
}();
// ../../node_modules/.pnpm/zone.js@0.15.1/node_modules/zone.js/fesm2015/zone.js
var $053b4050c185c268$var$global2 = globalThis;
function $053b4050c185c268$var$__symbol__(name) {
    const symbolPrefix = $053b4050c185c268$var$global2["__Zone_symbol_prefix"] || "__zone_symbol__";
    return symbolPrefix + name;
}
function $053b4050c185c268$var$initZone() {
    const performance2 = $053b4050c185c268$var$global2["performance"];
    function mark(name) {
        performance2 && performance2["mark"] && performance2["mark"](name);
    }
    function performanceMeasure(name, label) {
        performance2 && performance2["measure"] && performance2["measure"](name, label);
    }
    mark("Zone");
    const _ZoneImpl = class _ZoneImpl {
        constructor(parent, zoneSpec){
            $053b4050c185c268$var$__publicField(this, "_parent");
            $053b4050c185c268$var$__publicField(this, "_name");
            $053b4050c185c268$var$__publicField(this, "_properties");
            $053b4050c185c268$var$__publicField(this, "_zoneDelegate");
            this._parent = parent;
            this._name = zoneSpec ? zoneSpec.name || "unnamed" : "<root>";
            this._properties = zoneSpec && zoneSpec.properties || {};
            this._zoneDelegate = new _ZoneDelegate(this, this._parent && this._parent._zoneDelegate, zoneSpec);
        }
        static assertZonePatched() {
            if ($053b4050c185c268$var$global2["Promise"] !== patches["ZoneAwarePromise"]) throw new Error("Zone.js has detected that ZoneAwarePromise `(window|global).Promise` has been overwritten.\nMost likely cause is that a Promise polyfill has been loaded after Zone.js (Polyfilling Promise api is not necessary when zone.js is loaded. If you must load one, do so before loading zone.js.)");
        }
        static get root() {
            let zone = _ZoneImpl.current;
            while(zone.parent)zone = zone.parent;
            return zone;
        }
        static get current() {
            return _currentZoneFrame.zone;
        }
        static get currentTask() {
            return _currentTask;
        }
        static __load_patch(name, fn, ignoreDuplicate = false) {
            if (patches.hasOwnProperty(name)) {
                const checkDuplicate = $053b4050c185c268$var$global2[$053b4050c185c268$var$__symbol__("forceDuplicateZoneCheck")] === true;
                if (!ignoreDuplicate && checkDuplicate) throw Error("Already loaded patch: " + name);
            } else if (!$053b4050c185c268$var$global2["__Zone_disable_" + name]) {
                const perfName = "Zone:" + name;
                mark(perfName);
                patches[name] = fn($053b4050c185c268$var$global2, _ZoneImpl, _api);
                performanceMeasure(perfName, perfName);
            }
        }
        get parent() {
            return this._parent;
        }
        get name() {
            return this._name;
        }
        get(key) {
            const zone = this.getZoneWith(key);
            if (zone) return zone._properties[key];
        }
        getZoneWith(key) {
            let current = this;
            while(current){
                if (current._properties.hasOwnProperty(key)) return current;
                current = current._parent;
            }
            return null;
        }
        fork(zoneSpec) {
            if (!zoneSpec) throw new Error("ZoneSpec required!");
            return this._zoneDelegate.fork(this, zoneSpec);
        }
        wrap(callback, source) {
            if (typeof callback !== "function") throw new Error("Expecting function got: " + callback);
            const _callback = this._zoneDelegate.intercept(this, callback, source);
            const zone = this;
            return function() {
                return zone.runGuarded(_callback, this, arguments, source);
            };
        }
        run(callback, applyThis, applyArgs, source) {
            _currentZoneFrame = {
                parent: _currentZoneFrame,
                zone: this
            };
            try {
                return this._zoneDelegate.invoke(this, callback, applyThis, applyArgs, source);
            } finally{
                _currentZoneFrame = _currentZoneFrame.parent;
            }
        }
        runGuarded(callback, applyThis = null, applyArgs, source) {
            _currentZoneFrame = {
                parent: _currentZoneFrame,
                zone: this
            };
            try {
                try {
                    return this._zoneDelegate.invoke(this, callback, applyThis, applyArgs, source);
                } catch (error) {
                    if (this._zoneDelegate.handleError(this, error)) throw error;
                }
            } finally{
                _currentZoneFrame = _currentZoneFrame.parent;
            }
        }
        runTask(task, applyThis, applyArgs) {
            if (task.zone != this) throw new Error("A task can only be run in the zone of creation! (Creation: " + (task.zone || NO_ZONE).name + "; Execution: " + this.name + ")");
            const zoneTask = task;
            const { type: type, data: { isPeriodic: isPeriodic = false, isRefreshable: isRefreshable = false } = {} } = task;
            if (task.state === notScheduled && (type === eventTask || type === macroTask)) return;
            const reEntryGuard = task.state != running;
            reEntryGuard && zoneTask._transitionTo(running, scheduled);
            const previousTask = _currentTask;
            _currentTask = zoneTask;
            _currentZoneFrame = {
                parent: _currentZoneFrame,
                zone: this
            };
            try {
                if (type == macroTask && task.data && !isPeriodic && !isRefreshable) task.cancelFn = void 0;
                try {
                    return this._zoneDelegate.invokeTask(this, zoneTask, applyThis, applyArgs);
                } catch (error) {
                    if (this._zoneDelegate.handleError(this, error)) throw error;
                }
            } finally{
                const state = task.state;
                if (state !== notScheduled && state !== unknown) {
                    if (type == eventTask || isPeriodic || isRefreshable && state === scheduling) reEntryGuard && zoneTask._transitionTo(scheduled, running, scheduling);
                    else {
                        const zoneDelegates = zoneTask._zoneDelegates;
                        this._updateTaskCount(zoneTask, -1);
                        reEntryGuard && zoneTask._transitionTo(notScheduled, running, notScheduled);
                        if (isRefreshable) zoneTask._zoneDelegates = zoneDelegates;
                    }
                }
                _currentZoneFrame = _currentZoneFrame.parent;
                _currentTask = previousTask;
            }
        }
        scheduleTask(task) {
            if (task.zone && task.zone !== this) {
                let newZone = this;
                while(newZone){
                    if (newZone === task.zone) throw Error(`can not reschedule task to ${this.name} which is descendants of the original zone ${task.zone.name}`);
                    newZone = newZone.parent;
                }
            }
            task._transitionTo(scheduling, notScheduled);
            const zoneDelegates = [];
            task._zoneDelegates = zoneDelegates;
            task._zone = this;
            try {
                task = this._zoneDelegate.scheduleTask(this, task);
            } catch (err) {
                task._transitionTo(unknown, scheduling, notScheduled);
                this._zoneDelegate.handleError(this, err);
                throw err;
            }
            if (task._zoneDelegates === zoneDelegates) this._updateTaskCount(task, 1);
            if (task.state == scheduling) task._transitionTo(scheduled, scheduling);
            return task;
        }
        scheduleMicroTask(source, callback, data, customSchedule) {
            return this.scheduleTask(new ZoneTask(microTask, source, callback, data, customSchedule, void 0));
        }
        scheduleMacroTask(source, callback, data, customSchedule, customCancel) {
            return this.scheduleTask(new ZoneTask(macroTask, source, callback, data, customSchedule, customCancel));
        }
        scheduleEventTask(source, callback, data, customSchedule, customCancel) {
            return this.scheduleTask(new ZoneTask(eventTask, source, callback, data, customSchedule, customCancel));
        }
        cancelTask(task) {
            if (task.zone != this) throw new Error("A task can only be cancelled in the zone of creation! (Creation: " + (task.zone || NO_ZONE).name + "; Execution: " + this.name + ")");
            if (task.state !== scheduled && task.state !== running) return;
            task._transitionTo(canceling, scheduled, running);
            try {
                this._zoneDelegate.cancelTask(this, task);
            } catch (err) {
                task._transitionTo(unknown, canceling);
                this._zoneDelegate.handleError(this, err);
                throw err;
            }
            this._updateTaskCount(task, -1);
            task._transitionTo(notScheduled, canceling);
            task.runCount = -1;
            return task;
        }
        _updateTaskCount(task, count) {
            const zoneDelegates = task._zoneDelegates;
            if (count == -1) task._zoneDelegates = null;
            for(let i = 0; i < zoneDelegates.length; i++)zoneDelegates[i]._updateTaskCount(task.type, count);
        }
    };
    $053b4050c185c268$var$__publicField(_ZoneImpl, "__symbol__", $053b4050c185c268$var$__symbol__);
    let ZoneImpl = _ZoneImpl;
    const DELEGATE_ZS = {
        name: "",
        onHasTask: (delegate, _, target, hasTaskState)=>delegate.hasTask(target, hasTaskState),
        onScheduleTask: (delegate, _, target, task)=>delegate.scheduleTask(target, task),
        onInvokeTask: (delegate, _, target, task, applyThis, applyArgs)=>delegate.invokeTask(target, task, applyThis, applyArgs),
        onCancelTask: (delegate, _, target, task)=>delegate.cancelTask(target, task)
    };
    class _ZoneDelegate {
        constructor(zone, parentDelegate, zoneSpec){
            $053b4050c185c268$var$__publicField(this, "_zone");
            $053b4050c185c268$var$__publicField(this, "_taskCounts", {
                "microTask": 0,
                "macroTask": 0,
                "eventTask": 0
            });
            $053b4050c185c268$var$__publicField(this, "_parentDelegate");
            $053b4050c185c268$var$__publicField(this, "_forkDlgt");
            $053b4050c185c268$var$__publicField(this, "_forkZS");
            $053b4050c185c268$var$__publicField(this, "_forkCurrZone");
            $053b4050c185c268$var$__publicField(this, "_interceptDlgt");
            $053b4050c185c268$var$__publicField(this, "_interceptZS");
            $053b4050c185c268$var$__publicField(this, "_interceptCurrZone");
            $053b4050c185c268$var$__publicField(this, "_invokeDlgt");
            $053b4050c185c268$var$__publicField(this, "_invokeZS");
            $053b4050c185c268$var$__publicField(this, "_invokeCurrZone");
            $053b4050c185c268$var$__publicField(this, "_handleErrorDlgt");
            $053b4050c185c268$var$__publicField(this, "_handleErrorZS");
            $053b4050c185c268$var$__publicField(this, "_handleErrorCurrZone");
            $053b4050c185c268$var$__publicField(this, "_scheduleTaskDlgt");
            $053b4050c185c268$var$__publicField(this, "_scheduleTaskZS");
            $053b4050c185c268$var$__publicField(this, "_scheduleTaskCurrZone");
            $053b4050c185c268$var$__publicField(this, "_invokeTaskDlgt");
            $053b4050c185c268$var$__publicField(this, "_invokeTaskZS");
            $053b4050c185c268$var$__publicField(this, "_invokeTaskCurrZone");
            $053b4050c185c268$var$__publicField(this, "_cancelTaskDlgt");
            $053b4050c185c268$var$__publicField(this, "_cancelTaskZS");
            $053b4050c185c268$var$__publicField(this, "_cancelTaskCurrZone");
            $053b4050c185c268$var$__publicField(this, "_hasTaskDlgt");
            $053b4050c185c268$var$__publicField(this, "_hasTaskDlgtOwner");
            $053b4050c185c268$var$__publicField(this, "_hasTaskZS");
            $053b4050c185c268$var$__publicField(this, "_hasTaskCurrZone");
            this._zone = zone;
            this._parentDelegate = parentDelegate;
            this._forkZS = zoneSpec && (zoneSpec && zoneSpec.onFork ? zoneSpec : parentDelegate._forkZS);
            this._forkDlgt = zoneSpec && (zoneSpec.onFork ? parentDelegate : parentDelegate._forkDlgt);
            this._forkCurrZone = zoneSpec && (zoneSpec.onFork ? this._zone : parentDelegate._forkCurrZone);
            this._interceptZS = zoneSpec && (zoneSpec.onIntercept ? zoneSpec : parentDelegate._interceptZS);
            this._interceptDlgt = zoneSpec && (zoneSpec.onIntercept ? parentDelegate : parentDelegate._interceptDlgt);
            this._interceptCurrZone = zoneSpec && (zoneSpec.onIntercept ? this._zone : parentDelegate._interceptCurrZone);
            this._invokeZS = zoneSpec && (zoneSpec.onInvoke ? zoneSpec : parentDelegate._invokeZS);
            this._invokeDlgt = zoneSpec && (zoneSpec.onInvoke ? parentDelegate : parentDelegate._invokeDlgt);
            this._invokeCurrZone = zoneSpec && (zoneSpec.onInvoke ? this._zone : parentDelegate._invokeCurrZone);
            this._handleErrorZS = zoneSpec && (zoneSpec.onHandleError ? zoneSpec : parentDelegate._handleErrorZS);
            this._handleErrorDlgt = zoneSpec && (zoneSpec.onHandleError ? parentDelegate : parentDelegate._handleErrorDlgt);
            this._handleErrorCurrZone = zoneSpec && (zoneSpec.onHandleError ? this._zone : parentDelegate._handleErrorCurrZone);
            this._scheduleTaskZS = zoneSpec && (zoneSpec.onScheduleTask ? zoneSpec : parentDelegate._scheduleTaskZS);
            this._scheduleTaskDlgt = zoneSpec && (zoneSpec.onScheduleTask ? parentDelegate : parentDelegate._scheduleTaskDlgt);
            this._scheduleTaskCurrZone = zoneSpec && (zoneSpec.onScheduleTask ? this._zone : parentDelegate._scheduleTaskCurrZone);
            this._invokeTaskZS = zoneSpec && (zoneSpec.onInvokeTask ? zoneSpec : parentDelegate._invokeTaskZS);
            this._invokeTaskDlgt = zoneSpec && (zoneSpec.onInvokeTask ? parentDelegate : parentDelegate._invokeTaskDlgt);
            this._invokeTaskCurrZone = zoneSpec && (zoneSpec.onInvokeTask ? this._zone : parentDelegate._invokeTaskCurrZone);
            this._cancelTaskZS = zoneSpec && (zoneSpec.onCancelTask ? zoneSpec : parentDelegate._cancelTaskZS);
            this._cancelTaskDlgt = zoneSpec && (zoneSpec.onCancelTask ? parentDelegate : parentDelegate._cancelTaskDlgt);
            this._cancelTaskCurrZone = zoneSpec && (zoneSpec.onCancelTask ? this._zone : parentDelegate._cancelTaskCurrZone);
            this._hasTaskZS = null;
            this._hasTaskDlgt = null;
            this._hasTaskDlgtOwner = null;
            this._hasTaskCurrZone = null;
            const zoneSpecHasTask = zoneSpec && zoneSpec.onHasTask;
            const parentHasTask = parentDelegate && parentDelegate._hasTaskZS;
            if (zoneSpecHasTask || parentHasTask) {
                this._hasTaskZS = zoneSpecHasTask ? zoneSpec : DELEGATE_ZS;
                this._hasTaskDlgt = parentDelegate;
                this._hasTaskDlgtOwner = this;
                this._hasTaskCurrZone = this._zone;
                if (!zoneSpec.onScheduleTask) {
                    this._scheduleTaskZS = DELEGATE_ZS;
                    this._scheduleTaskDlgt = parentDelegate;
                    this._scheduleTaskCurrZone = this._zone;
                }
                if (!zoneSpec.onInvokeTask) {
                    this._invokeTaskZS = DELEGATE_ZS;
                    this._invokeTaskDlgt = parentDelegate;
                    this._invokeTaskCurrZone = this._zone;
                }
                if (!zoneSpec.onCancelTask) {
                    this._cancelTaskZS = DELEGATE_ZS;
                    this._cancelTaskDlgt = parentDelegate;
                    this._cancelTaskCurrZone = this._zone;
                }
            }
        }
        get zone() {
            return this._zone;
        }
        fork(targetZone, zoneSpec) {
            return this._forkZS ? this._forkZS.onFork(this._forkDlgt, this.zone, targetZone, zoneSpec) : new ZoneImpl(targetZone, zoneSpec);
        }
        intercept(targetZone, callback, source) {
            return this._interceptZS ? this._interceptZS.onIntercept(this._interceptDlgt, this._interceptCurrZone, targetZone, callback, source) : callback;
        }
        invoke(targetZone, callback, applyThis, applyArgs, source) {
            return this._invokeZS ? this._invokeZS.onInvoke(this._invokeDlgt, this._invokeCurrZone, targetZone, callback, applyThis, applyArgs, source) : callback.apply(applyThis, applyArgs);
        }
        handleError(targetZone, error) {
            return this._handleErrorZS ? this._handleErrorZS.onHandleError(this._handleErrorDlgt, this._handleErrorCurrZone, targetZone, error) : true;
        }
        scheduleTask(targetZone, task) {
            let returnTask = task;
            if (this._scheduleTaskZS) {
                if (this._hasTaskZS) returnTask._zoneDelegates.push(this._hasTaskDlgtOwner);
                returnTask = this._scheduleTaskZS.onScheduleTask(this._scheduleTaskDlgt, this._scheduleTaskCurrZone, targetZone, task);
                if (!returnTask) returnTask = task;
            } else {
                if (task.scheduleFn) task.scheduleFn(task);
                else if (task.type == microTask) scheduleMicroTask(task);
                else throw new Error("Task is missing scheduleFn.");
            }
            return returnTask;
        }
        invokeTask(targetZone, task, applyThis, applyArgs) {
            return this._invokeTaskZS ? this._invokeTaskZS.onInvokeTask(this._invokeTaskDlgt, this._invokeTaskCurrZone, targetZone, task, applyThis, applyArgs) : task.callback.apply(applyThis, applyArgs);
        }
        cancelTask(targetZone, task) {
            let value;
            if (this._cancelTaskZS) value = this._cancelTaskZS.onCancelTask(this._cancelTaskDlgt, this._cancelTaskCurrZone, targetZone, task);
            else {
                if (!task.cancelFn) throw Error("Task is not cancelable");
                value = task.cancelFn(task);
            }
            return value;
        }
        hasTask(targetZone, isEmpty) {
            try {
                this._hasTaskZS && this._hasTaskZS.onHasTask(this._hasTaskDlgt, this._hasTaskCurrZone, targetZone, isEmpty);
            } catch (err) {
                this.handleError(targetZone, err);
            }
        }
        _updateTaskCount(type, count) {
            const counts = this._taskCounts;
            const prev = counts[type];
            const next = counts[type] = prev + count;
            if (next < 0) throw new Error("More tasks executed then were scheduled.");
            if (prev == 0 || next == 0) {
                const isEmpty = {
                    microTask: counts["microTask"] > 0,
                    macroTask: counts["macroTask"] > 0,
                    eventTask: counts["eventTask"] > 0,
                    change: type
                };
                this.hasTask(this._zone, isEmpty);
            }
        }
    }
    class ZoneTask {
        constructor(type, source, callback, options, scheduleFn, cancelFn){
            $053b4050c185c268$var$__publicField(this, "type");
            $053b4050c185c268$var$__publicField(this, "source");
            $053b4050c185c268$var$__publicField(this, "invoke");
            $053b4050c185c268$var$__publicField(this, "callback");
            $053b4050c185c268$var$__publicField(this, "data");
            $053b4050c185c268$var$__publicField(this, "scheduleFn");
            $053b4050c185c268$var$__publicField(this, "cancelFn");
            $053b4050c185c268$var$__publicField(this, "_zone", null);
            $053b4050c185c268$var$__publicField(this, "runCount", 0);
            $053b4050c185c268$var$__publicField(this, "_zoneDelegates", null);
            $053b4050c185c268$var$__publicField(this, "_state", "notScheduled");
            this.type = type;
            this.source = source;
            this.data = options;
            this.scheduleFn = scheduleFn;
            this.cancelFn = cancelFn;
            if (!callback) throw new Error("callback is not defined");
            this.callback = callback;
            const self2 = this;
            if (type === eventTask && options && options.useG) this.invoke = ZoneTask.invokeTask;
            else this.invoke = function() {
                return ZoneTask.invokeTask.call($053b4050c185c268$var$global2, self2, this, arguments);
            };
        }
        static invokeTask(task, target, args) {
            if (!task) task = this;
            _numberOfNestedTaskFrames++;
            try {
                task.runCount++;
                return task.zone.runTask(task, target, args);
            } finally{
                if (_numberOfNestedTaskFrames == 1) drainMicroTaskQueue();
                _numberOfNestedTaskFrames--;
            }
        }
        get zone() {
            return this._zone;
        }
        get state() {
            return this._state;
        }
        cancelScheduleRequest() {
            this._transitionTo(notScheduled, scheduling);
        }
        _transitionTo(toState, fromState1, fromState2) {
            if (this._state === fromState1 || this._state === fromState2) {
                this._state = toState;
                if (toState == notScheduled) this._zoneDelegates = null;
            } else throw new Error(`${this.type} '${this.source}': can not transition to '${toState}', expecting state '${fromState1}'${fromState2 ? " or '" + fromState2 + "'" : ""}, was '${this._state}'.`);
        }
        toString() {
            if (this.data && typeof this.data.handleId !== "undefined") return this.data.handleId.toString();
            else return Object.prototype.toString.call(this);
        }
        // add toJSON method to prevent cyclic error when
        // call JSON.stringify(zoneTask)
        toJSON() {
            return {
                type: this.type,
                state: this.state,
                source: this.source,
                zone: this.zone.name,
                runCount: this.runCount
            };
        }
    }
    const symbolSetTimeout = $053b4050c185c268$var$__symbol__("setTimeout");
    const symbolPromise = $053b4050c185c268$var$__symbol__("Promise");
    const symbolThen = $053b4050c185c268$var$__symbol__("then");
    let _microTaskQueue = [];
    let _isDrainingMicrotaskQueue = false;
    let nativeMicroTaskQueuePromise;
    function nativeScheduleMicroTask(func) {
        if (!nativeMicroTaskQueuePromise) {
            if ($053b4050c185c268$var$global2[symbolPromise]) nativeMicroTaskQueuePromise = $053b4050c185c268$var$global2[symbolPromise].resolve(0);
        }
        if (nativeMicroTaskQueuePromise) {
            let nativeThen = nativeMicroTaskQueuePromise[symbolThen];
            if (!nativeThen) nativeThen = nativeMicroTaskQueuePromise["then"];
            nativeThen.call(nativeMicroTaskQueuePromise, func);
        } else $053b4050c185c268$var$global2[symbolSetTimeout](func, 0);
    }
    function scheduleMicroTask(task) {
        if (_numberOfNestedTaskFrames === 0 && _microTaskQueue.length === 0) nativeScheduleMicroTask(drainMicroTaskQueue);
        task && _microTaskQueue.push(task);
    }
    function drainMicroTaskQueue() {
        if (!_isDrainingMicrotaskQueue) {
            _isDrainingMicrotaskQueue = true;
            while(_microTaskQueue.length){
                const queue = _microTaskQueue;
                _microTaskQueue = [];
                for(let i = 0; i < queue.length; i++){
                    const task = queue[i];
                    try {
                        task.zone.runTask(task, null, null);
                    } catch (error) {
                        _api.onUnhandledError(error);
                    }
                }
            }
            _api.microtaskDrainDone();
            _isDrainingMicrotaskQueue = false;
        }
    }
    const NO_ZONE = {
        name: "NO ZONE"
    };
    const notScheduled = "notScheduled", scheduling = "scheduling", scheduled = "scheduled", running = "running", canceling = "canceling", unknown = "unknown";
    const microTask = "microTask", macroTask = "macroTask", eventTask = "eventTask";
    const patches = {};
    const _api = {
        symbol: $053b4050c185c268$var$__symbol__,
        currentZoneFrame: ()=>_currentZoneFrame,
        onUnhandledError: noop,
        microtaskDrainDone: noop,
        scheduleMicroTask: scheduleMicroTask,
        showUncaughtError: ()=>!ZoneImpl[$053b4050c185c268$var$__symbol__("ignoreConsoleErrorUncaughtError")],
        patchEventTarget: ()=>[],
        patchOnProperties: noop,
        patchMethod: ()=>noop,
        bindArguments: ()=>[],
        patchThen: ()=>noop,
        patchMacroTask: ()=>noop,
        patchEventPrototype: ()=>noop,
        isIEOrEdge: ()=>false,
        getGlobalObjects: ()=>void 0,
        ObjectDefineProperty: ()=>noop,
        ObjectGetOwnPropertyDescriptor: ()=>void 0,
        ObjectCreate: ()=>void 0,
        ArraySlice: ()=>[],
        patchClass: ()=>noop,
        wrapWithCurrentZone: ()=>noop,
        filterProperties: ()=>[],
        attachOriginToPatched: ()=>noop,
        _redefineProperty: ()=>noop,
        patchCallbacks: ()=>noop,
        nativeScheduleMicroTask: nativeScheduleMicroTask
    };
    let _currentZoneFrame = {
        parent: null,
        zone: new ZoneImpl(null, null)
    };
    let _currentTask = null;
    let _numberOfNestedTaskFrames = 0;
    function noop() {}
    performanceMeasure("Zone", "Zone");
    return ZoneImpl;
}
function $053b4050c185c268$var$loadZone() {
    const global3 = globalThis;
    const checkDuplicate = global3[$053b4050c185c268$var$__symbol__("forceDuplicateZoneCheck")] === true;
    if (global3["Zone"] && (checkDuplicate || typeof global3["Zone"].__symbol__ !== "function")) throw new Error("Zone already loaded.");
    global3["Zone"] ?? (global3["Zone"] = $053b4050c185c268$var$initZone());
    return global3["Zone"];
}
var $053b4050c185c268$var$ObjectGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $053b4050c185c268$var$ObjectDefineProperty = Object.defineProperty;
var $053b4050c185c268$var$ObjectGetPrototypeOf = Object.getPrototypeOf;
var $053b4050c185c268$var$ObjectCreate = Object.create;
var $053b4050c185c268$var$ArraySlice = Array.prototype.slice;
var $053b4050c185c268$var$ADD_EVENT_LISTENER_STR = "addEventListener";
var $053b4050c185c268$var$REMOVE_EVENT_LISTENER_STR = "removeEventListener";
var $053b4050c185c268$var$ZONE_SYMBOL_ADD_EVENT_LISTENER = $053b4050c185c268$var$__symbol__($053b4050c185c268$var$ADD_EVENT_LISTENER_STR);
var $053b4050c185c268$var$ZONE_SYMBOL_REMOVE_EVENT_LISTENER = $053b4050c185c268$var$__symbol__($053b4050c185c268$var$REMOVE_EVENT_LISTENER_STR);
var $053b4050c185c268$var$TRUE_STR = "true";
var $053b4050c185c268$var$FALSE_STR = "false";
var $053b4050c185c268$var$ZONE_SYMBOL_PREFIX = $053b4050c185c268$var$__symbol__("");
function $053b4050c185c268$var$wrapWithCurrentZone(callback, source) {
    return Zone.current.wrap(callback, source);
}
function $053b4050c185c268$var$scheduleMacroTaskWithCurrentZone(source, callback, data, customSchedule, customCancel) {
    return Zone.current.scheduleMacroTask(source, callback, data, customSchedule, customCancel);
}
var $053b4050c185c268$var$zoneSymbol = $053b4050c185c268$var$__symbol__;
var $053b4050c185c268$var$isWindowExists = typeof window !== "undefined";
var $053b4050c185c268$var$internalWindow = $053b4050c185c268$var$isWindowExists ? window : void 0;
var $053b4050c185c268$var$_global2 = $053b4050c185c268$var$isWindowExists && $053b4050c185c268$var$internalWindow || globalThis;
var $053b4050c185c268$var$REMOVE_ATTRIBUTE = "removeAttribute";
function $053b4050c185c268$var$bindArguments(args, source) {
    for(let i = args.length - 1; i >= 0; i--)if (typeof args[i] === "function") args[i] = $053b4050c185c268$var$wrapWithCurrentZone(args[i], source + "_" + i);
    return args;
}
function $053b4050c185c268$var$patchPrototype(prototype, fnNames) {
    const source = prototype.constructor["name"];
    for(let i = 0; i < fnNames.length; i++){
        const name = fnNames[i];
        const delegate = prototype[name];
        if (delegate) {
            const prototypeDesc = $053b4050c185c268$var$ObjectGetOwnPropertyDescriptor(prototype, name);
            if (!$053b4050c185c268$var$isPropertyWritable(prototypeDesc)) continue;
            prototype[name] = ((delegate2)=>{
                const patched = function() {
                    return delegate2.apply(this, $053b4050c185c268$var$bindArguments(arguments, source + "." + name));
                };
                $053b4050c185c268$var$attachOriginToPatched(patched, delegate2);
                return patched;
            })(delegate);
        }
    }
}
function $053b4050c185c268$var$isPropertyWritable(propertyDesc) {
    if (!propertyDesc) return true;
    if (propertyDesc.writable === false) return false;
    return !(typeof propertyDesc.get === "function" && typeof propertyDesc.set === "undefined");
}
var $053b4050c185c268$var$isWebWorker = typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope;
var $053b4050c185c268$var$isNode = !("nw" in $053b4050c185c268$var$_global2) && typeof $053b4050c185c268$var$_global2.process !== "undefined" && $053b4050c185c268$var$_global2.process.toString() === "[object process]";
var $053b4050c185c268$var$isBrowser = !$053b4050c185c268$var$isNode && !$053b4050c185c268$var$isWebWorker && !!($053b4050c185c268$var$isWindowExists && $053b4050c185c268$var$internalWindow["HTMLElement"]);
var $053b4050c185c268$var$isMix = typeof $053b4050c185c268$var$_global2.process !== "undefined" && $053b4050c185c268$var$_global2.process.toString() === "[object process]" && !$053b4050c185c268$var$isWebWorker && !!($053b4050c185c268$var$isWindowExists && $053b4050c185c268$var$internalWindow["HTMLElement"]);
var $053b4050c185c268$var$zoneSymbolEventNames$1 = {};
var $053b4050c185c268$var$enableBeforeunloadSymbol = $053b4050c185c268$var$zoneSymbol("enable_beforeunload");
var $053b4050c185c268$var$wrapFn = function(event) {
    event = event || $053b4050c185c268$var$_global2.event;
    if (!event) return;
    let eventNameSymbol = $053b4050c185c268$var$zoneSymbolEventNames$1[event.type];
    if (!eventNameSymbol) eventNameSymbol = $053b4050c185c268$var$zoneSymbolEventNames$1[event.type] = $053b4050c185c268$var$zoneSymbol("ON_PROPERTY" + event.type);
    const target = this || event.target || $053b4050c185c268$var$_global2;
    const listener = target[eventNameSymbol];
    let result;
    if ($053b4050c185c268$var$isBrowser && target === $053b4050c185c268$var$internalWindow && event.type === "error") {
        const errorEvent = event;
        result = listener && listener.call(this, errorEvent.message, errorEvent.filename, errorEvent.lineno, errorEvent.colno, errorEvent.error);
        if (result === true) event.preventDefault();
    } else {
        result = listener && listener.apply(this, arguments);
        if (// https://github.com/angular/angular/issues/47579
        // https://www.w3.org/TR/2011/WD-html5-20110525/history.html#beforeunloadevent
        // This is the only specific case we should check for. The spec defines that the
        // `returnValue` attribute represents the message to show the user. When the event
        // is created, this attribute must be set to the empty string.
        event.type === "beforeunload" && // To prevent any breaking changes resulting from this change, given that
        // it was already causing a significant number of failures in G3, we have hidden
        // that behavior behind a global configuration flag. Consumers can enable this
        // flag explicitly if they want the `beforeunload` event to be handled as defined
        // in the specification.
        $053b4050c185c268$var$_global2[$053b4050c185c268$var$enableBeforeunloadSymbol] && // The IDL event definition is `attribute DOMString returnValue`, so we check whether
        // `typeof result` is a string.
        typeof result === "string") event.returnValue = result;
        else if (result != void 0 && !result) event.preventDefault();
    }
    return result;
};
function $053b4050c185c268$var$patchProperty(obj, prop, prototype) {
    let desc = $053b4050c185c268$var$ObjectGetOwnPropertyDescriptor(obj, prop);
    if (!desc && prototype) {
        const prototypeDesc = $053b4050c185c268$var$ObjectGetOwnPropertyDescriptor(prototype, prop);
        if (prototypeDesc) desc = {
            enumerable: true,
            configurable: true
        };
    }
    if (!desc || !desc.configurable) return;
    const onPropPatchedSymbol = $053b4050c185c268$var$zoneSymbol("on" + prop + "patched");
    if (obj.hasOwnProperty(onPropPatchedSymbol) && obj[onPropPatchedSymbol]) return;
    delete desc.writable;
    delete desc.value;
    const originalDescGet = desc.get;
    const originalDescSet = desc.set;
    const eventName = prop.slice(2);
    let eventNameSymbol = $053b4050c185c268$var$zoneSymbolEventNames$1[eventName];
    if (!eventNameSymbol) eventNameSymbol = $053b4050c185c268$var$zoneSymbolEventNames$1[eventName] = $053b4050c185c268$var$zoneSymbol("ON_PROPERTY" + eventName);
    desc.set = function(newValue) {
        let target = this;
        if (!target && obj === $053b4050c185c268$var$_global2) target = $053b4050c185c268$var$_global2;
        if (!target) return;
        const previousValue = target[eventNameSymbol];
        if (typeof previousValue === "function") target.removeEventListener(eventName, $053b4050c185c268$var$wrapFn);
        originalDescSet?.call(target, null);
        target[eventNameSymbol] = newValue;
        if (typeof newValue === "function") target.addEventListener(eventName, $053b4050c185c268$var$wrapFn, false);
    };
    desc.get = function() {
        let target = this;
        if (!target && obj === $053b4050c185c268$var$_global2) target = $053b4050c185c268$var$_global2;
        if (!target) return null;
        const listener = target[eventNameSymbol];
        if (listener) return listener;
        else if (originalDescGet) {
            let value = originalDescGet.call(this);
            if (value) {
                desc.set.call(this, value);
                if (typeof target[$053b4050c185c268$var$REMOVE_ATTRIBUTE] === "function") target.removeAttribute(prop);
                return value;
            }
        }
        return null;
    };
    $053b4050c185c268$var$ObjectDefineProperty(obj, prop, desc);
    obj[onPropPatchedSymbol] = true;
}
function $053b4050c185c268$var$patchOnProperties(obj, properties, prototype) {
    if (properties) for(let i = 0; i < properties.length; i++)$053b4050c185c268$var$patchProperty(obj, "on" + properties[i], prototype);
    else {
        const onProperties = [];
        for(const prop in obj)if (prop.slice(0, 2) == "on") onProperties.push(prop);
        for(let j = 0; j < onProperties.length; j++)$053b4050c185c268$var$patchProperty(obj, onProperties[j], prototype);
    }
}
var $053b4050c185c268$var$originalInstanceKey = $053b4050c185c268$var$zoneSymbol("originalInstance");
function $053b4050c185c268$var$patchClass(className) {
    const OriginalClass = $053b4050c185c268$var$_global2[className];
    if (!OriginalClass) return;
    $053b4050c185c268$var$_global2[$053b4050c185c268$var$zoneSymbol(className)] = OriginalClass;
    $053b4050c185c268$var$_global2[className] = function() {
        const a = $053b4050c185c268$var$bindArguments(arguments, className);
        switch(a.length){
            case 0:
                this[$053b4050c185c268$var$originalInstanceKey] = new OriginalClass();
                break;
            case 1:
                this[$053b4050c185c268$var$originalInstanceKey] = new OriginalClass(a[0]);
                break;
            case 2:
                this[$053b4050c185c268$var$originalInstanceKey] = new OriginalClass(a[0], a[1]);
                break;
            case 3:
                this[$053b4050c185c268$var$originalInstanceKey] = new OriginalClass(a[0], a[1], a[2]);
                break;
            case 4:
                this[$053b4050c185c268$var$originalInstanceKey] = new OriginalClass(a[0], a[1], a[2], a[3]);
                break;
            default:
                throw new Error("Arg list too long.");
        }
    };
    $053b4050c185c268$var$attachOriginToPatched($053b4050c185c268$var$_global2[className], OriginalClass);
    const instance = new OriginalClass(function() {});
    let prop;
    for(prop in instance){
        if (className === "XMLHttpRequest" && prop === "responseBlob") continue;
        (function(prop2) {
            if (typeof instance[prop2] === "function") $053b4050c185c268$var$_global2[className].prototype[prop2] = function() {
                return this[$053b4050c185c268$var$originalInstanceKey][prop2].apply(this[$053b4050c185c268$var$originalInstanceKey], arguments);
            };
            else $053b4050c185c268$var$ObjectDefineProperty($053b4050c185c268$var$_global2[className].prototype, prop2, {
                set: function(fn) {
                    if (typeof fn === "function") {
                        this[$053b4050c185c268$var$originalInstanceKey][prop2] = $053b4050c185c268$var$wrapWithCurrentZone(fn, className + "." + prop2);
                        $053b4050c185c268$var$attachOriginToPatched(this[$053b4050c185c268$var$originalInstanceKey][prop2], fn);
                    } else this[$053b4050c185c268$var$originalInstanceKey][prop2] = fn;
                },
                get: function() {
                    return this[$053b4050c185c268$var$originalInstanceKey][prop2];
                }
            });
        })(prop);
    }
    for(prop in OriginalClass)if (prop !== "prototype" && OriginalClass.hasOwnProperty(prop)) $053b4050c185c268$var$_global2[className][prop] = OriginalClass[prop];
}
function $053b4050c185c268$var$patchMethod(target, name, patchFn) {
    let proto = target;
    while(proto && !proto.hasOwnProperty(name))proto = $053b4050c185c268$var$ObjectGetPrototypeOf(proto);
    if (!proto && target[name]) proto = target;
    const delegateName = $053b4050c185c268$var$zoneSymbol(name);
    let delegate = null;
    if (proto && (!(delegate = proto[delegateName]) || !proto.hasOwnProperty(delegateName))) {
        delegate = proto[delegateName] = proto[name];
        const desc = proto && $053b4050c185c268$var$ObjectGetOwnPropertyDescriptor(proto, name);
        if ($053b4050c185c268$var$isPropertyWritable(desc)) {
            const patchDelegate = patchFn(delegate, delegateName, name);
            proto[name] = function() {
                return patchDelegate(this, arguments);
            };
            $053b4050c185c268$var$attachOriginToPatched(proto[name], delegate);
        }
    }
    return delegate;
}
function $053b4050c185c268$var$patchMacroTask(obj, funcName, metaCreator) {
    let setNative = null;
    function scheduleTask(task) {
        const data = task.data;
        data.args[data.cbIdx] = function() {
            task.invoke.apply(this, arguments);
        };
        setNative.apply(data.target, data.args);
        return task;
    }
    setNative = $053b4050c185c268$var$patchMethod(obj, funcName, (delegate)=>function(self2, args) {
            const meta = metaCreator(self2, args);
            if (meta.cbIdx >= 0 && typeof args[meta.cbIdx] === "function") return $053b4050c185c268$var$scheduleMacroTaskWithCurrentZone(meta.name, args[meta.cbIdx], meta, scheduleTask);
            else return delegate.apply(self2, args);
        });
}
function $053b4050c185c268$var$attachOriginToPatched(patched, original) {
    patched[$053b4050c185c268$var$zoneSymbol("OriginalDelegate")] = original;
}
var $053b4050c185c268$var$isDetectedIEOrEdge = false;
var $053b4050c185c268$var$ieOrEdge = false;
function $053b4050c185c268$var$isIEOrEdge() {
    if ($053b4050c185c268$var$isDetectedIEOrEdge) return $053b4050c185c268$var$ieOrEdge;
    $053b4050c185c268$var$isDetectedIEOrEdge = true;
    try {
        const ua = $053b4050c185c268$var$internalWindow.navigator.userAgent;
        if (ua.indexOf("MSIE ") !== -1 || ua.indexOf("Trident/") !== -1 || ua.indexOf("Edge/") !== -1) $053b4050c185c268$var$ieOrEdge = true;
    } catch (error) {}
    return $053b4050c185c268$var$ieOrEdge;
}
function $053b4050c185c268$var$isFunction2(value) {
    return typeof value === "function";
}
function $053b4050c185c268$var$isNumber(value) {
    return typeof value === "number";
}
var $053b4050c185c268$var$OPTIMIZED_ZONE_EVENT_TASK_DATA = {
    useG: true
};
var $053b4050c185c268$var$zoneSymbolEventNames = {};
var $053b4050c185c268$var$globalSources = {};
var $053b4050c185c268$var$EVENT_NAME_SYMBOL_REGX = new RegExp("^" + $053b4050c185c268$var$ZONE_SYMBOL_PREFIX + "(\\w+)(true|false)$");
var $053b4050c185c268$var$IMMEDIATE_PROPAGATION_SYMBOL = $053b4050c185c268$var$zoneSymbol("propagationStopped");
function $053b4050c185c268$var$prepareEventNames(eventName, eventNameToString) {
    const falseEventName = (eventNameToString ? eventNameToString(eventName) : eventName) + $053b4050c185c268$var$FALSE_STR;
    const trueEventName = (eventNameToString ? eventNameToString(eventName) : eventName) + $053b4050c185c268$var$TRUE_STR;
    const symbol = $053b4050c185c268$var$ZONE_SYMBOL_PREFIX + falseEventName;
    const symbolCapture = $053b4050c185c268$var$ZONE_SYMBOL_PREFIX + trueEventName;
    $053b4050c185c268$var$zoneSymbolEventNames[eventName] = {};
    $053b4050c185c268$var$zoneSymbolEventNames[eventName][$053b4050c185c268$var$FALSE_STR] = symbol;
    $053b4050c185c268$var$zoneSymbolEventNames[eventName][$053b4050c185c268$var$TRUE_STR] = symbolCapture;
}
function $053b4050c185c268$var$patchEventTarget(_global5, api, apis, patchOptions) {
    const ADD_EVENT_LISTENER = patchOptions && patchOptions.add || $053b4050c185c268$var$ADD_EVENT_LISTENER_STR;
    const REMOVE_EVENT_LISTENER = patchOptions && patchOptions.rm || $053b4050c185c268$var$REMOVE_EVENT_LISTENER_STR;
    const LISTENERS_EVENT_LISTENER = patchOptions && patchOptions.listeners || "eventListeners";
    const REMOVE_ALL_LISTENERS_EVENT_LISTENER = patchOptions && patchOptions.rmAll || "removeAllListeners";
    const zoneSymbolAddEventListener = $053b4050c185c268$var$zoneSymbol(ADD_EVENT_LISTENER);
    const ADD_EVENT_LISTENER_SOURCE = "." + ADD_EVENT_LISTENER + ":";
    const PREPEND_EVENT_LISTENER = "prependListener";
    const PREPEND_EVENT_LISTENER_SOURCE = "." + PREPEND_EVENT_LISTENER + ":";
    const invokeTask = function(task, target, event) {
        if (task.isRemoved) return;
        const delegate = task.callback;
        if (typeof delegate === "object" && delegate.handleEvent) {
            task.callback = (event2)=>delegate.handleEvent(event2);
            task.originalDelegate = delegate;
        }
        let error;
        try {
            task.invoke(task, target, [
                event
            ]);
        } catch (err) {
            error = err;
        }
        const options = task.options;
        if (options && typeof options === "object" && options.once) {
            const delegate2 = task.originalDelegate ? task.originalDelegate : task.callback;
            target[REMOVE_EVENT_LISTENER].call(target, event.type, delegate2, options);
        }
        return error;
    };
    function globalCallback(context2, event, isCapture) {
        event = event || _global5.event;
        if (!event) return;
        const target = context2 || event.target || _global5;
        const tasks = target[$053b4050c185c268$var$zoneSymbolEventNames[event.type][isCapture ? $053b4050c185c268$var$TRUE_STR : $053b4050c185c268$var$FALSE_STR]];
        if (tasks) {
            const errors = [];
            if (tasks.length === 1) {
                const err = invokeTask(tasks[0], target, event);
                err && errors.push(err);
            } else {
                const copyTasks = tasks.slice();
                for(let i = 0; i < copyTasks.length; i++){
                    if (event && event[$053b4050c185c268$var$IMMEDIATE_PROPAGATION_SYMBOL] === true) break;
                    const err = invokeTask(copyTasks[i], target, event);
                    err && errors.push(err);
                }
            }
            if (errors.length === 1) throw errors[0];
            else for(let i = 0; i < errors.length; i++){
                const err = errors[i];
                api.nativeScheduleMicroTask(()=>{
                    throw err;
                });
            }
        }
    }
    const globalZoneAwareCallback = function(event) {
        return globalCallback(this, event, false);
    };
    const globalZoneAwareCaptureCallback = function(event) {
        return globalCallback(this, event, true);
    };
    function patchEventTargetMethods(obj, patchOptions2) {
        if (!obj) return false;
        let useGlobalCallback = true;
        if (patchOptions2 && patchOptions2.useG !== void 0) useGlobalCallback = patchOptions2.useG;
        const validateHandler = patchOptions2 && patchOptions2.vh;
        let checkDuplicate = true;
        if (patchOptions2 && patchOptions2.chkDup !== void 0) checkDuplicate = patchOptions2.chkDup;
        let returnTarget = false;
        if (patchOptions2 && patchOptions2.rt !== void 0) returnTarget = patchOptions2.rt;
        let proto = obj;
        while(proto && !proto.hasOwnProperty(ADD_EVENT_LISTENER))proto = $053b4050c185c268$var$ObjectGetPrototypeOf(proto);
        if (!proto && obj[ADD_EVENT_LISTENER]) proto = obj;
        if (!proto) return false;
        if (proto[zoneSymbolAddEventListener]) return false;
        const eventNameToString = patchOptions2 && patchOptions2.eventNameToString;
        const taskData = {};
        const nativeAddEventListener = proto[zoneSymbolAddEventListener] = proto[ADD_EVENT_LISTENER];
        const nativeRemoveEventListener = proto[$053b4050c185c268$var$zoneSymbol(REMOVE_EVENT_LISTENER)] = proto[REMOVE_EVENT_LISTENER];
        const nativeListeners = proto[$053b4050c185c268$var$zoneSymbol(LISTENERS_EVENT_LISTENER)] = proto[LISTENERS_EVENT_LISTENER];
        const nativeRemoveAllListeners = proto[$053b4050c185c268$var$zoneSymbol(REMOVE_ALL_LISTENERS_EVENT_LISTENER)] = proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER];
        let nativePrependEventListener;
        if (patchOptions2 && patchOptions2.prepend) nativePrependEventListener = proto[$053b4050c185c268$var$zoneSymbol(patchOptions2.prepend)] = proto[patchOptions2.prepend];
        function buildEventListenerOptions(options, passive) {
            if (!passive) return options;
            if (typeof options === "boolean") return {
                capture: options,
                passive: true
            };
            if (!options) return {
                passive: true
            };
            if (typeof options === "object" && options.passive !== false) return {
                ...options,
                passive: true
            };
            return options;
        }
        const customScheduleGlobal = function(task) {
            if (taskData.isExisting) return;
            return nativeAddEventListener.call(taskData.target, taskData.eventName, taskData.capture ? globalZoneAwareCaptureCallback : globalZoneAwareCallback, taskData.options);
        };
        const customCancelGlobal = function(task) {
            if (!task.isRemoved) {
                const symbolEventNames = $053b4050c185c268$var$zoneSymbolEventNames[task.eventName];
                let symbolEventName;
                if (symbolEventNames) symbolEventName = symbolEventNames[task.capture ? $053b4050c185c268$var$TRUE_STR : $053b4050c185c268$var$FALSE_STR];
                const existingTasks = symbolEventName && task.target[symbolEventName];
                if (existingTasks) for(let i = 0; i < existingTasks.length; i++){
                    const existingTask = existingTasks[i];
                    if (existingTask === task) {
                        existingTasks.splice(i, 1);
                        task.isRemoved = true;
                        if (task.removeAbortListener) {
                            task.removeAbortListener();
                            task.removeAbortListener = null;
                        }
                        if (existingTasks.length === 0) {
                            task.allRemoved = true;
                            task.target[symbolEventName] = null;
                        }
                        break;
                    }
                }
            }
            if (!task.allRemoved) return;
            return nativeRemoveEventListener.call(task.target, task.eventName, task.capture ? globalZoneAwareCaptureCallback : globalZoneAwareCallback, task.options);
        };
        const customScheduleNonGlobal = function(task) {
            return nativeAddEventListener.call(taskData.target, taskData.eventName, task.invoke, taskData.options);
        };
        const customSchedulePrepend = function(task) {
            return nativePrependEventListener.call(taskData.target, taskData.eventName, task.invoke, taskData.options);
        };
        const customCancelNonGlobal = function(task) {
            return nativeRemoveEventListener.call(task.target, task.eventName, task.invoke, task.options);
        };
        const customSchedule = useGlobalCallback ? customScheduleGlobal : customScheduleNonGlobal;
        const customCancel = useGlobalCallback ? customCancelGlobal : customCancelNonGlobal;
        const compareTaskCallbackVsDelegate = function(task, delegate) {
            const typeOfDelegate = typeof delegate;
            return typeOfDelegate === "function" && task.callback === delegate || typeOfDelegate === "object" && task.originalDelegate === delegate;
        };
        const compare = patchOptions2?.diff || compareTaskCallbackVsDelegate;
        const unpatchedEvents = Zone[$053b4050c185c268$var$zoneSymbol("UNPATCHED_EVENTS")];
        const passiveEvents = _global5[$053b4050c185c268$var$zoneSymbol("PASSIVE_EVENTS")];
        function copyEventListenerOptions(options) {
            if (typeof options === "object" && options !== null) {
                const newOptions = {
                    ...options
                };
                if (options.signal) newOptions.signal = options.signal;
                return newOptions;
            }
            return options;
        }
        const makeAddListener = function(nativeListener, addSource, customScheduleFn, customCancelFn, returnTarget2 = false, prepend = false) {
            return function() {
                const target = this || _global5;
                let eventName = arguments[0];
                if (patchOptions2 && patchOptions2.transferEventName) eventName = patchOptions2.transferEventName(eventName);
                let delegate = arguments[1];
                if (!delegate) return nativeListener.apply(this, arguments);
                if ($053b4050c185c268$var$isNode && eventName === "uncaughtException") return nativeListener.apply(this, arguments);
                let isEventListenerObject = false;
                if (typeof delegate !== "function") {
                    if (!delegate.handleEvent) return nativeListener.apply(this, arguments);
                    isEventListenerObject = true;
                }
                if (validateHandler && !validateHandler(nativeListener, delegate, target, arguments)) return;
                const passive = !!passiveEvents && passiveEvents.indexOf(eventName) !== -1;
                const options = copyEventListenerOptions(buildEventListenerOptions(arguments[2], passive));
                const signal = options?.signal;
                if (signal?.aborted) return;
                if (unpatchedEvents) {
                    for(let i = 0; i < unpatchedEvents.length; i++)if (eventName === unpatchedEvents[i]) {
                        if (passive) return nativeListener.call(target, eventName, delegate, options);
                        else return nativeListener.apply(this, arguments);
                    }
                }
                const capture = !options ? false : typeof options === "boolean" ? true : options.capture;
                const once = options && typeof options === "object" ? options.once : false;
                const zone = Zone.current;
                let symbolEventNames = $053b4050c185c268$var$zoneSymbolEventNames[eventName];
                if (!symbolEventNames) {
                    $053b4050c185c268$var$prepareEventNames(eventName, eventNameToString);
                    symbolEventNames = $053b4050c185c268$var$zoneSymbolEventNames[eventName];
                }
                const symbolEventName = symbolEventNames[capture ? $053b4050c185c268$var$TRUE_STR : $053b4050c185c268$var$FALSE_STR];
                let existingTasks = target[symbolEventName];
                let isExisting = false;
                if (existingTasks) {
                    isExisting = true;
                    if (checkDuplicate) for(let i = 0; i < existingTasks.length; i++){
                        if (compare(existingTasks[i], delegate)) return;
                    }
                } else existingTasks = target[symbolEventName] = [];
                let source;
                const constructorName = target.constructor["name"];
                const targetSource = $053b4050c185c268$var$globalSources[constructorName];
                if (targetSource) source = targetSource[eventName];
                if (!source) source = constructorName + addSource + (eventNameToString ? eventNameToString(eventName) : eventName);
                taskData.options = options;
                if (once) taskData.options.once = false;
                taskData.target = target;
                taskData.capture = capture;
                taskData.eventName = eventName;
                taskData.isExisting = isExisting;
                const data = useGlobalCallback ? $053b4050c185c268$var$OPTIMIZED_ZONE_EVENT_TASK_DATA : void 0;
                if (data) data.taskData = taskData;
                if (signal) taskData.options.signal = void 0;
                const task = zone.scheduleEventTask(source, delegate, data, customScheduleFn, customCancelFn);
                if (signal) {
                    taskData.options.signal = signal;
                    const onAbort = ()=>task.zone.cancelTask(task);
                    nativeListener.call(signal, "abort", onAbort, {
                        once: true
                    });
                    task.removeAbortListener = ()=>signal.removeEventListener("abort", onAbort);
                }
                taskData.target = null;
                if (data) data.taskData = null;
                if (once) taskData.options.once = true;
                if (typeof task.options !== "boolean") task.options = options;
                task.target = target;
                task.capture = capture;
                task.eventName = eventName;
                if (isEventListenerObject) task.originalDelegate = delegate;
                if (!prepend) existingTasks.push(task);
                else existingTasks.unshift(task);
                if (returnTarget2) return target;
            };
        };
        proto[ADD_EVENT_LISTENER] = makeAddListener(nativeAddEventListener, ADD_EVENT_LISTENER_SOURCE, customSchedule, customCancel, returnTarget);
        if (nativePrependEventListener) proto[PREPEND_EVENT_LISTENER] = makeAddListener(nativePrependEventListener, PREPEND_EVENT_LISTENER_SOURCE, customSchedulePrepend, customCancel, returnTarget, true);
        proto[REMOVE_EVENT_LISTENER] = function() {
            const target = this || _global5;
            let eventName = arguments[0];
            if (patchOptions2 && patchOptions2.transferEventName) eventName = patchOptions2.transferEventName(eventName);
            const options = arguments[2];
            const capture = !options ? false : typeof options === "boolean" ? true : options.capture;
            const delegate = arguments[1];
            if (!delegate) return nativeRemoveEventListener.apply(this, arguments);
            if (validateHandler && !validateHandler(nativeRemoveEventListener, delegate, target, arguments)) return;
            const symbolEventNames = $053b4050c185c268$var$zoneSymbolEventNames[eventName];
            let symbolEventName;
            if (symbolEventNames) symbolEventName = symbolEventNames[capture ? $053b4050c185c268$var$TRUE_STR : $053b4050c185c268$var$FALSE_STR];
            const existingTasks = symbolEventName && target[symbolEventName];
            if (existingTasks) for(let i = 0; i < existingTasks.length; i++){
                const existingTask = existingTasks[i];
                if (compare(existingTask, delegate)) {
                    existingTasks.splice(i, 1);
                    existingTask.isRemoved = true;
                    if (existingTasks.length === 0) {
                        existingTask.allRemoved = true;
                        target[symbolEventName] = null;
                        if (!capture && typeof eventName === "string") {
                            const onPropertySymbol = $053b4050c185c268$var$ZONE_SYMBOL_PREFIX + "ON_PROPERTY" + eventName;
                            target[onPropertySymbol] = null;
                        }
                    }
                    existingTask.zone.cancelTask(existingTask);
                    if (returnTarget) return target;
                    return;
                }
            }
            return nativeRemoveEventListener.apply(this, arguments);
        };
        proto[LISTENERS_EVENT_LISTENER] = function() {
            const target = this || _global5;
            let eventName = arguments[0];
            if (patchOptions2 && patchOptions2.transferEventName) eventName = patchOptions2.transferEventName(eventName);
            const listeners = [];
            const tasks = $053b4050c185c268$var$findEventTasks(target, eventNameToString ? eventNameToString(eventName) : eventName);
            for(let i = 0; i < tasks.length; i++){
                const task = tasks[i];
                let delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                listeners.push(delegate);
            }
            return listeners;
        };
        proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER] = function() {
            const target = this || _global5;
            let eventName = arguments[0];
            if (!eventName) {
                const keys = Object.keys(target);
                for(let i = 0; i < keys.length; i++){
                    const prop = keys[i];
                    const match = $053b4050c185c268$var$EVENT_NAME_SYMBOL_REGX.exec(prop);
                    let evtName = match && match[1];
                    if (evtName && evtName !== "removeListener") this[REMOVE_ALL_LISTENERS_EVENT_LISTENER].call(this, evtName);
                }
                this[REMOVE_ALL_LISTENERS_EVENT_LISTENER].call(this, "removeListener");
            } else {
                if (patchOptions2 && patchOptions2.transferEventName) eventName = patchOptions2.transferEventName(eventName);
                const symbolEventNames = $053b4050c185c268$var$zoneSymbolEventNames[eventName];
                if (symbolEventNames) {
                    const symbolEventName = symbolEventNames[$053b4050c185c268$var$FALSE_STR];
                    const symbolCaptureEventName = symbolEventNames[$053b4050c185c268$var$TRUE_STR];
                    const tasks = target[symbolEventName];
                    const captureTasks = target[symbolCaptureEventName];
                    if (tasks) {
                        const removeTasks = tasks.slice();
                        for(let i = 0; i < removeTasks.length; i++){
                            const task = removeTasks[i];
                            let delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                            this[REMOVE_EVENT_LISTENER].call(this, eventName, delegate, task.options);
                        }
                    }
                    if (captureTasks) {
                        const removeTasks = captureTasks.slice();
                        for(let i = 0; i < removeTasks.length; i++){
                            const task = removeTasks[i];
                            let delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                            this[REMOVE_EVENT_LISTENER].call(this, eventName, delegate, task.options);
                        }
                    }
                }
            }
            if (returnTarget) return this;
        };
        $053b4050c185c268$var$attachOriginToPatched(proto[ADD_EVENT_LISTENER], nativeAddEventListener);
        $053b4050c185c268$var$attachOriginToPatched(proto[REMOVE_EVENT_LISTENER], nativeRemoveEventListener);
        if (nativeRemoveAllListeners) $053b4050c185c268$var$attachOriginToPatched(proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER], nativeRemoveAllListeners);
        if (nativeListeners) $053b4050c185c268$var$attachOriginToPatched(proto[LISTENERS_EVENT_LISTENER], nativeListeners);
        return true;
    }
    let results = [];
    for(let i = 0; i < apis.length; i++)results[i] = patchEventTargetMethods(apis[i], patchOptions);
    return results;
}
function $053b4050c185c268$var$findEventTasks(target, eventName) {
    if (!eventName) {
        const foundTasks = [];
        for(let prop in target){
            const match = $053b4050c185c268$var$EVENT_NAME_SYMBOL_REGX.exec(prop);
            let evtName = match && match[1];
            if (evtName && (!eventName || evtName === eventName)) {
                const tasks = target[prop];
                if (tasks) for(let i = 0; i < tasks.length; i++)foundTasks.push(tasks[i]);
            }
        }
        return foundTasks;
    }
    let symbolEventName = $053b4050c185c268$var$zoneSymbolEventNames[eventName];
    if (!symbolEventName) {
        $053b4050c185c268$var$prepareEventNames(eventName);
        symbolEventName = $053b4050c185c268$var$zoneSymbolEventNames[eventName];
    }
    const captureFalseTasks = target[symbolEventName[$053b4050c185c268$var$FALSE_STR]];
    const captureTrueTasks = target[symbolEventName[$053b4050c185c268$var$TRUE_STR]];
    if (!captureFalseTasks) return captureTrueTasks ? captureTrueTasks.slice() : [];
    else return captureTrueTasks ? captureFalseTasks.concat(captureTrueTasks) : captureFalseTasks.slice();
}
function $053b4050c185c268$var$patchEventPrototype(global3, api) {
    const Event2 = global3["Event"];
    if (Event2 && Event2.prototype) api.patchMethod(Event2.prototype, "stopImmediatePropagation", (delegate)=>function(self2, args) {
            self2[$053b4050c185c268$var$IMMEDIATE_PROPAGATION_SYMBOL] = true;
            delegate && delegate.apply(self2, args);
        });
}
function $053b4050c185c268$var$patchQueueMicrotask(global3, api) {
    api.patchMethod(global3, "queueMicrotask", (delegate)=>{
        return function(self2, args) {
            Zone.current.scheduleMicroTask("queueMicrotask", args[0]);
        };
    });
}
var $053b4050c185c268$var$taskSymbol = $053b4050c185c268$var$zoneSymbol("zoneTask");
function $053b4050c185c268$var$patchTimer(window2, setName, cancelName, nameSuffix) {
    let setNative = null;
    let clearNative = null;
    setName += nameSuffix;
    cancelName += nameSuffix;
    const tasksByHandleId = {};
    function scheduleTask(task) {
        const data = task.data;
        data.args[0] = function() {
            return task.invoke.apply(this, arguments);
        };
        const handleOrId = setNative.apply(window2, data.args);
        if ($053b4050c185c268$var$isNumber(handleOrId)) data.handleId = handleOrId;
        else {
            data.handle = handleOrId;
            data.isRefreshable = $053b4050c185c268$var$isFunction2(handleOrId.refresh);
        }
        return task;
    }
    function clearTask(task) {
        const { handle: handle, handleId: handleId } = task.data;
        return clearNative.call(window2, handle ?? handleId);
    }
    setNative = $053b4050c185c268$var$patchMethod(window2, setName, (delegate)=>function(self2, args) {
            if ($053b4050c185c268$var$isFunction2(args[0])) {
                const options = {
                    isRefreshable: false,
                    isPeriodic: nameSuffix === "Interval",
                    delay: nameSuffix === "Timeout" || nameSuffix === "Interval" ? args[1] || 0 : void 0,
                    args: args
                };
                const callback = args[0];
                args[0] = function timer() {
                    try {
                        return callback.apply(this, arguments);
                    } finally{
                        const { handle: handle2, handleId: handleId2, isPeriodic: isPeriodic2, isRefreshable: isRefreshable2 } = options;
                        if (!isPeriodic2 && !isRefreshable2) {
                            if (handleId2) delete tasksByHandleId[handleId2];
                            else if (handle2) handle2[$053b4050c185c268$var$taskSymbol] = null;
                        }
                    }
                };
                const task = $053b4050c185c268$var$scheduleMacroTaskWithCurrentZone(setName, args[0], options, scheduleTask, clearTask);
                if (!task) return task;
                const { handleId: handleId, handle: handle, isRefreshable: isRefreshable, isPeriodic: isPeriodic } = task.data;
                if (handleId) tasksByHandleId[handleId] = task;
                else if (handle) {
                    handle[$053b4050c185c268$var$taskSymbol] = task;
                    if (isRefreshable && !isPeriodic) {
                        const originalRefresh = handle.refresh;
                        handle.refresh = function() {
                            const { zone: zone, state: state } = task;
                            if (state === "notScheduled") {
                                task._state = "scheduled";
                                zone._updateTaskCount(task, 1);
                            } else if (state === "running") task._state = "scheduling";
                            return originalRefresh.call(this);
                        };
                    }
                }
                return handle ?? handleId ?? task;
            } else return delegate.apply(window2, args);
        });
    clearNative = $053b4050c185c268$var$patchMethod(window2, cancelName, (delegate)=>function(self2, args) {
            const id = args[0];
            let task;
            if ($053b4050c185c268$var$isNumber(id)) {
                task = tasksByHandleId[id];
                delete tasksByHandleId[id];
            } else {
                task = id?.[$053b4050c185c268$var$taskSymbol];
                if (task) id[$053b4050c185c268$var$taskSymbol] = null;
                else task = id;
            }
            if (task?.type) {
                if (task.cancelFn) task.zone.cancelTask(task);
            } else delegate.apply(window2, args);
        });
}
function $053b4050c185c268$var$patchCustomElements(_global5, api) {
    const { isBrowser: isBrowser2, isMix: isMix2 } = api.getGlobalObjects();
    if (!isBrowser2 && !isMix2 || !_global5["customElements"] || !("customElements" in _global5)) return;
    const callbacks = [
        "connectedCallback",
        "disconnectedCallback",
        "adoptedCallback",
        "attributeChangedCallback",
        "formAssociatedCallback",
        "formDisabledCallback",
        "formResetCallback",
        "formStateRestoreCallback"
    ];
    api.patchCallbacks(api, _global5.customElements, "customElements", "define", callbacks);
}
function $053b4050c185c268$var$eventTargetPatch(_global5, api) {
    if (Zone[api.symbol("patchEventTarget")]) return;
    const { eventNames: eventNames, zoneSymbolEventNames: zoneSymbolEventNames2, TRUE_STR: TRUE_STR2, FALSE_STR: FALSE_STR2, ZONE_SYMBOL_PREFIX: ZONE_SYMBOL_PREFIX2 } = api.getGlobalObjects();
    for(let i = 0; i < eventNames.length; i++){
        const eventName = eventNames[i];
        const falseEventName = eventName + FALSE_STR2;
        const trueEventName = eventName + TRUE_STR2;
        const symbol = ZONE_SYMBOL_PREFIX2 + falseEventName;
        const symbolCapture = ZONE_SYMBOL_PREFIX2 + trueEventName;
        zoneSymbolEventNames2[eventName] = {};
        zoneSymbolEventNames2[eventName][FALSE_STR2] = symbol;
        zoneSymbolEventNames2[eventName][TRUE_STR2] = symbolCapture;
    }
    const EVENT_TARGET = _global5["EventTarget"];
    if (!EVENT_TARGET || !EVENT_TARGET.prototype) return;
    api.patchEventTarget(_global5, api, [
        EVENT_TARGET && EVENT_TARGET.prototype
    ]);
    return true;
}
function $053b4050c185c268$var$patchEvent(global3, api) {
    api.patchEventPrototype(global3, api);
}
function $053b4050c185c268$var$filterProperties(target, onProperties, ignoreProperties) {
    if (!ignoreProperties || ignoreProperties.length === 0) return onProperties;
    const tip = ignoreProperties.filter((ip)=>ip.target === target);
    if (tip.length === 0) return onProperties;
    const targetIgnoreProperties = tip[0].ignoreProperties;
    return onProperties.filter((op)=>targetIgnoreProperties.indexOf(op) === -1);
}
function $053b4050c185c268$var$patchFilteredProperties(target, onProperties, ignoreProperties, prototype) {
    if (!target) return;
    const filteredProperties = $053b4050c185c268$var$filterProperties(target, onProperties, ignoreProperties);
    $053b4050c185c268$var$patchOnProperties(target, filteredProperties, prototype);
}
function $053b4050c185c268$var$getOnEventNames(target) {
    return Object.getOwnPropertyNames(target).filter((name)=>name.startsWith("on") && name.length > 2).map((name)=>name.substring(2));
}
function $053b4050c185c268$var$propertyDescriptorPatch(api, _global5) {
    if ($053b4050c185c268$var$isNode && !$053b4050c185c268$var$isMix) return;
    if (Zone[api.symbol("patchEvents")]) return;
    const ignoreProperties = _global5["__Zone_ignore_on_properties"];
    let patchTargets = [];
    if ($053b4050c185c268$var$isBrowser) {
        const internalWindow2 = window;
        patchTargets = patchTargets.concat([
            "Document",
            "SVGElement",
            "Element",
            "HTMLElement",
            "HTMLBodyElement",
            "HTMLMediaElement",
            "HTMLFrameSetElement",
            "HTMLFrameElement",
            "HTMLIFrameElement",
            "HTMLMarqueeElement",
            "Worker"
        ]);
        const ignoreErrorProperties = [];
        $053b4050c185c268$var$patchFilteredProperties(internalWindow2, $053b4050c185c268$var$getOnEventNames(internalWindow2), ignoreProperties ? ignoreProperties.concat(ignoreErrorProperties) : ignoreProperties, $053b4050c185c268$var$ObjectGetPrototypeOf(internalWindow2));
    }
    patchTargets = patchTargets.concat([
        "XMLHttpRequest",
        "XMLHttpRequestEventTarget",
        "IDBIndex",
        "IDBRequest",
        "IDBOpenDBRequest",
        "IDBDatabase",
        "IDBTransaction",
        "IDBCursor",
        "WebSocket"
    ]);
    for(let i = 0; i < patchTargets.length; i++){
        const target = _global5[patchTargets[i]];
        target?.prototype && $053b4050c185c268$var$patchFilteredProperties(target.prototype, $053b4050c185c268$var$getOnEventNames(target.prototype), ignoreProperties);
    }
}
function $053b4050c185c268$var$patchBrowser(Zone2) {
    Zone2.__load_patch("legacy", (global3)=>{
        const legacyPatch = global3[Zone2.__symbol__("legacyPatch")];
        if (legacyPatch) legacyPatch();
    });
    Zone2.__load_patch("timers", (global3)=>{
        const set = "set";
        const clear = "clear";
        $053b4050c185c268$var$patchTimer(global3, set, clear, "Timeout");
        $053b4050c185c268$var$patchTimer(global3, set, clear, "Interval");
        $053b4050c185c268$var$patchTimer(global3, set, clear, "Immediate");
    });
    Zone2.__load_patch("requestAnimationFrame", (global3)=>{
        $053b4050c185c268$var$patchTimer(global3, "request", "cancel", "AnimationFrame");
        $053b4050c185c268$var$patchTimer(global3, "mozRequest", "mozCancel", "AnimationFrame");
        $053b4050c185c268$var$patchTimer(global3, "webkitRequest", "webkitCancel", "AnimationFrame");
    });
    Zone2.__load_patch("blocking", (global3, Zone3)=>{
        const blockingMethods = [
            "alert",
            "prompt",
            "confirm"
        ];
        for(let i = 0; i < blockingMethods.length; i++){
            const name = blockingMethods[i];
            $053b4050c185c268$var$patchMethod(global3, name, (delegate, symbol, name2)=>{
                return function(s, args) {
                    return Zone3.current.run(delegate, global3, args, name2);
                };
            });
        }
    });
    Zone2.__load_patch("EventTarget", (global3, Zone3, api)=>{
        $053b4050c185c268$var$patchEvent(global3, api);
        $053b4050c185c268$var$eventTargetPatch(global3, api);
        const XMLHttpRequestEventTarget = global3["XMLHttpRequestEventTarget"];
        if (XMLHttpRequestEventTarget && XMLHttpRequestEventTarget.prototype) api.patchEventTarget(global3, api, [
            XMLHttpRequestEventTarget.prototype
        ]);
    });
    Zone2.__load_patch("MutationObserver", (global3, Zone3, api)=>{
        $053b4050c185c268$var$patchClass("MutationObserver");
        $053b4050c185c268$var$patchClass("WebKitMutationObserver");
    });
    Zone2.__load_patch("IntersectionObserver", (global3, Zone3, api)=>{
        $053b4050c185c268$var$patchClass("IntersectionObserver");
    });
    Zone2.__load_patch("FileReader", (global3, Zone3, api)=>{
        $053b4050c185c268$var$patchClass("FileReader");
    });
    Zone2.__load_patch("on_property", (global3, Zone3, api)=>{
        $053b4050c185c268$var$propertyDescriptorPatch(api, global3);
    });
    Zone2.__load_patch("customElements", (global3, Zone3, api)=>{
        $053b4050c185c268$var$patchCustomElements(global3, api);
    });
    Zone2.__load_patch("XHR", (global3, Zone3)=>{
        patchXHR(global3);
        const XHR_TASK = $053b4050c185c268$var$zoneSymbol("xhrTask");
        const XHR_SYNC = $053b4050c185c268$var$zoneSymbol("xhrSync");
        const XHR_LISTENER = $053b4050c185c268$var$zoneSymbol("xhrListener");
        const XHR_SCHEDULED = $053b4050c185c268$var$zoneSymbol("xhrScheduled");
        const XHR_URL = $053b4050c185c268$var$zoneSymbol("xhrURL");
        const XHR_ERROR_BEFORE_SCHEDULED = $053b4050c185c268$var$zoneSymbol("xhrErrorBeforeScheduled");
        function patchXHR(window2) {
            const XMLHttpRequest2 = window2["XMLHttpRequest"];
            if (!XMLHttpRequest2) return;
            const XMLHttpRequestPrototype = XMLHttpRequest2.prototype;
            function findPendingTask(target) {
                return target[XHR_TASK];
            }
            let oriAddListener = XMLHttpRequestPrototype[$053b4050c185c268$var$ZONE_SYMBOL_ADD_EVENT_LISTENER];
            let oriRemoveListener = XMLHttpRequestPrototype[$053b4050c185c268$var$ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
            if (!oriAddListener) {
                const XMLHttpRequestEventTarget = window2["XMLHttpRequestEventTarget"];
                if (XMLHttpRequestEventTarget) {
                    const XMLHttpRequestEventTargetPrototype = XMLHttpRequestEventTarget.prototype;
                    oriAddListener = XMLHttpRequestEventTargetPrototype[$053b4050c185c268$var$ZONE_SYMBOL_ADD_EVENT_LISTENER];
                    oriRemoveListener = XMLHttpRequestEventTargetPrototype[$053b4050c185c268$var$ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
                }
            }
            const READY_STATE_CHANGE = "readystatechange";
            const SCHEDULED = "scheduled";
            function scheduleTask(task) {
                const data = task.data;
                const target = data.target;
                target[XHR_SCHEDULED] = false;
                target[XHR_ERROR_BEFORE_SCHEDULED] = false;
                const listener = target[XHR_LISTENER];
                if (!oriAddListener) {
                    oriAddListener = target[$053b4050c185c268$var$ZONE_SYMBOL_ADD_EVENT_LISTENER];
                    oriRemoveListener = target[$053b4050c185c268$var$ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
                }
                if (listener) oriRemoveListener.call(target, READY_STATE_CHANGE, listener);
                const newListener = target[XHR_LISTENER] = ()=>{
                    if (target.readyState === target.DONE) {
                        if (!data.aborted && target[XHR_SCHEDULED] && task.state === SCHEDULED) {
                            const loadTasks = target[Zone3.__symbol__("loadfalse")];
                            if (target.status !== 0 && loadTasks && loadTasks.length > 0) {
                                const oriInvoke = task.invoke;
                                task.invoke = function() {
                                    const loadTasks2 = target[Zone3.__symbol__("loadfalse")];
                                    for(let i = 0; i < loadTasks2.length; i++)if (loadTasks2[i] === task) loadTasks2.splice(i, 1);
                                    if (!data.aborted && task.state === SCHEDULED) oriInvoke.call(task);
                                };
                                loadTasks.push(task);
                            } else task.invoke();
                        } else if (!data.aborted && target[XHR_SCHEDULED] === false) target[XHR_ERROR_BEFORE_SCHEDULED] = true;
                    }
                };
                oriAddListener.call(target, READY_STATE_CHANGE, newListener);
                const storedTask = target[XHR_TASK];
                if (!storedTask) target[XHR_TASK] = task;
                sendNative.apply(target, data.args);
                target[XHR_SCHEDULED] = true;
                return task;
            }
            function placeholderCallback() {}
            function clearTask(task) {
                const data = task.data;
                data.aborted = true;
                return abortNative.apply(data.target, data.args);
            }
            const openNative = $053b4050c185c268$var$patchMethod(XMLHttpRequestPrototype, "open", ()=>function(self2, args) {
                    self2[XHR_SYNC] = args[2] == false;
                    self2[XHR_URL] = args[1];
                    return openNative.apply(self2, args);
                });
            const XMLHTTPREQUEST_SOURCE = "XMLHttpRequest.send";
            const fetchTaskAborting = $053b4050c185c268$var$zoneSymbol("fetchTaskAborting");
            const fetchTaskScheduling = $053b4050c185c268$var$zoneSymbol("fetchTaskScheduling");
            const sendNative = $053b4050c185c268$var$patchMethod(XMLHttpRequestPrototype, "send", ()=>function(self2, args) {
                    if (Zone3.current[fetchTaskScheduling] === true) return sendNative.apply(self2, args);
                    if (self2[XHR_SYNC]) return sendNative.apply(self2, args);
                    else {
                        const options = {
                            target: self2,
                            url: self2[XHR_URL],
                            isPeriodic: false,
                            args: args,
                            aborted: false
                        };
                        const task = $053b4050c185c268$var$scheduleMacroTaskWithCurrentZone(XMLHTTPREQUEST_SOURCE, placeholderCallback, options, scheduleTask, clearTask);
                        if (self2 && self2[XHR_ERROR_BEFORE_SCHEDULED] === true && !options.aborted && task.state === SCHEDULED) task.invoke();
                    }
                });
            const abortNative = $053b4050c185c268$var$patchMethod(XMLHttpRequestPrototype, "abort", ()=>function(self2, args) {
                    const task = findPendingTask(self2);
                    if (task && typeof task.type == "string") {
                        if (task.cancelFn == null || task.data && task.data.aborted) return;
                        task.zone.cancelTask(task);
                    } else if (Zone3.current[fetchTaskAborting] === true) return abortNative.apply(self2, args);
                });
        }
    });
    Zone2.__load_patch("geolocation", (global3)=>{
        if (global3["navigator"] && global3["navigator"].geolocation) $053b4050c185c268$var$patchPrototype(global3["navigator"].geolocation, [
            "getCurrentPosition",
            "watchPosition"
        ]);
    });
    Zone2.__load_patch("PromiseRejectionEvent", (global3, Zone3)=>{
        function findPromiseRejectionHandler(evtName) {
            return function(e) {
                const eventTasks = $053b4050c185c268$var$findEventTasks(global3, evtName);
                eventTasks.forEach((eventTask)=>{
                    const PromiseRejectionEvent = global3["PromiseRejectionEvent"];
                    if (PromiseRejectionEvent) {
                        const evt = new PromiseRejectionEvent(evtName, {
                            promise: e.promise,
                            reason: e.rejection
                        });
                        eventTask.invoke(evt);
                    }
                });
            };
        }
        if (global3["PromiseRejectionEvent"]) {
            Zone3[$053b4050c185c268$var$zoneSymbol("unhandledPromiseRejectionHandler")] = findPromiseRejectionHandler("unhandledrejection");
            Zone3[$053b4050c185c268$var$zoneSymbol("rejectionHandledHandler")] = findPromiseRejectionHandler("rejectionhandled");
        }
    });
    Zone2.__load_patch("queueMicrotask", (global3, Zone3, api)=>{
        $053b4050c185c268$var$patchQueueMicrotask(global3, api);
    });
}
function $053b4050c185c268$var$patchPromise(Zone2) {
    Zone2.__load_patch("ZoneAwarePromise", (global3, Zone3, api)=>{
        const ObjectGetOwnPropertyDescriptor2 = Object.getOwnPropertyDescriptor;
        const ObjectDefineProperty2 = Object.defineProperty;
        function readableObjectToString(obj) {
            if (obj && obj.toString === Object.prototype.toString) {
                const className = obj.constructor && obj.constructor.name;
                return (className ? className : "") + ": " + JSON.stringify(obj);
            }
            return obj ? obj.toString() : Object.prototype.toString.call(obj);
        }
        const __symbol__2 = api.symbol;
        const _uncaughtPromiseErrors = [];
        const isDisableWrappingUncaughtPromiseRejection = global3[__symbol__2("DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION")] !== false;
        const symbolPromise = __symbol__2("Promise");
        const symbolThen = __symbol__2("then");
        const creationTrace = "__creationTrace__";
        api.onUnhandledError = (e)=>{
            if (api.showUncaughtError()) {
                const rejection = e && e.rejection;
                if (rejection) console.error("Unhandled Promise rejection:", rejection instanceof Error ? rejection.message : rejection, "; Zone:", e.zone.name, "; Task:", e.task && e.task.source, "; Value:", rejection, rejection instanceof Error ? rejection.stack : void 0);
                else console.error(e);
            }
        };
        api.microtaskDrainDone = ()=>{
            while(_uncaughtPromiseErrors.length){
                const uncaughtPromiseError = _uncaughtPromiseErrors.shift();
                try {
                    uncaughtPromiseError.zone.runGuarded(()=>{
                        if (uncaughtPromiseError.throwOriginal) throw uncaughtPromiseError.rejection;
                        throw uncaughtPromiseError;
                    });
                } catch (error) {
                    handleUnhandledRejection(error);
                }
            }
        };
        const UNHANDLED_PROMISE_REJECTION_HANDLER_SYMBOL = __symbol__2("unhandledPromiseRejectionHandler");
        function handleUnhandledRejection(e) {
            api.onUnhandledError(e);
            try {
                const handler = Zone3[UNHANDLED_PROMISE_REJECTION_HANDLER_SYMBOL];
                if (typeof handler === "function") handler.call(this, e);
            } catch (err) {}
        }
        function isThenable(value) {
            return value && typeof value.then === "function";
        }
        function forwardResolution(value) {
            return value;
        }
        function forwardRejection(rejection) {
            return ZoneAwarePromise.reject(rejection);
        }
        const symbolState = __symbol__2("state");
        const symbolValue = __symbol__2("value");
        const symbolFinally = __symbol__2("finally");
        const symbolParentPromiseValue = __symbol__2("parentPromiseValue");
        const symbolParentPromiseState = __symbol__2("parentPromiseState");
        const source = "Promise.then";
        const UNRESOLVED = null;
        const RESOLVED = true;
        const REJECTED = false;
        const REJECTED_NO_CATCH = 0;
        function makeResolver(promise, state) {
            return (v)=>{
                try {
                    resolvePromise(promise, state, v);
                } catch (err) {
                    resolvePromise(promise, false, err);
                }
            };
        }
        const once = function() {
            let wasCalled = false;
            return function wrapper(wrappedFunction) {
                return function() {
                    if (wasCalled) return;
                    wasCalled = true;
                    wrappedFunction.apply(null, arguments);
                };
            };
        };
        const TYPE_ERROR = "Promise resolved with itself";
        const CURRENT_TASK_TRACE_SYMBOL = __symbol__2("currentTaskTrace");
        function resolvePromise(promise, state, value) {
            const onceWrapper = once();
            if (promise === value) throw new TypeError(TYPE_ERROR);
            if (promise[symbolState] === UNRESOLVED) {
                let then = null;
                try {
                    if (typeof value === "object" || typeof value === "function") then = value && value.then;
                } catch (err) {
                    onceWrapper(()=>{
                        resolvePromise(promise, false, err);
                    })();
                    return promise;
                }
                if (state !== REJECTED && value instanceof ZoneAwarePromise && value.hasOwnProperty(symbolState) && value.hasOwnProperty(symbolValue) && value[symbolState] !== UNRESOLVED) {
                    clearRejectedNoCatch(value);
                    resolvePromise(promise, value[symbolState], value[symbolValue]);
                } else if (state !== REJECTED && typeof then === "function") try {
                    then.call(value, onceWrapper(makeResolver(promise, state)), onceWrapper(makeResolver(promise, false)));
                } catch (err) {
                    onceWrapper(()=>{
                        resolvePromise(promise, false, err);
                    })();
                }
                else {
                    promise[symbolState] = state;
                    const queue = promise[symbolValue];
                    promise[symbolValue] = value;
                    if (promise[symbolFinally] === symbolFinally) {
                        if (state === RESOLVED) {
                            promise[symbolState] = promise[symbolParentPromiseState];
                            promise[symbolValue] = promise[symbolParentPromiseValue];
                        }
                    }
                    if (state === REJECTED && value instanceof Error) {
                        const trace2 = Zone3.currentTask && Zone3.currentTask.data && Zone3.currentTask.data[creationTrace];
                        if (trace2) ObjectDefineProperty2(value, CURRENT_TASK_TRACE_SYMBOL, {
                            configurable: true,
                            enumerable: false,
                            writable: true,
                            value: trace2
                        });
                    }
                    for(let i = 0; i < queue.length;)scheduleResolveOrReject(promise, queue[i++], queue[i++], queue[i++], queue[i++]);
                    if (queue.length == 0 && state == REJECTED) {
                        promise[symbolState] = REJECTED_NO_CATCH;
                        let uncaughtPromiseError = value;
                        try {
                            throw new Error("Uncaught (in promise): " + readableObjectToString(value) + (value && value.stack ? "\n" + value.stack : ""));
                        } catch (err) {
                            uncaughtPromiseError = err;
                        }
                        if (isDisableWrappingUncaughtPromiseRejection) uncaughtPromiseError.throwOriginal = true;
                        uncaughtPromiseError.rejection = value;
                        uncaughtPromiseError.promise = promise;
                        uncaughtPromiseError.zone = Zone3.current;
                        uncaughtPromiseError.task = Zone3.currentTask;
                        _uncaughtPromiseErrors.push(uncaughtPromiseError);
                        api.scheduleMicroTask();
                    }
                }
            }
            return promise;
        }
        const REJECTION_HANDLED_HANDLER = __symbol__2("rejectionHandledHandler");
        function clearRejectedNoCatch(promise) {
            if (promise[symbolState] === REJECTED_NO_CATCH) {
                try {
                    const handler = Zone3[REJECTION_HANDLED_HANDLER];
                    if (handler && typeof handler === "function") handler.call(this, {
                        rejection: promise[symbolValue],
                        promise: promise
                    });
                } catch (err) {}
                promise[symbolState] = REJECTED;
                for(let i = 0; i < _uncaughtPromiseErrors.length; i++)if (promise === _uncaughtPromiseErrors[i].promise) _uncaughtPromiseErrors.splice(i, 1);
            }
        }
        function scheduleResolveOrReject(promise, zone, chainPromise, onFulfilled, onRejected) {
            clearRejectedNoCatch(promise);
            const promiseState = promise[symbolState];
            const delegate = promiseState ? typeof onFulfilled === "function" ? onFulfilled : forwardResolution : typeof onRejected === "function" ? onRejected : forwardRejection;
            zone.scheduleMicroTask(source, ()=>{
                try {
                    const parentPromiseValue = promise[symbolValue];
                    const isFinallyPromise = !!chainPromise && symbolFinally === chainPromise[symbolFinally];
                    if (isFinallyPromise) {
                        chainPromise[symbolParentPromiseValue] = parentPromiseValue;
                        chainPromise[symbolParentPromiseState] = promiseState;
                    }
                    const value = zone.run(delegate, void 0, isFinallyPromise && delegate !== forwardRejection && delegate !== forwardResolution ? [] : [
                        parentPromiseValue
                    ]);
                    resolvePromise(chainPromise, true, value);
                } catch (error) {
                    resolvePromise(chainPromise, false, error);
                }
            }, chainPromise);
        }
        const ZONE_AWARE_PROMISE_TO_STRING = "function ZoneAwarePromise() { [native code] }";
        const noop = function() {};
        const AggregateError = global3.AggregateError;
        class ZoneAwarePromise {
            static toString() {
                return ZONE_AWARE_PROMISE_TO_STRING;
            }
            static resolve(value) {
                if (value instanceof ZoneAwarePromise) return value;
                return resolvePromise(new this(null), RESOLVED, value);
            }
            static reject(error) {
                return resolvePromise(new this(null), REJECTED, error);
            }
            static withResolvers() {
                const result = {};
                result.promise = new ZoneAwarePromise((res, rej)=>{
                    result.resolve = res;
                    result.reject = rej;
                });
                return result;
            }
            static any(values) {
                if (!values || typeof values[Symbol.iterator] !== "function") return Promise.reject(new AggregateError([], "All promises were rejected"));
                const promises = [];
                let count = 0;
                try {
                    for (let v of values){
                        count++;
                        promises.push(ZoneAwarePromise.resolve(v));
                    }
                } catch (err) {
                    return Promise.reject(new AggregateError([], "All promises were rejected"));
                }
                if (count === 0) return Promise.reject(new AggregateError([], "All promises were rejected"));
                let finished = false;
                const errors = [];
                return new ZoneAwarePromise((resolve, reject)=>{
                    for(let i = 0; i < promises.length; i++)promises[i].then((v)=>{
                        if (finished) return;
                        finished = true;
                        resolve(v);
                    }, (err)=>{
                        errors.push(err);
                        count--;
                        if (count === 0) {
                            finished = true;
                            reject(new AggregateError(errors, "All promises were rejected"));
                        }
                    });
                });
            }
            static race(values) {
                let resolve;
                let reject;
                let promise = new this((res, rej)=>{
                    resolve = res;
                    reject = rej;
                });
                function onResolve(value) {
                    resolve(value);
                }
                function onReject(error) {
                    reject(error);
                }
                for (let value of values){
                    if (!isThenable(value)) value = this.resolve(value);
                    value.then(onResolve, onReject);
                }
                return promise;
            }
            static all(values) {
                return ZoneAwarePromise.allWithCallback(values);
            }
            static allSettled(values) {
                const P = this && this.prototype instanceof ZoneAwarePromise ? this : ZoneAwarePromise;
                return P.allWithCallback(values, {
                    thenCallback: (value)=>({
                            status: "fulfilled",
                            value: value
                        }),
                    errorCallback: (err)=>({
                            status: "rejected",
                            reason: err
                        })
                });
            }
            static allWithCallback(values, callback) {
                let resolve;
                let reject;
                let promise = new this((res, rej)=>{
                    resolve = res;
                    reject = rej;
                });
                let unresolvedCount = 2;
                let valueIndex = 0;
                const resolvedValues = [];
                for (let value of values){
                    if (!isThenable(value)) value = this.resolve(value);
                    const curValueIndex = valueIndex;
                    try {
                        value.then((value2)=>{
                            resolvedValues[curValueIndex] = callback ? callback.thenCallback(value2) : value2;
                            unresolvedCount--;
                            if (unresolvedCount === 0) resolve(resolvedValues);
                        }, (err)=>{
                            if (!callback) reject(err);
                            else {
                                resolvedValues[curValueIndex] = callback.errorCallback(err);
                                unresolvedCount--;
                                if (unresolvedCount === 0) resolve(resolvedValues);
                            }
                        });
                    } catch (thenErr) {
                        reject(thenErr);
                    }
                    unresolvedCount++;
                    valueIndex++;
                }
                unresolvedCount -= 2;
                if (unresolvedCount === 0) resolve(resolvedValues);
                return promise;
            }
            constructor(executor){
                const promise = this;
                if (!(promise instanceof ZoneAwarePromise)) throw new Error("Must be an instanceof Promise.");
                promise[symbolState] = UNRESOLVED;
                promise[symbolValue] = [];
                try {
                    const onceWrapper = once();
                    executor && executor(onceWrapper(makeResolver(promise, RESOLVED)), onceWrapper(makeResolver(promise, REJECTED)));
                } catch (error) {
                    resolvePromise(promise, false, error);
                }
            }
            get [Symbol.toStringTag]() {
                return "Promise";
            }
            get [Symbol.species]() {
                return ZoneAwarePromise;
            }
            then(onFulfilled, onRejected) {
                let C = this.constructor?.[Symbol.species];
                if (!C || typeof C !== "function") C = this.constructor || ZoneAwarePromise;
                const chainPromise = new C(noop);
                const zone = Zone3.current;
                if (this[symbolState] == UNRESOLVED) this[symbolValue].push(zone, chainPromise, onFulfilled, onRejected);
                else scheduleResolveOrReject(this, zone, chainPromise, onFulfilled, onRejected);
                return chainPromise;
            }
            catch(onRejected) {
                return this.then(null, onRejected);
            }
            finally(onFinally) {
                let C = this.constructor?.[Symbol.species];
                if (!C || typeof C !== "function") C = ZoneAwarePromise;
                const chainPromise = new C(noop);
                chainPromise[symbolFinally] = symbolFinally;
                const zone = Zone3.current;
                if (this[symbolState] == UNRESOLVED) this[symbolValue].push(zone, chainPromise, onFinally, onFinally);
                else scheduleResolveOrReject(this, zone, chainPromise, onFinally, onFinally);
                return chainPromise;
            }
        }
        ZoneAwarePromise["resolve"] = ZoneAwarePromise.resolve;
        ZoneAwarePromise["reject"] = ZoneAwarePromise.reject;
        ZoneAwarePromise["race"] = ZoneAwarePromise.race;
        ZoneAwarePromise["all"] = ZoneAwarePromise.all;
        const NativePromise = global3[symbolPromise] = global3["Promise"];
        global3["Promise"] = ZoneAwarePromise;
        const symbolThenPatched = __symbol__2("thenPatched");
        function patchThen(Ctor) {
            const proto = Ctor.prototype;
            const prop = ObjectGetOwnPropertyDescriptor2(proto, "then");
            if (prop && (prop.writable === false || !prop.configurable)) return;
            const originalThen = proto.then;
            proto[symbolThen] = originalThen;
            Ctor.prototype.then = function(onResolve, onReject) {
                const wrapped = new ZoneAwarePromise((resolve, reject)=>{
                    originalThen.call(this, resolve, reject);
                });
                return wrapped.then(onResolve, onReject);
            };
            Ctor[symbolThenPatched] = true;
        }
        api.patchThen = patchThen;
        function zoneify(fn) {
            return function(self2, args) {
                let resultPromise = fn.apply(self2, args);
                if (resultPromise instanceof ZoneAwarePromise) return resultPromise;
                let ctor = resultPromise.constructor;
                if (!ctor[symbolThenPatched]) patchThen(ctor);
                return resultPromise;
            };
        }
        if (NativePromise) {
            patchThen(NativePromise);
            $053b4050c185c268$var$patchMethod(global3, "fetch", (delegate)=>zoneify(delegate));
        }
        Promise[Zone3.__symbol__("uncaughtPromiseErrors")] = _uncaughtPromiseErrors;
        return ZoneAwarePromise;
    });
}
function $053b4050c185c268$var$patchToString(Zone2) {
    Zone2.__load_patch("toString", (global3)=>{
        const originalFunctionToString = Function.prototype.toString;
        const ORIGINAL_DELEGATE_SYMBOL = $053b4050c185c268$var$zoneSymbol("OriginalDelegate");
        const PROMISE_SYMBOL = $053b4050c185c268$var$zoneSymbol("Promise");
        const ERROR_SYMBOL = $053b4050c185c268$var$zoneSymbol("Error");
        const newFunctionToString = function toString() {
            if (typeof this === "function") {
                const originalDelegate = this[ORIGINAL_DELEGATE_SYMBOL];
                if (originalDelegate) {
                    if (typeof originalDelegate === "function") return originalFunctionToString.call(originalDelegate);
                    else return Object.prototype.toString.call(originalDelegate);
                }
                if (this === Promise) {
                    const nativePromise = global3[PROMISE_SYMBOL];
                    if (nativePromise) return originalFunctionToString.call(nativePromise);
                }
                if (this === Error) {
                    const nativeError = global3[ERROR_SYMBOL];
                    if (nativeError) return originalFunctionToString.call(nativeError);
                }
            }
            return originalFunctionToString.call(this);
        };
        newFunctionToString[ORIGINAL_DELEGATE_SYMBOL] = originalFunctionToString;
        Function.prototype.toString = newFunctionToString;
        const originalObjectToString = Object.prototype.toString;
        const PROMISE_OBJECT_TO_STRING = "[object Promise]";
        Object.prototype.toString = function() {
            if (typeof Promise === "function" && this instanceof Promise) return PROMISE_OBJECT_TO_STRING;
            return originalObjectToString.call(this);
        };
    });
}
function $053b4050c185c268$var$patchCallbacks(api, target, targetName, method, callbacks) {
    const symbol = Zone.__symbol__(method);
    if (target[symbol]) return;
    const nativeDelegate = target[symbol] = target[method];
    target[method] = function(name, opts, options) {
        if (opts && opts.prototype) callbacks.forEach(function(callback) {
            const source = `${targetName}.${method}::` + callback;
            const prototype = opts.prototype;
            try {
                if (prototype.hasOwnProperty(callback)) {
                    const descriptor = api.ObjectGetOwnPropertyDescriptor(prototype, callback);
                    if (descriptor && descriptor.value) {
                        descriptor.value = api.wrapWithCurrentZone(descriptor.value, source);
                        api._redefineProperty(opts.prototype, callback, descriptor);
                    } else if (prototype[callback]) prototype[callback] = api.wrapWithCurrentZone(prototype[callback], source);
                } else if (prototype[callback]) prototype[callback] = api.wrapWithCurrentZone(prototype[callback], source);
            } catch  {}
        });
        return nativeDelegate.call(target, name, opts, options);
    };
    api.attachOriginToPatched(target[method], nativeDelegate);
}
function $053b4050c185c268$var$patchUtil(Zone2) {
    Zone2.__load_patch("util", (global3, Zone3, api)=>{
        const eventNames = $053b4050c185c268$var$getOnEventNames(global3);
        api.patchOnProperties = $053b4050c185c268$var$patchOnProperties;
        api.patchMethod = $053b4050c185c268$var$patchMethod;
        api.bindArguments = $053b4050c185c268$var$bindArguments;
        api.patchMacroTask = $053b4050c185c268$var$patchMacroTask;
        const SYMBOL_BLACK_LISTED_EVENTS = Zone3.__symbol__("BLACK_LISTED_EVENTS");
        const SYMBOL_UNPATCHED_EVENTS = Zone3.__symbol__("UNPATCHED_EVENTS");
        if (global3[SYMBOL_UNPATCHED_EVENTS]) global3[SYMBOL_BLACK_LISTED_EVENTS] = global3[SYMBOL_UNPATCHED_EVENTS];
        if (global3[SYMBOL_BLACK_LISTED_EVENTS]) Zone3[SYMBOL_BLACK_LISTED_EVENTS] = Zone3[SYMBOL_UNPATCHED_EVENTS] = global3[SYMBOL_BLACK_LISTED_EVENTS];
        api.patchEventPrototype = $053b4050c185c268$var$patchEventPrototype;
        api.patchEventTarget = $053b4050c185c268$var$patchEventTarget;
        api.isIEOrEdge = $053b4050c185c268$var$isIEOrEdge;
        api.ObjectDefineProperty = $053b4050c185c268$var$ObjectDefineProperty;
        api.ObjectGetOwnPropertyDescriptor = $053b4050c185c268$var$ObjectGetOwnPropertyDescriptor;
        api.ObjectCreate = $053b4050c185c268$var$ObjectCreate;
        api.ArraySlice = $053b4050c185c268$var$ArraySlice;
        api.patchClass = $053b4050c185c268$var$patchClass;
        api.wrapWithCurrentZone = $053b4050c185c268$var$wrapWithCurrentZone;
        api.filterProperties = $053b4050c185c268$var$filterProperties;
        api.attachOriginToPatched = $053b4050c185c268$var$attachOriginToPatched;
        api._redefineProperty = Object.defineProperty;
        api.patchCallbacks = $053b4050c185c268$var$patchCallbacks;
        api.getGlobalObjects = ()=>({
                globalSources: $053b4050c185c268$var$globalSources,
                zoneSymbolEventNames: $053b4050c185c268$var$zoneSymbolEventNames,
                eventNames: eventNames,
                isBrowser: $053b4050c185c268$var$isBrowser,
                isMix: $053b4050c185c268$var$isMix,
                isNode: $053b4050c185c268$var$isNode,
                TRUE_STR: $053b4050c185c268$var$TRUE_STR,
                FALSE_STR: $053b4050c185c268$var$FALSE_STR,
                ZONE_SYMBOL_PREFIX: $053b4050c185c268$var$ZONE_SYMBOL_PREFIX,
                ADD_EVENT_LISTENER_STR: $053b4050c185c268$var$ADD_EVENT_LISTENER_STR,
                REMOVE_EVENT_LISTENER_STR: $053b4050c185c268$var$REMOVE_EVENT_LISTENER_STR
            });
    });
}
function $053b4050c185c268$var$patchCommon(Zone2) {
    $053b4050c185c268$var$patchPromise(Zone2);
    $053b4050c185c268$var$patchToString(Zone2);
    $053b4050c185c268$var$patchUtil(Zone2);
}
var $053b4050c185c268$var$Zone$1 = $053b4050c185c268$var$loadZone();
$053b4050c185c268$var$patchCommon($053b4050c185c268$var$Zone$1);
$053b4050c185c268$var$patchBrowser($053b4050c185c268$var$Zone$1);
// ../../node_modules/.pnpm/@opentelemetry+otlp-exporter-base@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-exporter-base/build/esm/OTLPExporterBase.js
var $053b4050c185c268$var$OTLPExporterBase = /** @class */ function() {
    function OTLPExporterBase2(_delegate) {
        this._delegate = _delegate;
    }
    OTLPExporterBase2.prototype.export = function(items, resultCallback) {
        this._delegate.export(items, resultCallback);
    };
    OTLPExporterBase2.prototype.forceFlush = function() {
        return this._delegate.forceFlush();
    };
    OTLPExporterBase2.prototype.shutdown = function() {
        return this._delegate.shutdown();
    };
    return OTLPExporterBase2;
}();
// ../../node_modules/.pnpm/@opentelemetry+otlp-exporter-base@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-exporter-base/build/esm/types.js
var $053b4050c185c268$var$__extends2 = /* @__PURE__ */ function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d2, b2) {
            d2.__proto__ = b2;
        } || function(d2, b2) {
            for(var p in b2)if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $053b4050c185c268$var$OTLPExporterError = /** @class */ function(_super) {
    $053b4050c185c268$var$__extends2(OTLPExporterError2, _super);
    function OTLPExporterError2(message, code, data) {
        var _this = _super.call(this, message) || this;
        _this.name = "OTLPExporterError";
        _this.data = data;
        _this.code = code;
        return _this;
    }
    return OTLPExporterError2;
}(Error);
// ../../node_modules/.pnpm/@opentelemetry+otlp-exporter-base@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-exporter-base/build/esm/configuration/shared-configuration.js
function $053b4050c185c268$var$validateTimeoutMillis(timeoutMillis) {
    if (!Number.isNaN(timeoutMillis) && Number.isFinite(timeoutMillis) && timeoutMillis > 0) return timeoutMillis;
    throw new Error("Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '" + timeoutMillis + "')");
}
function $053b4050c185c268$var$wrapStaticHeadersInFunction(headers) {
    if (headers == null) return void 0;
    return function() {
        return headers;
    };
}
function $053b4050c185c268$var$mergeOtlpSharedConfigurationWithDefaults(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration) {
    var _a3, _b, _c, _d, _e, _f;
    return {
        timeoutMillis: $053b4050c185c268$var$validateTimeoutMillis((_b = (_a3 = userProvidedConfiguration.timeoutMillis) !== null && _a3 !== void 0 ? _a3 : fallbackConfiguration.timeoutMillis) !== null && _b !== void 0 ? _b : defaultConfiguration.timeoutMillis),
        concurrencyLimit: (_d = (_c = userProvidedConfiguration.concurrencyLimit) !== null && _c !== void 0 ? _c : fallbackConfiguration.concurrencyLimit) !== null && _d !== void 0 ? _d : defaultConfiguration.concurrencyLimit,
        compression: (_f = (_e = userProvidedConfiguration.compression) !== null && _e !== void 0 ? _e : fallbackConfiguration.compression) !== null && _f !== void 0 ? _f : defaultConfiguration.compression
    };
}
function $053b4050c185c268$var$getSharedConfigurationDefaults() {
    return {
        timeoutMillis: 1e4,
        concurrencyLimit: 30,
        compression: "none"
    };
}
// ../../node_modules/.pnpm/@opentelemetry+otlp-exporter-base@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-exporter-base/build/esm/bounded-queue-export-promise-handler.js
var $053b4050c185c268$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $053b4050c185c268$var$__generator = function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $053b4050c185c268$var$BoundedQueueExportPromiseHandler = /** @class */ function() {
    function BoundedQueueExportPromiseHandler2(concurrencyLimit) {
        this._sendingPromises = [];
        this._concurrencyLimit = concurrencyLimit;
    }
    BoundedQueueExportPromiseHandler2.prototype.pushPromise = function(promise) {
        var _this = this;
        if (this.hasReachedLimit()) throw new Error("Concurrency Limit reached");
        this._sendingPromises.push(promise);
        var popPromise = function() {
            var index = _this._sendingPromises.indexOf(promise);
            _this._sendingPromises.splice(index, 1);
        };
        promise.then(popPromise, popPromise);
    };
    BoundedQueueExportPromiseHandler2.prototype.hasReachedLimit = function() {
        return this._sendingPromises.length >= this._concurrencyLimit;
    };
    BoundedQueueExportPromiseHandler2.prototype.awaitAll = function() {
        return $053b4050c185c268$var$__awaiter(this, void 0, void 0, function() {
            return $053b4050c185c268$var$__generator(this, function(_a3) {
                switch(_a3.label){
                    case 0:
                        return [
                            4,
                            Promise.all(this._sendingPromises)
                        ];
                    case 1:
                        _a3.sent();
                        return [
                            2
                        ];
                }
            });
        });
    };
    return BoundedQueueExportPromiseHandler2;
}();
function $053b4050c185c268$var$createBoundedQueueExportPromiseHandler(options) {
    return new $053b4050c185c268$var$BoundedQueueExportPromiseHandler(options.concurrencyLimit);
}
// ../../node_modules/.pnpm/@opentelemetry+otlp-exporter-base@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-exporter-base/build/esm/logging-response-handler.js
function $053b4050c185c268$var$isPartialSuccessResponse(response) {
    return Object.prototype.hasOwnProperty.call(response, "partialSuccess");
}
function $053b4050c185c268$var$createLoggingPartialSuccessResponseHandler() {
    return {
        handleResponse: function(response) {
            if (response == null || !$053b4050c185c268$var$isPartialSuccessResponse(response) || response.partialSuccess == null || Object.keys(response.partialSuccess).length === 0) return;
            $053b4050c185c268$var$diag2.warn("Received Partial Success response:", JSON.stringify(response.partialSuccess));
        }
    };
}
// ../../node_modules/.pnpm/@opentelemetry+otlp-exporter-base@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-exporter-base/build/esm/otlp-export-delegate.js
var $053b4050c185c268$var$__awaiter2 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $053b4050c185c268$var$__generator2 = function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $053b4050c185c268$var$OTLPExportDelegate = /** @class */ function() {
    function OTLPExportDelegate2(_transport, _serializer, _responseHandler, _promiseQueue, _timeout) {
        this._transport = _transport;
        this._serializer = _serializer;
        this._responseHandler = _responseHandler;
        this._promiseQueue = _promiseQueue;
        this._timeout = _timeout;
        this._diagLogger = $053b4050c185c268$var$diag2.createComponentLogger({
            namespace: "OTLPExportDelegate"
        });
    }
    OTLPExportDelegate2.prototype.export = function(internalRepresentation, resultCallback) {
        var _this = this;
        this._diagLogger.debug("items to be sent", internalRepresentation);
        if (this._promiseQueue.hasReachedLimit()) {
            resultCallback({
                code: $053b4050c185c268$var$ExportResultCode.FAILED,
                error: new Error("Concurrent export limit reached")
            });
            return;
        }
        var serializedRequest = this._serializer.serializeRequest(internalRepresentation);
        if (serializedRequest == null) {
            resultCallback({
                code: $053b4050c185c268$var$ExportResultCode.FAILED,
                error: new Error("Nothing to send")
            });
            return;
        }
        this._promiseQueue.pushPromise(this._transport.send(serializedRequest, this._timeout).then(function(response) {
            if (response.status === "success") {
                if (response.data != null) try {
                    _this._responseHandler.handleResponse(_this._serializer.deserializeResponse(response.data));
                } catch (e) {
                    _this._diagLogger.warn("Export succeeded but could not deserialize response - is the response specification compliant?", e, response.data);
                }
                resultCallback({
                    code: $053b4050c185c268$var$ExportResultCode.SUCCESS
                });
                return;
            } else if (response.status === "failure" && response.error) {
                resultCallback({
                    code: $053b4050c185c268$var$ExportResultCode.FAILED,
                    error: response.error
                });
                return;
            } else if (response.status === "retryable") resultCallback({
                code: $053b4050c185c268$var$ExportResultCode.FAILED,
                error: new $053b4050c185c268$var$OTLPExporterError("Export failed with retryable status")
            });
            else resultCallback({
                code: $053b4050c185c268$var$ExportResultCode.FAILED,
                error: new $053b4050c185c268$var$OTLPExporterError("Export failed with unknown error")
            });
        }, function(reason) {
            return resultCallback({
                code: $053b4050c185c268$var$ExportResultCode.FAILED,
                error: reason
            });
        }));
    };
    OTLPExportDelegate2.prototype.forceFlush = function() {
        return this._promiseQueue.awaitAll();
    };
    OTLPExportDelegate2.prototype.shutdown = function() {
        return $053b4050c185c268$var$__awaiter2(this, void 0, void 0, function() {
            return $053b4050c185c268$var$__generator2(this, function(_a3) {
                switch(_a3.label){
                    case 0:
                        this._diagLogger.debug("shutdown started");
                        return [
                            4,
                            this.forceFlush()
                        ];
                    case 1:
                        _a3.sent();
                        this._transport.shutdown();
                        return [
                            2
                        ];
                }
            });
        });
    };
    return OTLPExportDelegate2;
}();
function $053b4050c185c268$var$createOtlpExportDelegate(components, settings) {
    return new $053b4050c185c268$var$OTLPExportDelegate(components.transport, components.serializer, $053b4050c185c268$var$createLoggingPartialSuccessResponseHandler(), components.promiseHandler, settings.timeout);
}
// ../../node_modules/.pnpm/@opentelemetry+otlp-exporter-base@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-exporter-base/build/esm/otlp-network-export-delegate.js
function $053b4050c185c268$var$createOtlpNetworkExportDelegate(options, serializer, transport) {
    return $053b4050c185c268$var$createOtlpExportDelegate({
        transport: transport,
        serializer: serializer,
        promiseHandler: $053b4050c185c268$var$createBoundedQueueExportPromiseHandler(options)
    }, {
        timeout: options.timeoutMillis
    });
}
// ../../node_modules/.pnpm/@opentelemetry+otlp-transformer@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-transformer/build/esm/common/utils.js
function $053b4050c185c268$var$hrTimeToNanos(hrTime3) {
    var NANOSECONDS = BigInt(1e9);
    return BigInt(hrTime3[0]) * NANOSECONDS + BigInt(hrTime3[1]);
}
function $053b4050c185c268$var$toLongBits(value) {
    var low = Number(BigInt.asUintN(32, value));
    var high = Number(BigInt.asUintN(32, value >> BigInt(32)));
    return {
        low: low,
        high: high
    };
}
function $053b4050c185c268$var$encodeAsLongBits(hrTime3) {
    var nanos = $053b4050c185c268$var$hrTimeToNanos(hrTime3);
    return $053b4050c185c268$var$toLongBits(nanos);
}
function $053b4050c185c268$var$encodeAsString(hrTime3) {
    var nanos = $053b4050c185c268$var$hrTimeToNanos(hrTime3);
    return nanos.toString();
}
var $053b4050c185c268$var$encodeTimestamp = typeof BigInt !== "undefined" ? $053b4050c185c268$var$encodeAsString : $053b4050c185c268$var$hrTimeToNanoseconds;
function $053b4050c185c268$var$identity(value) {
    return value;
}
function $053b4050c185c268$var$optionalHexToBinary(str) {
    if (str === void 0) return void 0;
    return $053b4050c185c268$var$hexToBinary(str);
}
var $053b4050c185c268$var$DEFAULT_ENCODER = {
    encodeHrTime: $053b4050c185c268$var$encodeAsLongBits,
    encodeSpanContext: $053b4050c185c268$var$hexToBinary,
    encodeOptionalSpanContext: $053b4050c185c268$var$optionalHexToBinary
};
function $053b4050c185c268$var$getOtlpEncoder(options) {
    var _a3, _b;
    if (options === void 0) return $053b4050c185c268$var$DEFAULT_ENCODER;
    var useLongBits = (_a3 = options.useLongBits) !== null && _a3 !== void 0 ? _a3 : true;
    var useHex = (_b = options.useHex) !== null && _b !== void 0 ? _b : false;
    return {
        encodeHrTime: useLongBits ? $053b4050c185c268$var$encodeAsLongBits : $053b4050c185c268$var$encodeTimestamp,
        encodeSpanContext: useHex ? $053b4050c185c268$var$identity : $053b4050c185c268$var$hexToBinary,
        encodeOptionalSpanContext: useHex ? $053b4050c185c268$var$identity : $053b4050c185c268$var$optionalHexToBinary
    };
}
// ../../node_modules/.pnpm/@opentelemetry+otlp-transformer@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-transformer/build/esm/common/internal.js
var $053b4050c185c268$var$__read9 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $053b4050c185c268$var$createResource(resource) {
    return {
        attributes: $053b4050c185c268$var$toAttributes(resource.attributes),
        droppedAttributesCount: 0
    };
}
function $053b4050c185c268$var$createInstrumentationScope(scope) {
    return {
        name: scope.name,
        version: scope.version
    };
}
function $053b4050c185c268$var$toAttributes(attributes) {
    return Object.keys(attributes).map(function(key) {
        return $053b4050c185c268$var$toKeyValue(key, attributes[key]);
    });
}
function $053b4050c185c268$var$toKeyValue(key, value) {
    return {
        key: key,
        value: $053b4050c185c268$var$toAnyValue(value)
    };
}
function $053b4050c185c268$var$toAnyValue(value) {
    var t = typeof value;
    if (t === "string") return {
        stringValue: value
    };
    if (t === "number") {
        if (!Number.isInteger(value)) return {
            doubleValue: value
        };
        return {
            intValue: value
        };
    }
    if (t === "boolean") return {
        boolValue: value
    };
    if (value instanceof Uint8Array) return {
        bytesValue: value
    };
    if (Array.isArray(value)) return {
        arrayValue: {
            values: value.map($053b4050c185c268$var$toAnyValue)
        }
    };
    if (t === "object" && value != null) return {
        kvlistValue: {
            values: Object.entries(value).map(function(_a3) {
                var _b = $053b4050c185c268$var$__read9(_a3, 2), k = _b[0], v = _b[1];
                return $053b4050c185c268$var$toKeyValue(k, v);
            })
        }
    };
    return {};
}
// ../../node_modules/.pnpm/@opentelemetry+resources@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/resources/build/esm/platform/browser/default-service-name.js
function $053b4050c185c268$var$defaultServiceName() {
    return "unknown_service";
}
// ../../node_modules/.pnpm/@opentelemetry+resources@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/resources/build/esm/Resource.js
var $053b4050c185c268$var$__assign = function() {
    $053b4050c185c268$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $053b4050c185c268$var$__assign.apply(this, arguments);
};
var $053b4050c185c268$var$__awaiter3 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $053b4050c185c268$var$__generator3 = function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $053b4050c185c268$var$__read10 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $053b4050c185c268$var$Resource = /** @class */ function() {
    function Resource2(attributes, asyncAttributesPromise) {
        var _this = this;
        var _a3;
        this._attributes = attributes;
        this.asyncAttributesPending = asyncAttributesPromise != null;
        this._syncAttributes = (_a3 = this._attributes) !== null && _a3 !== void 0 ? _a3 : {};
        this._asyncAttributesPromise = asyncAttributesPromise === null || asyncAttributesPromise === void 0 ? void 0 : asyncAttributesPromise.then(function(asyncAttributes) {
            _this._attributes = Object.assign({}, _this._attributes, asyncAttributes);
            _this.asyncAttributesPending = false;
            return asyncAttributes;
        }, function(err) {
            $053b4050c185c268$var$diag2.debug("a resource's async attributes promise rejected: %s", err);
            _this.asyncAttributesPending = false;
            return {};
        });
    }
    Resource2.empty = function() {
        return Resource2.EMPTY;
    };
    Resource2.default = function() {
        var _a3;
        return new Resource2((_a3 = {}, _a3[$053b4050c185c268$var$SEMRESATTRS_SERVICE_NAME] = $053b4050c185c268$var$defaultServiceName(), _a3[$053b4050c185c268$var$SEMRESATTRS_TELEMETRY_SDK_LANGUAGE] = $053b4050c185c268$var$SDK_INFO[$053b4050c185c268$var$SEMRESATTRS_TELEMETRY_SDK_LANGUAGE], _a3[$053b4050c185c268$var$SEMRESATTRS_TELEMETRY_SDK_NAME] = $053b4050c185c268$var$SDK_INFO[$053b4050c185c268$var$SEMRESATTRS_TELEMETRY_SDK_NAME], _a3[$053b4050c185c268$var$SEMRESATTRS_TELEMETRY_SDK_VERSION] = $053b4050c185c268$var$SDK_INFO[$053b4050c185c268$var$SEMRESATTRS_TELEMETRY_SDK_VERSION], _a3));
    };
    Object.defineProperty(Resource2.prototype, "attributes", {
        get: function() {
            var _a3;
            if (this.asyncAttributesPending) $053b4050c185c268$var$diag2.error("Accessing resource attributes before async attributes settled");
            return (_a3 = this._attributes) !== null && _a3 !== void 0 ? _a3 : {};
        },
        enumerable: false,
        configurable: true
    });
    Resource2.prototype.waitForAsyncAttributes = function() {
        return $053b4050c185c268$var$__awaiter3(this, void 0, void 0, function() {
            return $053b4050c185c268$var$__generator3(this, function(_a3) {
                switch(_a3.label){
                    case 0:
                        if (!this.asyncAttributesPending) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this._asyncAttributesPromise
                        ];
                    case 1:
                        _a3.sent();
                        _a3.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    };
    Resource2.prototype.merge = function(other) {
        var _this = this;
        var _a3;
        if (!other) return this;
        var mergedSyncAttributes = $053b4050c185c268$var$__assign($053b4050c185c268$var$__assign({}, this._syncAttributes), (_a3 = other._syncAttributes) !== null && _a3 !== void 0 ? _a3 : other.attributes);
        if (!this._asyncAttributesPromise && !other._asyncAttributesPromise) return new Resource2(mergedSyncAttributes);
        var mergedAttributesPromise = Promise.all([
            this._asyncAttributesPromise,
            other._asyncAttributesPromise
        ]).then(function(_a4) {
            var _b;
            var _c = $053b4050c185c268$var$__read10(_a4, 2), thisAsyncAttributes = _c[0], otherAsyncAttributes = _c[1];
            return $053b4050c185c268$var$__assign($053b4050c185c268$var$__assign($053b4050c185c268$var$__assign($053b4050c185c268$var$__assign({}, _this._syncAttributes), thisAsyncAttributes), (_b = other._syncAttributes) !== null && _b !== void 0 ? _b : other.attributes), otherAsyncAttributes);
        });
        return new Resource2(mergedSyncAttributes, mergedAttributesPromise);
    };
    Resource2.EMPTY = new Resource2({});
    return Resource2;
}();
// ../../node_modules/.pnpm/@opentelemetry+otlp-transformer@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-transformer/build/esm/trace/internal.js
var $053b4050c185c268$var$__values5 = function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $053b4050c185c268$var$__read11 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $053b4050c185c268$var$sdkSpanToOtlpSpan(span, encoder) {
    var _a3;
    var ctx = span.spanContext();
    var status = span.status;
    return {
        traceId: encoder.encodeSpanContext(ctx.traceId),
        spanId: encoder.encodeSpanContext(ctx.spanId),
        parentSpanId: encoder.encodeOptionalSpanContext(span.parentSpanId),
        traceState: (_a3 = ctx.traceState) === null || _a3 === void 0 ? void 0 : _a3.serialize(),
        name: span.name,
        // Span kind is offset by 1 because the API does not define a value for unset
        kind: span.kind == null ? 0 : span.kind + 1,
        startTimeUnixNano: encoder.encodeHrTime(span.startTime),
        endTimeUnixNano: encoder.encodeHrTime(span.endTime),
        attributes: $053b4050c185c268$var$toAttributes(span.attributes),
        droppedAttributesCount: span.droppedAttributesCount,
        events: span.events.map(function(event) {
            return $053b4050c185c268$var$toOtlpSpanEvent(event, encoder);
        }),
        droppedEventsCount: span.droppedEventsCount,
        status: {
            // API and proto enums share the same values
            code: status.code,
            message: status.message
        },
        links: span.links.map(function(link) {
            return $053b4050c185c268$var$toOtlpLink(link, encoder);
        }),
        droppedLinksCount: span.droppedLinksCount
    };
}
function $053b4050c185c268$var$toOtlpLink(link, encoder) {
    var _a3;
    return {
        attributes: link.attributes ? $053b4050c185c268$var$toAttributes(link.attributes) : [],
        spanId: encoder.encodeSpanContext(link.context.spanId),
        traceId: encoder.encodeSpanContext(link.context.traceId),
        traceState: (_a3 = link.context.traceState) === null || _a3 === void 0 ? void 0 : _a3.serialize(),
        droppedAttributesCount: link.droppedAttributesCount || 0
    };
}
function $053b4050c185c268$var$toOtlpSpanEvent(timedEvent, encoder) {
    return {
        attributes: timedEvent.attributes ? $053b4050c185c268$var$toAttributes(timedEvent.attributes) : [],
        name: timedEvent.name,
        timeUnixNano: encoder.encodeHrTime(timedEvent.time),
        droppedAttributesCount: timedEvent.droppedAttributesCount || 0
    };
}
function $053b4050c185c268$var$createExportTraceServiceRequest(spans, options) {
    var encoder = $053b4050c185c268$var$getOtlpEncoder(options);
    return {
        resourceSpans: $053b4050c185c268$var$spanRecordsToResourceSpans(spans, encoder)
    };
}
function $053b4050c185c268$var$createResourceMap(readableSpans) {
    var e_1, _a3;
    var resourceMap = /* @__PURE__ */ new Map();
    try {
        for(var readableSpans_1 = $053b4050c185c268$var$__values5(readableSpans), readableSpans_1_1 = readableSpans_1.next(); !readableSpans_1_1.done; readableSpans_1_1 = readableSpans_1.next()){
            var record = readableSpans_1_1.value;
            var ilmMap = resourceMap.get(record.resource);
            if (!ilmMap) {
                ilmMap = /* @__PURE__ */ new Map();
                resourceMap.set(record.resource, ilmMap);
            }
            var instrumentationLibraryKey = record.instrumentationLibrary.name + "@" + (record.instrumentationLibrary.version || "") + ":" + (record.instrumentationLibrary.schemaUrl || "");
            var records = ilmMap.get(instrumentationLibraryKey);
            if (!records) {
                records = [];
                ilmMap.set(instrumentationLibraryKey, records);
            }
            records.push(record);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (readableSpans_1_1 && !readableSpans_1_1.done && (_a3 = readableSpans_1.return)) _a3.call(readableSpans_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return resourceMap;
}
function $053b4050c185c268$var$spanRecordsToResourceSpans(readableSpans, encoder) {
    var resourceMap = $053b4050c185c268$var$createResourceMap(readableSpans);
    var out = [];
    var entryIterator = resourceMap.entries();
    var entry = entryIterator.next();
    while(!entry.done){
        var _a3 = $053b4050c185c268$var$__read11(entry.value, 2), resource = _a3[0], ilmMap = _a3[1];
        var scopeResourceSpans = [];
        var ilmIterator = ilmMap.values();
        var ilmEntry = ilmIterator.next();
        while(!ilmEntry.done){
            var scopeSpans = ilmEntry.value;
            if (scopeSpans.length > 0) {
                var spans = scopeSpans.map(function(readableSpan) {
                    return $053b4050c185c268$var$sdkSpanToOtlpSpan(readableSpan, encoder);
                });
                scopeResourceSpans.push({
                    scope: $053b4050c185c268$var$createInstrumentationScope(scopeSpans[0].instrumentationLibrary),
                    spans: spans,
                    schemaUrl: scopeSpans[0].instrumentationLibrary.schemaUrl
                });
            }
            ilmEntry = ilmIterator.next();
        }
        var transformedSpans = {
            resource: $053b4050c185c268$var$createResource(resource),
            scopeSpans: scopeResourceSpans,
            schemaUrl: void 0
        };
        out.push(transformedSpans);
        entry = entryIterator.next();
    }
    return out;
}
// ../../node_modules/.pnpm/@opentelemetry+otlp-transformer@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-transformer/build/esm/trace/json/trace.js
var $053b4050c185c268$var$JsonTraceSerializer = {
    serializeRequest: function(arg) {
        var request = $053b4050c185c268$var$createExportTraceServiceRequest(arg, {
            useHex: true,
            useLongBits: false
        });
        var encoder = new TextEncoder();
        return encoder.encode(JSON.stringify(request));
    },
    deserializeResponse: function(arg) {
        var decoder = new TextDecoder();
        return JSON.parse(decoder.decode(arg));
    }
};
// ../../node_modules/.pnpm/@opentelemetry+otlp-exporter-base@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-exporter-base/build/esm/retrying-transport.js
var $053b4050c185c268$var$__awaiter4 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $053b4050c185c268$var$__generator4 = function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $053b4050c185c268$var$MAX_ATTEMPTS = 5;
var $053b4050c185c268$var$INITIAL_BACKOFF = 1e3;
var $053b4050c185c268$var$MAX_BACKOFF = 5e3;
var $053b4050c185c268$var$BACKOFF_MULTIPLIER = 1.5;
var $053b4050c185c268$var$JITTER = 0.2;
function $053b4050c185c268$var$getJitter() {
    return Math.random() * (2 * $053b4050c185c268$var$JITTER) - $053b4050c185c268$var$JITTER;
}
var $053b4050c185c268$var$RetryingTransport = /** @class */ function() {
    function RetryingTransport2(_transport) {
        this._transport = _transport;
    }
    RetryingTransport2.prototype.retry = function(data, timeoutMillis, inMillis) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            setTimeout(function() {
                _this._transport.send(data, timeoutMillis).then(resolve, reject);
            }, inMillis);
        });
    };
    RetryingTransport2.prototype.send = function(data, timeoutMillis) {
        var _a3;
        return $053b4050c185c268$var$__awaiter4(this, void 0, void 0, function() {
            var deadline, result, attempts, nextBackoff, backoff, retryInMillis, remainingTimeoutMillis;
            return $053b4050c185c268$var$__generator4(this, function(_b) {
                switch(_b.label){
                    case 0:
                        deadline = Date.now() + timeoutMillis;
                        return [
                            4,
                            this._transport.send(data, timeoutMillis)
                        ];
                    case 1:
                        result = _b.sent();
                        attempts = $053b4050c185c268$var$MAX_ATTEMPTS;
                        nextBackoff = $053b4050c185c268$var$INITIAL_BACKOFF;
                        _b.label = 2;
                    case 2:
                        if (!(result.status === "retryable" && attempts > 0)) return [
                            3,
                            4
                        ];
                        attempts--;
                        backoff = Math.max(Math.min(nextBackoff, $053b4050c185c268$var$MAX_BACKOFF) + $053b4050c185c268$var$getJitter(), 0);
                        nextBackoff = nextBackoff * $053b4050c185c268$var$BACKOFF_MULTIPLIER;
                        retryInMillis = (_a3 = result.retryInMillis) !== null && _a3 !== void 0 ? _a3 : backoff;
                        remainingTimeoutMillis = deadline - Date.now();
                        if (retryInMillis > remainingTimeoutMillis) return [
                            2,
                            result
                        ];
                        return [
                            4,
                            this.retry(data, remainingTimeoutMillis, retryInMillis)
                        ];
                    case 3:
                        result = _b.sent();
                        return [
                            3,
                            2
                        ];
                    case 4:
                        return [
                            2,
                            result
                        ];
                }
            });
        });
    };
    RetryingTransport2.prototype.shutdown = function() {
        return this._transport.shutdown();
    };
    return RetryingTransport2;
}();
function $053b4050c185c268$var$createRetryingTransport(options) {
    return new $053b4050c185c268$var$RetryingTransport(options.transport);
}
// ../../node_modules/.pnpm/@opentelemetry+otlp-exporter-base@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-exporter-base/build/esm/is-export-retryable.js
function $053b4050c185c268$var$isExportRetryable(statusCode) {
    var retryCodes = [
        429,
        502,
        503,
        504
    ];
    return retryCodes.includes(statusCode);
}
function $053b4050c185c268$var$parseRetryAfterToMills(retryAfter) {
    if (retryAfter == null) return void 0;
    var seconds = Number.parseInt(retryAfter, 10);
    if (Number.isInteger(seconds)) return seconds > 0 ? seconds * 1e3 : -1;
    var delay = new Date(retryAfter).getTime() - Date.now();
    if (delay >= 0) return delay;
    return 0;
}
// ../../node_modules/.pnpm/@opentelemetry+otlp-exporter-base@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-exporter-base/build/esm/transport/xhr-transport.js
var $053b4050c185c268$var$__read12 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $053b4050c185c268$var$XhrTransport = /** @class */ function() {
    function XhrTransport2(_parameters) {
        this._parameters = _parameters;
    }
    XhrTransport2.prototype.send = function(data, timeoutMillis) {
        var _this = this;
        return new Promise(function(resolve) {
            var xhr = new XMLHttpRequest();
            xhr.timeout = timeoutMillis;
            xhr.open("POST", _this._parameters.url);
            var headers = _this._parameters.headers();
            Object.entries(headers).forEach(function(_a3) {
                var _b = $053b4050c185c268$var$__read12(_a3, 2), k = _b[0], v = _b[1];
                xhr.setRequestHeader(k, v);
            });
            xhr.ontimeout = function(_) {
                resolve({
                    status: "failure",
                    error: new Error("XHR request timed out")
                });
            };
            xhr.onreadystatechange = function() {
                if (xhr.status >= 200 && xhr.status <= 299) {
                    $053b4050c185c268$var$diag2.debug("XHR success");
                    resolve({
                        status: "success"
                    });
                } else if (xhr.status && $053b4050c185c268$var$isExportRetryable(xhr.status)) resolve({
                    status: "retryable",
                    retryInMillis: $053b4050c185c268$var$parseRetryAfterToMills(xhr.getResponseHeader("Retry-After"))
                });
                else if (xhr.status !== 0) resolve({
                    status: "failure",
                    error: new Error("XHR request failed with non-retryable status")
                });
            };
            xhr.onabort = function() {
                resolve({
                    status: "failure",
                    error: new Error("XHR request aborted")
                });
            };
            xhr.onerror = function() {
                resolve({
                    status: "failure",
                    error: new Error("XHR request errored")
                });
            };
            xhr.send(data);
        });
    };
    XhrTransport2.prototype.shutdown = function() {};
    return XhrTransport2;
}();
function $053b4050c185c268$var$createXhrTransport(parameters) {
    return new $053b4050c185c268$var$XhrTransport(parameters);
}
// ../../node_modules/.pnpm/@opentelemetry+otlp-exporter-base@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-exporter-base/build/esm/transport/send-beacon-transport.js
var $053b4050c185c268$var$SendBeaconTransport = /** @class */ function() {
    function SendBeaconTransport2(_params) {
        this._params = _params;
    }
    SendBeaconTransport2.prototype.send = function(data) {
        var _this = this;
        return new Promise(function(resolve) {
            if (navigator.sendBeacon(_this._params.url, new Blob([
                data
            ], {
                type: _this._params.blobType
            }))) {
                $053b4050c185c268$var$diag2.debug("SendBeacon success");
                resolve({
                    status: "success"
                });
            } else resolve({
                status: "failure",
                error: new Error("SendBeacon failed")
            });
        });
    };
    SendBeaconTransport2.prototype.shutdown = function() {};
    return SendBeaconTransport2;
}();
function $053b4050c185c268$var$createSendBeaconTransport(parameters) {
    return new $053b4050c185c268$var$SendBeaconTransport(parameters);
}
// ../../node_modules/.pnpm/@opentelemetry+otlp-exporter-base@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-exporter-base/build/esm/otlp-browser-http-export-delegate.js
function $053b4050c185c268$var$createOtlpXhrExportDelegate(options, serializer) {
    return $053b4050c185c268$var$createOtlpNetworkExportDelegate(options, serializer, $053b4050c185c268$var$createRetryingTransport({
        transport: $053b4050c185c268$var$createXhrTransport(options)
    }));
}
function $053b4050c185c268$var$createOtlpSendBeaconExportDelegate(options, serializer) {
    return $053b4050c185c268$var$createOtlpNetworkExportDelegate(options, serializer, $053b4050c185c268$var$createRetryingTransport({
        transport: $053b4050c185c268$var$createSendBeaconTransport({
            url: options.url,
            blobType: options.headers()["Content-Type"]
        })
    }));
}
// ../../node_modules/.pnpm/@opentelemetry+otlp-exporter-base@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-exporter-base/build/esm/util.js
var $053b4050c185c268$var$__read13 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $053b4050c185c268$var$validateAndNormalizeHeaders(partialHeaders) {
    return function() {
        var _a3;
        var headers = {};
        Object.entries((_a3 = partialHeaders === null || partialHeaders === void 0 ? void 0 : partialHeaders()) !== null && _a3 !== void 0 ? _a3 : {}).forEach(function(_a4) {
            var _b = $053b4050c185c268$var$__read13(_a4, 2), key = _b[0], value = _b[1];
            if (typeof value !== "undefined") headers[key] = String(value);
            else $053b4050c185c268$var$diag2.warn('Header "' + key + '" has invalid value (' + value + ") and will be ignored");
        });
        return headers;
    };
}
// ../../node_modules/.pnpm/@opentelemetry+otlp-exporter-base@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-exporter-base/build/esm/configuration/otlp-http-configuration.js
var $053b4050c185c268$var$__assign2 = function() {
    $053b4050c185c268$var$__assign2 = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $053b4050c185c268$var$__assign2.apply(this, arguments);
};
function $053b4050c185c268$var$mergeHeaders(userProvidedHeaders, fallbackHeaders, defaultHeaders) {
    var requiredHeaders = $053b4050c185c268$var$__assign2({}, defaultHeaders());
    var headers = {};
    return function() {
        if (fallbackHeaders != null) Object.assign(headers, fallbackHeaders());
        if (userProvidedHeaders != null) Object.assign(headers, userProvidedHeaders());
        return Object.assign(headers, requiredHeaders);
    };
}
function $053b4050c185c268$var$validateUserProvidedUrl(url) {
    if (url == null) return void 0;
    try {
        new URL(url);
        return url;
    } catch (e) {
        throw new Error("Configuration: Could not parse user-provided export URL: '" + url + "'");
    }
}
function $053b4050c185c268$var$mergeOtlpHttpConfigurationWithDefaults(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration) {
    var _a3, _b, _c, _d;
    return $053b4050c185c268$var$__assign2($053b4050c185c268$var$__assign2({}, $053b4050c185c268$var$mergeOtlpSharedConfigurationWithDefaults(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration)), {
        headers: $053b4050c185c268$var$mergeHeaders($053b4050c185c268$var$validateAndNormalizeHeaders(userProvidedConfiguration.headers), fallbackConfiguration.headers, defaultConfiguration.headers),
        url: (_b = (_a3 = $053b4050c185c268$var$validateUserProvidedUrl(userProvidedConfiguration.url)) !== null && _a3 !== void 0 ? _a3 : fallbackConfiguration.url) !== null && _b !== void 0 ? _b : defaultConfiguration.url,
        agentOptions: (_d = (_c = userProvidedConfiguration.agentOptions) !== null && _c !== void 0 ? _c : fallbackConfiguration.agentOptions) !== null && _d !== void 0 ? _d : defaultConfiguration.agentOptions
    });
}
function $053b4050c185c268$var$getHttpConfigurationDefaults(requiredHeaders, signalResourcePath) {
    return $053b4050c185c268$var$__assign2($053b4050c185c268$var$__assign2({}, $053b4050c185c268$var$getSharedConfigurationDefaults()), {
        headers: function() {
            return requiredHeaders;
        },
        url: "http://localhost:4318/" + signalResourcePath,
        agentOptions: {
            keepAlive: true
        }
    });
}
// ../../node_modules/.pnpm/@opentelemetry+otlp-exporter-base@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-exporter-base/build/esm/configuration/convert-legacy-browser-http-options.js
function $053b4050c185c268$var$convertLegacyBrowserHttpOptions(config, signalResourcePath, requiredHeaders) {
    return $053b4050c185c268$var$mergeOtlpHttpConfigurationWithDefaults({
        url: config.url,
        timeoutMillis: config.timeoutMillis,
        headers: $053b4050c185c268$var$wrapStaticHeadersInFunction(config.headers),
        concurrencyLimit: config.concurrencyLimit
    }, {}, // no fallback for browser case
    $053b4050c185c268$var$getHttpConfigurationDefaults(requiredHeaders, signalResourcePath));
}
// ../../node_modules/.pnpm/@opentelemetry+otlp-exporter-base@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/otlp-exporter-base/build/esm/configuration/create-legacy-browser-delegate.js
function $053b4050c185c268$var$createLegacyOtlpBrowserExportDelegate(config, serializer, signalResourcePath, requiredHeaders) {
    var useXhr = !!config.headers || typeof navigator.sendBeacon !== "function";
    var options = $053b4050c185c268$var$convertLegacyBrowserHttpOptions(config, signalResourcePath, requiredHeaders);
    if (useXhr) return $053b4050c185c268$var$createOtlpXhrExportDelegate(options, serializer);
    else return $053b4050c185c268$var$createOtlpSendBeaconExportDelegate(options, serializer);
}
// ../../node_modules/.pnpm/@opentelemetry+exporter-trace-otlp-http@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/exporter-trace-otlp-http/build/esm/platform/browser/OTLPTraceExporter.js
var $053b4050c185c268$var$__extends3 = /* @__PURE__ */ function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d2, b2) {
            d2.__proto__ = b2;
        } || function(d2, b2) {
            for(var p in b2)if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $053b4050c185c268$var$OTLPTraceExporter = /** @class */ function(_super) {
    $053b4050c185c268$var$__extends3(OTLPTraceExporter2, _super);
    function OTLPTraceExporter2(config) {
        if (config === void 0) config = {};
        return _super.call(this, $053b4050c185c268$var$createLegacyOtlpBrowserExportDelegate(config, $053b4050c185c268$var$JsonTraceSerializer, "v1/traces", {
            "Content-Type": "application/json"
        })) || this;
    }
    return OTLPTraceExporter2;
}($053b4050c185c268$var$OTLPExporterBase);
// ../../node_modules/.pnpm/@opentelemetry+api-logs@0.57.2/node_modules/@opentelemetry/api-logs/build/esm/NoopLogger.js
var $053b4050c185c268$var$NoopLogger = /** @class */ function() {
    function NoopLogger3() {}
    NoopLogger3.prototype.emit = function(_logRecord) {};
    return NoopLogger3;
}();
var $053b4050c185c268$var$NOOP_LOGGER = new $053b4050c185c268$var$NoopLogger();
// ../../node_modules/.pnpm/@opentelemetry+api-logs@0.57.2/node_modules/@opentelemetry/api-logs/build/esm/NoopLoggerProvider.js
var $053b4050c185c268$var$NoopLoggerProvider = /** @class */ function() {
    function NoopLoggerProvider3() {}
    NoopLoggerProvider3.prototype.getLogger = function(_name, _version, _options) {
        return new $053b4050c185c268$var$NoopLogger();
    };
    return NoopLoggerProvider3;
}();
var $053b4050c185c268$var$NOOP_LOGGER_PROVIDER = new $053b4050c185c268$var$NoopLoggerProvider();
// ../../node_modules/.pnpm/@opentelemetry+api-logs@0.57.2/node_modules/@opentelemetry/api-logs/build/esm/ProxyLogger.js
var $053b4050c185c268$var$ProxyLogger = /** @class */ function() {
    function ProxyLogger3(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyLogger3.prototype.emit = function(logRecord) {
        this._getLogger().emit(logRecord);
    };
    ProxyLogger3.prototype._getLogger = function() {
        if (this._delegate) return this._delegate;
        var logger = this._provider.getDelegateLogger(this.name, this.version, this.options);
        if (!logger) return $053b4050c185c268$var$NOOP_LOGGER;
        this._delegate = logger;
        return this._delegate;
    };
    return ProxyLogger3;
}();
// ../../node_modules/.pnpm/@opentelemetry+api-logs@0.57.2/node_modules/@opentelemetry/api-logs/build/esm/ProxyLoggerProvider.js
var $053b4050c185c268$var$ProxyLoggerProvider = /** @class */ function() {
    function ProxyLoggerProvider3() {}
    ProxyLoggerProvider3.prototype.getLogger = function(name, version, options) {
        var _a3;
        return (_a3 = this.getDelegateLogger(name, version, options)) !== null && _a3 !== void 0 ? _a3 : new $053b4050c185c268$var$ProxyLogger(this, name, version, options);
    };
    ProxyLoggerProvider3.prototype.getDelegate = function() {
        var _a3;
        return (_a3 = this._delegate) !== null && _a3 !== void 0 ? _a3 : $053b4050c185c268$var$NOOP_LOGGER_PROVIDER;
    };
    ProxyLoggerProvider3.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyLoggerProvider3.prototype.getDelegateLogger = function(name, version, options) {
        var _a3;
        return (_a3 = this._delegate) === null || _a3 === void 0 ? void 0 : _a3.getLogger(name, version, options);
    };
    return ProxyLoggerProvider3;
}();
// ../../node_modules/.pnpm/@opentelemetry+api-logs@0.57.2/node_modules/@opentelemetry/api-logs/build/esm/platform/browser/globalThis.js
var $053b4050c185c268$var$_globalThis3 = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof $parcel$global === "object" ? $parcel$global : {};
// ../../node_modules/.pnpm/@opentelemetry+api-logs@0.57.2/node_modules/@opentelemetry/api-logs/build/esm/internal/global-utils.js
var $053b4050c185c268$var$GLOBAL_LOGS_API_KEY = Symbol.for("io.opentelemetry.js.api.logs");
var $053b4050c185c268$var$_global3 = $053b4050c185c268$var$_globalThis3;
function $053b4050c185c268$var$makeGetter(requiredVersion, instance, fallback) {
    return function(version) {
        return version === requiredVersion ? instance : fallback;
    };
}
var $053b4050c185c268$var$API_BACKWARDS_COMPATIBILITY_VERSION = 1;
// ../../node_modules/.pnpm/@opentelemetry+api-logs@0.57.2/node_modules/@opentelemetry/api-logs/build/esm/api/logs.js
var $053b4050c185c268$var$LogsAPI = /** @class */ function() {
    function LogsAPI3() {
        this._proxyLoggerProvider = new $053b4050c185c268$var$ProxyLoggerProvider();
    }
    LogsAPI3.getInstance = function() {
        if (!this._instance) this._instance = new LogsAPI3();
        return this._instance;
    };
    LogsAPI3.prototype.setGlobalLoggerProvider = function(provider) {
        if ($053b4050c185c268$var$_global3[$053b4050c185c268$var$GLOBAL_LOGS_API_KEY]) return this.getLoggerProvider();
        $053b4050c185c268$var$_global3[$053b4050c185c268$var$GLOBAL_LOGS_API_KEY] = $053b4050c185c268$var$makeGetter($053b4050c185c268$var$API_BACKWARDS_COMPATIBILITY_VERSION, provider, $053b4050c185c268$var$NOOP_LOGGER_PROVIDER);
        this._proxyLoggerProvider.setDelegate(provider);
        return provider;
    };
    LogsAPI3.prototype.getLoggerProvider = function() {
        var _a3, _b;
        return (_b = (_a3 = $053b4050c185c268$var$_global3[$053b4050c185c268$var$GLOBAL_LOGS_API_KEY]) === null || _a3 === void 0 ? void 0 : _a3.call($053b4050c185c268$var$_global3, $053b4050c185c268$var$API_BACKWARDS_COMPATIBILITY_VERSION)) !== null && _b !== void 0 ? _b : this._proxyLoggerProvider;
    };
    LogsAPI3.prototype.getLogger = function(name, version, options) {
        return this.getLoggerProvider().getLogger(name, version, options);
    };
    LogsAPI3.prototype.disable = function() {
        delete $053b4050c185c268$var$_global3[$053b4050c185c268$var$GLOBAL_LOGS_API_KEY];
        this._proxyLoggerProvider = new $053b4050c185c268$var$ProxyLoggerProvider();
    };
    return LogsAPI3;
}();
// ../../node_modules/.pnpm/@opentelemetry+api-logs@0.57.2/node_modules/@opentelemetry/api-logs/build/esm/index.js
var $053b4050c185c268$var$logs = $053b4050c185c268$var$LogsAPI.getInstance();
// ../../node_modules/.pnpm/@opentelemetry+instrumentation@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation/build/esm/autoLoaderUtils.js
function $053b4050c185c268$var$enableInstrumentations(instrumentations, tracerProvider, meterProvider, loggerProvider) {
    for(var i = 0, j = instrumentations.length; i < j; i++){
        var instrumentation = instrumentations[i];
        if (tracerProvider) instrumentation.setTracerProvider(tracerProvider);
        if (meterProvider) instrumentation.setMeterProvider(meterProvider);
        if (loggerProvider && instrumentation.setLoggerProvider) instrumentation.setLoggerProvider(loggerProvider);
        if (!instrumentation.getConfig().enabled) instrumentation.enable();
    }
}
function $053b4050c185c268$var$disableInstrumentations(instrumentations) {
    instrumentations.forEach(function(instrumentation) {
        return instrumentation.disable();
    });
}
// ../../node_modules/.pnpm/@opentelemetry+instrumentation@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation/build/esm/autoLoader.js
function $053b4050c185c268$var$registerInstrumentations(options) {
    var _a3, _b;
    var tracerProvider = options.tracerProvider || $053b4050c185c268$var$trace.getTracerProvider();
    var meterProvider = options.meterProvider || $053b4050c185c268$var$metrics.getMeterProvider();
    var loggerProvider = options.loggerProvider || $053b4050c185c268$var$logs.getLoggerProvider();
    var instrumentations = (_b = (_a3 = options.instrumentations) === null || _a3 === void 0 ? void 0 : _a3.flat()) !== null && _b !== void 0 ? _b : [];
    $053b4050c185c268$var$enableInstrumentations(instrumentations, tracerProvider, meterProvider, loggerProvider);
    return function() {
        $053b4050c185c268$var$disableInstrumentations(instrumentations);
    };
}
// ../../node_modules/.pnpm/@opentelemetry+instrumentation@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation/build/esm/instrumentation.js
var $053b4050c185c268$var$shimmer = $053b4050c185c268$var$__toESM($053b4050c185c268$var$require_shimmer());
var $053b4050c185c268$var$__assign3 = function() {
    $053b4050c185c268$var$__assign3 = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $053b4050c185c268$var$__assign3.apply(this, arguments);
};
var $053b4050c185c268$var$InstrumentationAbstract = /** @class */ function() {
    function InstrumentationAbstract3(instrumentationName, instrumentationVersion, config) {
        this.instrumentationName = instrumentationName;
        this.instrumentationVersion = instrumentationVersion;
        this._config = {};
        this._wrap = $053b4050c185c268$var$shimmer.wrap;
        this._unwrap = $053b4050c185c268$var$shimmer.unwrap;
        this._massWrap = $053b4050c185c268$var$shimmer.massWrap;
        this._massUnwrap = $053b4050c185c268$var$shimmer.massUnwrap;
        this.setConfig(config);
        this._diag = $053b4050c185c268$var$diag2.createComponentLogger({
            namespace: instrumentationName
        });
        this._tracer = $053b4050c185c268$var$trace.getTracer(instrumentationName, instrumentationVersion);
        this._meter = $053b4050c185c268$var$metrics.getMeter(instrumentationName, instrumentationVersion);
        this._logger = $053b4050c185c268$var$logs.getLogger(instrumentationName, instrumentationVersion);
        this._updateMetricInstruments();
    }
    Object.defineProperty(InstrumentationAbstract3.prototype, "meter", {
        /* Returns meter */ get: function() {
            return this._meter;
        },
        enumerable: false,
        configurable: true
    });
    InstrumentationAbstract3.prototype.setMeterProvider = function(meterProvider) {
        this._meter = meterProvider.getMeter(this.instrumentationName, this.instrumentationVersion);
        this._updateMetricInstruments();
    };
    Object.defineProperty(InstrumentationAbstract3.prototype, "logger", {
        /* Returns logger */ get: function() {
            return this._logger;
        },
        enumerable: false,
        configurable: true
    });
    InstrumentationAbstract3.prototype.setLoggerProvider = function(loggerProvider) {
        this._logger = loggerProvider.getLogger(this.instrumentationName, this.instrumentationVersion);
    };
    InstrumentationAbstract3.prototype.getModuleDefinitions = function() {
        var _a3;
        var initResult = (_a3 = this.init()) !== null && _a3 !== void 0 ? _a3 : [];
        if (!Array.isArray(initResult)) return [
            initResult
        ];
        return initResult;
    };
    InstrumentationAbstract3.prototype._updateMetricInstruments = function() {
        return;
    };
    InstrumentationAbstract3.prototype.getConfig = function() {
        return this._config;
    };
    InstrumentationAbstract3.prototype.setConfig = function(config) {
        this._config = $053b4050c185c268$var$__assign3({
            enabled: true
        }, config);
    };
    InstrumentationAbstract3.prototype.setTracerProvider = function(tracerProvider) {
        this._tracer = tracerProvider.getTracer(this.instrumentationName, this.instrumentationVersion);
    };
    Object.defineProperty(InstrumentationAbstract3.prototype, "tracer", {
        /* Returns tracer */ get: function() {
            return this._tracer;
        },
        enumerable: false,
        configurable: true
    });
    InstrumentationAbstract3.prototype._runSpanCustomizationHook = function(hookHandler, triggerName, span, info) {
        if (!hookHandler) return;
        try {
            hookHandler(span, info);
        } catch (e) {
            this._diag.error("Error running span customization hook due to exception in handler", {
                triggerName: triggerName
            }, e);
        }
    };
    return InstrumentationAbstract3;
}();
// ../../node_modules/.pnpm/@opentelemetry+instrumentation@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation/build/esm/platform/browser/instrumentation.js
var $053b4050c185c268$var$__extends4 = /* @__PURE__ */ function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d2, b2) {
            d2.__proto__ = b2;
        } || function(d2, b2) {
            for(var p in b2)if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $053b4050c185c268$var$InstrumentationBase = /** @class */ function(_super) {
    $053b4050c185c268$var$__extends4(InstrumentationBase3, _super);
    function InstrumentationBase3(instrumentationName, instrumentationVersion, config) {
        var _this = _super.call(this, instrumentationName, instrumentationVersion, config) || this;
        if (_this._config.enabled) _this.enable();
        return _this;
    }
    return InstrumentationBase3;
}($053b4050c185c268$var$InstrumentationAbstract);
// ../../node_modules/.pnpm/@opentelemetry+instrumentation@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation/build/esm/utils.js
function $053b4050c185c268$var$safeExecuteInTheMiddle(execute, onFinish, preventThrowingError) {
    var error;
    var result;
    try {
        result = execute();
    } catch (e) {
        error = e;
    } finally{
        onFinish(error, result);
        if (error && !preventThrowingError) throw error;
        return result;
    }
}
function $053b4050c185c268$var$isWrapped(func) {
    return typeof func === "function" && typeof func.__original === "function" && typeof func.__unwrap === "function" && func.__wrapped === true;
}
// ../../node_modules/.pnpm/@opentelemetry+semantic-conventions@1.33.0/node_modules/@opentelemetry/semantic-conventions/build/esm/trace/SemanticAttributes.js
var $053b4050c185c268$var$TMP_HTTP_URL2 = "http.url";
var $053b4050c185c268$var$TMP_HTTP_USER_AGENT2 = "http.user_agent";
var $053b4050c185c268$var$SEMATTRS_HTTP_URL2 = $053b4050c185c268$var$TMP_HTTP_URL2;
var $053b4050c185c268$var$SEMATTRS_HTTP_USER_AGENT2 = $053b4050c185c268$var$TMP_HTTP_USER_AGENT2;
// ../../node_modules/.pnpm/@opentelemetry+semantic-conventions@1.33.0/node_modules/@opentelemetry/semantic-conventions/build/esm/stable_attributes.js
var $053b4050c185c268$var$ATTR_SERVICE_NAME = "service.name";
var $053b4050c185c268$var$ATTR_SERVICE_VERSION = "service.version";
// ../../node_modules/.pnpm/@opentelemetry+core@2.7.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/platform/browser/index.js
var $053b4050c185c268$var$otperformance2 = performance;
// ../../node_modules/.pnpm/@opentelemetry+core@2.7.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/common/time.js
var $053b4050c185c268$var$NANOSECOND_DIGITS2 = 9;
var $053b4050c185c268$var$NANOSECOND_DIGITS_IN_MILLIS2 = 6;
var $053b4050c185c268$var$MILLISECONDS_TO_NANOSECONDS2 = Math.pow(10, $053b4050c185c268$var$NANOSECOND_DIGITS_IN_MILLIS2);
var $053b4050c185c268$var$SECOND_TO_NANOSECONDS2 = Math.pow(10, $053b4050c185c268$var$NANOSECOND_DIGITS2);
function $053b4050c185c268$var$millisToHrTime2(epochMillis) {
    const epochSeconds = epochMillis / 1e3;
    const seconds = Math.trunc(epochSeconds);
    const nanos = Math.round(epochMillis % 1e3 * $053b4050c185c268$var$MILLISECONDS_TO_NANOSECONDS2);
    return [
        seconds,
        nanos
    ];
}
function $053b4050c185c268$var$hrTime2(performanceNow) {
    const timeOrigin = $053b4050c185c268$var$millisToHrTime2($053b4050c185c268$var$otperformance2.timeOrigin);
    const now = $053b4050c185c268$var$millisToHrTime2(typeof performanceNow === "number" ? performanceNow : $053b4050c185c268$var$otperformance2.now());
    return $053b4050c185c268$var$addHrTimes2(timeOrigin, now);
}
function $053b4050c185c268$var$addHrTimes2(time1, time2) {
    const out = [
        time1[0] + time2[0],
        time1[1] + time2[1]
    ];
    if (out[1] >= $053b4050c185c268$var$SECOND_TO_NANOSECONDS2) {
        out[1] -= $053b4050c185c268$var$SECOND_TO_NANOSECONDS2;
        out[0] += 1;
    }
    return out;
}
// ../../node_modules/.pnpm/@opentelemetry+core@2.7.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/core/build/esm/trace/W3CTraceContextPropagator.js
var $053b4050c185c268$var$TRACE_PARENT_HEADER2 = "traceparent";
var $053b4050c185c268$var$VERSION_PART2 = "(?!ff)[\\da-f]{2}";
var $053b4050c185c268$var$TRACE_ID_PART2 = "(?![0]{32})[\\da-f]{32}";
var $053b4050c185c268$var$PARENT_ID_PART2 = "(?![0]{16})[\\da-f]{16}";
var $053b4050c185c268$var$FLAGS_PART2 = "[\\da-f]{2}";
var $053b4050c185c268$var$TRACE_PARENT_REGEX2 = new RegExp(`^\\s?(${$053b4050c185c268$var$VERSION_PART2})-(${$053b4050c185c268$var$TRACE_ID_PART2})-(${$053b4050c185c268$var$PARENT_ID_PART2})-(${$053b4050c185c268$var$FLAGS_PART2})(-.*)?\\s?$`);
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-web@2.7.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-web/build/esm/enums/PerformanceTimingNames.js
var $053b4050c185c268$var$PerformanceTimingNames;
(function(PerformanceTimingNames3) {
    PerformanceTimingNames3["CONNECT_END"] = "connectEnd";
    PerformanceTimingNames3["CONNECT_START"] = "connectStart";
    PerformanceTimingNames3["DECODED_BODY_SIZE"] = "decodedBodySize";
    PerformanceTimingNames3["DOM_COMPLETE"] = "domComplete";
    PerformanceTimingNames3["DOM_CONTENT_LOADED_EVENT_END"] = "domContentLoadedEventEnd";
    PerformanceTimingNames3["DOM_CONTENT_LOADED_EVENT_START"] = "domContentLoadedEventStart";
    PerformanceTimingNames3["DOM_INTERACTIVE"] = "domInteractive";
    PerformanceTimingNames3["DOMAIN_LOOKUP_END"] = "domainLookupEnd";
    PerformanceTimingNames3["DOMAIN_LOOKUP_START"] = "domainLookupStart";
    PerformanceTimingNames3["ENCODED_BODY_SIZE"] = "encodedBodySize";
    PerformanceTimingNames3["FETCH_START"] = "fetchStart";
    PerformanceTimingNames3["LOAD_EVENT_END"] = "loadEventEnd";
    PerformanceTimingNames3["LOAD_EVENT_START"] = "loadEventStart";
    PerformanceTimingNames3["NAVIGATION_START"] = "navigationStart";
    PerformanceTimingNames3["REDIRECT_END"] = "redirectEnd";
    PerformanceTimingNames3["REDIRECT_START"] = "redirectStart";
    PerformanceTimingNames3["REQUEST_START"] = "requestStart";
    PerformanceTimingNames3["RESPONSE_END"] = "responseEnd";
    PerformanceTimingNames3["RESPONSE_START"] = "responseStart";
    PerformanceTimingNames3["SECURE_CONNECTION_START"] = "secureConnectionStart";
    PerformanceTimingNames3["START_TIME"] = "startTime";
    PerformanceTimingNames3["UNLOAD_EVENT_END"] = "unloadEventEnd";
    PerformanceTimingNames3["UNLOAD_EVENT_START"] = "unloadEventStart";
})($053b4050c185c268$var$PerformanceTimingNames || ($053b4050c185c268$var$PerformanceTimingNames = {}));
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-web@2.7.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-web/build/esm/semconv.js
var $053b4050c185c268$var$ATTR_HTTP_RESPONSE_CONTENT_LENGTH = "http.response_content_length";
var $053b4050c185c268$var$ATTR_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = "http.response_content_length_uncompressed";
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-web@2.7.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-web/build/esm/utils.js
function $053b4050c185c268$var$hasKey(obj, key) {
    return key in obj;
}
function $053b4050c185c268$var$addSpanNetworkEvent(span, performanceName, entries, ignoreZeros = true) {
    if ($053b4050c185c268$var$hasKey(entries, performanceName) && typeof entries[performanceName] === "number" && !(ignoreZeros && entries[performanceName] === 0)) return span.addEvent(performanceName, entries[performanceName]);
    return void 0;
}
function $053b4050c185c268$var$addSpanNetworkEvents(span, resource, ignoreNetworkEvents = false, ignoreZeros, skipOldSemconvContentLengthAttrs) {
    if (ignoreZeros === void 0) ignoreZeros = resource[$053b4050c185c268$var$PerformanceTimingNames.START_TIME] !== 0;
    if (!ignoreNetworkEvents) {
        $053b4050c185c268$var$addSpanNetworkEvent(span, $053b4050c185c268$var$PerformanceTimingNames.FETCH_START, resource, ignoreZeros);
        $053b4050c185c268$var$addSpanNetworkEvent(span, $053b4050c185c268$var$PerformanceTimingNames.DOMAIN_LOOKUP_START, resource, ignoreZeros);
        $053b4050c185c268$var$addSpanNetworkEvent(span, $053b4050c185c268$var$PerformanceTimingNames.DOMAIN_LOOKUP_END, resource, ignoreZeros);
        $053b4050c185c268$var$addSpanNetworkEvent(span, $053b4050c185c268$var$PerformanceTimingNames.CONNECT_START, resource, ignoreZeros);
        $053b4050c185c268$var$addSpanNetworkEvent(span, $053b4050c185c268$var$PerformanceTimingNames.SECURE_CONNECTION_START, resource, ignoreZeros);
        $053b4050c185c268$var$addSpanNetworkEvent(span, $053b4050c185c268$var$PerformanceTimingNames.CONNECT_END, resource, ignoreZeros);
        $053b4050c185c268$var$addSpanNetworkEvent(span, $053b4050c185c268$var$PerformanceTimingNames.REQUEST_START, resource, ignoreZeros);
        $053b4050c185c268$var$addSpanNetworkEvent(span, $053b4050c185c268$var$PerformanceTimingNames.RESPONSE_START, resource, ignoreZeros);
        $053b4050c185c268$var$addSpanNetworkEvent(span, $053b4050c185c268$var$PerformanceTimingNames.RESPONSE_END, resource, ignoreZeros);
    }
    if (!skipOldSemconvContentLengthAttrs) {
        const encodedLength = resource[$053b4050c185c268$var$PerformanceTimingNames.ENCODED_BODY_SIZE];
        if (encodedLength !== void 0) span.setAttribute($053b4050c185c268$var$ATTR_HTTP_RESPONSE_CONTENT_LENGTH, encodedLength);
        const decodedLength = resource[$053b4050c185c268$var$PerformanceTimingNames.DECODED_BODY_SIZE];
        if (decodedLength !== void 0 && encodedLength !== decodedLength) span.setAttribute($053b4050c185c268$var$ATTR_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED, decodedLength);
    }
}
function $053b4050c185c268$var$getElementXPath(target, optimised) {
    if (target.nodeType === Node.DOCUMENT_NODE) return "/";
    const targetValue = $053b4050c185c268$var$getNodeValue(target, optimised);
    if (optimised && targetValue.indexOf("@id") > 0) return targetValue;
    let xpath = "";
    if (target.parentNode) xpath += $053b4050c185c268$var$getElementXPath(target.parentNode, optimised);
    xpath += targetValue;
    return xpath;
}
function $053b4050c185c268$var$getNodeIndex(target) {
    if (!target.parentNode) return 0;
    const allowedTypes = [
        target.nodeType
    ];
    if (target.nodeType === Node.CDATA_SECTION_NODE) allowedTypes.push(Node.TEXT_NODE);
    let elements = Array.from(target.parentNode.childNodes);
    elements = elements.filter((element)=>{
        const localName = element.localName;
        return allowedTypes.indexOf(element.nodeType) >= 0 && localName === target.localName;
    });
    if (elements.length >= 1) return elements.indexOf(target) + 1;
    return 0;
}
function $053b4050c185c268$var$getNodeValue(target, optimised) {
    const nodeType = target.nodeType;
    const index = $053b4050c185c268$var$getNodeIndex(target);
    let nodeValue = "";
    if (nodeType === Node.ELEMENT_NODE) {
        const id = target.getAttribute("id");
        if (optimised && id) return `//*[@id="${id}"]`;
        nodeValue = target.localName;
    } else if (nodeType === Node.TEXT_NODE || nodeType === Node.CDATA_SECTION_NODE) nodeValue = "text()";
    else if (nodeType === Node.COMMENT_NODE) nodeValue = "comment()";
    else return "";
    if (nodeValue && index > 1) return `/${nodeValue}[${index}]`;
    return `/${nodeValue}`;
}
// ../../node_modules/.pnpm/@opentelemetry+api-logs@0.200.0/node_modules/@opentelemetry/api-logs/build/esm/NoopLogger.js
var $053b4050c185c268$var$NoopLogger2 = class {
    emit(_logRecord) {}
};
var $053b4050c185c268$var$NOOP_LOGGER2 = new $053b4050c185c268$var$NoopLogger2();
// ../../node_modules/.pnpm/@opentelemetry+api-logs@0.200.0/node_modules/@opentelemetry/api-logs/build/esm/NoopLoggerProvider.js
var $053b4050c185c268$var$NoopLoggerProvider2 = class {
    getLogger(_name, _version, _options) {
        return new $053b4050c185c268$var$NoopLogger2();
    }
};
var $053b4050c185c268$var$NOOP_LOGGER_PROVIDER2 = new $053b4050c185c268$var$NoopLoggerProvider2();
// ../../node_modules/.pnpm/@opentelemetry+api-logs@0.200.0/node_modules/@opentelemetry/api-logs/build/esm/ProxyLogger.js
var $053b4050c185c268$var$ProxyLogger2 = class {
    constructor(_provider, name, version, options){
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    /**
   * Emit a log record. This method should only be used by log appenders.
   *
   * @param logRecord
   */ emit(logRecord) {
        this._getLogger().emit(logRecord);
    }
    /**
   * Try to get a logger from the proxy logger provider.
   * If the proxy logger provider has no delegate, return a noop logger.
   */ _getLogger() {
        if (this._delegate) return this._delegate;
        const logger = this._provider.getDelegateLogger(this.name, this.version, this.options);
        if (!logger) return $053b4050c185c268$var$NOOP_LOGGER2;
        this._delegate = logger;
        return this._delegate;
    }
};
// ../../node_modules/.pnpm/@opentelemetry+api-logs@0.200.0/node_modules/@opentelemetry/api-logs/build/esm/ProxyLoggerProvider.js
var $053b4050c185c268$var$ProxyLoggerProvider2 = class {
    getLogger(name, version, options) {
        var _a3;
        return (_a3 = this.getDelegateLogger(name, version, options)) !== null && _a3 !== void 0 ? _a3 : new $053b4050c185c268$var$ProxyLogger2(this, name, version, options);
    }
    getDelegate() {
        var _a3;
        return (_a3 = this._delegate) !== null && _a3 !== void 0 ? _a3 : $053b4050c185c268$var$NOOP_LOGGER_PROVIDER2;
    }
    /**
   * Set the delegate logger provider
   */ setDelegate(delegate) {
        this._delegate = delegate;
    }
    getDelegateLogger(name, version, options) {
        var _a3;
        return (_a3 = this._delegate) === null || _a3 === void 0 ? void 0 : _a3.getLogger(name, version, options);
    }
};
// ../../node_modules/.pnpm/@opentelemetry+api-logs@0.200.0/node_modules/@opentelemetry/api-logs/build/esm/platform/browser/globalThis.js
var $053b4050c185c268$var$_globalThis5 = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof $parcel$global === "object" ? $parcel$global : {};
// ../../node_modules/.pnpm/@opentelemetry+api-logs@0.200.0/node_modules/@opentelemetry/api-logs/build/esm/internal/global-utils.js
var $053b4050c185c268$var$GLOBAL_LOGS_API_KEY2 = Symbol.for("io.opentelemetry.js.api.logs");
var $053b4050c185c268$var$_global4 = $053b4050c185c268$var$_globalThis5;
function $053b4050c185c268$var$makeGetter2(requiredVersion, instance, fallback) {
    return (version)=>version === requiredVersion ? instance : fallback;
}
var $053b4050c185c268$var$API_BACKWARDS_COMPATIBILITY_VERSION2 = 1;
// ../../node_modules/.pnpm/@opentelemetry+api-logs@0.200.0/node_modules/@opentelemetry/api-logs/build/esm/api/logs.js
var $053b4050c185c268$var$LogsAPI2 = class _LogsAPI {
    constructor(){
        this._proxyLoggerProvider = new $053b4050c185c268$var$ProxyLoggerProvider2();
    }
    static getInstance() {
        if (!this._instance) this._instance = new _LogsAPI();
        return this._instance;
    }
    setGlobalLoggerProvider(provider) {
        if ($053b4050c185c268$var$_global4[$053b4050c185c268$var$GLOBAL_LOGS_API_KEY2]) return this.getLoggerProvider();
        $053b4050c185c268$var$_global4[$053b4050c185c268$var$GLOBAL_LOGS_API_KEY2] = $053b4050c185c268$var$makeGetter2($053b4050c185c268$var$API_BACKWARDS_COMPATIBILITY_VERSION2, provider, $053b4050c185c268$var$NOOP_LOGGER_PROVIDER2);
        this._proxyLoggerProvider.setDelegate(provider);
        return provider;
    }
    /**
   * Returns the global logger provider.
   *
   * @returns LoggerProvider
   */ getLoggerProvider() {
        var _a3, _b;
        return (_b = (_a3 = $053b4050c185c268$var$_global4[$053b4050c185c268$var$GLOBAL_LOGS_API_KEY2]) === null || _a3 === void 0 ? void 0 : _a3.call($053b4050c185c268$var$_global4, $053b4050c185c268$var$API_BACKWARDS_COMPATIBILITY_VERSION2)) !== null && _b !== void 0 ? _b : this._proxyLoggerProvider;
    }
    /**
   * Returns a logger from the global logger provider.
   *
   * @returns Logger
   */ getLogger(name, version, options) {
        return this.getLoggerProvider().getLogger(name, version, options);
    }
    /** Remove the global logger provider */ disable() {
        delete $053b4050c185c268$var$_global4[$053b4050c185c268$var$GLOBAL_LOGS_API_KEY2];
        this._proxyLoggerProvider = new $053b4050c185c268$var$ProxyLoggerProvider2();
    }
};
// ../../node_modules/.pnpm/@opentelemetry+api-logs@0.200.0/node_modules/@opentelemetry/api-logs/build/esm/index.js
var $053b4050c185c268$var$logs2 = $053b4050c185c268$var$LogsAPI2.getInstance();
// ../../node_modules/.pnpm/@opentelemetry+instrumentation@0.200.0_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation/build/esm/instrumentation.js
var $053b4050c185c268$var$shimmer2 = $053b4050c185c268$var$__toESM($053b4050c185c268$var$require_shimmer());
var $053b4050c185c268$var$InstrumentationAbstract2 = class {
    constructor(instrumentationName, instrumentationVersion, config){
        $053b4050c185c268$var$__publicField(this, "instrumentationName");
        $053b4050c185c268$var$__publicField(this, "instrumentationVersion");
        $053b4050c185c268$var$__publicField(this, "_config", {});
        $053b4050c185c268$var$__publicField(this, "_tracer");
        $053b4050c185c268$var$__publicField(this, "_meter");
        $053b4050c185c268$var$__publicField(this, "_logger");
        $053b4050c185c268$var$__publicField(this, "_diag");
        /* Api to wrap instrumented method */ $053b4050c185c268$var$__publicField(this, "_wrap", $053b4050c185c268$var$shimmer2.wrap);
        /* Api to unwrap instrumented methods */ $053b4050c185c268$var$__publicField(this, "_unwrap", $053b4050c185c268$var$shimmer2.unwrap);
        /* Api to mass wrap instrumented method */ $053b4050c185c268$var$__publicField(this, "_massWrap", $053b4050c185c268$var$shimmer2.massWrap);
        /* Api to mass unwrap instrumented methods */ $053b4050c185c268$var$__publicField(this, "_massUnwrap", $053b4050c185c268$var$shimmer2.massUnwrap);
        this.instrumentationName = instrumentationName;
        this.instrumentationVersion = instrumentationVersion;
        this.setConfig(config);
        this._diag = $053b4050c185c268$var$diag2.createComponentLogger({
            namespace: instrumentationName
        });
        this._tracer = $053b4050c185c268$var$trace.getTracer(instrumentationName, instrumentationVersion);
        this._meter = $053b4050c185c268$var$metrics.getMeter(instrumentationName, instrumentationVersion);
        this._logger = $053b4050c185c268$var$logs2.getLogger(instrumentationName, instrumentationVersion);
        this._updateMetricInstruments();
    }
    /* Returns meter */ get meter() {
        return this._meter;
    }
    /**
   * Sets MeterProvider to this plugin
   * @param meterProvider
   */ setMeterProvider(meterProvider) {
        this._meter = meterProvider.getMeter(this.instrumentationName, this.instrumentationVersion);
        this._updateMetricInstruments();
    }
    /* Returns logger */ get logger() {
        return this._logger;
    }
    /**
   * Sets LoggerProvider to this plugin
   * @param loggerProvider
   */ setLoggerProvider(loggerProvider) {
        this._logger = loggerProvider.getLogger(this.instrumentationName, this.instrumentationVersion);
    }
    /**
   * @experimental
   *
   * Get module definitions defined by {@link init}.
   * This can be used for experimental compile-time instrumentation.
   *
   * @returns an array of {@link InstrumentationModuleDefinition}
   */ getModuleDefinitions() {
        const initResult = this.init() ?? [];
        if (!Array.isArray(initResult)) return [
            initResult
        ];
        return initResult;
    }
    /**
   * Sets the new metric instruments with the current Meter.
   */ _updateMetricInstruments() {
        return;
    }
    /* Returns InstrumentationConfig */ getConfig() {
        return this._config;
    }
    /**
   * Sets InstrumentationConfig to this plugin
   * @param config
   */ setConfig(config) {
        this._config = {
            enabled: true,
            ...config
        };
    }
    /**
   * Sets TraceProvider to this plugin
   * @param tracerProvider
   */ setTracerProvider(tracerProvider) {
        this._tracer = tracerProvider.getTracer(this.instrumentationName, this.instrumentationVersion);
    }
    /* Returns tracer */ get tracer() {
        return this._tracer;
    }
    /**
   * Execute span customization hook, if configured, and log any errors.
   * Any semantics of the trigger and info are defined by the specific instrumentation.
   * @param hookHandler The optional hook handler which the user has configured via instrumentation config
   * @param triggerName The name of the trigger for executing the hook for logging purposes
   * @param span The span to which the hook should be applied
   * @param info The info object to be passed to the hook, with useful data the hook may use
   */ _runSpanCustomizationHook(hookHandler, triggerName, span, info) {
        if (!hookHandler) return;
        try {
            hookHandler(span, info);
        } catch (e) {
            this._diag.error(`Error running span customization hook due to exception in handler`, {
                triggerName: triggerName
            }, e);
        }
    }
};
// ../../node_modules/.pnpm/@opentelemetry+instrumentation@0.200.0_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation/build/esm/platform/browser/instrumentation.js
var $053b4050c185c268$var$InstrumentationBase2 = class extends $053b4050c185c268$var$InstrumentationAbstract2 {
    constructor(instrumentationName, instrumentationVersion, config){
        super(instrumentationName, instrumentationVersion, config);
        if (this._config.enabled) this.enable();
    }
};
// ../../node_modules/.pnpm/@opentelemetry+instrumentation@0.200.0_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation/build/esm/utils.js
function $053b4050c185c268$var$safeExecuteInTheMiddle2(execute, onFinish, preventThrowingError) {
    let error;
    let result;
    try {
        result = execute();
    } catch (e) {
        error = e;
    } finally{
        onFinish(error, result);
        if (error && !preventThrowingError) throw error;
        return result;
    }
}
function $053b4050c185c268$var$isWrapped2(func) {
    return typeof func === "function" && typeof func.__original === "function" && typeof func.__unwrap === "function" && func.__wrapped === true;
}
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-document-load@0.45.0_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation-document-load/build/esm/enums/AttributeNames.js
var $053b4050c185c268$var$AttributeNames;
(function(AttributeNames5) {
    AttributeNames5["DOCUMENT_LOAD"] = "documentLoad";
    AttributeNames5["DOCUMENT_FETCH"] = "documentFetch";
    AttributeNames5["RESOURCE_FETCH"] = "resourceFetch";
})($053b4050c185c268$var$AttributeNames || ($053b4050c185c268$var$AttributeNames = {}));
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-document-load@0.45.0_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation-document-load/build/esm/version.js
var $053b4050c185c268$var$PACKAGE_VERSION = "0.45.0";
var $053b4050c185c268$var$PACKAGE_NAME = "@opentelemetry/instrumentation-document-load";
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-document-load@0.45.0_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation-document-load/build/esm/enums/EventNames.js
var $053b4050c185c268$var$EventNames;
(function(EventNames3) {
    EventNames3["FIRST_PAINT"] = "firstPaint";
    EventNames3["FIRST_CONTENTFUL_PAINT"] = "firstContentfulPaint";
})($053b4050c185c268$var$EventNames || ($053b4050c185c268$var$EventNames = {}));
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-document-load@0.45.0_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation-document-load/build/esm/utils.js
var $053b4050c185c268$var$getPerformanceNavigationEntries = ()=>{
    const entries = {};
    const performanceNavigationTiming = $053b4050c185c268$var$otperformance2.getEntriesByType?.("navigation")[0];
    if (performanceNavigationTiming) {
        const keys = Object.values($053b4050c185c268$var$PerformanceTimingNames);
        keys.forEach((key)=>{
            if ($053b4050c185c268$var$hasKey(performanceNavigationTiming, key)) {
                const value = performanceNavigationTiming[key];
                if (typeof value === "number") entries[key] = value;
            }
        });
    } else {
        const perf = $053b4050c185c268$var$otperformance2;
        const performanceTiming = perf.timing;
        if (performanceTiming) {
            const keys = Object.values($053b4050c185c268$var$PerformanceTimingNames);
            keys.forEach((key)=>{
                if ($053b4050c185c268$var$hasKey(performanceTiming, key)) {
                    const value = performanceTiming[key];
                    if (typeof value === "number") entries[key] = value;
                }
            });
        }
    }
    return entries;
};
var $053b4050c185c268$var$performancePaintNames = {
    "first-paint": $053b4050c185c268$var$EventNames.FIRST_PAINT,
    "first-contentful-paint": $053b4050c185c268$var$EventNames.FIRST_CONTENTFUL_PAINT
};
var $053b4050c185c268$var$addSpanPerformancePaintEvents = (span)=>{
    const performancePaintTiming = $053b4050c185c268$var$otperformance2.getEntriesByType?.("paint");
    if (performancePaintTiming) performancePaintTiming.forEach(({ name: name, startTime: startTime })=>{
        if ($053b4050c185c268$var$hasKey($053b4050c185c268$var$performancePaintNames, name)) span.addEvent($053b4050c185c268$var$performancePaintNames[name], startTime);
    });
};
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-document-load@0.45.0_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation-document-load/build/esm/instrumentation.js
var $053b4050c185c268$var$DocumentLoadInstrumentation = class extends $053b4050c185c268$var$InstrumentationBase2 {
    constructor(config = {}){
        super($053b4050c185c268$var$PACKAGE_NAME, $053b4050c185c268$var$PACKAGE_VERSION, config);
        $053b4050c185c268$var$__publicField(this, "component", "document-load");
        $053b4050c185c268$var$__publicField(this, "version", "1");
        $053b4050c185c268$var$__publicField(this, "moduleName", this.component);
    }
    init() {}
    /**
   * callback to be executed when page is loaded
   */ _onDocumentLoaded() {
        window.setTimeout(()=>{
            this._collectPerformance();
        });
    }
    /**
   * Adds spans for all resources
   * @param rootSpan
   */ _addResourcesSpans(rootSpan) {
        const resources = $053b4050c185c268$var$otperformance2.getEntriesByType?.("resource");
        if (resources) resources.forEach((resource)=>{
            this._initResourceSpan(resource, rootSpan);
        });
    }
    /**
   * Collects information about performance and creates appropriate spans
   */ _collectPerformance() {
        const metaElement = Array.from(document.getElementsByTagName("meta")).find((e)=>e.getAttribute("name") === $053b4050c185c268$var$TRACE_PARENT_HEADER2);
        const entries = $053b4050c185c268$var$getPerformanceNavigationEntries();
        const traceparent = metaElement && metaElement.content || "";
        $053b4050c185c268$var$context.with($053b4050c185c268$var$propagation.extract($053b4050c185c268$var$ROOT_CONTEXT, {
            traceparent: traceparent
        }), ()=>{
            const rootSpan = this._startSpan($053b4050c185c268$var$AttributeNames.DOCUMENT_LOAD, $053b4050c185c268$var$PerformanceTimingNames.FETCH_START, entries);
            if (!rootSpan) return;
            $053b4050c185c268$var$context.with($053b4050c185c268$var$trace.setSpan($053b4050c185c268$var$context.active(), rootSpan), ()=>{
                const fetchSpan = this._startSpan($053b4050c185c268$var$AttributeNames.DOCUMENT_FETCH, $053b4050c185c268$var$PerformanceTimingNames.FETCH_START, entries);
                if (fetchSpan) {
                    fetchSpan.setAttribute($053b4050c185c268$var$SEMATTRS_HTTP_URL2, location.href);
                    $053b4050c185c268$var$context.with($053b4050c185c268$var$trace.setSpan($053b4050c185c268$var$context.active(), fetchSpan), ()=>{
                        if (!this.getConfig().ignoreNetworkEvents) $053b4050c185c268$var$addSpanNetworkEvents(fetchSpan, entries);
                        this._addCustomAttributesOnSpan(fetchSpan, this.getConfig().applyCustomAttributesOnSpan?.documentFetch);
                        this._endSpan(fetchSpan, $053b4050c185c268$var$PerformanceTimingNames.RESPONSE_END, entries);
                    });
                }
            });
            rootSpan.setAttribute($053b4050c185c268$var$SEMATTRS_HTTP_URL2, location.href);
            rootSpan.setAttribute($053b4050c185c268$var$SEMATTRS_HTTP_USER_AGENT2, navigator.userAgent);
            this._addResourcesSpans(rootSpan);
            if (!this.getConfig().ignoreNetworkEvents) {
                $053b4050c185c268$var$addSpanNetworkEvent(rootSpan, $053b4050c185c268$var$PerformanceTimingNames.FETCH_START, entries);
                $053b4050c185c268$var$addSpanNetworkEvent(rootSpan, $053b4050c185c268$var$PerformanceTimingNames.UNLOAD_EVENT_START, entries);
                $053b4050c185c268$var$addSpanNetworkEvent(rootSpan, $053b4050c185c268$var$PerformanceTimingNames.UNLOAD_EVENT_END, entries);
                $053b4050c185c268$var$addSpanNetworkEvent(rootSpan, $053b4050c185c268$var$PerformanceTimingNames.DOM_INTERACTIVE, entries);
                $053b4050c185c268$var$addSpanNetworkEvent(rootSpan, $053b4050c185c268$var$PerformanceTimingNames.DOM_CONTENT_LOADED_EVENT_START, entries);
                $053b4050c185c268$var$addSpanNetworkEvent(rootSpan, $053b4050c185c268$var$PerformanceTimingNames.DOM_CONTENT_LOADED_EVENT_END, entries);
                $053b4050c185c268$var$addSpanNetworkEvent(rootSpan, $053b4050c185c268$var$PerformanceTimingNames.DOM_COMPLETE, entries);
                $053b4050c185c268$var$addSpanNetworkEvent(rootSpan, $053b4050c185c268$var$PerformanceTimingNames.LOAD_EVENT_START, entries);
                $053b4050c185c268$var$addSpanNetworkEvent(rootSpan, $053b4050c185c268$var$PerformanceTimingNames.LOAD_EVENT_END, entries);
            }
            if (!this.getConfig().ignorePerformancePaintEvents) $053b4050c185c268$var$addSpanPerformancePaintEvents(rootSpan);
            this._addCustomAttributesOnSpan(rootSpan, this.getConfig().applyCustomAttributesOnSpan?.documentLoad);
            this._endSpan(rootSpan, $053b4050c185c268$var$PerformanceTimingNames.LOAD_EVENT_END, entries);
        });
    }
    /**
   * Helper function for ending span
   * @param span
   * @param performanceName name of performance entry for time end
   * @param entries
   */ _endSpan(span, performanceName, entries) {
        if (span) {
            if ($053b4050c185c268$var$hasKey(entries, performanceName)) span.end(entries[performanceName]);
            else span.end();
        }
    }
    /**
   * Creates and ends a span with network information about resource added as timed events
   * @param resource
   * @param parentSpan
   */ _initResourceSpan(resource, parentSpan) {
        const span = this._startSpan($053b4050c185c268$var$AttributeNames.RESOURCE_FETCH, $053b4050c185c268$var$PerformanceTimingNames.FETCH_START, resource, parentSpan);
        if (span) {
            span.setAttribute($053b4050c185c268$var$SEMATTRS_HTTP_URL2, resource.name);
            if (!this.getConfig().ignoreNetworkEvents) $053b4050c185c268$var$addSpanNetworkEvents(span, resource);
            this._addCustomAttributesOnResourceSpan(span, resource, this.getConfig().applyCustomAttributesOnSpan?.resourceFetch);
            this._endSpan(span, $053b4050c185c268$var$PerformanceTimingNames.RESPONSE_END, resource);
        }
    }
    /**
   * Helper function for starting a span
   * @param spanName name of span
   * @param performanceName name of performance entry for time start
   * @param entries
   * @param parentSpan
   */ _startSpan(spanName, performanceName, entries, parentSpan) {
        if ($053b4050c185c268$var$hasKey(entries, performanceName) && typeof entries[performanceName] === "number") {
            const span = this.tracer.startSpan(spanName, {
                startTime: entries[performanceName]
            }, parentSpan ? $053b4050c185c268$var$trace.setSpan($053b4050c185c268$var$context.active(), parentSpan) : void 0);
            return span;
        }
        return void 0;
    }
    /**
   * executes callback {_onDocumentLoaded} when the page is loaded
   */ _waitForPageLoad() {
        if (window.document.readyState === "complete") this._onDocumentLoaded();
        else {
            this._onDocumentLoaded = this._onDocumentLoaded.bind(this);
            window.addEventListener("load", this._onDocumentLoaded);
        }
    }
    /**
   * adds custom attributes to root span if configured
   */ _addCustomAttributesOnSpan(span, applyCustomAttributesOnSpan) {
        if (applyCustomAttributesOnSpan) $053b4050c185c268$var$safeExecuteInTheMiddle2(()=>applyCustomAttributesOnSpan(span), (error)=>{
            if (!error) return;
            this._diag.error("addCustomAttributesOnSpan", error);
        }, true);
    }
    /**
   * adds custom attributes to span if configured
   */ _addCustomAttributesOnResourceSpan(span, resource, applyCustomAttributesOnSpan) {
        if (applyCustomAttributesOnSpan) $053b4050c185c268$var$safeExecuteInTheMiddle2(()=>applyCustomAttributesOnSpan(span, resource), (error)=>{
            if (!error) return;
            this._diag.error("addCustomAttributesOnResourceSpan", error);
        }, true);
    }
    /**
   * implements enable function
   */ enable() {
        window.removeEventListener("load", this._onDocumentLoaded);
        this._waitForPageLoad();
    }
    /**
   * implements disable function
   */ disable() {
        window.removeEventListener("load", this._onDocumentLoaded);
    }
};
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-base@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-base/build/esm/enums.js
var $053b4050c185c268$var$ExceptionEventName = "exception";
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-base@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-base/build/esm/Span.js
var $053b4050c185c268$var$__assign4 = function() {
    $053b4050c185c268$var$__assign4 = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $053b4050c185c268$var$__assign4.apply(this, arguments);
};
var $053b4050c185c268$var$__values6 = function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $053b4050c185c268$var$__read14 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $053b4050c185c268$var$__spreadArray6 = function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $053b4050c185c268$var$Span = /** @class */ function() {
    function Span2(parentTracer, context2, spanName, spanContext, kind, parentSpanId, links, startTime, _deprecatedClock, attributes) {
        if (links === void 0) links = [];
        this.attributes = {};
        this.links = [];
        this.events = [];
        this._droppedAttributesCount = 0;
        this._droppedEventsCount = 0;
        this._droppedLinksCount = 0;
        this.status = {
            code: $053b4050c185c268$var$SpanStatusCode.UNSET
        };
        this.endTime = [
            0,
            0
        ];
        this._ended = false;
        this._duration = [
            -1,
            -1
        ];
        this.name = spanName;
        this._spanContext = spanContext;
        this.parentSpanId = parentSpanId;
        this.kind = kind;
        this.links = links;
        var now = Date.now();
        this._performanceStartTime = $053b4050c185c268$var$otperformance.now();
        this._performanceOffset = now - (this._performanceStartTime + $053b4050c185c268$var$getTimeOrigin());
        this._startTimeProvided = startTime != null;
        this.startTime = this._getTime(startTime !== null && startTime !== void 0 ? startTime : now);
        this.resource = parentTracer.resource;
        this.instrumentationLibrary = parentTracer.instrumentationLibrary;
        this._spanLimits = parentTracer.getSpanLimits();
        this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0;
        if (attributes != null) this.setAttributes(attributes);
        this._spanProcessor = parentTracer.getActiveSpanProcessor();
        this._spanProcessor.onStart(this, context2);
    }
    Span2.prototype.spanContext = function() {
        return this._spanContext;
    };
    Span2.prototype.setAttribute = function(key, value) {
        if (value == null || this._isSpanEnded()) return this;
        if (key.length === 0) {
            $053b4050c185c268$var$diag2.warn("Invalid attribute key: " + key);
            return this;
        }
        if (!$053b4050c185c268$var$isAttributeValue(value)) {
            $053b4050c185c268$var$diag2.warn("Invalid attribute value set for key: " + key);
            return this;
        }
        if (Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, key)) {
            this._droppedAttributesCount++;
            return this;
        }
        this.attributes[key] = this._truncateToSize(value);
        return this;
    };
    Span2.prototype.setAttributes = function(attributes) {
        var e_1, _a3;
        try {
            for(var _b = $053b4050c185c268$var$__values6(Object.entries(attributes)), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = $053b4050c185c268$var$__read14(_c.value, 2), k = _d[0], v = _d[1];
                this.setAttribute(k, v);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a3 = _b.return)) _a3.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return this;
    };
    Span2.prototype.addEvent = function(name, attributesOrStartTime, timeStamp) {
        if (this._isSpanEnded()) return this;
        if (this._spanLimits.eventCountLimit === 0) {
            $053b4050c185c268$var$diag2.warn("No events allowed.");
            this._droppedEventsCount++;
            return this;
        }
        if (this.events.length >= this._spanLimits.eventCountLimit) {
            if (this._droppedEventsCount === 0) $053b4050c185c268$var$diag2.debug("Dropping extra events.");
            this.events.shift();
            this._droppedEventsCount++;
        }
        if ($053b4050c185c268$var$isTimeInput(attributesOrStartTime)) {
            if (!$053b4050c185c268$var$isTimeInput(timeStamp)) timeStamp = attributesOrStartTime;
            attributesOrStartTime = void 0;
        }
        var attributes = $053b4050c185c268$var$sanitizeAttributes(attributesOrStartTime);
        this.events.push({
            name: name,
            attributes: attributes,
            time: this._getTime(timeStamp),
            droppedAttributesCount: 0
        });
        return this;
    };
    Span2.prototype.addLink = function(link) {
        this.links.push(link);
        return this;
    };
    Span2.prototype.addLinks = function(links) {
        var _a3;
        (_a3 = this.links).push.apply(_a3, $053b4050c185c268$var$__spreadArray6([], $053b4050c185c268$var$__read14(links), false));
        return this;
    };
    Span2.prototype.setStatus = function(status) {
        if (this._isSpanEnded()) return this;
        this.status = $053b4050c185c268$var$__assign4({}, status);
        if (this.status.message != null && typeof status.message !== "string") {
            $053b4050c185c268$var$diag2.warn("Dropping invalid status.message of type '" + typeof status.message + "', expected 'string'");
            delete this.status.message;
        }
        return this;
    };
    Span2.prototype.updateName = function(name) {
        if (this._isSpanEnded()) return this;
        this.name = name;
        return this;
    };
    Span2.prototype.end = function(endTime) {
        if (this._isSpanEnded()) {
            $053b4050c185c268$var$diag2.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
            return;
        }
        this._ended = true;
        this.endTime = this._getTime(endTime);
        this._duration = $053b4050c185c268$var$hrTimeDuration(this.startTime, this.endTime);
        if (this._duration[0] < 0) {
            $053b4050c185c268$var$diag2.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime);
            this.endTime = this.startTime.slice();
            this._duration = [
                0,
                0
            ];
        }
        if (this._droppedEventsCount > 0) $053b4050c185c268$var$diag2.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached");
        this._spanProcessor.onEnd(this);
    };
    Span2.prototype._getTime = function(inp) {
        if (typeof inp === "number" && inp <= $053b4050c185c268$var$otperformance.now()) return $053b4050c185c268$var$hrTime(inp + this._performanceOffset);
        if (typeof inp === "number") return $053b4050c185c268$var$millisToHrTime(inp);
        if (inp instanceof Date) return $053b4050c185c268$var$millisToHrTime(inp.getTime());
        if ($053b4050c185c268$var$isTimeInputHrTime(inp)) return inp;
        if (this._startTimeProvided) return $053b4050c185c268$var$millisToHrTime(Date.now());
        var msDuration = $053b4050c185c268$var$otperformance.now() - this._performanceStartTime;
        return $053b4050c185c268$var$addHrTimes(this.startTime, $053b4050c185c268$var$millisToHrTime(msDuration));
    };
    Span2.prototype.isRecording = function() {
        return this._ended === false;
    };
    Span2.prototype.recordException = function(exception, time) {
        var attributes = {};
        if (typeof exception === "string") attributes[$053b4050c185c268$var$SEMATTRS_EXCEPTION_MESSAGE] = exception;
        else if (exception) {
            if (exception.code) attributes[$053b4050c185c268$var$SEMATTRS_EXCEPTION_TYPE] = exception.code.toString();
            else if (exception.name) attributes[$053b4050c185c268$var$SEMATTRS_EXCEPTION_TYPE] = exception.name;
            if (exception.message) attributes[$053b4050c185c268$var$SEMATTRS_EXCEPTION_MESSAGE] = exception.message;
            if (exception.stack) attributes[$053b4050c185c268$var$SEMATTRS_EXCEPTION_STACKTRACE] = exception.stack;
        }
        if (attributes[$053b4050c185c268$var$SEMATTRS_EXCEPTION_TYPE] || attributes[$053b4050c185c268$var$SEMATTRS_EXCEPTION_MESSAGE]) this.addEvent($053b4050c185c268$var$ExceptionEventName, attributes, time);
        else $053b4050c185c268$var$diag2.warn("Failed to record an exception " + exception);
    };
    Object.defineProperty(Span2.prototype, "duration", {
        get: function() {
            return this._duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span2.prototype, "ended", {
        get: function() {
            return this._ended;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span2.prototype, "droppedAttributesCount", {
        get: function() {
            return this._droppedAttributesCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span2.prototype, "droppedEventsCount", {
        get: function() {
            return this._droppedEventsCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span2.prototype, "droppedLinksCount", {
        get: function() {
            return this._droppedLinksCount;
        },
        enumerable: false,
        configurable: true
    });
    Span2.prototype._isSpanEnded = function() {
        if (this._ended) $053b4050c185c268$var$diag2.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}");
        return this._ended;
    };
    Span2.prototype._truncateToLimitUtil = function(value, limit) {
        if (value.length <= limit) return value;
        return value.substring(0, limit);
    };
    Span2.prototype._truncateToSize = function(value) {
        var _this = this;
        var limit = this._attributeValueLengthLimit;
        if (limit <= 0) {
            $053b4050c185c268$var$diag2.warn("Attribute value limit must be positive, got " + limit);
            return value;
        }
        if (typeof value === "string") return this._truncateToLimitUtil(value, limit);
        if (Array.isArray(value)) return value.map(function(val) {
            return typeof val === "string" ? _this._truncateToLimitUtil(val, limit) : val;
        });
        return value;
    };
    return Span2;
}();
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-base@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-base/build/esm/Sampler.js
var $053b4050c185c268$var$SamplingDecision2;
(function(SamplingDecision3) {
    SamplingDecision3[SamplingDecision3["NOT_RECORD"] = 0] = "NOT_RECORD";
    SamplingDecision3[SamplingDecision3["RECORD"] = 1] = "RECORD";
    SamplingDecision3[SamplingDecision3["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})($053b4050c185c268$var$SamplingDecision2 || ($053b4050c185c268$var$SamplingDecision2 = {}));
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-base@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-base/build/esm/sampler/AlwaysOffSampler.js
var $053b4050c185c268$var$AlwaysOffSampler = /** @class */ function() {
    function AlwaysOffSampler2() {}
    AlwaysOffSampler2.prototype.shouldSample = function() {
        return {
            decision: $053b4050c185c268$var$SamplingDecision2.NOT_RECORD
        };
    };
    AlwaysOffSampler2.prototype.toString = function() {
        return "AlwaysOffSampler";
    };
    return AlwaysOffSampler2;
}();
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-base@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-base/build/esm/sampler/AlwaysOnSampler.js
var $053b4050c185c268$var$AlwaysOnSampler = /** @class */ function() {
    function AlwaysOnSampler2() {}
    AlwaysOnSampler2.prototype.shouldSample = function() {
        return {
            decision: $053b4050c185c268$var$SamplingDecision2.RECORD_AND_SAMPLED
        };
    };
    AlwaysOnSampler2.prototype.toString = function() {
        return "AlwaysOnSampler";
    };
    return AlwaysOnSampler2;
}();
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-base@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-base/build/esm/sampler/ParentBasedSampler.js
var $053b4050c185c268$var$ParentBasedSampler = /** @class */ function() {
    function ParentBasedSampler2(config) {
        var _a3, _b, _c, _d;
        this._root = config.root;
        if (!this._root) {
            $053b4050c185c268$var$globalErrorHandler(new Error("ParentBasedSampler must have a root sampler configured"));
            this._root = new $053b4050c185c268$var$AlwaysOnSampler();
        }
        this._remoteParentSampled = (_a3 = config.remoteParentSampled) !== null && _a3 !== void 0 ? _a3 : new $053b4050c185c268$var$AlwaysOnSampler();
        this._remoteParentNotSampled = (_b = config.remoteParentNotSampled) !== null && _b !== void 0 ? _b : new $053b4050c185c268$var$AlwaysOffSampler();
        this._localParentSampled = (_c = config.localParentSampled) !== null && _c !== void 0 ? _c : new $053b4050c185c268$var$AlwaysOnSampler();
        this._localParentNotSampled = (_d = config.localParentNotSampled) !== null && _d !== void 0 ? _d : new $053b4050c185c268$var$AlwaysOffSampler();
    }
    ParentBasedSampler2.prototype.shouldSample = function(context2, traceId, spanName, spanKind, attributes, links) {
        var parentContext = $053b4050c185c268$var$trace.getSpanContext(context2);
        if (!parentContext || !$053b4050c185c268$var$isSpanContextValid(parentContext)) return this._root.shouldSample(context2, traceId, spanName, spanKind, attributes, links);
        if (parentContext.isRemote) {
            if (parentContext.traceFlags & $053b4050c185c268$var$TraceFlags.SAMPLED) return this._remoteParentSampled.shouldSample(context2, traceId, spanName, spanKind, attributes, links);
            return this._remoteParentNotSampled.shouldSample(context2, traceId, spanName, spanKind, attributes, links);
        }
        if (parentContext.traceFlags & $053b4050c185c268$var$TraceFlags.SAMPLED) return this._localParentSampled.shouldSample(context2, traceId, spanName, spanKind, attributes, links);
        return this._localParentNotSampled.shouldSample(context2, traceId, spanName, spanKind, attributes, links);
    };
    ParentBasedSampler2.prototype.toString = function() {
        return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    };
    return ParentBasedSampler2;
}();
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-base@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-base/build/esm/sampler/TraceIdRatioBasedSampler.js
var $053b4050c185c268$var$TraceIdRatioBasedSampler = /** @class */ function() {
    function TraceIdRatioBasedSampler2(_ratio) {
        if (_ratio === void 0) _ratio = 0;
        this._ratio = _ratio;
        this._ratio = this._normalize(_ratio);
        this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    TraceIdRatioBasedSampler2.prototype.shouldSample = function(context2, traceId) {
        return {
            decision: $053b4050c185c268$var$isValidTraceId(traceId) && this._accumulate(traceId) < this._upperBound ? $053b4050c185c268$var$SamplingDecision2.RECORD_AND_SAMPLED : $053b4050c185c268$var$SamplingDecision2.NOT_RECORD
        };
    };
    TraceIdRatioBasedSampler2.prototype.toString = function() {
        return "TraceIdRatioBased{" + this._ratio + "}";
    };
    TraceIdRatioBasedSampler2.prototype._normalize = function(ratio) {
        if (typeof ratio !== "number" || isNaN(ratio)) return 0;
        return ratio >= 1 ? 1 : ratio <= 0 ? 0 : ratio;
    };
    TraceIdRatioBasedSampler2.prototype._accumulate = function(traceId) {
        var accumulation = 0;
        for(var i = 0; i < traceId.length / 8; i++){
            var pos = i * 8;
            var part = parseInt(traceId.slice(pos, pos + 8), 16);
            accumulation = (accumulation ^ part) >>> 0;
        }
        return accumulation;
    };
    return TraceIdRatioBasedSampler2;
}();
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-base@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-base/build/esm/config.js
var $053b4050c185c268$var$FALLBACK_OTEL_TRACES_SAMPLER = $053b4050c185c268$var$TracesSamplerValues.AlwaysOn;
var $053b4050c185c268$var$DEFAULT_RATIO = 1;
function $053b4050c185c268$var$loadDefaultConfig() {
    var env = $053b4050c185c268$var$getEnv();
    return {
        sampler: $053b4050c185c268$var$buildSamplerFromEnv(env),
        forceFlushTimeoutMillis: 3e4,
        generalLimits: {
            attributeValueLengthLimit: env.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
            attributeCountLimit: env.OTEL_ATTRIBUTE_COUNT_LIMIT
        },
        spanLimits: {
            attributeValueLengthLimit: env.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
            attributeCountLimit: env.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
            linkCountLimit: env.OTEL_SPAN_LINK_COUNT_LIMIT,
            eventCountLimit: env.OTEL_SPAN_EVENT_COUNT_LIMIT,
            attributePerEventCountLimit: env.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
            attributePerLinkCountLimit: env.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
        },
        mergeResourceWithDefaults: true
    };
}
function $053b4050c185c268$var$buildSamplerFromEnv(environment) {
    if (environment === void 0) environment = $053b4050c185c268$var$getEnv();
    switch(environment.OTEL_TRACES_SAMPLER){
        case $053b4050c185c268$var$TracesSamplerValues.AlwaysOn:
            return new $053b4050c185c268$var$AlwaysOnSampler();
        case $053b4050c185c268$var$TracesSamplerValues.AlwaysOff:
            return new $053b4050c185c268$var$AlwaysOffSampler();
        case $053b4050c185c268$var$TracesSamplerValues.ParentBasedAlwaysOn:
            return new $053b4050c185c268$var$ParentBasedSampler({
                root: new $053b4050c185c268$var$AlwaysOnSampler()
            });
        case $053b4050c185c268$var$TracesSamplerValues.ParentBasedAlwaysOff:
            return new $053b4050c185c268$var$ParentBasedSampler({
                root: new $053b4050c185c268$var$AlwaysOffSampler()
            });
        case $053b4050c185c268$var$TracesSamplerValues.TraceIdRatio:
            return new $053b4050c185c268$var$TraceIdRatioBasedSampler($053b4050c185c268$var$getSamplerProbabilityFromEnv(environment));
        case $053b4050c185c268$var$TracesSamplerValues.ParentBasedTraceIdRatio:
            return new $053b4050c185c268$var$ParentBasedSampler({
                root: new $053b4050c185c268$var$TraceIdRatioBasedSampler($053b4050c185c268$var$getSamplerProbabilityFromEnv(environment))
            });
        default:
            $053b4050c185c268$var$diag2.error('OTEL_TRACES_SAMPLER value "' + environment.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + $053b4050c185c268$var$FALLBACK_OTEL_TRACES_SAMPLER + '".');
            return new $053b4050c185c268$var$AlwaysOnSampler();
    }
}
function $053b4050c185c268$var$getSamplerProbabilityFromEnv(environment) {
    if (environment.OTEL_TRACES_SAMPLER_ARG === void 0 || environment.OTEL_TRACES_SAMPLER_ARG === "") {
        $053b4050c185c268$var$diag2.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + $053b4050c185c268$var$DEFAULT_RATIO + ".");
        return $053b4050c185c268$var$DEFAULT_RATIO;
    }
    var probability = Number(environment.OTEL_TRACES_SAMPLER_ARG);
    if (isNaN(probability)) {
        $053b4050c185c268$var$diag2.error("OTEL_TRACES_SAMPLER_ARG=" + environment.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + $053b4050c185c268$var$DEFAULT_RATIO + ".");
        return $053b4050c185c268$var$DEFAULT_RATIO;
    }
    if (probability < 0 || probability > 1) {
        $053b4050c185c268$var$diag2.error("OTEL_TRACES_SAMPLER_ARG=" + environment.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + $053b4050c185c268$var$DEFAULT_RATIO + ".");
        return $053b4050c185c268$var$DEFAULT_RATIO;
    }
    return probability;
}
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-base@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-base/build/esm/utility.js
function $053b4050c185c268$var$mergeConfig(userConfig) {
    var perInstanceDefaults = {
        sampler: $053b4050c185c268$var$buildSamplerFromEnv()
    };
    var DEFAULT_CONFIG = $053b4050c185c268$var$loadDefaultConfig();
    var target = Object.assign({}, DEFAULT_CONFIG, perInstanceDefaults, userConfig);
    target.generalLimits = Object.assign({}, DEFAULT_CONFIG.generalLimits, userConfig.generalLimits || {});
    target.spanLimits = Object.assign({}, DEFAULT_CONFIG.spanLimits, userConfig.spanLimits || {});
    return target;
}
function $053b4050c185c268$var$reconfigureLimits(userConfig) {
    var _a3, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var spanLimits = Object.assign({}, userConfig.spanLimits);
    var parsedEnvConfig = $053b4050c185c268$var$getEnvWithoutDefaults();
    spanLimits.attributeCountLimit = (_f = (_e = (_d = (_b = (_a3 = userConfig.spanLimits) === null || _a3 === void 0 ? void 0 : _a3.attributeCountLimit) !== null && _b !== void 0 ? _b : (_c = userConfig.generalLimits) === null || _c === void 0 ? void 0 : _c.attributeCountLimit) !== null && _d !== void 0 ? _d : parsedEnvConfig.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && _e !== void 0 ? _e : parsedEnvConfig.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && _f !== void 0 ? _f : $053b4050c185c268$var$DEFAULT_ATTRIBUTE_COUNT_LIMIT;
    spanLimits.attributeValueLengthLimit = (_m = (_l = (_k = (_h = (_g = userConfig.spanLimits) === null || _g === void 0 ? void 0 : _g.attributeValueLengthLimit) !== null && _h !== void 0 ? _h : (_j = userConfig.generalLimits) === null || _j === void 0 ? void 0 : _j.attributeValueLengthLimit) !== null && _k !== void 0 ? _k : parsedEnvConfig.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && _l !== void 0 ? _l : parsedEnvConfig.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && _m !== void 0 ? _m : $053b4050c185c268$var$DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT;
    return Object.assign({}, userConfig, {
        spanLimits: spanLimits
    });
}
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-base@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-base/build/esm/export/BatchSpanProcessorBase.js
var $053b4050c185c268$var$BatchSpanProcessorBase = /** @class */ function() {
    function BatchSpanProcessorBase2(_exporter, config) {
        this._exporter = _exporter;
        this._isExporting = false;
        this._finishedSpans = [];
        this._droppedSpansCount = 0;
        var env = $053b4050c185c268$var$getEnv();
        this._maxExportBatchSize = typeof (config === null || config === void 0 ? void 0 : config.maxExportBatchSize) === "number" ? config.maxExportBatchSize : env.OTEL_BSP_MAX_EXPORT_BATCH_SIZE;
        this._maxQueueSize = typeof (config === null || config === void 0 ? void 0 : config.maxQueueSize) === "number" ? config.maxQueueSize : env.OTEL_BSP_MAX_QUEUE_SIZE;
        this._scheduledDelayMillis = typeof (config === null || config === void 0 ? void 0 : config.scheduledDelayMillis) === "number" ? config.scheduledDelayMillis : env.OTEL_BSP_SCHEDULE_DELAY;
        this._exportTimeoutMillis = typeof (config === null || config === void 0 ? void 0 : config.exportTimeoutMillis) === "number" ? config.exportTimeoutMillis : env.OTEL_BSP_EXPORT_TIMEOUT;
        this._shutdownOnce = new $053b4050c185c268$var$BindOnceFuture(this._shutdown, this);
        if (this._maxExportBatchSize > this._maxQueueSize) {
            $053b4050c185c268$var$diag2.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize");
            this._maxExportBatchSize = this._maxQueueSize;
        }
    }
    BatchSpanProcessorBase2.prototype.forceFlush = function() {
        if (this._shutdownOnce.isCalled) return this._shutdownOnce.promise;
        return this._flushAll();
    };
    BatchSpanProcessorBase2.prototype.onStart = function(_span, _parentContext) {};
    BatchSpanProcessorBase2.prototype.onEnd = function(span) {
        if (this._shutdownOnce.isCalled) return;
        if ((span.spanContext().traceFlags & $053b4050c185c268$var$TraceFlags.SAMPLED) === 0) return;
        this._addToBuffer(span);
    };
    BatchSpanProcessorBase2.prototype.shutdown = function() {
        return this._shutdownOnce.call();
    };
    BatchSpanProcessorBase2.prototype._shutdown = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.onShutdown();
        }).then(function() {
            return _this._flushAll();
        }).then(function() {
            return _this._exporter.shutdown();
        });
    };
    BatchSpanProcessorBase2.prototype._addToBuffer = function(span) {
        if (this._finishedSpans.length >= this._maxQueueSize) {
            if (this._droppedSpansCount === 0) $053b4050c185c268$var$diag2.debug("maxQueueSize reached, dropping spans");
            this._droppedSpansCount++;
            return;
        }
        if (this._droppedSpansCount > 0) {
            $053b4050c185c268$var$diag2.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached");
            this._droppedSpansCount = 0;
        }
        this._finishedSpans.push(span);
        this._maybeStartTimer();
    };
    BatchSpanProcessorBase2.prototype._flushAll = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var promises = [];
            var count = Math.ceil(_this._finishedSpans.length / _this._maxExportBatchSize);
            for(var i = 0, j = count; i < j; i++)promises.push(_this._flushOneBatch());
            Promise.all(promises).then(function() {
                resolve();
            }).catch(reject);
        });
    };
    BatchSpanProcessorBase2.prototype._flushOneBatch = function() {
        var _this = this;
        this._clearTimer();
        if (this._finishedSpans.length === 0) return Promise.resolve();
        return new Promise(function(resolve, reject) {
            var timer = setTimeout(function() {
                reject(new Error("Timeout"));
            }, _this._exportTimeoutMillis);
            $053b4050c185c268$var$context.with($053b4050c185c268$var$suppressTracing($053b4050c185c268$var$context.active()), function() {
                var spans;
                if (_this._finishedSpans.length <= _this._maxExportBatchSize) {
                    spans = _this._finishedSpans;
                    _this._finishedSpans = [];
                } else spans = _this._finishedSpans.splice(0, _this._maxExportBatchSize);
                var doExport = function() {
                    return _this._exporter.export(spans, function(result) {
                        var _a3;
                        clearTimeout(timer);
                        if (result.code === $053b4050c185c268$var$ExportResultCode.SUCCESS) resolve();
                        else reject((_a3 = result.error) !== null && _a3 !== void 0 ? _a3 : new Error("BatchSpanProcessor: span export failed"));
                    });
                };
                var pendingResources = null;
                for(var i = 0, len = spans.length; i < len; i++){
                    var span = spans[i];
                    if (span.resource.asyncAttributesPending && span.resource.waitForAsyncAttributes) {
                        pendingResources !== null && pendingResources !== void 0 ? pendingResources : pendingResources = [];
                        pendingResources.push(span.resource.waitForAsyncAttributes());
                    }
                }
                if (pendingResources === null) doExport();
                else Promise.all(pendingResources).then(doExport, function(err) {
                    $053b4050c185c268$var$globalErrorHandler(err);
                    reject(err);
                });
            });
        });
    };
    BatchSpanProcessorBase2.prototype._maybeStartTimer = function() {
        var _this = this;
        if (this._isExporting) return;
        var flush = function() {
            _this._isExporting = true;
            _this._flushOneBatch().finally(function() {
                _this._isExporting = false;
                if (_this._finishedSpans.length > 0) {
                    _this._clearTimer();
                    _this._maybeStartTimer();
                }
            }).catch(function(e) {
                _this._isExporting = false;
                $053b4050c185c268$var$globalErrorHandler(e);
            });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize) return flush();
        if (this._timer !== void 0) return;
        this._timer = setTimeout(function() {
            return flush();
        }, this._scheduledDelayMillis);
        $053b4050c185c268$var$unrefTimer(this._timer);
    };
    BatchSpanProcessorBase2.prototype._clearTimer = function() {
        if (this._timer !== void 0) {
            clearTimeout(this._timer);
            this._timer = void 0;
        }
    };
    return BatchSpanProcessorBase2;
}();
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-base@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-base/build/esm/platform/browser/export/BatchSpanProcessor.js
var $053b4050c185c268$var$__extends5 = /* @__PURE__ */ function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d2, b2) {
            d2.__proto__ = b2;
        } || function(d2, b2) {
            for(var p in b2)if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $053b4050c185c268$var$BatchSpanProcessor = /** @class */ function(_super) {
    $053b4050c185c268$var$__extends5(BatchSpanProcessor2, _super);
    function BatchSpanProcessor2(_exporter, config) {
        var _this = _super.call(this, _exporter, config) || this;
        _this.onInit(config);
        return _this;
    }
    BatchSpanProcessor2.prototype.onInit = function(config) {
        var _this = this;
        if ((config === null || config === void 0 ? void 0 : config.disableAutoFlushOnDocumentHide) !== true && typeof document !== "undefined") {
            this._visibilityChangeListener = function() {
                if (document.visibilityState === "hidden") _this.forceFlush().catch(function(error) {
                    $053b4050c185c268$var$globalErrorHandler(error);
                });
            };
            this._pageHideListener = function() {
                _this.forceFlush().catch(function(error) {
                    $053b4050c185c268$var$globalErrorHandler(error);
                });
            };
            document.addEventListener("visibilitychange", this._visibilityChangeListener);
            document.addEventListener("pagehide", this._pageHideListener);
        }
    };
    BatchSpanProcessor2.prototype.onShutdown = function() {
        if (typeof document !== "undefined") {
            if (this._visibilityChangeListener) document.removeEventListener("visibilitychange", this._visibilityChangeListener);
            if (this._pageHideListener) document.removeEventListener("pagehide", this._pageHideListener);
        }
    };
    return BatchSpanProcessor2;
}($053b4050c185c268$var$BatchSpanProcessorBase);
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-base@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-base/build/esm/platform/browser/RandomIdGenerator.js
var $053b4050c185c268$var$SPAN_ID_BYTES = 8;
var $053b4050c185c268$var$TRACE_ID_BYTES = 16;
var $053b4050c185c268$var$RandomIdGenerator2 = /** @class */ /* @__PURE__ */ function() {
    function RandomIdGenerator3() {
        this.generateTraceId = $053b4050c185c268$var$getIdGenerator($053b4050c185c268$var$TRACE_ID_BYTES);
        this.generateSpanId = $053b4050c185c268$var$getIdGenerator($053b4050c185c268$var$SPAN_ID_BYTES);
    }
    return RandomIdGenerator3;
}();
var $053b4050c185c268$var$SHARED_CHAR_CODES_ARRAY = Array(32);
function $053b4050c185c268$var$getIdGenerator(bytes) {
    return function generateId() {
        for(var i = 0; i < bytes * 2; i++){
            $053b4050c185c268$var$SHARED_CHAR_CODES_ARRAY[i] = Math.floor(Math.random() * 16) + 48;
            if ($053b4050c185c268$var$SHARED_CHAR_CODES_ARRAY[i] >= 58) $053b4050c185c268$var$SHARED_CHAR_CODES_ARRAY[i] += 39;
        }
        return String.fromCharCode.apply(null, $053b4050c185c268$var$SHARED_CHAR_CODES_ARRAY.slice(0, bytes * 2));
    };
}
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-base@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-base/build/esm/Tracer.js
var $053b4050c185c268$var$Tracer = /** @class */ function() {
    function Tracer2(instrumentationLibrary, config, _tracerProvider) {
        this._tracerProvider = _tracerProvider;
        var localConfig = $053b4050c185c268$var$mergeConfig(config);
        this._sampler = localConfig.sampler;
        this._generalLimits = localConfig.generalLimits;
        this._spanLimits = localConfig.spanLimits;
        this._idGenerator = config.idGenerator || new $053b4050c185c268$var$RandomIdGenerator2();
        this.resource = _tracerProvider.resource;
        this.instrumentationLibrary = instrumentationLibrary;
    }
    Tracer2.prototype.startSpan = function(name, options, context2) {
        var _a3, _b, _c;
        if (options === void 0) options = {};
        if (context2 === void 0) context2 = $053b4050c185c268$var$context.active();
        if (options.root) context2 = $053b4050c185c268$var$trace.deleteSpan(context2);
        var parentSpan = $053b4050c185c268$var$trace.getSpan(context2);
        if ($053b4050c185c268$var$isTracingSuppressed(context2)) {
            $053b4050c185c268$var$diag2.debug("Instrumentation suppressed, returning Noop Span");
            var nonRecordingSpan = $053b4050c185c268$var$trace.wrapSpanContext($053b4050c185c268$var$INVALID_SPAN_CONTEXT);
            return nonRecordingSpan;
        }
        var parentSpanContext = parentSpan === null || parentSpan === void 0 ? void 0 : parentSpan.spanContext();
        var spanId = this._idGenerator.generateSpanId();
        var traceId;
        var traceState;
        var parentSpanId;
        if (!parentSpanContext || !$053b4050c185c268$var$trace.isSpanContextValid(parentSpanContext)) traceId = this._idGenerator.generateTraceId();
        else {
            traceId = parentSpanContext.traceId;
            traceState = parentSpanContext.traceState;
            parentSpanId = parentSpanContext.spanId;
        }
        var spanKind = (_a3 = options.kind) !== null && _a3 !== void 0 ? _a3 : $053b4050c185c268$var$SpanKind.INTERNAL;
        var links = ((_b = options.links) !== null && _b !== void 0 ? _b : []).map(function(link) {
            return {
                context: link.context,
                attributes: $053b4050c185c268$var$sanitizeAttributes(link.attributes)
            };
        });
        var attributes = $053b4050c185c268$var$sanitizeAttributes(options.attributes);
        var samplingResult = this._sampler.shouldSample(context2, traceId, name, spanKind, attributes, links);
        traceState = (_c = samplingResult.traceState) !== null && _c !== void 0 ? _c : traceState;
        var traceFlags = samplingResult.decision === $053b4050c185c268$var$SamplingDecision.RECORD_AND_SAMPLED ? $053b4050c185c268$var$TraceFlags.SAMPLED : $053b4050c185c268$var$TraceFlags.NONE;
        var spanContext = {
            traceId: traceId,
            spanId: spanId,
            traceFlags: traceFlags,
            traceState: traceState
        };
        if (samplingResult.decision === $053b4050c185c268$var$SamplingDecision.NOT_RECORD) {
            $053b4050c185c268$var$diag2.debug("Recording is off, propagating context in a non-recording span");
            var nonRecordingSpan = $053b4050c185c268$var$trace.wrapSpanContext(spanContext);
            return nonRecordingSpan;
        }
        var initAttributes = $053b4050c185c268$var$sanitizeAttributes(Object.assign(attributes, samplingResult.attributes));
        var span = new $053b4050c185c268$var$Span(this, context2, name, spanContext, spanKind, parentSpanId, links, options.startTime, void 0, initAttributes);
        return span;
    };
    Tracer2.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $053b4050c185c268$var$context.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = $053b4050c185c268$var$trace.setSpan(parentContext, span);
        return $053b4050c185c268$var$context.with(contextWithSpanSet, fn, void 0, span);
    };
    Tracer2.prototype.getGeneralLimits = function() {
        return this._generalLimits;
    };
    Tracer2.prototype.getSpanLimits = function() {
        return this._spanLimits;
    };
    Tracer2.prototype.getActiveSpanProcessor = function() {
        return this._tracerProvider.getActiveSpanProcessor();
    };
    return Tracer2;
}();
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-base@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-base/build/esm/MultiSpanProcessor.js
var $053b4050c185c268$var$__values7 = function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $053b4050c185c268$var$MultiSpanProcessor = /** @class */ function() {
    function MultiSpanProcessor2(_spanProcessors) {
        this._spanProcessors = _spanProcessors;
    }
    MultiSpanProcessor2.prototype.forceFlush = function() {
        var e_1, _a3;
        var promises = [];
        try {
            for(var _b = $053b4050c185c268$var$__values7(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()){
                var spanProcessor = _c.value;
                promises.push(spanProcessor.forceFlush());
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a3 = _b.return)) _a3.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return new Promise(function(resolve) {
            Promise.all(promises).then(function() {
                resolve();
            }).catch(function(error) {
                $053b4050c185c268$var$globalErrorHandler(error || new Error("MultiSpanProcessor: forceFlush failed"));
                resolve();
            });
        });
    };
    MultiSpanProcessor2.prototype.onStart = function(span, context2) {
        var e_2, _a3;
        try {
            for(var _b = $053b4050c185c268$var$__values7(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()){
                var spanProcessor = _c.value;
                spanProcessor.onStart(span, context2);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a3 = _b.return)) _a3.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    MultiSpanProcessor2.prototype.onEnd = function(span) {
        var e_3, _a3;
        try {
            for(var _b = $053b4050c185c268$var$__values7(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()){
                var spanProcessor = _c.value;
                spanProcessor.onEnd(span);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a3 = _b.return)) _a3.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
    };
    MultiSpanProcessor2.prototype.shutdown = function() {
        var e_4, _a3;
        var promises = [];
        try {
            for(var _b = $053b4050c185c268$var$__values7(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()){
                var spanProcessor = _c.value;
                promises.push(spanProcessor.shutdown());
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a3 = _b.return)) _a3.call(_b);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        return new Promise(function(resolve, reject) {
            Promise.all(promises).then(function() {
                resolve();
            }, reject);
        });
    };
    return MultiSpanProcessor2;
}();
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-base@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-base/build/esm/export/NoopSpanProcessor.js
var $053b4050c185c268$var$NoopSpanProcessor = /** @class */ function() {
    function NoopSpanProcessor2() {}
    NoopSpanProcessor2.prototype.onStart = function(_span, _context) {};
    NoopSpanProcessor2.prototype.onEnd = function(_span) {};
    NoopSpanProcessor2.prototype.shutdown = function() {
        return Promise.resolve();
    };
    NoopSpanProcessor2.prototype.forceFlush = function() {
        return Promise.resolve();
    };
    return NoopSpanProcessor2;
}();
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-base@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-base/build/esm/BasicTracerProvider.js
var $053b4050c185c268$var$__read15 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $053b4050c185c268$var$__spreadArray7 = function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $053b4050c185c268$var$ForceFlushState;
(function(ForceFlushState2) {
    ForceFlushState2[ForceFlushState2["resolved"] = 0] = "resolved";
    ForceFlushState2[ForceFlushState2["timeout"] = 1] = "timeout";
    ForceFlushState2[ForceFlushState2["error"] = 2] = "error";
    ForceFlushState2[ForceFlushState2["unresolved"] = 3] = "unresolved";
})($053b4050c185c268$var$ForceFlushState || ($053b4050c185c268$var$ForceFlushState = {}));
var $053b4050c185c268$var$BasicTracerProvider = /** @class */ function() {
    function BasicTracerProvider2(config) {
        if (config === void 0) config = {};
        var _a3, _b;
        this._registeredSpanProcessors = [];
        this._tracers = /* @__PURE__ */ new Map();
        var mergedConfig = $053b4050c185c268$var$merge({}, $053b4050c185c268$var$loadDefaultConfig(), $053b4050c185c268$var$reconfigureLimits(config));
        this.resource = (_a3 = mergedConfig.resource) !== null && _a3 !== void 0 ? _a3 : $053b4050c185c268$var$Resource.empty();
        if (mergedConfig.mergeResourceWithDefaults) this.resource = $053b4050c185c268$var$Resource.default().merge(this.resource);
        this._config = Object.assign({}, mergedConfig, {
            resource: this.resource
        });
        if ((_b = config.spanProcessors) === null || _b === void 0 ? void 0 : _b.length) {
            this._registeredSpanProcessors = $053b4050c185c268$var$__spreadArray7([], $053b4050c185c268$var$__read15(config.spanProcessors), false);
            this.activeSpanProcessor = new $053b4050c185c268$var$MultiSpanProcessor(this._registeredSpanProcessors);
        } else {
            var defaultExporter = this._buildExporterFromEnv();
            if (defaultExporter !== void 0) {
                var batchProcessor = new $053b4050c185c268$var$BatchSpanProcessor(defaultExporter);
                this.activeSpanProcessor = batchProcessor;
            } else this.activeSpanProcessor = new $053b4050c185c268$var$NoopSpanProcessor();
        }
    }
    BasicTracerProvider2.prototype.getTracer = function(name, version, options) {
        var key = name + "@" + (version || "") + ":" + ((options === null || options === void 0 ? void 0 : options.schemaUrl) || "");
        if (!this._tracers.has(key)) this._tracers.set(key, new $053b4050c185c268$var$Tracer({
            name: name,
            version: version,
            schemaUrl: options === null || options === void 0 ? void 0 : options.schemaUrl
        }, this._config, this));
        return this._tracers.get(key);
    };
    BasicTracerProvider2.prototype.addSpanProcessor = function(spanProcessor) {
        if (this._registeredSpanProcessors.length === 0) this.activeSpanProcessor.shutdown().catch(function(err) {
            return $053b4050c185c268$var$diag2.error("Error while trying to shutdown current span processor", err);
        });
        this._registeredSpanProcessors.push(spanProcessor);
        this.activeSpanProcessor = new $053b4050c185c268$var$MultiSpanProcessor(this._registeredSpanProcessors);
    };
    BasicTracerProvider2.prototype.getActiveSpanProcessor = function() {
        return this.activeSpanProcessor;
    };
    BasicTracerProvider2.prototype.register = function(config) {
        if (config === void 0) config = {};
        $053b4050c185c268$var$trace.setGlobalTracerProvider(this);
        if (config.propagator === void 0) config.propagator = this._buildPropagatorFromEnv();
        if (config.contextManager) $053b4050c185c268$var$context.setGlobalContextManager(config.contextManager);
        if (config.propagator) $053b4050c185c268$var$propagation.setGlobalPropagator(config.propagator);
    };
    BasicTracerProvider2.prototype.forceFlush = function() {
        var timeout = this._config.forceFlushTimeoutMillis;
        var promises = this._registeredSpanProcessors.map(function(spanProcessor) {
            return new Promise(function(resolve) {
                var state;
                var timeoutInterval = setTimeout(function() {
                    resolve(new Error("Span processor did not completed within timeout period of " + timeout + " ms"));
                    state = $053b4050c185c268$var$ForceFlushState.timeout;
                }, timeout);
                spanProcessor.forceFlush().then(function() {
                    clearTimeout(timeoutInterval);
                    if (state !== $053b4050c185c268$var$ForceFlushState.timeout) {
                        state = $053b4050c185c268$var$ForceFlushState.resolved;
                        resolve(state);
                    }
                }).catch(function(error) {
                    clearTimeout(timeoutInterval);
                    state = $053b4050c185c268$var$ForceFlushState.error;
                    resolve(error);
                });
            });
        });
        return new Promise(function(resolve, reject) {
            Promise.all(promises).then(function(results) {
                var errors = results.filter(function(result) {
                    return result !== $053b4050c185c268$var$ForceFlushState.resolved;
                });
                if (errors.length > 0) reject(errors);
                else resolve();
            }).catch(function(error) {
                return reject([
                    error
                ]);
            });
        });
    };
    BasicTracerProvider2.prototype.shutdown = function() {
        return this.activeSpanProcessor.shutdown();
    };
    BasicTracerProvider2.prototype._getPropagator = function(name) {
        var _a3;
        return (_a3 = this.constructor._registeredPropagators.get(name)) === null || _a3 === void 0 ? void 0 : _a3();
    };
    BasicTracerProvider2.prototype._getSpanExporter = function(name) {
        var _a3;
        return (_a3 = this.constructor._registeredExporters.get(name)) === null || _a3 === void 0 ? void 0 : _a3();
    };
    BasicTracerProvider2.prototype._buildPropagatorFromEnv = function() {
        var _this = this;
        var uniquePropagatorNames = Array.from(new Set($053b4050c185c268$var$getEnv().OTEL_PROPAGATORS));
        var propagators = uniquePropagatorNames.map(function(name) {
            var propagator = _this._getPropagator(name);
            if (!propagator) $053b4050c185c268$var$diag2.warn('Propagator "' + name + '" requested through environment variable is unavailable.');
            return propagator;
        });
        var validPropagators = propagators.reduce(function(list, item) {
            if (item) list.push(item);
            return list;
        }, []);
        if (validPropagators.length === 0) return;
        else if (uniquePropagatorNames.length === 1) return validPropagators[0];
        else return new $053b4050c185c268$var$CompositePropagator({
            propagators: validPropagators
        });
    };
    BasicTracerProvider2.prototype._buildExporterFromEnv = function() {
        var exporterName = $053b4050c185c268$var$getEnv().OTEL_TRACES_EXPORTER;
        if (exporterName === "none" || exporterName === "") return;
        var exporter = this._getSpanExporter(exporterName);
        if (!exporter) $053b4050c185c268$var$diag2.error('Exporter "' + exporterName + '" requested through environment variable is unavailable.');
        return exporter;
    };
    BasicTracerProvider2._registeredPropagators = /* @__PURE__ */ new Map([
        [
            "tracecontext",
            function() {
                return new $053b4050c185c268$var$W3CTraceContextPropagator();
            }
        ],
        [
            "baggage",
            function() {
                return new $053b4050c185c268$var$W3CBaggagePropagator();
            }
        ]
    ]);
    BasicTracerProvider2._registeredExporters = /* @__PURE__ */ new Map();
    return BasicTracerProvider2;
}();
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-web@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-web/build/esm/StackContextManager.js
var $053b4050c185c268$var$__read16 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $053b4050c185c268$var$__spreadArray8 = function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $053b4050c185c268$var$StackContextManager = /** @class */ function() {
    function StackContextManager2() {
        this._enabled = false;
        this._currentContext = $053b4050c185c268$var$ROOT_CONTEXT;
    }
    StackContextManager2.prototype._bindFunction = function(context2, target) {
        if (context2 === void 0) context2 = $053b4050c185c268$var$ROOT_CONTEXT;
        var manager = this;
        var contextWrapper = function() {
            var _this = this;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return manager.with(context2, function() {
                return target.apply(_this, args);
            });
        };
        Object.defineProperty(contextWrapper, "length", {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    };
    StackContextManager2.prototype.active = function() {
        return this._currentContext;
    };
    StackContextManager2.prototype.bind = function(context2, target) {
        if (context2 === void 0) context2 = this.active();
        if (typeof target === "function") return this._bindFunction(context2, target);
        return target;
    };
    StackContextManager2.prototype.disable = function() {
        this._currentContext = $053b4050c185c268$var$ROOT_CONTEXT;
        this._enabled = false;
        return this;
    };
    StackContextManager2.prototype.enable = function() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = $053b4050c185c268$var$ROOT_CONTEXT;
        return this;
    };
    StackContextManager2.prototype.with = function(context2, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        var previousContext = this._currentContext;
        this._currentContext = context2 || $053b4050c185c268$var$ROOT_CONTEXT;
        try {
            return fn.call.apply(fn, $053b4050c185c268$var$__spreadArray8([
                thisArg
            ], $053b4050c185c268$var$__read16(args), false));
        } finally{
            this._currentContext = previousContext;
        }
    };
    return StackContextManager2;
}();
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-web@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-web/build/esm/WebTracerProvider.js
var $053b4050c185c268$var$__extends6 = /* @__PURE__ */ function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d2, b2) {
            d2.__proto__ = b2;
        } || function(d2, b2) {
            for(var p in b2)if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $053b4050c185c268$var$WebTracerProvider = /** @class */ function(_super) {
    $053b4050c185c268$var$__extends6(WebTracerProvider2, _super);
    function WebTracerProvider2(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this, config) || this;
        if (config.contextManager) throw "contextManager should be defined in register method not in constructor";
        if (config.propagator) throw "propagator should be defined in register method not in constructor";
        return _this;
    }
    WebTracerProvider2.prototype.register = function(config) {
        if (config === void 0) config = {};
        if (config.contextManager === void 0) config.contextManager = new $053b4050c185c268$var$StackContextManager();
        if (config.contextManager) config.contextManager.enable();
        _super.prototype.register.call(this, config);
    };
    return WebTracerProvider2;
}($053b4050c185c268$var$BasicTracerProvider);
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-web@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-web/build/esm/enums/PerformanceTimingNames.js
var $053b4050c185c268$var$PerformanceTimingNames2;
(function(PerformanceTimingNames3) {
    PerformanceTimingNames3["CONNECT_END"] = "connectEnd";
    PerformanceTimingNames3["CONNECT_START"] = "connectStart";
    PerformanceTimingNames3["DECODED_BODY_SIZE"] = "decodedBodySize";
    PerformanceTimingNames3["DOM_COMPLETE"] = "domComplete";
    PerformanceTimingNames3["DOM_CONTENT_LOADED_EVENT_END"] = "domContentLoadedEventEnd";
    PerformanceTimingNames3["DOM_CONTENT_LOADED_EVENT_START"] = "domContentLoadedEventStart";
    PerformanceTimingNames3["DOM_INTERACTIVE"] = "domInteractive";
    PerformanceTimingNames3["DOMAIN_LOOKUP_END"] = "domainLookupEnd";
    PerformanceTimingNames3["DOMAIN_LOOKUP_START"] = "domainLookupStart";
    PerformanceTimingNames3["ENCODED_BODY_SIZE"] = "encodedBodySize";
    PerformanceTimingNames3["FETCH_START"] = "fetchStart";
    PerformanceTimingNames3["LOAD_EVENT_END"] = "loadEventEnd";
    PerformanceTimingNames3["LOAD_EVENT_START"] = "loadEventStart";
    PerformanceTimingNames3["NAVIGATION_START"] = "navigationStart";
    PerformanceTimingNames3["REDIRECT_END"] = "redirectEnd";
    PerformanceTimingNames3["REDIRECT_START"] = "redirectStart";
    PerformanceTimingNames3["REQUEST_START"] = "requestStart";
    PerformanceTimingNames3["RESPONSE_END"] = "responseEnd";
    PerformanceTimingNames3["RESPONSE_START"] = "responseStart";
    PerformanceTimingNames3["SECURE_CONNECTION_START"] = "secureConnectionStart";
    PerformanceTimingNames3["UNLOAD_EVENT_END"] = "unloadEventEnd";
    PerformanceTimingNames3["UNLOAD_EVENT_START"] = "unloadEventStart";
})($053b4050c185c268$var$PerformanceTimingNames2 || ($053b4050c185c268$var$PerformanceTimingNames2 = {}));
// ../../node_modules/.pnpm/@opentelemetry+sdk-trace-web@1.30.1_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/sdk-trace-web/build/esm/utils.js
var $053b4050c185c268$var$urlNormalizingAnchor;
function $053b4050c185c268$var$getUrlNormalizingAnchor() {
    if (!$053b4050c185c268$var$urlNormalizingAnchor) $053b4050c185c268$var$urlNormalizingAnchor = document.createElement("a");
    return $053b4050c185c268$var$urlNormalizingAnchor;
}
function $053b4050c185c268$var$hasKey2(obj, key) {
    return key in obj;
}
function $053b4050c185c268$var$addSpanNetworkEvent2(span, performanceName, entries, refPerfName) {
    var perfTime = void 0;
    var refTime = void 0;
    if ($053b4050c185c268$var$hasKey2(entries, performanceName) && typeof entries[performanceName] === "number") perfTime = entries[performanceName];
    var refName = refPerfName || $053b4050c185c268$var$PerformanceTimingNames2.FETCH_START;
    if ($053b4050c185c268$var$hasKey2(entries, refName) && typeof entries[refName] === "number") refTime = entries[refName];
    if (perfTime !== void 0 && refTime !== void 0 && perfTime >= refTime) {
        span.addEvent(performanceName, perfTime);
        return span;
    }
    return void 0;
}
function $053b4050c185c268$var$addSpanNetworkEvents2(span, resource, ignoreNetworkEvents) {
    if (ignoreNetworkEvents === void 0) ignoreNetworkEvents = false;
    if (!ignoreNetworkEvents) {
        $053b4050c185c268$var$addSpanNetworkEvent2(span, $053b4050c185c268$var$PerformanceTimingNames2.FETCH_START, resource);
        $053b4050c185c268$var$addSpanNetworkEvent2(span, $053b4050c185c268$var$PerformanceTimingNames2.DOMAIN_LOOKUP_START, resource);
        $053b4050c185c268$var$addSpanNetworkEvent2(span, $053b4050c185c268$var$PerformanceTimingNames2.DOMAIN_LOOKUP_END, resource);
        $053b4050c185c268$var$addSpanNetworkEvent2(span, $053b4050c185c268$var$PerformanceTimingNames2.CONNECT_START, resource);
        if ($053b4050c185c268$var$hasKey2(resource, "name") && resource["name"].startsWith("https:")) $053b4050c185c268$var$addSpanNetworkEvent2(span, $053b4050c185c268$var$PerformanceTimingNames2.SECURE_CONNECTION_START, resource);
        $053b4050c185c268$var$addSpanNetworkEvent2(span, $053b4050c185c268$var$PerformanceTimingNames2.CONNECT_END, resource);
        $053b4050c185c268$var$addSpanNetworkEvent2(span, $053b4050c185c268$var$PerformanceTimingNames2.REQUEST_START, resource);
        $053b4050c185c268$var$addSpanNetworkEvent2(span, $053b4050c185c268$var$PerformanceTimingNames2.RESPONSE_START, resource);
        $053b4050c185c268$var$addSpanNetworkEvent2(span, $053b4050c185c268$var$PerformanceTimingNames2.RESPONSE_END, resource);
    }
    var encodedLength = resource[$053b4050c185c268$var$PerformanceTimingNames2.ENCODED_BODY_SIZE];
    if (encodedLength !== void 0) span.setAttribute($053b4050c185c268$var$SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH, encodedLength);
    var decodedLength = resource[$053b4050c185c268$var$PerformanceTimingNames2.DECODED_BODY_SIZE];
    if (decodedLength !== void 0 && encodedLength !== decodedLength) span.setAttribute($053b4050c185c268$var$SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED, decodedLength);
}
function $053b4050c185c268$var$sortResources2(filteredResources) {
    return filteredResources.slice().sort(function(a, b) {
        var valueA = a[$053b4050c185c268$var$PerformanceTimingNames2.FETCH_START];
        var valueB = b[$053b4050c185c268$var$PerformanceTimingNames2.FETCH_START];
        if (valueA > valueB) return 1;
        else if (valueA < valueB) return -1;
        return 0;
    });
}
function $053b4050c185c268$var$getOrigin() {
    return typeof location !== "undefined" ? location.origin : void 0;
}
function $053b4050c185c268$var$getResource2(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    if (ignoredResources === void 0) ignoredResources = /* @__PURE__ */ new WeakSet();
    var parsedSpanUrl = $053b4050c185c268$var$parseUrl2(spanUrl);
    spanUrl = parsedSpanUrl.toString();
    var filteredResources = $053b4050c185c268$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType);
    if (filteredResources.length === 0) return {
        mainRequest: void 0
    };
    if (filteredResources.length === 1) return {
        mainRequest: filteredResources[0]
    };
    var sorted = $053b4050c185c268$var$sortResources2(filteredResources);
    if (parsedSpanUrl.origin !== $053b4050c185c268$var$getOrigin() && sorted.length > 1) {
        var corsPreFlightRequest = sorted[0];
        var mainRequest = $053b4050c185c268$var$findMainRequest(sorted, corsPreFlightRequest[$053b4050c185c268$var$PerformanceTimingNames2.RESPONSE_END], endTimeHR);
        var responseEnd = corsPreFlightRequest[$053b4050c185c268$var$PerformanceTimingNames2.RESPONSE_END];
        var fetchStart = mainRequest[$053b4050c185c268$var$PerformanceTimingNames2.FETCH_START];
        if (fetchStart < responseEnd) {
            mainRequest = corsPreFlightRequest;
            corsPreFlightRequest = void 0;
        }
        return {
            corsPreFlightRequest: corsPreFlightRequest,
            mainRequest: mainRequest
        };
    } else return {
        mainRequest: filteredResources[0]
    };
}
function $053b4050c185c268$var$findMainRequest(resources, corsPreFlightRequestEndTime, spanEndTimeHR) {
    var spanEndTime = $053b4050c185c268$var$hrTimeToNanoseconds(spanEndTimeHR);
    var minTime = $053b4050c185c268$var$hrTimeToNanoseconds($053b4050c185c268$var$timeInputToHrTime(corsPreFlightRequestEndTime));
    var mainRequest = resources[1];
    var bestGap;
    var length = resources.length;
    for(var i = 1; i < length; i++){
        var resource = resources[i];
        var resourceStartTime = $053b4050c185c268$var$hrTimeToNanoseconds($053b4050c185c268$var$timeInputToHrTime(resource[$053b4050c185c268$var$PerformanceTimingNames2.FETCH_START]));
        var resourceEndTime = $053b4050c185c268$var$hrTimeToNanoseconds($053b4050c185c268$var$timeInputToHrTime(resource[$053b4050c185c268$var$PerformanceTimingNames2.RESPONSE_END]));
        var currentGap = spanEndTime - resourceEndTime;
        if (resourceStartTime >= minTime && (!bestGap || currentGap < bestGap)) {
            bestGap = currentGap;
            mainRequest = resource;
        }
    }
    return mainRequest;
}
function $053b4050c185c268$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    var startTime = $053b4050c185c268$var$hrTimeToNanoseconds(startTimeHR);
    var endTime = $053b4050c185c268$var$hrTimeToNanoseconds(endTimeHR);
    var filteredResources = resources.filter(function(resource) {
        var resourceStartTime = $053b4050c185c268$var$hrTimeToNanoseconds($053b4050c185c268$var$timeInputToHrTime(resource[$053b4050c185c268$var$PerformanceTimingNames2.FETCH_START]));
        var resourceEndTime = $053b4050c185c268$var$hrTimeToNanoseconds($053b4050c185c268$var$timeInputToHrTime(resource[$053b4050c185c268$var$PerformanceTimingNames2.RESPONSE_END]));
        return resource.initiatorType.toLowerCase() === (initiatorType || "xmlhttprequest") && resource.name === spanUrl && resourceStartTime >= startTime && resourceEndTime <= endTime;
    });
    if (filteredResources.length > 0) filteredResources = filteredResources.filter(function(resource) {
        return !ignoredResources.has(resource);
    });
    return filteredResources;
}
function $053b4050c185c268$var$parseUrl2(url) {
    if (typeof URL === "function") return new URL(url, typeof document !== "undefined" ? document.baseURI : typeof location !== "undefined" ? location.href : void 0);
    var element = $053b4050c185c268$var$getUrlNormalizingAnchor();
    element.href = url;
    return element;
}
function $053b4050c185c268$var$shouldPropagateTraceHeaders2(spanUrl, propagateTraceHeaderCorsUrls) {
    var propagateTraceHeaderUrls = propagateTraceHeaderCorsUrls || [];
    if (typeof propagateTraceHeaderUrls === "string" || propagateTraceHeaderUrls instanceof RegExp) propagateTraceHeaderUrls = [
        propagateTraceHeaderUrls
    ];
    var parsedSpanUrl = $053b4050c185c268$var$parseUrl2(spanUrl);
    if (parsedSpanUrl.origin === $053b4050c185c268$var$getOrigin()) return true;
    else return propagateTraceHeaderUrls.some(function(propagateTraceHeaderUrl) {
        return $053b4050c185c268$var$urlMatches(spanUrl, propagateTraceHeaderUrl);
    });
}
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-fetch@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation-fetch/build/esm/enums/AttributeNames.js
var $053b4050c185c268$var$AttributeNames2;
(function(AttributeNames5) {
    AttributeNames5["COMPONENT"] = "component";
    AttributeNames5["HTTP_ERROR_NAME"] = "http.error_name";
    AttributeNames5["HTTP_STATUS_TEXT"] = "http.status_text";
})($053b4050c185c268$var$AttributeNames2 || ($053b4050c185c268$var$AttributeNames2 = {}));
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-fetch@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation-fetch/build/esm/utils.js
var $053b4050c185c268$var$__awaiter5 = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $053b4050c185c268$var$__generator5 = function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $053b4050c185c268$var$__values8 = function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $053b4050c185c268$var$__read17 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $053b4050c185c268$var$DIAG_LOGGER = $053b4050c185c268$var$diag2.createComponentLogger({
    namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils"
});
function $053b4050c185c268$var$getFetchBodyLength() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (args[0] instanceof URL || typeof args[0] === "string") {
        var requestInit = args[1];
        if (!(requestInit === null || requestInit === void 0 ? void 0 : requestInit.body)) return Promise.resolve();
        if (requestInit.body instanceof ReadableStream) {
            var _a3 = $053b4050c185c268$var$_getBodyNonDestructively(requestInit.body), body = _a3.body, length_1 = _a3.length;
            requestInit.body = body;
            return length_1;
        } else return Promise.resolve($053b4050c185c268$var$getXHRBodyLength(requestInit.body));
    } else {
        var info = args[0];
        if (!(info === null || info === void 0 ? void 0 : info.body)) return Promise.resolve();
        return info.clone().text().then(function(t) {
            return $053b4050c185c268$var$getByteLength(t);
        });
    }
}
function $053b4050c185c268$var$_getBodyNonDestructively(body) {
    if (!body.pipeThrough) {
        $053b4050c185c268$var$DIAG_LOGGER.warn("Platform has ReadableStream but not pipeThrough!");
        return {
            body: body,
            length: Promise.resolve(void 0)
        };
    }
    var length = 0;
    var resolveLength;
    var lengthPromise = new Promise(function(resolve) {
        resolveLength = resolve;
    });
    var transform = new TransformStream({
        start: function() {},
        transform: function(chunk, controller) {
            return $053b4050c185c268$var$__awaiter5(this, void 0, void 0, function() {
                var bytearray;
                return $053b4050c185c268$var$__generator5(this, function(_a3) {
                    switch(_a3.label){
                        case 0:
                            return [
                                4,
                                chunk
                            ];
                        case 1:
                            bytearray = _a3.sent();
                            length += bytearray.byteLength;
                            controller.enqueue(chunk);
                            return [
                                2
                            ];
                    }
                });
            });
        },
        flush: function() {
            resolveLength(length);
        }
    });
    return {
        body: body.pipeThrough(transform),
        length: lengthPromise
    };
}
function $053b4050c185c268$var$getXHRBodyLength(body) {
    if (typeof Document !== "undefined" && body instanceof Document) return new XMLSerializer().serializeToString(document).length;
    if (body instanceof Blob) return body.size;
    if (body.byteLength !== void 0) return body.byteLength;
    if (body instanceof FormData) return $053b4050c185c268$var$getFormDataSize(body);
    if (body instanceof URLSearchParams) return $053b4050c185c268$var$getByteLength(body.toString());
    if (typeof body === "string") return $053b4050c185c268$var$getByteLength(body);
    $053b4050c185c268$var$DIAG_LOGGER.warn("unknown body type");
    return void 0;
}
var $053b4050c185c268$var$TEXT_ENCODER = new TextEncoder();
function $053b4050c185c268$var$getByteLength(s) {
    return $053b4050c185c268$var$TEXT_ENCODER.encode(s).byteLength;
}
function $053b4050c185c268$var$getFormDataSize(formData) {
    var e_1, _a3;
    var size = 0;
    try {
        for(var _b = $053b4050c185c268$var$__values8(formData.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = $053b4050c185c268$var$__read17(_c.value, 2), key = _d[0], value = _d[1];
            size += key.length;
            if (value instanceof Blob) size += value.size;
            else size += value.length;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a3 = _b.return)) _a3.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return size;
}
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-fetch@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation-fetch/build/esm/version.js
var $053b4050c185c268$var$VERSION4 = "0.57.2";
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-fetch@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation-fetch/build/esm/fetch.js
var $053b4050c185c268$var$__extends7 = /* @__PURE__ */ function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d2, b2) {
            d2.__proto__ = b2;
        } || function(d2, b2) {
            for(var p in b2)if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $053b4050c185c268$var$__read18 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $053b4050c185c268$var$__spreadArray9 = function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $053b4050c185c268$var$_a2;
var $053b4050c185c268$var$OBSERVER_WAIT_TIME_MS = 300;
var $053b4050c185c268$var$isNode2 = false;
var $053b4050c185c268$var$FetchInstrumentation = /** @class */ function(_super) {
    $053b4050c185c268$var$__extends7(FetchInstrumentation2, _super);
    function FetchInstrumentation2(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this, "@opentelemetry/instrumentation-fetch", $053b4050c185c268$var$VERSION4, config) || this;
        _this.component = "fetch";
        _this.version = $053b4050c185c268$var$VERSION4;
        _this.moduleName = _this.component;
        _this._usedResources = /* @__PURE__ */ new WeakSet();
        _this._tasksCount = 0;
        return _this;
    }
    FetchInstrumentation2.prototype.init = function() {};
    FetchInstrumentation2.prototype._addChildSpan = function(span, corsPreFlightRequest) {
        var childSpan = this.tracer.startSpan("CORS Preflight", {
            startTime: corsPreFlightRequest[$053b4050c185c268$var$PerformanceTimingNames2.FETCH_START]
        }, $053b4050c185c268$var$trace.setSpan($053b4050c185c268$var$context.active(), span));
        $053b4050c185c268$var$addSpanNetworkEvents2(childSpan, corsPreFlightRequest, this.getConfig().ignoreNetworkEvents);
        childSpan.end(corsPreFlightRequest[$053b4050c185c268$var$PerformanceTimingNames2.RESPONSE_END]);
    };
    FetchInstrumentation2.prototype._addFinalSpanAttributes = function(span, response) {
        var parsedUrl = $053b4050c185c268$var$parseUrl2(response.url);
        span.setAttribute($053b4050c185c268$var$SEMATTRS_HTTP_STATUS_CODE, response.status);
        if (response.statusText != null) span.setAttribute($053b4050c185c268$var$AttributeNames2.HTTP_STATUS_TEXT, response.statusText);
        span.setAttribute($053b4050c185c268$var$SEMATTRS_HTTP_HOST, parsedUrl.host);
        span.setAttribute($053b4050c185c268$var$SEMATTRS_HTTP_SCHEME, parsedUrl.protocol.replace(":", ""));
        if (typeof navigator !== "undefined") span.setAttribute($053b4050c185c268$var$SEMATTRS_HTTP_USER_AGENT, navigator.userAgent);
    };
    FetchInstrumentation2.prototype._addHeaders = function(options, spanUrl) {
        if (!$053b4050c185c268$var$shouldPropagateTraceHeaders2(spanUrl, this.getConfig().propagateTraceHeaderCorsUrls)) {
            var headers = {};
            $053b4050c185c268$var$propagation.inject($053b4050c185c268$var$context.active(), headers);
            if (Object.keys(headers).length > 0) this._diag.debug("headers inject skipped due to CORS policy");
            return;
        }
        if (options instanceof Request) $053b4050c185c268$var$propagation.inject($053b4050c185c268$var$context.active(), options.headers, {
            set: function(h, k, v) {
                return h.set(k, typeof v === "string" ? v : String(v));
            }
        });
        else if (options.headers instanceof Headers) $053b4050c185c268$var$propagation.inject($053b4050c185c268$var$context.active(), options.headers, {
            set: function(h, k, v) {
                return h.set(k, typeof v === "string" ? v : String(v));
            }
        });
        else if (options.headers instanceof Map) $053b4050c185c268$var$propagation.inject($053b4050c185c268$var$context.active(), options.headers, {
            set: function(h, k, v) {
                return h.set(k, typeof v === "string" ? v : String(v));
            }
        });
        else {
            var headers = {};
            $053b4050c185c268$var$propagation.inject($053b4050c185c268$var$context.active(), headers);
            options.headers = Object.assign({}, headers, options.headers || {});
        }
    };
    FetchInstrumentation2.prototype._clearResources = function() {
        if (this._tasksCount === 0 && this.getConfig().clearTimingResources) {
            performance.clearResourceTimings();
            this._usedResources = /* @__PURE__ */ new WeakSet();
        }
    };
    FetchInstrumentation2.prototype._createSpan = function(url, options) {
        var _a3;
        if (options === void 0) options = {};
        if ($053b4050c185c268$var$isUrlIgnored(url, this.getConfig().ignoreUrls)) {
            this._diag.debug("ignoring span as url matches ignored url");
            return;
        }
        var method = (options.method || "GET").toUpperCase();
        var spanName = "HTTP " + method;
        return this.tracer.startSpan(spanName, {
            kind: $053b4050c185c268$var$SpanKind.CLIENT,
            attributes: (_a3 = {}, _a3[$053b4050c185c268$var$AttributeNames2.COMPONENT] = this.moduleName, _a3[$053b4050c185c268$var$SEMATTRS_HTTP_METHOD] = method, _a3[$053b4050c185c268$var$SEMATTRS_HTTP_URL] = url, _a3)
        });
    };
    FetchInstrumentation2.prototype._findResourceAndAddNetworkEvents = function(span, resourcesObserver, endTime) {
        var resources = resourcesObserver.entries;
        if (!resources.length) {
            if (!performance.getEntriesByType) return;
            resources = performance.getEntriesByType("resource");
        }
        var resource = $053b4050c185c268$var$getResource2(resourcesObserver.spanUrl, resourcesObserver.startTime, endTime, resources, this._usedResources, "fetch");
        if (resource.mainRequest) {
            var mainRequest = resource.mainRequest;
            this._markResourceAsUsed(mainRequest);
            var corsPreFlightRequest = resource.corsPreFlightRequest;
            if (corsPreFlightRequest) {
                this._addChildSpan(span, corsPreFlightRequest);
                this._markResourceAsUsed(corsPreFlightRequest);
            }
            $053b4050c185c268$var$addSpanNetworkEvents2(span, mainRequest, this.getConfig().ignoreNetworkEvents);
        }
    };
    FetchInstrumentation2.prototype._markResourceAsUsed = function(resource) {
        this._usedResources.add(resource);
    };
    FetchInstrumentation2.prototype._endSpan = function(span, spanData, response) {
        var _this = this;
        var endTime = $053b4050c185c268$var$millisToHrTime(Date.now());
        var performanceEndTime = $053b4050c185c268$var$hrTime();
        this._addFinalSpanAttributes(span, response);
        setTimeout(function() {
            var _a3;
            (_a3 = spanData.observer) === null || _a3 === void 0 || _a3.disconnect();
            _this._findResourceAndAddNetworkEvents(span, spanData, performanceEndTime);
            _this._tasksCount--;
            _this._clearResources();
            span.end(endTime);
        }, $053b4050c185c268$var$OBSERVER_WAIT_TIME_MS);
    };
    FetchInstrumentation2.prototype._patchConstructor = function() {
        var _this = this;
        return function(original) {
            var plugin = _this;
            return function patchConstructor() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var self2 = this;
                var url = $053b4050c185c268$var$parseUrl2(args[0] instanceof Request ? args[0].url : String(args[0])).href;
                var options = args[0] instanceof Request ? args[0] : args[1] || {};
                var createdSpan = plugin._createSpan(url, options);
                if (!createdSpan) return original.apply(this, args);
                var spanData = plugin._prepareSpanData(url);
                if (plugin.getConfig().measureRequestSize) $053b4050c185c268$var$getFetchBodyLength.apply(void 0, $053b4050c185c268$var$__spreadArray9([], $053b4050c185c268$var$__read18(args), false)).then(function(length) {
                    if (!length) return;
                    createdSpan.setAttribute($053b4050c185c268$var$SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED, length);
                }).catch(function(error) {
                    plugin._diag.warn("getFetchBodyLength", error);
                });
                function endSpanOnError(span, error) {
                    plugin._applyAttributesAfterFetch(span, options, error);
                    plugin._endSpan(span, spanData, {
                        status: error.status || 0,
                        statusText: error.message,
                        url: url
                    });
                }
                function endSpanOnSuccess(span, response) {
                    plugin._applyAttributesAfterFetch(span, options, response);
                    if (response.status >= 200 && response.status < 400) plugin._endSpan(span, spanData, response);
                    else plugin._endSpan(span, spanData, {
                        status: response.status,
                        statusText: response.statusText,
                        url: url
                    });
                }
                function onSuccess(span, resolve, response) {
                    try {
                        var resClone = response.clone();
                        var resClone4Hook_1 = response.clone();
                        var body = resClone.body;
                        if (body) {
                            var reader_1 = body.getReader();
                            var read_1 = function() {
                                reader_1.read().then(function(_a3) {
                                    var done = _a3.done;
                                    if (done) endSpanOnSuccess(span, resClone4Hook_1);
                                    else read_1();
                                }, function(error) {
                                    endSpanOnError(span, error);
                                });
                            };
                            read_1();
                        } else endSpanOnSuccess(span, response);
                    } finally{
                        resolve(response);
                    }
                }
                function onError(span, reject, error) {
                    try {
                        endSpanOnError(span, error);
                    } finally{
                        reject(error);
                    }
                }
                return new Promise(function(resolve, reject) {
                    return $053b4050c185c268$var$context.with($053b4050c185c268$var$trace.setSpan($053b4050c185c268$var$context.active(), createdSpan), function() {
                        plugin._addHeaders(options, url);
                        plugin._tasksCount++;
                        return original.apply(self2, options instanceof Request ? [
                            options
                        ] : [
                            url,
                            options
                        ]).then(onSuccess.bind(self2, createdSpan, resolve), onError.bind(self2, createdSpan, reject));
                    });
                });
            };
        };
    };
    FetchInstrumentation2.prototype._applyAttributesAfterFetch = function(span, request, result) {
        var _this = this;
        var applyCustomAttributesOnSpan = this.getConfig().applyCustomAttributesOnSpan;
        if (applyCustomAttributesOnSpan) $053b4050c185c268$var$safeExecuteInTheMiddle(function() {
            return applyCustomAttributesOnSpan(span, request, result);
        }, function(error) {
            if (!error) return;
            _this._diag.error("applyCustomAttributesOnSpan", error);
        }, true);
    };
    FetchInstrumentation2.prototype._prepareSpanData = function(spanUrl) {
        var startTime = $053b4050c185c268$var$hrTime();
        var entries = [];
        if (typeof PerformanceObserver !== "function") return {
            entries: entries,
            startTime: startTime,
            spanUrl: spanUrl
        };
        var observer = new PerformanceObserver(function(list) {
            var perfObsEntries = list.getEntries();
            perfObsEntries.forEach(function(entry) {
                if (entry.initiatorType === "fetch" && entry.name === spanUrl) entries.push(entry);
            });
        });
        observer.observe({
            entryTypes: [
                "resource"
            ]
        });
        return {
            entries: entries,
            observer: observer,
            startTime: startTime,
            spanUrl: spanUrl
        };
    };
    FetchInstrumentation2.prototype.enable = function() {
        if ($053b4050c185c268$var$isNode2) {
            this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
            return;
        }
        if ($053b4050c185c268$var$isWrapped(fetch)) {
            this._unwrap($053b4050c185c268$var$_globalThis2, "fetch");
            this._diag.debug("removing previous patch for constructor");
        }
        this._wrap($053b4050c185c268$var$_globalThis2, "fetch", this._patchConstructor());
    };
    FetchInstrumentation2.prototype.disable = function() {
        if ($053b4050c185c268$var$isNode2) return;
        this._unwrap($053b4050c185c268$var$_globalThis2, "fetch");
        this._usedResources = /* @__PURE__ */ new WeakSet();
    };
    return FetchInstrumentation2;
}($053b4050c185c268$var$InstrumentationBase);
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-user-interaction@0.45.0_@opentelemetry+api@1.9.0_zone.js@0.15.1/node_modules/@opentelemetry/instrumentation-user-interaction/build/esm/enums/AttributeNames.js
var $053b4050c185c268$var$AttributeNames3;
(function(AttributeNames5) {
    AttributeNames5["EVENT_TYPE"] = "event_type";
    AttributeNames5["TARGET_ELEMENT"] = "target_element";
    AttributeNames5["TARGET_XPATH"] = "target_xpath";
    AttributeNames5["HTTP_URL"] = "http.url";
})($053b4050c185c268$var$AttributeNames3 || ($053b4050c185c268$var$AttributeNames3 = {}));
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-user-interaction@0.45.0_@opentelemetry+api@1.9.0_zone.js@0.15.1/node_modules/@opentelemetry/instrumentation-user-interaction/build/esm/version.js
var $053b4050c185c268$var$PACKAGE_VERSION2 = "0.45.0";
var $053b4050c185c268$var$PACKAGE_NAME2 = "@opentelemetry/instrumentation-user-interaction";
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-user-interaction@0.45.0_@opentelemetry+api@1.9.0_zone.js@0.15.1/node_modules/@opentelemetry/instrumentation-user-interaction/build/esm/instrumentation.js
var $053b4050c185c268$var$ZONE_CONTEXT_KEY2 = "OT_ZONE_CONTEXT";
var $053b4050c185c268$var$EVENT_NAVIGATION_NAME = "Navigation:";
var $053b4050c185c268$var$DEFAULT_EVENT_NAMES = [
    "click"
];
function $053b4050c185c268$var$defaultShouldPreventSpanCreation() {
    return false;
}
var $053b4050c185c268$var$UserInteractionInstrumentation = class extends $053b4050c185c268$var$InstrumentationBase2 {
    constructor(config = {}){
        super($053b4050c185c268$var$PACKAGE_NAME2, $053b4050c185c268$var$PACKAGE_VERSION2, config);
        $053b4050c185c268$var$__publicField(this, "version", $053b4050c185c268$var$PACKAGE_VERSION2);
        $053b4050c185c268$var$__publicField(this, "moduleName", "user-interaction");
        $053b4050c185c268$var$__publicField(this, "_spansData", /* @__PURE__ */ new WeakMap());
        // for addEventListener/removeEventListener state
        $053b4050c185c268$var$__publicField(this, "_wrappedListeners", /* @__PURE__ */ new WeakMap());
        // for event bubbling
        $053b4050c185c268$var$__publicField(this, "_eventsSpanMap", /* @__PURE__ */ new WeakMap());
        $053b4050c185c268$var$__publicField(this, "_eventNames");
        $053b4050c185c268$var$__publicField(this, "_shouldPreventSpanCreation");
        this._eventNames = new Set(config?.eventNames ?? $053b4050c185c268$var$DEFAULT_EVENT_NAMES);
        this._shouldPreventSpanCreation = typeof config?.shouldPreventSpanCreation === "function" ? config.shouldPreventSpanCreation : $053b4050c185c268$var$defaultShouldPreventSpanCreation;
    }
    init() {}
    /**
   * This will check if last task was timeout and will save the time to
   * fix the user interaction when nothing happens
   * This timeout comes from xhr plugin which is needed to collect information
   * about last xhr main request from observer
   * @param task
   * @param span
   */ _checkForTimeout(task, span) {
        const spanData = this._spansData.get(span);
        if (spanData) {
            if (task.source === "setTimeout") spanData.hrTimeLastTimeout = $053b4050c185c268$var$hrTime2();
            else if (task.source !== "Promise.then" && task.source !== "setTimeout") spanData.hrTimeLastTimeout = void 0;
        }
    }
    /**
   * Controls whether or not to create a span, based on the event type.
   */ _allowEventName(eventName) {
        return this._eventNames.has(eventName);
    }
    /**
   * Creates a new span
   * @param element
   * @param eventName
   * @param parentSpan
   */ _createSpan(element, eventName, parentSpan) {
        if (!(element instanceof HTMLElement)) return void 0;
        if (!element.getAttribute) return void 0;
        if (element.hasAttribute("disabled")) return void 0;
        if (!this._allowEventName(eventName)) return void 0;
        const xpath = $053b4050c185c268$var$getElementXPath(element, true);
        try {
            const span = this.tracer.startSpan(eventName, {
                attributes: {
                    [$053b4050c185c268$var$AttributeNames3.EVENT_TYPE]: eventName,
                    [$053b4050c185c268$var$AttributeNames3.TARGET_ELEMENT]: element.tagName,
                    [$053b4050c185c268$var$AttributeNames3.TARGET_XPATH]: xpath,
                    [$053b4050c185c268$var$AttributeNames3.HTTP_URL]: window.location.href
                }
            }, parentSpan ? $053b4050c185c268$var$trace.setSpan($053b4050c185c268$var$context.active(), parentSpan) : void 0);
            if (this._shouldPreventSpanCreation(eventName, element, span) === true) return void 0;
            this._spansData.set(span, {
                taskCount: 0
            });
            return span;
        } catch (e) {
            this._diag.error("failed to start create new user interaction span", e);
        }
        return void 0;
    }
    /**
   * Decrement number of tasks that left in zone,
   * This is needed to be able to end span when no more tasks left
   * @param span
   */ _decrementTask(span) {
        const spanData = this._spansData.get(span);
        if (spanData) {
            spanData.taskCount--;
            if (spanData.taskCount === 0) this._tryToEndSpan(span, spanData.hrTimeLastTimeout);
        }
    }
    /**
   * Return the current span
   * @param zone
   * @private
   */ _getCurrentSpan(zone) {
        const context2 = zone.get($053b4050c185c268$var$ZONE_CONTEXT_KEY2);
        if (context2) return $053b4050c185c268$var$trace.getSpan(context2);
        return context2;
    }
    /**
   * Increment number of tasks that are run within the same zone.
   *     This is needed to be able to end span when no more tasks left
   * @param span
   */ _incrementTask(span) {
        const spanData = this._spansData.get(span);
        if (spanData) spanData.taskCount++;
    }
    /**
   * Returns true iff we should use the patched callback; false if it's already been patched
   */ addPatchedListener(on, type, listener, wrappedListener) {
        let listener2Type = this._wrappedListeners.get(listener);
        if (!listener2Type) {
            listener2Type = /* @__PURE__ */ new Map();
            this._wrappedListeners.set(listener, listener2Type);
        }
        let element2patched = listener2Type.get(type);
        if (!element2patched) {
            element2patched = /* @__PURE__ */ new Map();
            listener2Type.set(type, element2patched);
        }
        if (element2patched.has(on)) return false;
        element2patched.set(on, wrappedListener);
        return true;
    }
    /**
   * Returns the patched version of the callback (or undefined)
   */ removePatchedListener(on, type, listener) {
        const listener2Type = this._wrappedListeners.get(listener);
        if (!listener2Type) return void 0;
        const element2patched = listener2Type.get(type);
        if (!element2patched) return void 0;
        const patched = element2patched.get(on);
        if (patched) {
            element2patched.delete(on);
            if (element2patched.size === 0) {
                listener2Type.delete(type);
                if (listener2Type.size === 0) this._wrappedListeners.delete(listener);
            }
        }
        return patched;
    }
    // utility method to deal with the Function|EventListener nature of addEventListener
    _invokeListener(listener, target, args) {
        if (typeof listener === "function") return listener.apply(target, args);
        else return listener.handleEvent(args[0]);
    }
    /**
   * This patches the addEventListener of HTMLElement to be able to
   * auto instrument the click events
   * This is done when zone is not available
   */ _patchAddEventListener() {
        const plugin = this;
        return (original)=>{
            return function addEventListenerPatched(type, listener, useCapture) {
                if (!listener) return original.call(this, type, listener, useCapture);
                const once = useCapture && typeof useCapture === "object" && useCapture.once;
                const patchedListener = function(...args) {
                    let parentSpan;
                    const event = args[0];
                    const target = event?.target;
                    if (event) parentSpan = plugin._eventsSpanMap.get(event);
                    if (once) plugin.removePatchedListener(this, type, listener);
                    const span = plugin._createSpan(target, type, parentSpan);
                    if (span) {
                        if (event) plugin._eventsSpanMap.set(event, span);
                        return $053b4050c185c268$var$context.with($053b4050c185c268$var$trace.setSpan($053b4050c185c268$var$context.active(), span), ()=>{
                            const result = plugin._invokeListener(listener, this, args);
                            span.end();
                            return result;
                        });
                    } else return plugin._invokeListener(listener, this, args);
                };
                if (plugin.addPatchedListener(this, type, listener, patchedListener)) return original.call(this, type, patchedListener, useCapture);
            };
        };
    }
    /**
   * This patches the removeEventListener of HTMLElement to handle the fact that
   * we patched the original callbacks
   * This is done when zone is not available
   */ _patchRemoveEventListener() {
        const plugin = this;
        return (original)=>{
            return function removeEventListenerPatched(type, listener, useCapture) {
                const wrappedListener = plugin.removePatchedListener(this, type, listener);
                if (wrappedListener) return original.call(this, type, wrappedListener, useCapture);
                else return original.call(this, type, listener, useCapture);
            };
        };
    }
    /**
   * Most browser provide event listener api via EventTarget in prototype chain.
   * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
   *
   * * - has addEventListener in IE
   * ** - has addEventListener in all other browsers
   * ! - missing in IE
   *
   * HTMLElement -> Element -> Node * -> EventTarget **! -> Object
   * Document -> Node * -> EventTarget **! -> Object
   * Window * -> WindowProperties ! -> EventTarget **! -> Object
   */ _getPatchableEventTargets() {
        return window.EventTarget ? [
            EventTarget.prototype
        ] : [
            Node.prototype,
            Window.prototype
        ];
    }
    /**
   * Patches the history api
   */ _patchHistoryApi() {
        this._unpatchHistoryApi();
        this._wrap(history, "replaceState", this._patchHistoryMethod());
        this._wrap(history, "pushState", this._patchHistoryMethod());
        this._wrap(history, "back", this._patchHistoryMethod());
        this._wrap(history, "forward", this._patchHistoryMethod());
        this._wrap(history, "go", this._patchHistoryMethod());
    }
    /**
   * Patches the certain history api method
   */ _patchHistoryMethod() {
        const plugin = this;
        return (original)=>{
            return function patchHistoryMethod(...args) {
                const url = `${location.pathname}${location.hash}${location.search}`;
                const result = original.apply(this, args);
                const urlAfter = `${location.pathname}${location.hash}${location.search}`;
                if (url !== urlAfter) plugin._updateInteractionName(urlAfter);
                return result;
            };
        };
    }
    /**
   * unpatch the history api methods
   */ _unpatchHistoryApi() {
        if ($053b4050c185c268$var$isWrapped2(history.replaceState)) this._unwrap(history, "replaceState");
        if ($053b4050c185c268$var$isWrapped2(history.pushState)) this._unwrap(history, "pushState");
        if ($053b4050c185c268$var$isWrapped2(history.back)) this._unwrap(history, "back");
        if ($053b4050c185c268$var$isWrapped2(history.forward)) this._unwrap(history, "forward");
        if ($053b4050c185c268$var$isWrapped2(history.go)) this._unwrap(history, "go");
    }
    /**
   * Updates interaction span name
   * @param url
   */ _updateInteractionName(url) {
        const span = $053b4050c185c268$var$trace.getSpan($053b4050c185c268$var$context.active());
        if (span && typeof span.updateName === "function") span.updateName(`${$053b4050c185c268$var$EVENT_NAVIGATION_NAME} ${url}`);
    }
    /**
   * Patches zone cancel task - this is done to be able to correctly
   * decrement the number of remaining tasks
   */ _patchZoneCancelTask() {
        const plugin = this;
        return (original)=>{
            return function patchCancelTask(task) {
                const currentZone = Zone.current;
                const currentSpan = plugin._getCurrentSpan(currentZone);
                if (currentSpan && plugin._shouldCountTask(task, currentZone)) plugin._decrementTask(currentSpan);
                return original.call(this, task);
            };
        };
    }
    /**
   * Patches zone schedule task - this is done to be able to correctly
   * increment the number of tasks running within current zone but also to
   * save time in case of timeout running from xhr plugin when waiting for
   * main request from PerformanceResourceTiming
   */ _patchZoneScheduleTask() {
        const plugin = this;
        return (original)=>{
            return function patchScheduleTask(task) {
                const currentZone = Zone.current;
                const currentSpan = plugin._getCurrentSpan(currentZone);
                if (currentSpan && plugin._shouldCountTask(task, currentZone)) {
                    plugin._incrementTask(currentSpan);
                    plugin._checkForTimeout(task, currentSpan);
                }
                return original.call(this, task);
            };
        };
    }
    /**
   * Patches zone run task - this is done to be able to create a span when
   * user interaction starts
   * @private
   */ _patchZoneRunTask() {
        const plugin = this;
        return (original)=>{
            return function patchRunTask(task, applyThis, applyArgs) {
                const event = Array.isArray(applyArgs) && applyArgs[0] instanceof Event ? applyArgs[0] : void 0;
                const target = event?.target;
                let span;
                const activeZone = this;
                if (target) {
                    span = plugin._createSpan(target, task.eventName);
                    if (span) {
                        plugin._incrementTask(span);
                        return activeZone.run(()=>{
                            try {
                                return $053b4050c185c268$var$context.with($053b4050c185c268$var$trace.setSpan($053b4050c185c268$var$context.active(), span), ()=>{
                                    const currentZone = Zone.current;
                                    task._zone = currentZone;
                                    return original.call(currentZone, task, applyThis, applyArgs);
                                });
                            } finally{
                                plugin._decrementTask(span);
                            }
                        });
                    }
                } else span = plugin._getCurrentSpan(activeZone);
                try {
                    return original.call(activeZone, task, applyThis, applyArgs);
                } finally{
                    if (span && plugin._shouldCountTask(task, activeZone)) plugin._decrementTask(span);
                }
            };
        };
    }
    /**
   * Decides if task should be counted.
   * @param task
   * @param currentZone
   * @private
   */ _shouldCountTask(task, currentZone) {
        if (task._zone) currentZone = task._zone;
        if (!currentZone || !task.data || task.data.isPeriodic) return false;
        const currentSpan = this._getCurrentSpan(currentZone);
        if (!currentSpan) return false;
        if (!this._spansData.get(currentSpan)) return false;
        return task.type === "macroTask" || task.type === "microTask";
    }
    /**
   * Will try to end span when such span still exists.
   * @param span
   * @param endTime
   * @private
   */ _tryToEndSpan(span, endTime) {
        if (span) {
            const spanData = this._spansData.get(span);
            if (spanData) {
                span.end(endTime);
                this._spansData.delete(span);
            }
        }
    }
    /**
   * implements enable function
   */ enable() {
        const ZoneWithPrototype = this._getZoneWithPrototype();
        this._diag.debug("applying patch to", this.moduleName, this.version, "zone:", !!ZoneWithPrototype);
        if (ZoneWithPrototype) {
            if ($053b4050c185c268$var$isWrapped2(ZoneWithPrototype.prototype.runTask)) {
                this._unwrap(ZoneWithPrototype.prototype, "runTask");
                this._diag.debug("removing previous patch from method runTask");
            }
            if ($053b4050c185c268$var$isWrapped2(ZoneWithPrototype.prototype.scheduleTask)) {
                this._unwrap(ZoneWithPrototype.prototype, "scheduleTask");
                this._diag.debug("removing previous patch from method scheduleTask");
            }
            if ($053b4050c185c268$var$isWrapped2(ZoneWithPrototype.prototype.cancelTask)) {
                this._unwrap(ZoneWithPrototype.prototype, "cancelTask");
                this._diag.debug("removing previous patch from method cancelTask");
            }
            this._zonePatched = true;
            this._wrap(ZoneWithPrototype.prototype, "runTask", this._patchZoneRunTask());
            this._wrap(ZoneWithPrototype.prototype, "scheduleTask", this._patchZoneScheduleTask());
            this._wrap(ZoneWithPrototype.prototype, "cancelTask", this._patchZoneCancelTask());
        } else {
            this._zonePatched = false;
            const targets = this._getPatchableEventTargets();
            targets.forEach((target)=>{
                if ($053b4050c185c268$var$isWrapped2(target.addEventListener)) {
                    this._unwrap(target, "addEventListener");
                    this._diag.debug("removing previous patch from method addEventListener");
                }
                if ($053b4050c185c268$var$isWrapped2(target.removeEventListener)) {
                    this._unwrap(target, "removeEventListener");
                    this._diag.debug("removing previous patch from method removeEventListener");
                }
                this._wrap(target, "addEventListener", this._patchAddEventListener());
                this._wrap(target, "removeEventListener", this._patchRemoveEventListener());
            });
        }
        this._patchHistoryApi();
    }
    /**
   * implements unpatch function
   */ disable() {
        const ZoneWithPrototype = this._getZoneWithPrototype();
        this._diag.debug("removing patch from", this.moduleName, this.version, "zone:", !!ZoneWithPrototype);
        if (ZoneWithPrototype && this._zonePatched) {
            if ($053b4050c185c268$var$isWrapped2(ZoneWithPrototype.prototype.runTask)) this._unwrap(ZoneWithPrototype.prototype, "runTask");
            if ($053b4050c185c268$var$isWrapped2(ZoneWithPrototype.prototype.scheduleTask)) this._unwrap(ZoneWithPrototype.prototype, "scheduleTask");
            if ($053b4050c185c268$var$isWrapped2(ZoneWithPrototype.prototype.cancelTask)) this._unwrap(ZoneWithPrototype.prototype, "cancelTask");
        } else {
            const targets = this._getPatchableEventTargets();
            targets.forEach((target)=>{
                if ($053b4050c185c268$var$isWrapped2(target.addEventListener)) this._unwrap(target, "addEventListener");
                if ($053b4050c185c268$var$isWrapped2(target.removeEventListener)) this._unwrap(target, "removeEventListener");
            });
        }
        this._unpatchHistoryApi();
    }
    /**
   * returns Zone
   */ _getZoneWithPrototype() {
        const _window = window;
        return _window.Zone;
    }
};
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-xml-http-request@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/enums/EventNames.js
var $053b4050c185c268$var$EventNames2;
(function(EventNames3) {
    EventNames3["METHOD_OPEN"] = "open";
    EventNames3["METHOD_SEND"] = "send";
    EventNames3["EVENT_ABORT"] = "abort";
    EventNames3["EVENT_ERROR"] = "error";
    EventNames3["EVENT_LOAD"] = "loaded";
    EventNames3["EVENT_TIMEOUT"] = "timeout";
})($053b4050c185c268$var$EventNames2 || ($053b4050c185c268$var$EventNames2 = {}));
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-xml-http-request@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/utils.js
var $053b4050c185c268$var$__values9 = function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $053b4050c185c268$var$__read19 = function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $053b4050c185c268$var$DIAG_LOGGER2 = $053b4050c185c268$var$diag2.createComponentLogger({
    namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils"
});
function $053b4050c185c268$var$getXHRBodyLength2(body) {
    if (typeof Document !== "undefined" && body instanceof Document) return new XMLSerializer().serializeToString(document).length;
    if (body instanceof Blob) return body.size;
    if (body.byteLength !== void 0) return body.byteLength;
    if (body instanceof FormData) return $053b4050c185c268$var$getFormDataSize2(body);
    if (body instanceof URLSearchParams) return $053b4050c185c268$var$getByteLength2(body.toString());
    if (typeof body === "string") return $053b4050c185c268$var$getByteLength2(body);
    $053b4050c185c268$var$DIAG_LOGGER2.warn("unknown body type");
    return void 0;
}
var $053b4050c185c268$var$TEXT_ENCODER2 = new TextEncoder();
function $053b4050c185c268$var$getByteLength2(s) {
    return $053b4050c185c268$var$TEXT_ENCODER2.encode(s).byteLength;
}
function $053b4050c185c268$var$getFormDataSize2(formData) {
    var e_1, _a3;
    var size = 0;
    try {
        for(var _b = $053b4050c185c268$var$__values9(formData.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = $053b4050c185c268$var$__read19(_c.value, 2), key = _d[0], value = _d[1];
            size += key.length;
            if (value instanceof Blob) size += value.size;
            else size += value.length;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a3 = _b.return)) _a3.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return size;
}
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-xml-http-request@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/version.js
var $053b4050c185c268$var$VERSION5 = "0.57.2";
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-xml-http-request@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/enums/AttributeNames.js
var $053b4050c185c268$var$AttributeNames4;
(function(AttributeNames5) {
    AttributeNames5["HTTP_STATUS_TEXT"] = "http.status_text";
})($053b4050c185c268$var$AttributeNames4 || ($053b4050c185c268$var$AttributeNames4 = {}));
// ../../node_modules/.pnpm/@opentelemetry+instrumentation-xml-http-request@0.57.2_@opentelemetry+api@1.9.0/node_modules/@opentelemetry/instrumentation-xml-http-request/build/esm/xhr.js
var $053b4050c185c268$var$__extends8 = /* @__PURE__ */ function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d2, b2) {
            d2.__proto__ = b2;
        } || function(d2, b2) {
            for(var p in b2)if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $053b4050c185c268$var$OBSERVER_WAIT_TIME_MS2 = 300;
var $053b4050c185c268$var$XMLHttpRequestInstrumentation = /** @class */ function(_super) {
    $053b4050c185c268$var$__extends8(XMLHttpRequestInstrumentation2, _super);
    function XMLHttpRequestInstrumentation2(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this, "@opentelemetry/instrumentation-xml-http-request", $053b4050c185c268$var$VERSION5, config) || this;
        _this.component = "xml-http-request";
        _this.version = $053b4050c185c268$var$VERSION5;
        _this.moduleName = _this.component;
        _this._tasksCount = 0;
        _this._xhrMem = /* @__PURE__ */ new WeakMap();
        _this._usedResources = /* @__PURE__ */ new WeakSet();
        return _this;
    }
    XMLHttpRequestInstrumentation2.prototype.init = function() {};
    XMLHttpRequestInstrumentation2.prototype._addHeaders = function(xhr, spanUrl) {
        var url = $053b4050c185c268$var$parseUrl2(spanUrl).href;
        if (!$053b4050c185c268$var$shouldPropagateTraceHeaders2(url, this.getConfig().propagateTraceHeaderCorsUrls)) {
            var headers_1 = {};
            $053b4050c185c268$var$propagation.inject($053b4050c185c268$var$context.active(), headers_1);
            if (Object.keys(headers_1).length > 0) this._diag.debug("headers inject skipped due to CORS policy");
            return;
        }
        var headers = {};
        $053b4050c185c268$var$propagation.inject($053b4050c185c268$var$context.active(), headers);
        Object.keys(headers).forEach(function(key) {
            xhr.setRequestHeader(key, String(headers[key]));
        });
    };
    XMLHttpRequestInstrumentation2.prototype._addChildSpan = function(span, corsPreFlightRequest) {
        var _this = this;
        $053b4050c185c268$var$context.with($053b4050c185c268$var$trace.setSpan($053b4050c185c268$var$context.active(), span), function() {
            var childSpan = _this.tracer.startSpan("CORS Preflight", {
                startTime: corsPreFlightRequest[$053b4050c185c268$var$PerformanceTimingNames2.FETCH_START]
            });
            $053b4050c185c268$var$addSpanNetworkEvents2(childSpan, corsPreFlightRequest, _this.getConfig().ignoreNetworkEvents);
            childSpan.end(corsPreFlightRequest[$053b4050c185c268$var$PerformanceTimingNames2.RESPONSE_END]);
        });
    };
    XMLHttpRequestInstrumentation2.prototype._addFinalSpanAttributes = function(span, xhrMem, spanUrl) {
        if (typeof spanUrl === "string") {
            var parsedUrl = $053b4050c185c268$var$parseUrl2(spanUrl);
            if (xhrMem.status !== void 0) span.setAttribute($053b4050c185c268$var$SEMATTRS_HTTP_STATUS_CODE, xhrMem.status);
            if (xhrMem.statusText !== void 0) span.setAttribute($053b4050c185c268$var$AttributeNames4.HTTP_STATUS_TEXT, xhrMem.statusText);
            span.setAttribute($053b4050c185c268$var$SEMATTRS_HTTP_HOST, parsedUrl.host);
            span.setAttribute($053b4050c185c268$var$SEMATTRS_HTTP_SCHEME, parsedUrl.protocol.replace(":", ""));
            span.setAttribute($053b4050c185c268$var$SEMATTRS_HTTP_USER_AGENT, navigator.userAgent);
        }
    };
    XMLHttpRequestInstrumentation2.prototype._applyAttributesAfterXHR = function(span, xhr) {
        var _this = this;
        var applyCustomAttributesOnSpan = this.getConfig().applyCustomAttributesOnSpan;
        if (typeof applyCustomAttributesOnSpan === "function") $053b4050c185c268$var$safeExecuteInTheMiddle(function() {
            return applyCustomAttributesOnSpan(span, xhr);
        }, function(error) {
            if (!error) return;
            _this._diag.error("applyCustomAttributesOnSpan", error);
        }, true);
    };
    XMLHttpRequestInstrumentation2.prototype._addResourceObserver = function(xhr, spanUrl) {
        var xhrMem = this._xhrMem.get(xhr);
        if (!xhrMem || typeof PerformanceObserver !== "function" || typeof PerformanceResourceTiming !== "function") return;
        xhrMem.createdResources = {
            observer: new PerformanceObserver(function(list) {
                var entries = list.getEntries();
                var parsedUrl = $053b4050c185c268$var$parseUrl2(spanUrl);
                entries.forEach(function(entry) {
                    if (entry.initiatorType === "xmlhttprequest" && entry.name === parsedUrl.href) {
                        if (xhrMem.createdResources) xhrMem.createdResources.entries.push(entry);
                    }
                });
            }),
            entries: []
        };
        xhrMem.createdResources.observer.observe({
            entryTypes: [
                "resource"
            ]
        });
    };
    XMLHttpRequestInstrumentation2.prototype._clearResources = function() {
        if (this._tasksCount === 0 && this.getConfig().clearTimingResources) {
            $053b4050c185c268$var$otperformance.clearResourceTimings();
            this._xhrMem = /* @__PURE__ */ new WeakMap();
            this._usedResources = /* @__PURE__ */ new WeakSet();
        }
    };
    XMLHttpRequestInstrumentation2.prototype._findResourceAndAddNetworkEvents = function(xhrMem, span, spanUrl, startTime, endTime) {
        if (!spanUrl || !startTime || !endTime || !xhrMem.createdResources) return;
        var resources = xhrMem.createdResources.entries;
        if (!resources || !resources.length) resources = $053b4050c185c268$var$otperformance.getEntriesByType("resource");
        var resource = $053b4050c185c268$var$getResource2($053b4050c185c268$var$parseUrl2(spanUrl).href, startTime, endTime, resources, this._usedResources);
        if (resource.mainRequest) {
            var mainRequest = resource.mainRequest;
            this._markResourceAsUsed(mainRequest);
            var corsPreFlightRequest = resource.corsPreFlightRequest;
            if (corsPreFlightRequest) {
                this._addChildSpan(span, corsPreFlightRequest);
                this._markResourceAsUsed(corsPreFlightRequest);
            }
            $053b4050c185c268$var$addSpanNetworkEvents2(span, mainRequest, this.getConfig().ignoreNetworkEvents);
        }
    };
    XMLHttpRequestInstrumentation2.prototype._cleanPreviousSpanInformation = function(xhr) {
        var xhrMem = this._xhrMem.get(xhr);
        if (xhrMem) {
            var callbackToRemoveEvents = xhrMem.callbackToRemoveEvents;
            if (callbackToRemoveEvents) callbackToRemoveEvents();
            this._xhrMem.delete(xhr);
        }
    };
    XMLHttpRequestInstrumentation2.prototype._createSpan = function(xhr, url, method) {
        var _a3;
        if ($053b4050c185c268$var$isUrlIgnored(url, this.getConfig().ignoreUrls)) {
            this._diag.debug("ignoring span as url matches ignored url");
            return;
        }
        var spanName = method.toUpperCase();
        var currentSpan = this.tracer.startSpan(spanName, {
            kind: $053b4050c185c268$var$SpanKind.CLIENT,
            attributes: (_a3 = {}, _a3[$053b4050c185c268$var$SEMATTRS_HTTP_METHOD] = method, _a3[$053b4050c185c268$var$SEMATTRS_HTTP_URL] = $053b4050c185c268$var$parseUrl2(url).toString(), _a3)
        });
        currentSpan.addEvent($053b4050c185c268$var$EventNames2.METHOD_OPEN);
        this._cleanPreviousSpanInformation(xhr);
        this._xhrMem.set(xhr, {
            span: currentSpan,
            spanUrl: url
        });
        return currentSpan;
    };
    XMLHttpRequestInstrumentation2.prototype._markResourceAsUsed = function(resource) {
        this._usedResources.add(resource);
    };
    XMLHttpRequestInstrumentation2.prototype._patchOpen = function() {
        var _this = this;
        return function(original) {
            var plugin = _this;
            return function patchOpen() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var method = args[0];
                var url = args[1];
                plugin._createSpan(this, url, method);
                return original.apply(this, args);
            };
        };
    };
    XMLHttpRequestInstrumentation2.prototype._patchSend = function() {
        var plugin = this;
        function endSpanTimeout(eventName, xhrMem, performanceEndTime, endTime) {
            var callbackToRemoveEvents = xhrMem.callbackToRemoveEvents;
            if (typeof callbackToRemoveEvents === "function") callbackToRemoveEvents();
            var span = xhrMem.span, spanUrl = xhrMem.spanUrl, sendStartTime = xhrMem.sendStartTime;
            if (span) {
                plugin._findResourceAndAddNetworkEvents(xhrMem, span, spanUrl, sendStartTime, performanceEndTime);
                span.addEvent(eventName, endTime);
                plugin._addFinalSpanAttributes(span, xhrMem, spanUrl);
                span.end(endTime);
                plugin._tasksCount--;
            }
            plugin._clearResources();
        }
        function endSpan(eventName, xhr) {
            var xhrMem = plugin._xhrMem.get(xhr);
            if (!xhrMem) return;
            xhrMem.status = xhr.status;
            xhrMem.statusText = xhr.statusText;
            plugin._xhrMem.delete(xhr);
            if (xhrMem.span) plugin._applyAttributesAfterXHR(xhrMem.span, xhr);
            var performanceEndTime = $053b4050c185c268$var$hrTime();
            var endTime = Date.now();
            setTimeout(function() {
                endSpanTimeout(eventName, xhrMem, performanceEndTime, endTime);
            }, $053b4050c185c268$var$OBSERVER_WAIT_TIME_MS2);
        }
        function onError() {
            endSpan($053b4050c185c268$var$EventNames2.EVENT_ERROR, this);
        }
        function onAbort() {
            endSpan($053b4050c185c268$var$EventNames2.EVENT_ABORT, this);
        }
        function onTimeout() {
            endSpan($053b4050c185c268$var$EventNames2.EVENT_TIMEOUT, this);
        }
        function onLoad() {
            if (this.status < 299) endSpan($053b4050c185c268$var$EventNames2.EVENT_LOAD, this);
            else endSpan($053b4050c185c268$var$EventNames2.EVENT_ERROR, this);
        }
        function unregister(xhr) {
            xhr.removeEventListener("abort", onAbort);
            xhr.removeEventListener("error", onError);
            xhr.removeEventListener("load", onLoad);
            xhr.removeEventListener("timeout", onTimeout);
            var xhrMem = plugin._xhrMem.get(xhr);
            if (xhrMem) xhrMem.callbackToRemoveEvents = void 0;
        }
        return function(original) {
            return function patchSend() {
                var _this = this;
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var xhrMem = plugin._xhrMem.get(this);
                if (!xhrMem) return original.apply(this, args);
                var currentSpan = xhrMem.span;
                var spanUrl = xhrMem.spanUrl;
                if (currentSpan && spanUrl) {
                    if (plugin.getConfig().measureRequestSize && (args === null || args === void 0 ? void 0 : args[0])) {
                        var body = args[0];
                        var bodyLength = $053b4050c185c268$var$getXHRBodyLength2(body);
                        if (bodyLength !== void 0) currentSpan.setAttribute($053b4050c185c268$var$SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED, bodyLength);
                    }
                    $053b4050c185c268$var$context.with($053b4050c185c268$var$trace.setSpan($053b4050c185c268$var$context.active(), currentSpan), function() {
                        plugin._tasksCount++;
                        xhrMem.sendStartTime = $053b4050c185c268$var$hrTime();
                        currentSpan.addEvent($053b4050c185c268$var$EventNames2.METHOD_SEND);
                        _this.addEventListener("abort", onAbort);
                        _this.addEventListener("error", onError);
                        _this.addEventListener("load", onLoad);
                        _this.addEventListener("timeout", onTimeout);
                        xhrMem.callbackToRemoveEvents = function() {
                            unregister(_this);
                            if (xhrMem.createdResources) xhrMem.createdResources.observer.disconnect();
                        };
                        plugin._addHeaders(_this, spanUrl);
                        plugin._addResourceObserver(_this, spanUrl);
                    });
                }
                return original.apply(this, args);
            };
        };
    };
    XMLHttpRequestInstrumentation2.prototype.enable = function() {
        this._diag.debug("applying patch to", this.moduleName, this.version);
        if ($053b4050c185c268$var$isWrapped(XMLHttpRequest.prototype.open)) {
            this._unwrap(XMLHttpRequest.prototype, "open");
            this._diag.debug("removing previous patch from method open");
        }
        if ($053b4050c185c268$var$isWrapped(XMLHttpRequest.prototype.send)) {
            this._unwrap(XMLHttpRequest.prototype, "send");
            this._diag.debug("removing previous patch from method send");
        }
        this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen());
        this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    };
    XMLHttpRequestInstrumentation2.prototype.disable = function() {
        this._diag.debug("removing patch from", this.moduleName, this.version);
        this._unwrap(XMLHttpRequest.prototype, "open");
        this._unwrap(XMLHttpRequest.prototype, "send");
        this._tasksCount = 0;
        this._xhrMem = /* @__PURE__ */ new WeakMap();
        this._usedResources = /* @__PURE__ */ new WeakSet();
    };
    return XMLHttpRequestInstrumentation2;
}($053b4050c185c268$var$InstrumentationBase);
// src/init.ts
var $053b4050c185c268$var$initialized = false;
function $053b4050c185c268$export$fe0b9b444956aff3(opts) {
    if ($053b4050c185c268$var$initialized || typeof window === "undefined") return;
    $053b4050c185c268$var$initialized = true;
    const collectorUrl = new URL(opts.collectorUrl ?? "/v1/traces", window.location.origin).toString();
    const propagateUrls = opts.propagateUrls ?? [
        new RegExp(`^${$053b4050c185c268$var$escapeRegExp(window.location.origin)}`)
    ];
    const sampleRate = opts.sampleRate ?? 1;
    const provider = new $053b4050c185c268$var$WebTracerProvider({
        sampler: new $053b4050c185c268$var$ParentBasedSampler({
            root: new $053b4050c185c268$var$TraceIdRatioBasedSampler(sampleRate)
        }),
        resource: new $053b4050c185c268$var$Resource({
            [$053b4050c185c268$var$ATTR_SERVICE_NAME]: opts.serviceName,
            ...opts.serviceVersion ? {
                [$053b4050c185c268$var$ATTR_SERVICE_VERSION]: opts.serviceVersion
            } : {},
            ...opts.resourceAttributes
        }),
        spanProcessors: [
            new $053b4050c185c268$var$BatchSpanProcessor(new $053b4050c185c268$var$OTLPTraceExporter({
                url: collectorUrl
            }))
        ]
    });
    provider.register({
        contextManager: new $053b4050c185c268$var$ZoneContextManager(),
        propagator: new $053b4050c185c268$var$CompositePropagator({
            propagators: [
                new $053b4050c185c268$var$W3CTraceContextPropagator(),
                new $053b4050c185c268$var$W3CBaggagePropagator()
            ]
        })
    });
    $053b4050c185c268$var$registerInstrumentations({
        instrumentations: [
            new $053b4050c185c268$var$DocumentLoadInstrumentation(),
            new $053b4050c185c268$var$UserInteractionInstrumentation(),
            new $053b4050c185c268$var$FetchInstrumentation({
                propagateTraceHeaderCorsUrls: propagateUrls
            }),
            new $053b4050c185c268$var$XMLHttpRequestInstrumentation({
                propagateTraceHeaderCorsUrls: propagateUrls
            })
        ]
    });
}
function $053b4050c185c268$var$escapeRegExp(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
 /*! Bundled license information:

zone.js/fesm2015/zone.js:
  (**
   * @license Angular v<unknown>
   * (c) 2010-2025 Google LLC. https://angular.io/
   * License: MIT
   *)
*/ 

(0, $053b4050c185c268$export$fe0b9b444956aff3)({
    serviceName: 'payment',
    collectorUrl: '/v1/traces'
});

// Runtime config comes from the server (/config.json: ConfigMap in k8s, .env in
// dev) rather than being baked into the bundle at build time. Fetch it, publish
// it on window.__APP_CONFIG__, then import the app — app-context reads the
// config at module load, so the app must not be imported until it is set.
async function $91a44285e6bc1671$var$bootstrap() {
    try {
        const res = await fetch('/config.json');
        if (res.ok) window.__APP_CONFIG__ = await res.json();
        else console.error('failed to load /config.json:', res.status);
    } catch (err) {
        console.error('failed to load /config.json:', err);
    }
    const { default: App } = await (parcelRequire("P3rDU"));
    $idvMB.render(/*#__PURE__*/ (0, $e1QUF.jsx)(App, {}), document.getElementById('root'));
}
$91a44285e6bc1671$var$bootstrap();


//# sourceMappingURL=payment.5ad8a0f7.js.map
